import Stigg__default, { EntitlementResetPeriod, WidgetType, SubscriptionScheduleType, BillingModel, TiersMode, BillingPeriod, PricingType, Currency, SubscriptionStatus, FontWeight as FontWeight$1, Alignment, MeterType, DiscountType, DiscountDurationType, BillingVendorIdentifier, PaymentCollection } from '@stigg/js-client-sdk';
export * from '@stigg/js-client-sdk';
import React__default, { createElement, forwardRef, useState, useEffect, useCallback, useRef, useContext, useMemo } from 'react';
import _styled from '@emotion/styled/base';
import { Text, FontWeight } from 'styled-typography';
import { useTheme, css, Global, ThemeProvider as ThemeProvider$1 } from '@emotion/react';
import { compact, map, isFunction, countBy, uniq, merge as merge$1, keyBy, padStart, range, partition as partition$1 } from 'lodash-es';
import ClipLoader from 'react-spinners/ClipLoader';
import Color from 'color';
import merge from 'lodash-es/merge';
import moment from 'moment';
import isNil from 'lodash-es/isNil';
import classNames from 'classnames';
import { Select, OutlinedInput, MenuItem, Grid, Box as Box$1, Tooltip, tooltipClasses, Link, Divider as Divider$1, LinearProgress as LinearProgress$1, linearProgressClasses, Button as Button$2, buttonClasses, StepIcon, TextField, CircularProgress, Paper, Collapse, Radio, Alert, Chip } from '@mui/material';
import getSymbolFromCurrency from 'currency-symbol-map';
import Switch from 'react-switch';
import Skeleton$1, { SkeletonTheme } from 'react-loading-skeleton';
import sortBy from 'lodash-es/sortBy';
import styled, { ThemeProvider as ThemeProvider$2, css as css$1 } from 'styled-components';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Button$1 from '@mui/material/Button';
import flatMap from 'lodash-es/flatMap';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import isEmpty from 'lodash-es/isEmpty';
import Tabs from '@mui/material/Tabs';
import { ArrowDown, ExternalLink, Minus, Plus } from 'react-feather';
import LinearProgress from '@mui/material/LinearProgress';
import isUndefined from 'lodash-es/isUndefined';
import lowercase from 'lodash-es/lowerCase';
import { produce } from 'immer';
import cloneDeep from 'lodash-es/cloneDeep';
import remove from 'lodash-es/remove';
import keyBy$1 from 'lodash-es/keyBy';
import compact$1 from 'lodash-es/compact';
import { BillingPeriod as BillingPeriod$1 } from '@stigg/api-client-js/src/generated/sdk';
import { AddressElement, PaymentElement, useStripe, useElements, Elements } from '@stripe/react-stripe-js';
import partition from 'lodash-es/partition';
import styled$1 from '@emotion/styled';
import { loadStripe } from '@stripe/stripe-js';
import Lottie from 'react-lottie';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _path;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgCheckStigg = function SvgCheckStigg(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: 15,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M5.59 7.99 2.125 4.525A1 1 0 1 0 .71 5.94l4.88 4.88 8.705-8.705a.997.997 0 0 0-1.41-1.41L5.59 7.99Z",
    fill: "#B2BBD3"
  })));
};

function calculateUnitQuantityText(minUnitQuantity, maxUnitQuantity, unitsPlural) {
  var unitsText = unitsPlural ? " " + unitsPlural : ''; // copy for only maxunit

  if ((!minUnitQuantity || minUnitQuantity === 1) && maxUnitQuantity) {
    return "Up to " + maxUnitQuantity + unitsText;
  } // both limits


  if (minUnitQuantity && minUnitQuantity > 1 && maxUnitQuantity) {
    return minUnitQuantity + "-" + maxUnitQuantity + unitsText;
  }

  if (minUnitQuantity && minUnitQuantity > 1) {
    return "Minimum " + minUnitQuantity + unitsText;
  }

  return '';
}

var _excluded = ["children", "span", "style", "fontWeight", "variant", "color", "overrideColor", "bold"];

function getColor(theme, $color) {
  switch ($color) {
    case 'white':
      return 'white';

    case 'primary.main':
      return theme.stigg.palette.primary;

    case 'primary.main.light':
      return theme.stigg.palette.primaryLight;

    case 'warning':
      return theme.stigg.palette.warning;

    case 'error':
      return theme.stigg.palette.error;

    default:
      return theme.stigg.palette.text[$color];
  }
}

var StyledText = /*#__PURE__*/_styled(Text, process.env.NODE_ENV === "production" ? {
  target: "ewjez2x0"
} : {
  target: "ewjez2x0",
  label: "StyledText"
})("margin:0;", function (_ref) {
  var $span = _ref.$span;
  return $span && "display: inline";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function getLevel(variant) {
  switch (variant) {
    case 'h1':
      return 1;

    case 'h3':
      return 2;

    case 'h6':
      return 3;

    case 'body1':
      return 4;

    case 'caption':
      return 5;

    default:
      return 3;
  }
}

function mapFontWeight(fontWeight) {
  switch (fontWeight) {
    case 'bold':
      return FontWeight.Bold;

    case 'normal':
      return FontWeight.Normal;

    default:
      return FontWeight.Normal;
  }
}

function getFontWeight(theme, variant) {
  var typography = theme.stigg.typography;

  switch (variant) {
    case 'h1':
      return mapFontWeight(typography.h1.fontWeight);

    case 'h3':
      return mapFontWeight(typography.h2.fontWeight);

    case 'h6':
      return mapFontWeight(typography.h3.fontWeight);

    case 'body1':
      return mapFontWeight(typography.body.fontWeight);

    case 'caption':
      return mapFontWeight(typography.caption.fontWeight);

    default:
      return FontWeight.Normal;
  }
}

var Typography = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      span = props.span,
      style = props.style,
      fontWeight = props.fontWeight,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      overrideColor = props.overrideColor,
      bold = props.bold,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var theme = useTheme();
  var level = getLevel(variant);
  var levelClassName = "typography-level-" + level;
  var className = props.className ? props.className + " " + levelClassName : levelClassName;
  return React__default.createElement(StyledText, Object.assign({
    ref: ref
  }, rest, {
    className: className,
    style: style,
    level: level,
    color: overrideColor || getColor(theme, color),
    fontWeight: fontWeight != null ? fontWeight : bold ? FontWeight.Bold : getFontWeight(theme, variant),
    "$span": span
  }), children);
});

var _excluded$1 = ["displayNameOverride"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var EntitlementName = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e1mddeqb2"
} : {
  target: "e1mddeqb2",
  label: "EntitlementName"
})(process.env.NODE_ENV === "production" ? {
  name: "ti75j2",
  styles: "margin:0"
} : {
  name: "ti75j2",
  styles: "margin:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var EntitlementRowContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1mddeqb1"
} : {
  target: "e1mddeqb1",
  label: "EntitlementRowContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : {
  name: "s5xdrg",
  styles: "display:flex;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var EntitlementCheckIcon = /*#__PURE__*/_styled(SvgCheckStigg, process.env.NODE_ENV === "production" ? {
  target: "e1mddeqb0"
} : {
  target: "e1mddeqb0",
  label: "EntitlementCheckIcon"
})("margin-right:16px;flex-shrink:0;*{fill:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.text.disabled;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function formatUsageNumber(usageLimit) {
  return usageLimit.toLocaleString('en-US', {
    maximumFractionDigits: 0
  });
}

function getResetPeriodText(resetPeriod) {
  if (!resetPeriod) {
    return '';
  }

  switch (resetPeriod) {
    case EntitlementResetPeriod.Day:
      {
        return 'per day';
      }

    case EntitlementResetPeriod.Hour:
      {
        return 'per hour';
      }

    case EntitlementResetPeriod.Week:
      {
        return 'per week';
      }

    case EntitlementResetPeriod.Month:
      {
        return 'per month';
      }
  }
}

function getEntitlementDisplay(_ref2) {
  var hasUnlimitedUsage = _ref2.hasUnlimitedUsage,
      feature = _ref2.feature,
      resetPeriod = _ref2.resetPeriod,
      usageLimit = _ref2.usageLimit,
      minUnitQuantity = _ref2.minUnitQuantity,
      maxUnitQuantity = _ref2.maxUnitQuantity,
      isCustom = _ref2.isCustom;
  var unitBasedEntitlement = minUnitQuantity || maxUnitQuantity;
  var resetPeriodSuffix = "" + (resetPeriod && usageLimit ? "" + getResetPeriodText(resetPeriod) : '');

  if (hasUnlimitedUsage) {
    return "Unlimited " + (feature == null ? void 0 : feature.unitsPlural);
  } else if (isCustom) {
    return "Custom " + (feature == null ? void 0 : feature.unitsPlural);
  } else if (usageLimit) {
    var featureUnits = usageLimit === 1 ? feature == null ? void 0 : feature.units : feature == null ? void 0 : feature.unitsPlural;
    return formatUsageNumber(usageLimit) + " " + featureUnits + " " + resetPeriodSuffix;
  } else if (unitBasedEntitlement) {
    return calculateUnitQuantityText(minUnitQuantity, maxUnitQuantity, feature == null ? void 0 : feature.unitsPlural);
  }

  return feature == null ? void 0 : feature.displayName;
}

function EntitlementRow(props) {
  var displayNameOverride = props.displayNameOverride,
      restProps = _objectWithoutPropertiesLoose(props, _excluded$1);

  var displayName = getEntitlementDisplay(restProps);
  return React__default.createElement(EntitlementRowContainer, {
    className: "stigg-entitlement-row-container"
  }, React__default.createElement(EntitlementCheckIcon, {
    className: "stigg-entitlement-row-icon"
  }), React__default.createElement(EntitlementName, {
    className: "stigg-entitlement-name",
    variant: "h6",
    color: "secondary"
  }, displayNameOverride || displayName));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PlanEntitlementsContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1yz7zcg0"
} : {
  target: "e1yz7zcg0",
  label: "PlanEntitlementsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "budh8k",
  styles: "display:flex;flex-direction:column;gap:16px"
} : {
  name: "budh8k",
  styles: "display:flex;flex-direction:column;gap:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

function getTitle(plan, paywallLocale) {
  if (paywallLocale.entitlementsTitle) {
    return paywallLocale.entitlementsTitle(plan);
  }

  var title = plan.displayName + " includes";

  if (plan.basePlan) {
    title = "Everything in " + plan.basePlan.displayName + ", plus:";
  }

  return title;
}

function PlanEntitlements(_ref) {
  var _plan$pricePoints;

  var plan = _ref.plan,
      billingPeriod = _ref.billingPeriod,
      paywallLocale = _ref.paywallLocale;
  var prices = (_plan$pricePoints = plan.pricePoints) == null ? void 0 : _plan$pricePoints.filter(function (price) {
    return price.billingPeriod === billingPeriod;
  });
  var unitBasedEntitlements = prices == null ? void 0 : prices.map(function (price) {
    var _price$feature;

    var shouldRenderUnitBasedEntitlement = (price == null ? void 0 : price.minUnitQuantity) && (price == null ? void 0 : price.minUnitQuantity) > 1 || (price == null ? void 0 : price.maxUnitQuantity);

    if (!shouldRenderUnitBasedEntitlement) {
      return null;
    }

    return React__default.createElement(EntitlementRow, {
      key: "priceUnitEntitlement-" + (price == null ? void 0 : (_price$feature = price.feature) == null ? void 0 : _price$feature.displayName),
      feature: price == null ? void 0 : price.feature,
      minUnitQuantity: price == null ? void 0 : price.minUnitQuantity,
      maxUnitQuantity: price == null ? void 0 : price.maxUnitQuantity
    });
  });
  return React__default.createElement(PlanEntitlementsContainer, {
    className: "stigg-plan-entitlements-container"
  }, React__default.createElement(Typography, {
    className: "stigg-plan-entitlements-title",
    color: "secondary",
    variant: "h6",
    bold: true
  }, getTitle(plan, paywallLocale)), unitBasedEntitlements, plan.entitlements.filter(function (entitlement) {
    return !(entitlement.hiddenFromWidgets || []).includes(WidgetType.Paywall);
  }).map(function (entitlement) {
    var _entitlement$feature;

    return React__default.createElement(EntitlementRow, {
      key: (_entitlement$feature = entitlement.feature) == null ? void 0 : _entitlement$feature.id,
      displayNameOverride: entitlement.displayNameOverride,
      feature: entitlement.feature,
      resetPeriod: entitlement.resetPeriod,
      hasUnlimitedUsage: entitlement.hasUnlimitedUsage,
      usageLimit: entitlement.usageLimit,
      isCustom: entitlement.isCustom
    });
  }));
}

var SubscribeIntentionType;

(function (SubscribeIntentionType) {
  SubscribeIntentionType["START_TRIAL"] = "START_TRIAL";
  SubscribeIntentionType["UPGRADE_TRIAL_TO_PAID"] = "UPGRADE_TRIAL_TO_PAID";
  SubscribeIntentionType["REQUEST_CUSTOM_PLAN_ACCESS"] = "REQUEST_CUSTOM_PLAN_ACCESS";
  SubscribeIntentionType["CHANGE_BILLING_PERIOD"] = "CHANGE_BILLING_PERIOD";
  SubscribeIntentionType["CHANGE_UNIT_QUANTITY"] = "CHANGE_UNIT_QUANTITY";
  SubscribeIntentionType["UPGRADE_PLAN"] = "UPGRADE_PLAN";
  SubscribeIntentionType["DOWNGRADE_PLAN"] = "DOWNGRADE_PLAN";
  SubscribeIntentionType["CANCEL_SCHEDULED_UPDATES"] = "CANCEL_SCHEDULED_UPDATES";
})(SubscribeIntentionType || (SubscribeIntentionType = {}));

var flexLayoutMapper = function flexLayoutMapper(horizontalAlignment) {
  return {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  }[horizontalAlignment];
};
var getResolvedTheme = function getResolvedTheme(customizedTheme) {
  var _customizedTheme$pale, _customizedTheme$pale2, _customizedTheme$pale3;

  var primaryColor = Color((customizedTheme == null ? void 0 : (_customizedTheme$pale = customizedTheme.palette) == null ? void 0 : _customizedTheme$pale.primary) || '#327EEE');
  var textColor = Color((customizedTheme == null ? void 0 : (_customizedTheme$pale2 = customizedTheme.palette) == null ? void 0 : (_customizedTheme$pale3 = _customizedTheme$pale2.text) == null ? void 0 : _customizedTheme$pale3.primary) || '#001E6C');
  var successColor = Color('#4CAF50');
  var errorColor = Color('#f44336');
  var baseTheme = {
    palette: {
      primary: primaryColor.hex(),
      primaryDark: primaryColor.darken(0.3).hex(),
      primaryLight: primaryColor.alpha(0.5).toString(),
      backgroundPaper: '#FFFFFF',
      backgroundHighlight: '#F5F6F9',
      backgroundSection: primaryColor.alpha(0.1).toString(),
      backgroundButton: primaryColor.alpha(0.08).toString(),
      outlinedBorder: '#C4CBDD',
      outlinedRestingBorder: primaryColor.alpha(0.5).toString(),
      outlinedHoverBackground: primaryColor.lightness(95).hex(),
      switchBorder: primaryColor.lighten(0.1).hex(),
      switchFill: primaryColor.lighten(0.5).hex(),
      switchHandle: primaryColor.hex(),
      warning: '#ed6c02',
      error: errorColor.hex(),
      errorDark: errorColor.darken(0.3).hex(),
      success: successColor.hex(),
      successDark: successColor.darken(0.3).hex(),
      white: '#FFFFFF',
      text: {
        primary: textColor.hex(),
        secondary: textColor.alpha(0.75).toString(),
        disabled: textColor.alpha(0.5).toString()
      }
    },
    layout: {
      planMinWidth: '330px',
      planMaxWidth: '330px',
      planMargin: '20px',
      planPadding: '40px',
      ctaAlignment: 'left',
      headerAlignment: 'left',
      descriptionAlignment: 'left',
      descriptionMinHeight: '80px',
      switchBottomSpacing: '40px'
    },
    shadows: {
      light: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)',
      popover: '0px 4px 5px -2px rgba(0, 30, 108, 0.2), 0px 7px 10px 1px rgba(0, 30, 108, 0.14), 0px 2px 16px 1px rgba(0, 30, 108, 0.12)'
    },
    border: {
      radius: '10px'
    },
    typography: {
      fontFamily: 'custom-font, DM Sans, sans-serif',
      h1: {
        fontSize: '32px',
        fontWeight: 'bold'
      },
      h2: {
        fontSize: '24px',
        fontWeight: 'normal'
      },
      h3: {
        fontSize: '16px',
        fontWeight: 'normal'
      },
      body: {
        fontSize: '14px',
        fontWeight: 'normal'
      },
      caption: {
        fontSize: '12px',
        fontWeight: 'normal'
      }
    },
    customCss: ''
  };
  return merge(baseTheme, customizedTheme);
};

var formatDate = function formatDate(date) {
  return moment.utc(date).format('MMMM Do, yyyy');
};

function getSubscriptionScheduleUpdateTexts(_ref) {
  var scheduledUpdate = _ref.scheduledUpdate,
      subscriptionPrices = _ref.subscriptionPrices,
      billingPeriodRange = _ref.billingPeriodRange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  if (!scheduledUpdate) {
    return {};
  }

  var withDate = options.withDate,
      _options$postfix = options.postfix,
      postfix = _options$postfix === void 0 ? '' : _options$postfix;

  switch (scheduledUpdate.subscriptionScheduleType) {
    case SubscriptionScheduleType.Downgrade:
      {
        var _scheduledUpdate$targ;

        var shouldShowDate = withDate;

        if (isNil(shouldShowDate) && billingPeriodRange != null && billingPeriodRange.end) {
          shouldShowDate = !moment(scheduledUpdate.scheduledExecutionTime).isSame(billingPeriodRange == null ? void 0 : billingPeriodRange.end, 'day');
        }

        var line1 = React__default.createElement(React__default.Fragment, null, "Your subscription will be downgraded to the ", React__default.createElement("b", null, (_scheduledUpdate$targ = scheduledUpdate.targetPackage) == null ? void 0 : _scheduledUpdate$targ.displayName, " plan"), ' ', shouldShowDate ? React__default.createElement(React__default.Fragment, null, "on ", formatDate(scheduledUpdate.scheduledExecutionTime)) : postfix, ".");
        var line2 = "Until then you still have access to your current plan.";
        return {
          line1: line1,
          line2: line2
        };
      }

    case SubscriptionScheduleType.BillingPeriod:
      {
        var _variables$billingPer;

        var variables = scheduledUpdate.scheduleVariables;

        var _line = React__default.createElement(React__default.Fragment, null, "Your billing cycle will change to ", React__default.createElement("b", null, (_variables$billingPer = variables.billingPeriod) == null ? void 0 : _variables$billingPer.toLocaleLowerCase()), ' ', withDate ? React__default.createElement(React__default.Fragment, null, "on ", formatDate(scheduledUpdate.scheduledExecutionTime)) : postfix, ".");

        return {
          line1: _line
        };
      }

    case SubscriptionScheduleType.UnitAmount:
      {
        var _variables = scheduledUpdate.scheduleVariables;
        var feature = compact(map(subscriptionPrices, 'feature')).find(function (_ref2) {
          var id = _ref2.id;
          return id === _variables.featureId;
        });

        var _ref3 = feature || {},
            featureUnits = _ref3.featureUnits,
            featureUnitsPlural = _ref3.featureUnitsPlural;

        var unitsText = _variables.newUnitAmount === 1 ? featureUnits : featureUnitsPlural;

        var _line2 = React__default.createElement(React__default.Fragment, null, "Your subscription will be updated to ", React__default.createElement("b", null, _variables.newUnitAmount), " ", unitsText, ' ', withDate ? React__default.createElement(React__default.Fragment, null, "on ", formatDate(scheduledUpdate.scheduledExecutionTime)) : postfix, ".");

        var _line3 = "Until then you still have access to your current " + featureUnits + " count.";

        return {
          line1: _line2,
          line2: _line3
        };
      }

    default:
      {
        return {};
      }
  }
}

function getPriceFeatureUnit(price) {
  if (!price.feature) {
    return '';
  }

  return (price.feature.unitQuantity != 1 ? price.feature.unitsPlural : price.feature.units) || '';
}
function getTierByQuantity(tiers, quantity) {
  if (!tiers) return;
  var ascendingTiers = [].concat(tiers);
  ascendingTiers.sort(function (a, b) {
    return a.upTo - b.upTo;
  });

  for (var _iterator = _createForOfIteratorHelperLoose(ascendingTiers), _step; !(_step = _iterator()).done;) {
    var tier = _step.value;

    if (quantity <= tier.upTo) {
      return tier;
    }
  }

  return ascendingTiers[ascendingTiers.length - 1];
}
function calculateTierPrice(price, currentTier, selectedBillingPeriod, shouldShowMonthlyPriceAmount) {
  switch (price.tiersMode) {
    case TiersMode.Volume:
      var unitPrice = selectedBillingPeriod === BillingPeriod.Annually && shouldShowMonthlyPriceAmount ? currentTier.unitPrice.amount / 12 : currentTier.unitPrice.amount;
      return unitPrice * currentTier.upTo;
  }

  return 0;
}
function getSelectedTier(plan, billingPeriod, currentSubscription, selectedTierByFeature) {
  var planTierPrices = plan.pricePoints.filter(function (price) {
    return price.billingPeriod === billingPeriod && price.isTieredPrice;
  });

  if (planTierPrices.length == 1) {
    var price = planTierPrices[0];
    var featureId = price.feature.featureId;
    var currentTier = price.tiers[0];

    if (selectedTierByFeature[featureId]) {
      var _price$tiers;

      currentTier = ((_price$tiers = price.tiers) == null ? void 0 : _price$tiers.find(function (tier) {
        return tier.upTo === selectedTierByFeature[featureId].upTo;
      })) || currentTier;
    } else if (currentSubscription) {
      var tieredPrice = currentSubscription.prices.find(function (subscriptionPrice) {
        var _subscriptionPrice$fe;

        return subscriptionPrice.pricingModel == BillingModel.PerUnit && subscriptionPrice.tiersMode && ((_subscriptionPrice$fe = subscriptionPrice.feature) == null ? void 0 : _subscriptionPrice$fe.featureId) === featureId;
      });

      if (tieredPrice) {
        currentTier = getTierByQuantity(price.tiers, tieredPrice.feature.unitQuantity || 1);
      }
    }

    var result = {};
    result[featureId] = currentTier;
    return result;
  }

  return {};
}
var PriceTierComparison;

(function (PriceTierComparison) {
  PriceTierComparison[PriceTierComparison["Lower"] = -1] = "Lower";
  PriceTierComparison[PriceTierComparison["Equal"] = 0] = "Equal";
  PriceTierComparison[PriceTierComparison["Higher"] = 1] = "Higher";
})(PriceTierComparison || (PriceTierComparison = {}));

function compareSelectedTierToCurrentTier(selectedTierByFeature, currentSubscription) {
  if (!currentSubscription || !selectedTierByFeature) {
    return PriceTierComparison.Equal;
  }

  var currentTierPrice = currentSubscription.prices.find(function (price) {
    return price.pricingModel == BillingModel.PerUnit && price.tiersMode;
  });

  if (!currentTierPrice) {
    return PriceTierComparison.Equal;
  }

  var _currentTierPrice$fea = currentTierPrice.feature,
      featureId = _currentTierPrice$fea.featureId,
      unitQuantity = _currentTierPrice$fea.unitQuantity;

  if (!unitQuantity) {
    return PriceTierComparison.Equal;
  }

  var selectedTier = selectedTierByFeature[featureId];

  if (!selectedTier) {
    return PriceTierComparison.Equal;
  }

  if (selectedTier.upTo < unitQuantity) {
    return PriceTierComparison.Lower;
  }

  if (selectedTier.upTo > unitQuantity) {
    return PriceTierComparison.Higher;
  }

  return PriceTierComparison.Equal;
}

var _templateObject;

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var LoadingIndicator = /*#__PURE__*/_styled(ClipLoader, process.env.NODE_ENV === "production" ? {
  target: "e199qof96"
} : {
  target: "e199qof96",
  label: "LoadingIndicator"
})(process.env.NODE_ENV === "production" ? {
  name: "1a2afmv",
  styles: "margin-left:10px"
} : {
  name: "1a2afmv",
  styles: "margin-left:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var OfferingButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e199qof95"
} : {
  target: "e199qof95",
  label: "OfferingButton"
})("cursor:", function (_ref) {
  var $disabled = _ref.$disabled;
  return $disabled ? 'default' : 'pointer';
}, ";padding:8px 12px;background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.stigg.palette.backgroundButton;
}, ";border:", function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid " + theme.stigg.palette.outlinedRestingBorder;
}, ";border-radius:10px;display:flex;align-items:center;justify-content:center;min-height:42px;min-width:120px;", function (_ref4) {
  var $disabled = _ref4.$disabled;
  return $disabled && css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      opacity: 0.5;\n    "])));
}, " &:hover{background-color:", function (_ref5) {
  var theme = _ref5.theme,
      $disabled = _ref5.$disabled;
  return $disabled ? theme.stigg.palette.backgroundButton : theme.stigg.palette.outlinedHoverBackground;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var ButtonText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e199qof94"
} : {
  target: "e199qof94",
  label: "ButtonText"
})(process.env.NODE_ENV === "production" ? {
  name: "h05omw",
  styles: "margin:0;font-size:15px"
} : {
  name: "h05omw",
  styles: "margin:0;font-size:15px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var ScheduledUpdateText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e199qof93"
} : {
  target: "e199qof93",
  label: "ScheduledUpdateText"
})(process.env.NODE_ENV === "production" ? {
  name: "1cnls12",
  styles: "min-height:87px"
} : {
  name: "1cnls12",
  styles: "min-height:87px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var CancelScheduledUpdateButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e199qof92"
} : {
  target: "e199qof92",
  label: "CancelScheduledUpdateButton"
})("background:none;border:none;padding:0;color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.stigg.palette.text.secondary;
}, ";text-decoration:underline;cursor:pointer;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsYW5PZmZlcmluZ0J1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMENrRCIsImZpbGUiOiJQbGFuT2ZmZXJpbmdCdXR0b24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZVN0YXRlIH0gZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBQcmljaW5nVHlwZSB9IGZyb20gJ0BzdGlnZy9qcy1jbGllbnQtc2RrJztcclxuaW1wb3J0IHsgaXNGdW5jdGlvbiB9IGZyb20gJ2xvZGFzaCc7XHJcbmltcG9ydCBDbGlwTG9hZGVyIGZyb20gJ3JlYWN0LXNwaW5uZXJzL0NsaXBMb2FkZXInO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IGNzcywgdXNlVGhlbWUgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XHJcbmltcG9ydCB7IFN1YnNjcmliZUludGVudGlvblR5cGUgfSBmcm9tICcuL3R5cGVzJztcclxuaW1wb3J0IHsgZmxleExheW91dE1hcHBlciB9IGZyb20gJy4uLy4uL3RoZW1lL2dldFJlc29sdmVkVGhlbWUnO1xyXG5pbXBvcnQgeyBUeXBvZ3JhcGh5IH0gZnJvbSAnLi4vY29tbW9uL1R5cG9ncmFwaHknO1xyXG5pbXBvcnQgeyBnZXRTdWJzY3JpcHRpb25TY2hlZHVsZVVwZGF0ZVRleHRzIH0gZnJvbSAnLi4vdXRpbHMvZ2V0U3Vic2NyaXB0aW9uU2NoZWR1bGVVcGRhdGVUZXh0cyc7XHJcbmltcG9ydCB7IGNvbXBhcmVTZWxlY3RlZFRpZXJUb0N1cnJlbnRUaWVyLCBQcmljZVRpZXJDb21wYXJpc29uIH0gZnJvbSAnLi4vdXRpbHMvcHJpY2VUaWVyVXRpbHMnO1xyXG5jb25zdCBMb2FkaW5nSW5kaWNhdG9yID0gc3R5bGVkKENsaXBMb2FkZXIpIGBcbiAgbWFyZ2luLWxlZnQ6IDEwcHg7XG5gO1xyXG5jb25zdCBPZmZlcmluZ0J1dHRvbiA9IHN0eWxlZC5idXR0b24gYFxuICBjdXJzb3I6ICR7KHsgJGRpc2FibGVkIH0pID0+ICgkZGlzYWJsZWQgPyAnZGVmYXVsdCcgOiAncG9pbnRlcicpfTtcbiAgcGFkZGluZzogOHB4IDEycHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuc3RpZ2cucGFsZXR0ZS5iYWNrZ3JvdW5kQnV0dG9ufTtcbiAgYm9yZGVyOiAkeyh7IHRoZW1lIH0pID0+IGAxcHggc29saWQgJHt0aGVtZS5zdGlnZy5wYWxldHRlLm91dGxpbmVkUmVzdGluZ0JvcmRlcn1gfTtcbiAgYm9yZGVyLXJhZGl1czogMTBweDtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIG1pbi1oZWlnaHQ6IDQycHg7XG4gIG1pbi13aWR0aDogMTIwcHg7XG5cbiAgJHsoeyAkZGlzYWJsZWQgfSkgPT4gJGRpc2FibGVkICYmXHJcbiAgICBjc3MgYFxuICAgICAgb3BhY2l0eTogMC41O1xuICAgIGB9XG5cbiAgJjpob3ZlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSwgJGRpc2FibGVkIH0pID0+ICRkaXNhYmxlZCA/IHRoZW1lLnN0aWdnLnBhbGV0dGUuYmFja2dyb3VuZEJ1dHRvbiA6IHRoZW1lLnN0aWdnLnBhbGV0dGUub3V0bGluZWRIb3ZlckJhY2tncm91bmR9O1xuICB9XG5gO1xyXG5jb25zdCBCdXR0b25UZXh0ID0gc3R5bGVkKFR5cG9ncmFwaHkpIGBcbiAgbWFyZ2luOiAwO1xuICBmb250LXNpemU6IDE1cHg7XG5gO1xyXG5jb25zdCBTY2hlZHVsZWRVcGRhdGVUZXh0ID0gc3R5bGVkKFR5cG9ncmFwaHkpIGBcbiAgbWluLWhlaWdodDogODdweDtcbmA7XHJcbmNvbnN0IENhbmNlbFNjaGVkdWxlZFVwZGF0ZUJ1dHRvbiA9IHN0eWxlZC5idXR0b24gYFxuICBiYWNrZ3JvdW5kOiBub25lO1xuICBib3JkZXI6IG5vbmU7XG4gIHBhZGRpbmc6IDA7XG4gIGNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnN0aWdnLnBhbGV0dGUudGV4dC5zZWNvbmRhcnl9O1xuXG4gIHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuICBjdXJzb3I6IHBvaW50ZXI7XG5gO1xyXG5jb25zdCBUcmlhbERheXNMZWZ0ID0gc3R5bGVkKFR5cG9ncmFwaHkpIGBcbiAgbWFyZ2luLXRvcDogOHB4O1xuICBtYXJnaW4tYm90dG9tOiAxN3B4O1xuICBtaW4taGVpZ2h0OiAyMHB4O1xuYDtcclxuY29uc3QgQnV0dG9uTGF5b3V0ID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIG1hcmdpbi10b3A6IDRweDtcbiAgYWxpZ24tc2VsZjogJHsoeyB0aGVtZSB9KSA9PiBmbGV4TGF5b3V0TWFwcGVyKHRoZW1lLnN0aWdnLmxheW91dC5jdGFBbGlnbm1lbnQpfTtcbiAgd2lkdGg6IDEwMCU7XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gUGxhbk9mZmVyaW5nQnV0dG9uKHsgaXNOZXh0UGxhbiwgY3VzdG9tZXIsIHBsYW4sIGJpbGxpbmdQZXJpb2QsIGlzQ3VzdG9tZXJPblRyaWFsLCBvblBsYW5TZWxlY3RlZCwgcGF5d2FsbExvY2FsZSwgaGFzVGllcnNSb3csIHdpdGhUcmlhbExlZnRSb3csIGN1cnJlbnRTdWJzY3JpcHRpb24sIHNlbGVjdGVkVGllckJ5RmVhdHVyZSwgfSkge1xyXG4gICAgY29uc3QgdGhlbWUgPSB1c2VUaGVtZSgpO1xyXG4gICAgY29uc3QgW2lzTG9hZGluZywgc2V0SXNMb2FkaW5nXSA9IHVzZVN0YXRlKGZhbHNlKTtcclxuICAgIGNvbnN0IHsgY3VycmVudFBsYW4sIGN1c3RvbSwgZG93bmdyYWRlLCBzdGFydFRyaWFsLCB1cGdyYWRlLCBzdGFydE5ldywgc3dpdGNoVG9CaWxsaW5nUGVyaW9kLCBjYW5jZWxTY2hlZHVsZWRVcGRhdGUsIH0gPSBwYXl3YWxsTG9jYWxlLnBsYW5DVEFCdXR0b247XHJcbiAgICBjb25zdCByZXNvbHZlZERvd25ncmFkZSA9IGlzRnVuY3Rpb24oZG93bmdyYWRlKSA/IGRvd25ncmFkZShwbGFuKSA6IGRvd25ncmFkZTtcclxuICAgIGNvbnN0IHJlc29sdmVkVXBncmFkZSA9IGlzRnVuY3Rpb24odXBncmFkZSkgPyB1cGdyYWRlKHBsYW4pIDogdXBncmFkZTtcclxuICAgIGNvbnN0IGJ1dHRvblByb3BzID0ge1xyXG4gICAgICAgIHRpdGxlOiBjdXN0b21lciA/IChwbGFuLmlzTG93ZXJUaGFuQ3VycmVudFBsYW4gPyByZXNvbHZlZERvd25ncmFkZSA6IHJlc29sdmVkVXBncmFkZSkgOiBzdGFydE5ldyxcclxuICAgICAgICBkaXNhYmxlZDogZmFsc2UsXHJcbiAgICAgICAgaW50ZW50aW9uVHlwZTogcGxhbi5pc0xvd2VyVGhhbkN1cnJlbnRQbGFuXHJcbiAgICAgICAgICAgID8gU3Vic2NyaWJlSW50ZW50aW9uVHlwZS5ET1dOR1JBREVfUExBTlxyXG4gICAgICAgICAgICA6IGlzQ3VzdG9tZXJPblRyaWFsXHJcbiAgICAgICAgICAgICAgICA/IFN1YnNjcmliZUludGVudGlvblR5cGUuVVBHUkFERV9UUklBTF9UT19QQUlEXHJcbiAgICAgICAgICAgICAgICA6IFN1YnNjcmliZUludGVudGlvblR5cGUuVVBHUkFERV9QTEFOLFxyXG4gICAgfTtcclxuICAgIGNvbnN0IGlzQ3VzdG9tUHJpY2UgPSBwbGFuLnByaWNpbmdUeXBlID09PSBQcmljaW5nVHlwZS5DdXN0b207XHJcbiAgICBjb25zdCB7IGxpbmUxOiBzY2hlZHVsZWRVcGRhdGVUZXh0IH0gPSBnZXRTdWJzY3JpcHRpb25TY2hlZHVsZVVwZGF0ZVRleHRzKHtcclxuICAgICAgICBzY2hlZHVsZWRVcGRhdGU6IHBsYW4uc2NoZWR1bGVkVXBkYXRlLFxyXG4gICAgICAgIG9wdGlvbnM6IHsgd2l0aERhdGU6IHRydWUgfSxcclxuICAgIH0pO1xyXG4gICAgaWYgKHBsYW4uaXNUcmlhYmxlICYmICFwbGFuLmlzQ3VycmVudEN1c3RvbWVyUGxhbiAmJiAhaXNDdXN0b21lck9uVHJpYWwpIHtcclxuICAgICAgICBidXR0b25Qcm9wcy50aXRsZSA9IHN0YXJ0VHJpYWwocGxhbik7XHJcbiAgICAgICAgYnV0dG9uUHJvcHMuaW50ZW50aW9uVHlwZSA9IFN1YnNjcmliZUludGVudGlvblR5cGUuU1RBUlRfVFJJQUw7XHJcbiAgICB9XHJcbiAgICBlbHNlIGlmIChwbGFuLmlzQ3VycmVudEN1c3RvbWVyUGxhbiAmJiAhaXNDdXN0b21lck9uVHJpYWwpIHtcclxuICAgICAgICBjb25zdCBpc1NhbWVCaWxsaW5nUGVyaW9kID0gYmlsbGluZ1BlcmlvZCA9PT0gcGxhbi5jdXJyZW50Q3VzdG9tZXJQbGFuQmlsbGluZ1BlcmlvZDtcclxuICAgICAgICBpZiAoaXNTYW1lQmlsbGluZ1BlcmlvZCB8fFxyXG4gICAgICAgICAgICAocGxhbi5wcmljaW5nVHlwZSAmJiBbUHJpY2luZ1R5cGUuRnJlZSwgUHJpY2luZ1R5cGUuQ3VzdG9tXS5pbmNsdWRlcyhwbGFuLnByaWNpbmdUeXBlKSkpIHtcclxuICAgICAgICAgICAgY29uc3QgcGxhbkNvbXBhcmlzb24gPSBjb21wYXJlU2VsZWN0ZWRUaWVyVG9DdXJyZW50VGllcihzZWxlY3RlZFRpZXJCeUZlYXR1cmUsIGN1cnJlbnRTdWJzY3JpcHRpb24pO1xyXG4gICAgICAgICAgICBzd2l0Y2ggKHBsYW5Db21wYXJpc29uKSB7XHJcbiAgICAgICAgICAgICAgICBjYXNlIFByaWNlVGllckNvbXBhcmlzb24uTG93ZXI6XHJcbiAgICAgICAgICAgICAgICAgICAgYnV0dG9uUHJvcHMuaW50ZW50aW9uVHlwZSA9IFN1YnNjcmliZUludGVudGlvblR5cGUuQ0hBTkdFX1VOSVRfUVVBTlRJVFk7XHJcbiAgICAgICAgICAgICAgICAgICAgYnV0dG9uUHJvcHMudGl0bGUgPSByZXNvbHZlZERvd25ncmFkZTtcclxuICAgICAgICAgICAgICAgICAgICBicmVhaztcclxuICAgICAgICAgICAgICAgIGNhc2UgUHJpY2VUaWVyQ29tcGFyaXNvbi5IaWdoZXI6XHJcbiAgICAgICAgICAgICAgICAgICAgYnV0dG9uUHJvcHMuaW50ZW50aW9uVHlwZSA9IFN1YnNjcmliZUludGVudGlvblR5cGUuQ0hBTkdFX1VOSVRfUVVBTlRJVFk7XHJcbiAgICAgICAgICAgICAgICAgICAgYnV0dG9uUHJvcHMudGl0bGUgPSByZXNvbHZlZFVwZ3JhZGU7XHJcbiAgICAgICAgICAgICAgICAgICAgYnJlYWs7XHJcbiAgICAgICAgICAgICAgICBkZWZhdWx0OlxyXG4gICAgICAgICAgICAgICAgICAgIGJ1dHRvblByb3BzLnRpdGxlID0gY3VycmVudFBsYW47XHJcbiAgICAgICAgICAgICAgICAgICAgYnV0dG9uUHJvcHMuZGlzYWJsZWQgPSB0cnVlO1xyXG4gICAgICAgICAgICAgICAgICAgIGJyZWFrO1xyXG4gICAgICAgICAgICB9XHJcbiAgICAgICAgfVxyXG4gICAgICAgIGVsc2Uge1xyXG4gICAgICAgICAgICBidXR0b25Qcm9wcy50aXRsZSA9IHN3aXRjaFRvQmlsbGluZ1BlcmlvZChiaWxsaW5nUGVyaW9kKTtcclxuICAgICAgICAgICAgYnV0dG9uUHJvcHMuaW50ZW50aW9uVHlwZSA9IFN1YnNjcmliZUludGVudGlvblR5cGUuQ0hBTkdFX0JJTExJTkdfUEVSSU9EO1xyXG4gICAgICAgIH1cclxuICAgIH1cclxuICAgIGVsc2UgaWYgKGlzQ3VzdG9tUHJpY2UpIHtcclxuICAgICAgICBidXR0b25Qcm9wcy50aXRsZSA9IGN1c3RvbTtcclxuICAgICAgICBidXR0b25Qcm9wcy5pbnRlbnRpb25UeXBlID0gU3Vic2NyaWJlSW50ZW50aW9uVHlwZS5SRVFVRVNUX0NVU1RPTV9QTEFOX0FDQ0VTUztcclxuICAgIH1cclxuICAgIGlmIChpc05leHRQbGFuICYmIHBsYW4uc2NoZWR1bGVkVXBkYXRlKSB7XHJcbiAgICAgICAgYnV0dG9uUHJvcHMuZGlzYWJsZWQgPSBmYWxzZTtcclxuICAgICAgICBidXR0b25Qcm9wcy50aXRsZSA9IGNhbmNlbFNjaGVkdWxlZFVwZGF0ZTtcclxuICAgICAgICBidXR0b25Qcm9wcy5pbnRlbnRpb25UeXBlID0gU3Vic2NyaWJlSW50ZW50aW9uVHlwZS5DQU5DRUxfU0NIRURVTEVEX1VQREFURVM7XHJcbiAgICB9XHJcbiAgICBjb25zdCBpc0Rpc2FibGVkID0gaXNMb2FkaW5nIHx8IGJ1dHRvblByb3BzLmRpc2FibGVkO1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFJlYWN0LkZyYWdtZW50LCBudWxsLFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoQnV0dG9uTGF5b3V0LCB7IGNsYXNzTmFtZTogXCJzdGlnZy1wYXl3YWxsLXBsYW4tYnV0dG9uLWxheW91dFwiIH0sIGlzTmV4dFBsYW4gJiYgc2NoZWR1bGVkVXBkYXRlVGV4dCA/IChSZWFjdC5jcmVhdGVFbGVtZW50KFNjaGVkdWxlZFVwZGF0ZVRleHQsIHsgY29sb3I6IFwic2Vjb25kYXJ5XCIsIHZhcmlhbnQ6IFwiYm9keTFcIiwgY2xhc3NOYW1lOiBcInN0aWdnLXBheXdhbGwtc2NoZWR1bGUtdXBkYXRlLXRleHRcIiB9LFxyXG4gICAgICAgICAgICBzY2hlZHVsZWRVcGRhdGVUZXh0LFxyXG4gICAgICAgICAgICAnICcsXHJcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoQ2FuY2VsU2NoZWR1bGVkVXBkYXRlQnV0dG9uLCB7IGNvbG9yOiBcInNlY29uZGFyeVwiLCBvbkNsaWNrOiAoKSA9PiB7XHJcbiAgICAgICAgICAgICAgICAgICAgc2V0SXNMb2FkaW5nKHRydWUpO1xyXG4gICAgICAgICAgICAgICAgICAgIFByb21pc2UucmVzb2x2ZShvblBsYW5TZWxlY3RlZChidXR0b25Qcm9wcy5pbnRlbnRpb25UeXBlKSkuZmluYWxseSgoKSA9PiBzZXRJc0xvYWRpbmcoZmFsc2UpKTtcclxuICAgICAgICAgICAgICAgIH0gfSwgYnV0dG9uUHJvcHMudGl0bGUpKSkgOiAoUmVhY3QuY3JlYXRlRWxlbWVudChSZWFjdC5GcmFnbWVudCwgbnVsbCxcclxuICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChPZmZlcmluZ0J1dHRvbiwgeyBjbGFzc05hbWU6IFwic3RpZ2ctcGF5d2FsbC1wbGFuLWJ1dHRvblwiLCBcImRhdGEtdGVzdGlkXCI6IGBwYXl3YWxsLWNhcmQtY3RhLSR7cGxhbi5kaXNwbGF5TmFtZX1gLCBkaXNhYmxlZDogaXNEaXNhYmxlZCwgXCIkZGlzYWJsZWRcIjogaXNEaXNhYmxlZCwgb25DbGljazogKCkgPT4ge1xyXG4gICAgICAgICAgICAgICAgICAgIHNldElzTG9hZGluZyh0cnVlKTtcclxuICAgICAgICAgICAgICAgICAgICBQcm9taXNlLnJlc29sdmUob25QbGFuU2VsZWN0ZWQoYnV0dG9uUHJvcHMuaW50ZW50aW9uVHlwZSkpLmZpbmFsbHkoKCkgPT4gc2V0SXNMb2FkaW5nKGZhbHNlKSk7XHJcbiAgICAgICAgICAgICAgICB9IH0sXHJcbiAgICAgICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KEJ1dHRvblRleHQsIHsgY2xhc3NOYW1lOiBcInN0aWdnLXBheXdhbGwtcGxhbi1idXR0b24tdGV4dFwiLCB2YXJpYW50OiBcImg2XCIsIGNvbG9yOiBcInByaW1hcnkubWFpblwiIH0sIGJ1dHRvblByb3BzLnRpdGxlKSxcclxuICAgICAgICAgICAgICAgIGlzTG9hZGluZyAmJiBSZWFjdC5jcmVhdGVFbGVtZW50KExvYWRpbmdJbmRpY2F0b3IsIHsgY29sb3I6IHRoZW1lLnN0aWdnLnBhbGV0dGUudGV4dC5kaXNhYmxlZCwgbG9hZGluZzogdHJ1ZSwgc2l6ZTogMTYgfSkpLFxyXG4gICAgICAgICAgICBoYXNUaWVyc1JvdyAmJiAhd2l0aFRyaWFsTGVmdFJvdyA/IChSZWFjdC5jcmVhdGVFbGVtZW50KFwiZGl2XCIsIHsgc3R5bGU6IHsgaGVpZ2h0OiAnMjBweCcgfSB9KSkgOiAoUmVhY3QuY3JlYXRlRWxlbWVudChUcmlhbERheXNMZWZ0LCB7IGNsYXNzTmFtZTogXCJzdGlnZy10cmlhbC1kYXlzLWxlZnQtdGV4dFwiLCB2YXJpYW50OiBcImg2XCIsIGNvbG9yOiBcInNlY29uZGFyeVwiIH0sIHBsYW4uaXNDdXJyZW50Q3VzdG9tZXJQbGFuICYmIHBsYW4udHJpYWxEYXlzTGVmdCAmJiAoUmVhY3QuY3JlYXRlRWxlbWVudChSZWFjdC5GcmFnbWVudCwgbnVsbCxcclxuICAgICAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJiXCIsIG51bGwsXHJcbiAgICAgICAgICAgICAgICAgICAgcGxhbi50cmlhbERheXNMZWZ0LFxyXG4gICAgICAgICAgICAgICAgICAgIFwiIGRheXNcIiksXHJcbiAgICAgICAgICAgICAgICBcIiBsZWZ0IG9uIHlvdXIgZnJlZSB0cmlhbFwiKSkpKSkpKSkpO1xyXG59XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVBsYW5PZmZlcmluZ0J1dHRvbi5qcy5tYXAiXX0= */"));

var TrialDaysLeft = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e199qof91"
} : {
  target: "e199qof91",
  label: "TrialDaysLeft"
})(process.env.NODE_ENV === "production" ? {
  name: "1etgg0o",
  styles: "margin-top:8px;margin-bottom:17px;min-height:20px"
} : {
  name: "1etgg0o",
  styles: "margin-top:8px;margin-bottom:17px;min-height:20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});

var ButtonLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e199qof90"
} : {
  target: "e199qof90",
  label: "ButtonLayout"
})("display:flex;flex-direction:column;margin-top:4px;align-self:", function (_ref7) {
  var theme = _ref7.theme;
  return flexLayoutMapper(theme.stigg.layout.ctaAlignment);
}, ";width:100%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function PlanOfferingButton(_ref8) {
  var isNextPlan = _ref8.isNextPlan,
      customer = _ref8.customer,
      plan = _ref8.plan,
      billingPeriod = _ref8.billingPeriod,
      isCustomerOnTrial = _ref8.isCustomerOnTrial,
      onPlanSelected = _ref8.onPlanSelected,
      paywallLocale = _ref8.paywallLocale,
      hasTiersRow = _ref8.hasTiersRow,
      withTrialLeftRow = _ref8.withTrialLeftRow,
      currentSubscription = _ref8.currentSubscription,
      selectedTierByFeature = _ref8.selectedTierByFeature;
  var theme = useTheme();

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _paywallLocale$planCT = paywallLocale.planCTAButton,
      currentPlan = _paywallLocale$planCT.currentPlan,
      custom = _paywallLocale$planCT.custom,
      downgrade = _paywallLocale$planCT.downgrade,
      startTrial = _paywallLocale$planCT.startTrial,
      upgrade = _paywallLocale$planCT.upgrade,
      startNew = _paywallLocale$planCT.startNew,
      switchToBillingPeriod = _paywallLocale$planCT.switchToBillingPeriod,
      cancelScheduledUpdate = _paywallLocale$planCT.cancelScheduledUpdate;
  var resolvedDowngrade = isFunction(downgrade) ? downgrade(plan) : downgrade;
  var resolvedUpgrade = isFunction(upgrade) ? upgrade(plan) : upgrade;
  var buttonProps = {
    title: customer ? plan.isLowerThanCurrentPlan ? resolvedDowngrade : resolvedUpgrade : startNew,
    disabled: false,
    intentionType: plan.isLowerThanCurrentPlan ? SubscribeIntentionType.DOWNGRADE_PLAN : isCustomerOnTrial ? SubscribeIntentionType.UPGRADE_TRIAL_TO_PAID : SubscribeIntentionType.UPGRADE_PLAN
  };
  var isCustomPrice = plan.pricingType === PricingType.Custom;

  var _getSubscriptionSched = getSubscriptionScheduleUpdateTexts({
    scheduledUpdate: plan.scheduledUpdate,
    options: {
      withDate: true
    }
  }),
      scheduledUpdateText = _getSubscriptionSched.line1;

  if (plan.isTriable && !plan.isCurrentCustomerPlan && !isCustomerOnTrial) {
    buttonProps.title = startTrial(plan);
    buttonProps.intentionType = SubscribeIntentionType.START_TRIAL;
  } else if (plan.isCurrentCustomerPlan && !isCustomerOnTrial) {
    var isSameBillingPeriod = billingPeriod === plan.currentCustomerPlanBillingPeriod;

    if (isSameBillingPeriod || plan.pricingType && [PricingType.Free, PricingType.Custom].includes(plan.pricingType)) {
      var planComparison = compareSelectedTierToCurrentTier(selectedTierByFeature, currentSubscription);

      switch (planComparison) {
        case PriceTierComparison.Lower:
          buttonProps.intentionType = SubscribeIntentionType.CHANGE_UNIT_QUANTITY;
          buttonProps.title = resolvedDowngrade;
          break;

        case PriceTierComparison.Higher:
          buttonProps.intentionType = SubscribeIntentionType.CHANGE_UNIT_QUANTITY;
          buttonProps.title = resolvedUpgrade;
          break;

        default:
          buttonProps.title = currentPlan;
          buttonProps.disabled = true;
          break;
      }
    } else {
      buttonProps.title = switchToBillingPeriod(billingPeriod);
      buttonProps.intentionType = SubscribeIntentionType.CHANGE_BILLING_PERIOD;
    }
  } else if (isCustomPrice) {
    buttonProps.title = custom;
    buttonProps.intentionType = SubscribeIntentionType.REQUEST_CUSTOM_PLAN_ACCESS;
  }

  if (isNextPlan && plan.scheduledUpdate) {
    buttonProps.disabled = false;
    buttonProps.title = cancelScheduledUpdate;
    buttonProps.intentionType = SubscribeIntentionType.CANCEL_SCHEDULED_UPDATES;
  }

  var isDisabled = isLoading || buttonProps.disabled;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(ButtonLayout, {
    className: "stigg-paywall-plan-button-layout"
  }, isNextPlan && scheduledUpdateText ? React__default.createElement(ScheduledUpdateText, {
    color: "secondary",
    variant: "body1",
    className: "stigg-paywall-schedule-update-text"
  }, scheduledUpdateText, ' ', React__default.createElement(CancelScheduledUpdateButton, {
    color: "secondary",
    onClick: function onClick() {
      setIsLoading(true);
      Promise.resolve(onPlanSelected(buttonProps.intentionType))["finally"](function () {
        return setIsLoading(false);
      });
    }
  }, buttonProps.title)) : React__default.createElement(React__default.Fragment, null, React__default.createElement(OfferingButton, {
    className: "stigg-paywall-plan-button",
    "data-testid": "paywall-card-cta-" + plan.displayName,
    disabled: isDisabled,
    "$disabled": isDisabled,
    onClick: function onClick() {
      setIsLoading(true);
      Promise.resolve(onPlanSelected(buttonProps.intentionType))["finally"](function () {
        return setIsLoading(false);
      });
    }
  }, React__default.createElement(ButtonText, {
    className: "stigg-paywall-plan-button-text",
    variant: "h6",
    color: "primary.main"
  }, buttonProps.title), isLoading && React__default.createElement(LoadingIndicator, {
    color: theme.stigg.palette.text.disabled,
    loading: true,
    size: 16
  })), hasTiersRow && !withTrialLeftRow ? React__default.createElement("div", {
    style: {
      height: '20px'
    }
  }) : React__default.createElement(TrialDaysLeft, {
    className: "stigg-trial-days-left-text",
    variant: "h6",
    color: "secondary"
  }, plan.isCurrentCustomerPlan && plan.trialDaysLeft && React__default.createElement(React__default.Fragment, null, React__default.createElement("b", null, plan.trialDaysLeft, " days"), " left on your free trial")))));
}

var _path$1;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgMiniSchedule = function SvgMiniSchedule(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.954 1.034A1 1 0 0 1 6.3 2.287a5.666 5.666 0 1 0 7.367 5.406 1 1 0 0 1 2 0c0 .23-.01.458-.03.684.01.072.012.147.006.223l-.004.049a1 1 0 0 1-.078.312A7.668 7.668 0 1 1 5.7.38a1 1 0 0 1 1.254.654Zm.614.239A1 1 0 0 1 8.648.36l.05.004a1 1 0 1 1-.182 1.992l-.037-.003a1 1 0 0 1-.911-1.081Zm4.85 1.636a1 1 0 0 1 1.41.11l.064.076a1 1 0 1 1-1.537 1.28 4.154 4.154 0 0 0-.047-.056 1 1 0 0 1 .11-1.41ZM9 5.334a1 1 0 0 0-2 0V8a1 1 0 0 0 1 1h2.667a1 1 0 1 0 0-2H9V5.334Z",
    fill: "#7586B0"
  })));
};

var currencyPriceFormatter = function currencyPriceFormatter(_ref) {
  var amount = _ref.amount,
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? Currency.Usd : _ref$currency,
      locale = _ref.locale,
      _ref$maximumFractionD = _ref.maximumFractionDigits,
      maximumFractionDigits = _ref$maximumFractionD === void 0 ? 5 : _ref$maximumFractionD,
      _ref$minimumFractionD = _ref.minimumFractionDigits,
      minimumFractionDigits = _ref$minimumFractionD === void 0 ? 0 : _ref$minimumFractionD;
  var currencyString = currency.toString();
  var currencySymbol = getSymbolFromCurrency(currencyString);
  var formattedPrice = new Intl.NumberFormat(locale, _extends({
    maximumFractionDigits: maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits,
    style: 'currency',
    currency: currencyString
  }, currencySymbol ? {
    currencyDisplay: 'code'
  } : {})).format(amount || 0);

  if (currencySymbol) {
    formattedPrice = formattedPrice.replace(currencyString, currencySymbol);
  } // remove space between currency symbol and price


  formattedPrice = formattedPrice.replace(/\s/g, '');
  return formattedPrice;
};

function getPaidPriceText(_ref) {
  var planPrices = _ref.planPrices,
      paywallCalculatedPrice = _ref.paywallCalculatedPrice,
      selectedBillingPeriod = _ref.selectedBillingPeriod,
      locale = _ref.locale,
      shouldShowMonthlyPriceAmount = _ref.shouldShowMonthlyPriceAmount,
      selectedTierByFeature = _ref.selectedTierByFeature,
      paywallLocale = _ref.paywallLocale;

  var _ref2 = paywallCalculatedPrice || planPrices[0],
      amount = _ref2.amount,
      currency = _ref2.currency;

  var priceAmount = amount || 0;
  var isSinglePrice = planPrices.length === 1;
  var priceNumber = selectedBillingPeriod === BillingPeriod.Annually && shouldShowMonthlyPriceAmount ? priceAmount / 12 : priceAmount;
  var tiers;
  var tierUnits;
  var pricePeriod = paywallLocale.price.pricePeriod(shouldShowMonthlyPriceAmount ? BillingPeriod.Monthly : BillingPeriod.Annually);
  var unit = pricePeriod;

  for (var _iterator = _createForOfIteratorHelperLoose(planPrices), _step; !(_step = _iterator()).done;) {
    var _price = _step.value;

    if (_price.isTieredPrice) {
      var currentTier = _price.tiers[0];

      if (selectedTierByFeature[_price.feature.featureId]) {
        currentTier = selectedTierByFeature[_price.feature.featureId] || currentTier;
        tiers = _price.tiers;
        tierUnits = getPriceFeatureUnit(_price);
      }

      priceNumber += calculateTierPrice(_price, currentTier, selectedBillingPeriod, shouldShowMonthlyPriceAmount);
    }
  }

  if (isSinglePrice) {
    var _price$feature;

    var price = planPrices[0];
    var featureUnit = ((_price$feature = price.feature) == null ? void 0 : _price$feature.units) || '';

    if (price.pricingModel === BillingModel.PerUnit && !price.isTieredPrice) {
      unit = shouldShowMonthlyPriceAmount ? "per " + featureUnit + " " + pricePeriod : "per " + featureUnit + " " + pricePeriod;
    } else if (price.pricingModel === BillingModel.UsageBased) {
      unit = "per " + featureUnit;
    }
  }

  return {
    price: currencyPriceFormatter({
      amount: priceNumber,
      currency: currency,
      locale: locale
    }),
    unit: unit,
    tiers: tiers,
    tierUnits: tierUnits
  };
}

function getPlanPrice(plan, billingPeriod, paywallLocale, locale, shouldShowMonthlyPriceAmount, selectedTierByFeature) {
  switch (plan.pricingType) {
    case PricingType.Free:
      if (typeof paywallLocale.price.free === 'function') {
        return paywallLocale.price.free(plan.paywallCurrency);
      }

      return paywallLocale.price.free;

    case PricingType.Custom:
      return {
        price: paywallLocale.price.custom
      };

    case PricingType.Paid:
      {
        var _plan$paywallCalculat;

        var planPrices = plan.pricePoints.filter(function (pricePoint) {
          return pricePoint.billingPeriod === billingPeriod;
        });
        var paywallCalculatedPrice = (_plan$paywallCalculat = plan.paywallCalculatedPricePoints) == null ? void 0 : _plan$paywallCalculat.find(function (pricePoint) {
          return pricePoint.billingPeriod === billingPeriod;
        });

        if (!(planPrices != null && planPrices.length) && !paywallCalculatedPrice) {
          return {
            price: paywallLocale.price.priceNotSet
          };
        }

        var paidParams = {
          planPrices: planPrices,
          paywallCalculatedPrice: paywallCalculatedPrice,
          selectedBillingPeriod: billingPeriod,
          selectedTierByFeature: selectedTierByFeature || {}
        };
        return paywallLocale.price.paid ? paywallLocale.price.paid(_extends({}, paidParams, {
          plan: plan
        })) : getPaidPriceText(_extends({}, paidParams, {
          locale: locale,
          shouldShowMonthlyPriceAmount: shouldShowMonthlyPriceAmount,
          paywallLocale: paywallLocale
        }));
      }

    default:
      return {
        price: ''
      };
  }
}

var TierSelect = /*#__PURE__*/_styled(Select, process.env.NODE_ENV === "production" ? {
  target: "eeq8l4e1"
} : {
  target: "eeq8l4e1",
  label: "TierSelect"
})("border-radius:10px;min-height:42px;min-width:120px;&:hover .MuiOutlinedInput-notchedOutline{border-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.outlinedBorder;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var TierInput = /*#__PURE__*/_styled(OutlinedInput, process.env.NODE_ENV === "production" ? {
  target: "eeq8l4e0"
} : {
  target: "eeq8l4e0",
  label: "TierInput"
})("& .MuiInputBase-input{padding:10px 12px;}&.Mui-focused .MuiOutlinedInput-notchedOutline{border-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.stigg.palette.primary;
}, "!important;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function TiersSelectContainer(_ref3) {
  var componentId = _ref3.componentId,
      tiers = _ref3.tiers,
      tierUnits = _ref3.tierUnits,
      selectedTier = _ref3.selectedTier,
      handleTierChange = _ref3.handleTierChange;

  var handleChange = function handleChange(event, _) {
    if (!tiers) return;
    handleTierChange(getTierByQuantity(tiers, event.target.value));
  };

  return React__default.createElement(Typography, {
    className: "stigg-price-tier-select",
    style: {
      minHeight: '46px'
    }
  }, tiers ? React__default.createElement(TierSelect, {
    value: selectedTier ? selectedTier.upTo.toString() : tiers[0].upTo.toString(),
    fullWidth: true,
    onChange: handleChange,
    id: componentId,
    input: React__default.createElement(TierInput, null),
    MenuProps: {
      MenuListProps: {
        disablePadding: true
      },
      PaperProps: {
        sx: {
          marginTop: '4px',
          borderRadius: '10px'
        }
      }
    }
  }, map(tiers, function (tier) {
    return React__default.createElement(MenuItem, {
      className: "stigg-price-tier-menu-item-text",
      key: tier.upTo,
      value: tier.upTo.toString()
    }, React__default.createElement(Typography, {
      variant: "body1",
      color: "primary",
      style: {
        lineHeight: 'unset'
      }
    }, tier.upTo, " ", tierUnits));
  })) : React__default.createElement("div", null));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var EMPTY_CHAR = '‎';

var PlanPriceContainer = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e1gsqbi12"
} : {
  target: "e1gsqbi12",
  label: "PlanPriceContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "bfvx8c",
  styles: "word-break:break-word;width:100%"
} : {
  name: "bfvx8c",
  styles: "word-break:break-word;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var UnitSpan = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e1gsqbi11"
} : {
  target: "e1gsqbi11",
  label: "UnitSpan"
})(process.env.NODE_ENV === "production" ? {
  name: "1bmnxg7",
  styles: "white-space:nowrap"
} : {
  name: "1bmnxg7",
  styles: "white-space:nowrap",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

var PriceSpan = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e1gsqbi10"
} : {
  target: "e1gsqbi10",
  label: "PriceSpan"
})(process.env.NODE_ENV === "production" ? {
  name: "nurf5y",
  styles: "white-space:normal;min-height:39px"
} : {
  name: "nurf5y",
  styles: "white-space:normal;min-height:39px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});

function PriceBillingPeriod(_ref) {
  var plan = _ref.plan,
      billingPeriod = _ref.billingPeriod,
      hasMonthlyPrice = _ref.hasMonthlyPrice,
      hasAnnuallyPrice = _ref.hasAnnuallyPrice,
      paywallLocale = _ref.paywallLocale;
  var hasPrice = plan.pricePoints.find(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
  var content = EMPTY_CHAR;

  if (hasPrice && hasMonthlyPrice && hasAnnuallyPrice) {
    content = (paywallLocale.price.billingPeriod == null ? void 0 : paywallLocale.price.billingPeriod(billingPeriod)) || ", billed " + billingPeriod.toLowerCase();
  }

  return React__default.createElement(Typography, {
    span: true,
    className: "stigg-price-billing-period-text",
    variant: "h6",
    color: "secondary"
  }, content);
}

var PlanPrice = function PlanPrice(_ref2) {
  var showStartingAt = _ref2.showStartingAt,
      withUnitPriceRow = _ref2.withUnitPriceRow,
      withStartingAtRow = _ref2.withStartingAtRow,
      withTiersRow = _ref2.withTiersRow,
      selectedTierByFeature = _ref2.selectedTierByFeature,
      setSelectedTierByFeature = _ref2.setSelectedTierByFeature,
      plan = _ref2.plan,
      billingPeriod = _ref2.billingPeriod,
      paywallLocale = _ref2.paywallLocale,
      locale = _ref2.locale,
      hasMonthlyPrice = _ref2.hasMonthlyPrice,
      hasAnnuallyPrice = _ref2.hasAnnuallyPrice;

  var _getPlanPrice = getPlanPrice(plan, billingPeriod, paywallLocale, locale, hasMonthlyPrice, selectedTierByFeature),
      price = _getPlanPrice.price,
      unit = _getPlanPrice.unit,
      tiers = _getPlanPrice.tiers,
      tierUnits = _getPlanPrice.tierUnits; // We currently only support prices with one tier - so we select the first one


  var tieredPrice = plan.pricePoints.find(function (planPrice) {
    return planPrice.billingPeriod === billingPeriod && planPrice.isTieredPrice;
  });
  var featureId = tieredPrice ? tieredPrice.feature.featureId : undefined;
  var selectedTier = featureId ? selectedTierByFeature[featureId] : undefined;

  var handleTierChange = function handleTierChange(tier) {
    if (!featureId) {
      return;
    }

    setSelectedTierByFeature(function (prevState) {
      var _extends2;

      return _extends({}, prevState, (_extends2 = {}, _extends2[featureId] = tier, _extends2));
    });
  };

  return React__default.createElement(PlanPriceContainer, {
    className: "stigg-price-text"
  }, React__default.createElement(React__default.Fragment, null, withStartingAtRow && React__default.createElement(Typography, {
    style: {
      minHeight: '20px'
    },
    className: "stigg-starting-at-text",
    variant: "body1",
    color: "secondary"
  }, showStartingAt ? paywallLocale.price.startingAtCaption : EMPTY_CHAR), React__default.createElement(PriceSpan, {
    variant: "h1"
  }, price), withUnitPriceRow && React__default.createElement(Typography, {
    className: "stigg-price-unit-and-billing-period-text",
    style: {
      minHeight: '48px'
    }
  }, React__default.createElement(UnitSpan, {
    span: true,
    variant: "h6",
    color: "secondary"
  }, unit), React__default.createElement(PriceBillingPeriod, {
    plan: plan,
    billingPeriod: billingPeriod,
    hasAnnuallyPrice: hasAnnuallyPrice,
    hasMonthlyPrice: hasMonthlyPrice,
    paywallLocale: paywallLocale
  })), withTiersRow ? React__default.createElement(TiersSelectContainer, {
    componentId: plan.id + "_" + featureId + "_tier",
    tiers: tiers,
    tierUnits: tierUnits,
    selectedTier: selectedTier,
    handleTierChange: handleTierChange
  }) : null));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PlanOfferingContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eacdu8d8"
} : {
  target: "eacdu8d8",
  label: "PlanOfferingContainer"
})("position:relative;background-color:", function (_ref) {
  var theme = _ref.theme,
      $isCurrentPlan = _ref.$isCurrentPlan;
  return $isCurrentPlan ? theme.stigg.palette.backgroundHighlight : theme.stigg.palette.backgroundPaper;
}, ";border:", function (_ref2) {
  var theme = _ref2.theme,
      $isHighlighted = _ref2.$isHighlighted;
  return $isHighlighted ? "3px solid " + theme.stigg.palette.primary : "1px solid " + theme.stigg.palette.outlinedBorder;
}, ";border-radius:10px;padding:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.stigg.layout.planPadding;
}, ";display:flex;min-width:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.stigg.layout.planMinWidth;
}, ";max-width:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.stigg.layout.planMaxWidth;
}, ";flex-direction:column;align-items:flex-start;justify-content:flex-start;position:relative;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var PlanHeader = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "eacdu8d7"
} : {
  target: "eacdu8d7",
  label: "PlanHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "mpkj0c",
  styles: "padding-bottom:8px"
} : {
  name: "mpkj0c",
  styles: "padding-bottom:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});

var Divider = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eacdu8d6"
} : {
  target: "eacdu8d6",
  label: "Divider"
})("height:2px;width:100%;background-color:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.stigg.palette.outlinedBorder;
}, ";margin-bottom:40px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var PlanDescription = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "eacdu8d5"
} : {
  target: "eacdu8d5",
  label: "PlanDescription"
})("text-align:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.stigg.layout.descriptionAlignment;
}, ";min-height:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.stigg.layout.descriptionMinHeight;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var HighlightBadge = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eacdu8d4"
} : {
  target: "eacdu8d4",
  label: "HighlightBadge"
})("background-color:", function (_ref9) {
  var theme = _ref9.theme;
  return theme.stigg.palette.primary;
}, ";border-radius:40px;position:absolute;top:-12px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var HighlightText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "eacdu8d3"
} : {
  target: "eacdu8d3",
  label: "HighlightText"
})(process.env.NODE_ENV === "production" ? {
  name: "a8c38r",
  styles: "margin:0;padding:2px 8px"
} : {
  name: "a8c38r",
  styles: "margin:0;padding:2px 8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});

var HeaderWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eacdu8d2"
} : {
  target: "eacdu8d2",
  label: "HeaderWrapper"
})("width:100%;display:flex;flex-direction:column;align-items:", function (_ref10) {
  var theme = _ref10.theme;
  return flexLayoutMapper(theme.stigg.layout.headerAlignment);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var NextPlanTagContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eacdu8d1"
} : {
  target: "eacdu8d1",
  label: "NextPlanTagContainer"
})("position:absolute;top:0;background-color:", function (_ref11) {
  var theme = _ref11.theme;
  return theme.stigg.palette.outlinedBorder;
}, ";border-radius:0px 0px 10px 10px;padding:3px 12px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var StyledMiniSchedule = /*#__PURE__*/_styled(SvgMiniSchedule, process.env.NODE_ENV === "production" ? {
  target: "eacdu8d0"
} : {
  target: "eacdu8d0",
  label: "StyledMiniSchedule"
})("display:flex;height:100%;margin-right:4px;path{fill:", function (_ref12) {
  var theme = _ref12.theme;
  return theme.stigg.palette.text.primary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function UpcomingChangeTag(_ref13) {
  var _ref13$text = _ref13.text,
      text = _ref13$text === void 0 ? 'Next' : _ref13$text,
      iconsColor = _ref13.iconsColor;
  return React__default.createElement(NextPlanTagContainer, null, React__default.createElement(Grid, {
    display: "flex",
    alignItems: "center",
    gap: 1
  }, React__default.createElement(StyledMiniSchedule, {
    "$iconsColor": iconsColor
  }), React__default.createElement(Typography, {
    color: "primary",
    variant: "body1"
  }, text)));
}

function PlanOffering(_ref14) {
  var _plan$paywallCalculat;

  var withUnitPriceRow = _ref14.withUnitPriceRow,
      withTiersRow = _ref14.withTiersRow,
      withTrialLeftRow = _ref14.withTrialLeftRow,
      customer = _ref14.customer,
      plan = _ref14.plan,
      billingPeriod = _ref14.billingPeriod,
      isHighlighted = _ref14.isHighlighted,
      currentSubscription = _ref14.currentSubscription,
      shouldShowDescriptionSection = _ref14.shouldShowDescriptionSection,
      hasMonthlyPrice = _ref14.hasMonthlyPrice,
      hasAnnuallyPrice = _ref14.hasAnnuallyPrice,
      isCustomerOnTrial = _ref14.isCustomerOnTrial,
      onPlanSelected = _ref14.onPlanSelected,
      paywallLocale = _ref14.paywallLocale,
      locale = _ref14.locale,
      withStartingAtRow = _ref14.withStartingAtRow;
  var isNextPlan = plan.isNextPlan && plan.isNextPlan(billingPeriod);
  var planPrices = plan.pricePoints.filter(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
  var paywallCalculatedPrice = (_plan$paywallCalculat = plan.paywallCalculatedPricePoints) == null ? void 0 : _plan$paywallCalculat.find(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
  var showStartingAt = planPrices.length > 1 && !!(paywallCalculatedPrice != null && paywallCalculatedPrice.additionalChargesMayApply);
  var planBadge = null;

  if (isNextPlan) {
    planBadge = React__default.createElement(UpcomingChangeTag, {
      text: "Next plan"
    });
  } else if (isHighlighted && paywallLocale.highlightChip) {
    planBadge = React__default.createElement(HighlightBadge, {
      className: "stigg-highlight-badge"
    }, React__default.createElement(HighlightText, {
      className: "stigg-highlight-badge-text",
      color: "white",
      bold: true
    }, paywallLocale.highlightChip));
  }

  var _React$useState = React__default.useState(getSelectedTier(plan, billingPeriod, currentSubscription, {})),
      selectedTierByFeature = _React$useState[0],
      setSelectedTierByFeature = _React$useState[1];

  useEffect(function () {
    setSelectedTierByFeature(getSelectedTier(plan, billingPeriod, currentSubscription, selectedTierByFeature));
  }, [billingPeriod]);

  var onPlanButtonClick = function onPlanButtonClick(intentionType) {
    var billableFeatures = Object.keys(selectedTierByFeature).map(function (featureId) {
      return {
        featureId: featureId,
        quantity: selectedTierByFeature[featureId].upTo
      };
    });
    return onPlanSelected(intentionType, billableFeatures);
  };

  return React__default.createElement(PlanOfferingContainer, {
    className: classNames('stigg-plan-offering-container', {
      'stigg-current-plan': plan.isCurrentCustomerPlan
    }),
    "$isHighlighted": isHighlighted,
    "$isCurrentPlan": plan.isCurrentCustomerPlan
  }, planBadge, React__default.createElement(HeaderWrapper, {
    className: "stigg-header-wrapper"
  }, React__default.createElement(PlanHeader, {
    className: "stigg-plan-header",
    variant: "h3"
  }, plan.displayName), shouldShowDescriptionSection && React__default.createElement(PlanDescription, {
    className: "stigg-plan-description",
    variant: "h6",
    color: "secondary"
  }, plan.description), React__default.createElement(PlanPrice, {
    showStartingAt: showStartingAt,
    withUnitPriceRow: withUnitPriceRow,
    withStartingAtRow: withStartingAtRow,
    withTiersRow: withTiersRow,
    selectedTierByFeature: selectedTierByFeature,
    setSelectedTierByFeature: setSelectedTierByFeature,
    plan: plan,
    billingPeriod: billingPeriod,
    paywallLocale: paywallLocale,
    locale: locale,
    hasAnnuallyPrice: hasAnnuallyPrice,
    hasMonthlyPrice: hasMonthlyPrice
  }), React__default.createElement(PlanOfferingButton, {
    isNextPlan: isNextPlan,
    customer: customer,
    plan: plan,
    currentSubscription: currentSubscription,
    billingPeriod: billingPeriod,
    isCustomerOnTrial: isCustomerOnTrial,
    onPlanSelected: onPlanButtonClick,
    paywallLocale: paywallLocale,
    hasTiersRow: withTiersRow,
    withTrialLeftRow: withTrialLeftRow,
    selectedTierByFeature: selectedTierByFeature
  }), React__default.createElement(Divider, {
    className: "stigg-plan-header-divider"
  })), React__default.createElement(PlanEntitlements, {
    plan: plan,
    billingPeriod: billingPeriod,
    paywallLocale: paywallLocale
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PickerContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "esqa6i42"
} : {
  target: "esqa6i42",
  label: "PickerContainer"
})("height:40px;padding:0 20px;margin-bottom:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.layout.switchBottomSpacing;
}, ";border-radius:10px;border:", function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid " + theme.stigg.palette.outlinedBorder;
}, ";background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.stigg.palette.backgroundPaper;
}, ";display:flex;align-items:center;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var PeriodText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "esqa6i41"
} : {
  target: "esqa6i41",
  label: "PeriodText"
})(process.env.NODE_ENV === "production" ? {
  name: "zvmrfm",
  styles: "margin:0 8px"
} : {
  name: "zvmrfm",
  styles: "margin:0 8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});

var StyledSwitch = /*#__PURE__*/_styled(Switch, process.env.NODE_ENV === "production" ? {
  target: "esqa6i40"
} : {
  target: "esqa6i40",
  label: "StyledSwitch"
})("& .react-switch-bg{border:", function (_ref4) {
  var theme = _ref4.theme;
  return "1px solid " + theme.stigg.palette.switchBorder;
}, ";background:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.stigg.palette.switchFill;
}, "!important;}& .react-switch-handle{box-shadow:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.stigg.shadows.light;
}, ";background:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.stigg.palette.switchHandle;
}, "!important;top:0.5px!important;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function DiscountRate(_ref8) {
  var discount = _ref8.discount,
      disabled = _ref8.disabled;
  return React__default.createElement(Typography, {
    variant: "h6",
    color: disabled ? 'disabled' : 'primary',
    className: "stigg-discount-rate-text"
  }, discount, "% off");
}

function BillingPeriodPicker(_ref9) {
  var discountRate = _ref9.discountRate,
      selectedBillingPeriod = _ref9.selectedBillingPeriod,
      onBillingPeriodChanged = _ref9.onBillingPeriodChanged,
      availableBillingPeriods = _ref9.availableBillingPeriods;

  if (availableBillingPeriods.length <= 1) {
    return null;
  }

  var isMonthlyBillingPeriod = selectedBillingPeriod === BillingPeriod.Monthly;
  return React__default.createElement(PickerContainer, {
    className: "stigg-period-picker-container"
  }, React__default.createElement(PeriodText, {
    variant: "h6",
    className: "stigg-monthly-period-text",
    color: isMonthlyBillingPeriod ? 'primary' : 'disabled'
  }, "Monthly"), React__default.createElement(StyledSwitch, {
    className: "stigg-period-switch",
    uncheckedIcon: false,
    checkedIcon: false,
    height: 16,
    width: 33,
    onChange: function onChange(isAnnuallySelected) {
      return onBillingPeriodChanged(isAnnuallySelected ? BillingPeriod.Annually : BillingPeriod.Monthly);
    },
    checked: !isMonthlyBillingPeriod,
    borderRadius: 10,
    handleDiameter: 19
  }), React__default.createElement(PeriodText, {
    variant: "h6",
    className: "stigg-annual-period-text",
    color: !isMonthlyBillingPeriod ? 'primary' : 'disabled'
  }, "Annual"), discountRate !== 0 && React__default.createElement(DiscountRate, {
    discount: discountRate,
    disabled: isMonthlyBillingPeriod
  }));
}

function calculateDiscountRate(monthlyPrice, annuallyPrice) {
  if (!isNil(monthlyPrice) && !isNil(annuallyPrice)) {
    var annuallyPerMonthPrice = annuallyPrice / 12;
    return Math.round((monthlyPrice - annuallyPerMonthPrice) / monthlyPrice * 100);
  }

  return null;
}

function getPlanBillingPeriodAmount(plan, billingPeriod) {
  var _plan$paywallCalculat, _pricePoint, _pricePoint2;

  var pricePoint;
  pricePoint = (_plan$paywallCalculat = plan.paywallCalculatedPricePoints) == null ? void 0 : _plan$paywallCalculat.find(function (price) {
    return price.billingPeriod === billingPeriod;
  });

  if (!pricePoint) {
    pricePoint = plan.pricePoints.find(function (price) {
      return price.billingPeriod === billingPeriod;
    });
  }

  if (!((_pricePoint = pricePoint) != null && _pricePoint.amount)) {
    var tieredPrice = plan.pricePoints.find(function (price) {
      return price.isTieredPrice && price.billingPeriod === billingPeriod;
    });

    if (tieredPrice) {
      return tieredPrice.tiers[0].unitPrice.amount;
    }
  }

  return (_pricePoint2 = pricePoint) == null ? void 0 : _pricePoint2.amount;
}

function calculatePaywallDiscountRate(plans) {
  return plans.reduce(function (maxDiscount, plan) {
    var monthlyAmount = getPlanBillingPeriodAmount(plan, BillingPeriod.Monthly);
    var annuallyAmount = getPlanBillingPeriodAmount(plan, BillingPeriod.Annually);
    var discountRate = calculateDiscountRate(monthlyAmount, annuallyAmount);

    if (discountRate) {
      maxDiscount = Math.max(maxDiscount, discountRate);
    }

    return maxDiscount;
  }, 0);
}

var _path$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgPoweredByStigg = function SvgPoweredByStigg(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: 135,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    d: "M.099 3.43v9.558h1.057V9.527h2.81c1.983 0 3.323-1.275 3.323-3.049 0-1.773-1.34-3.048-3.324-3.048H.1Zm1.057 5.127v-4.15h2.889c1.289 0 2.143.855 2.143 2.071 0 1.217-.854 2.079-2.143 2.079h-2.89ZM11.779 13.162c2.129 0 3.873-1.622 3.873-3.78 0-2.165-1.715-3.758-3.844-3.758-2.158 0-3.874 1.622-3.874 3.787 0 2.158 1.687 3.75 3.845 3.75Zm.014-.934c-1.556 0-2.773-1.202-2.773-2.832 0-1.629 1.216-2.83 2.773-2.83 1.528 0 2.773 1.201 2.773 2.83 0 1.63-1.245 2.832-2.773 2.832ZM19.905 12.988l1.572-6.046h.029l1.556 6.046h1.34l2.194-7.183h-1.18l-1.622 6.104h-.03l-1.549-6.104h-1.433l-1.55 6.104h-.029l-1.65-6.104h-1.195l2.208 7.183h1.34ZM34.983 9.425c0-2.121-1.578-3.8-3.83-3.8-2.1 0-3.845 1.556-3.845 3.786 0 2.143 1.6 3.75 3.874 3.75 1.586 0 2.875-.767 3.497-1.969l-.897-.485c-.413.898-1.412 1.528-2.585 1.528-1.673 0-2.694-1.246-2.795-2.513h6.567c.014-.13.014-.18.014-.297ZM31.14 6.551c1.404 0 2.527.948 2.715 2.259h-5.423a2.745 2.745 0 0 1 2.708-2.26ZM39.592 5.682c-1.028 0-1.774.521-2.1 1.253l-.101-1.13h-.905v7.183h1.057V8.564c0-1.115.615-1.789 1.774-1.789h.68V5.682h-.405ZM48.249 9.425c0-2.121-1.579-3.8-3.83-3.8-2.1 0-3.845 1.556-3.845 3.786 0 2.143 1.6 3.75 3.873 3.75 1.586 0 2.875-.767 3.497-1.969l-.897-.485c-.413.898-1.412 1.528-2.585 1.528-1.673 0-2.694-1.246-2.795-2.513h6.567c.015-.13.015-.18.015-.297Zm-3.845-2.874c1.404 0 2.527.948 2.715 2.259h-5.423a2.745 2.745 0 0 1 2.708-2.26ZM55.846 7.029c-.63-.89-1.644-1.398-2.831-1.398-2.093 0-3.773 1.586-3.773 3.765 0 2.18 1.651 3.766 3.744 3.766 1.195 0 2.23-.522 2.867-1.42l.145 1.246h.905V2.56l-1.057.116V7.03Zm-2.817 5.199c-1.498 0-2.7-1.188-2.7-2.832 0-1.643 1.202-2.83 2.7-2.83a2.787 2.787 0 0 1 2.817 2.83 2.787 2.787 0 0 1-2.817 2.832ZM65.731 5.631c-1.194 0-2.222.514-2.86 1.412V2.561l-1.057.116v10.31h.905l.145-1.237c.63.898 1.644 1.412 2.838 1.412 2.093 0 3.773-1.586 3.773-3.766 0-2.179-1.651-3.765-3.744-3.765Zm-.043 6.597a2.787 2.787 0 0 1-2.817-2.832 2.787 2.787 0 0 1 2.817-2.83c1.499 0 2.7 1.187 2.7 2.83 0 1.644-1.201 2.832-2.7 2.832ZM76.219 5.805v4.113c0 1.412-.905 2.266-2.172 2.266-1.26 0-1.97-.738-1.97-2.07V5.804H71.02v4.468c0 1.694 1.115 2.824 2.744 2.824 1.079 0 1.926-.42 2.455-1.116v.913c0 1.267-.956 2.186-2.346 2.186-1.123 0-2.05-.6-2.288-1.65l-.927.477C71.1 15.16 72.308 16 73.858 16c1.955 0 3.418-1.405 3.418-3.208V5.805h-1.057ZM108.672 10.487c0 1.42-1.261 2.3-3.181 2.3-1.027 0-1.857-.184-2.651-.578.074-.449.142-.99.16-1.618.738.43 1.575.64 2.381.64.959 0 1.458-.221 1.458-.689.018-.461-.339-.67-1.772-.947-1.661-.332-2.399-1.021-2.399-2.24 0-1.377 1.261-2.27 3.18-2.27.849 0 1.692.16 2.338.437l-.32 1.544a4.803 4.803 0 0 0-2.018-.43c-.898 0-1.341.221-1.341.658 0 .381.308.541 1.71.83 1.79.382 2.461 1.07 2.461 2.35l-.006.013Zm4.207.609c-.719 0-1.298-.382-1.298-1.39V6.887h1.827l.339-1.63h-2.166v-2.32a9.976 9.976 0 0 1-1.9.345l-.019 6.748c0 1.84 1.101 2.769 2.75 2.769.375 0 .701-.037.978-.105l.363-1.729c-.228.08-.517.136-.874.136v-.006Zm2.086 1.593h1.919V5.258h-1.919v7.43Zm.965-10.47c-.621-.006-1.101.45-1.107 1.052 0 .621.455 1.089 1.071 1.095.621 0 1.082-.437 1.095-1.04.012-.62-.443-1.095-1.052-1.107h-.007Zm10.126 3.039v6.268c0 2.369-1.6 3.999-4.3 3.999-.972 0-2.042-.216-2.762-.628.498-.51.837-.953 1.052-1.273.486.166.996.252 1.519.252 1.71 0 2.578-.947 2.578-2.14v-.24c-.609.7-1.489 1.138-2.541 1.138-2.018 0-3.537-1.501-3.537-3.728 0-2.227 1.661-3.808 3.691-3.808 1.052 0 1.968.381 2.577 1.101l.062-.947h1.667l-.006.006Zm-1.901 3.648c0-1.181-.861-2.08-2.048-2.08-1.188 0-2.061.899-2.061 2.08 0 1.18.861 2.048 2.061 2.048 1.199 0 2.048-.898 2.048-2.048Zm10.839-3.648v6.268c0 2.369-1.6 3.999-4.3 3.999-.972 0-2.042-.216-2.762-.628.498-.51.837-.953 1.052-1.273.486.166.996.252 1.519.252 1.71 0 2.578-.947 2.578-2.14v-.24c-.609.7-1.489 1.138-2.541 1.138-2.017 0-3.537-1.501-3.537-3.728 0-2.227 1.661-3.808 3.691-3.808 1.052 0 1.968.381 2.577 1.101l.062-.947H135l-.006.006Zm-1.901 3.648c0-1.181-.861-2.08-2.048-2.08-1.188 0-2.061.899-2.061 2.08 0 1.18.861 2.048 2.061 2.048 1.199 0 2.048-.898 2.048-2.048ZM95.71 14.982c-.075.037-1.483.659-3.975.542A14.827 14.827 0 0 1 88.512 15l4.312-5.007c.77.197 1.76.381 2.885.436 2.492.123 3.9-.504 3.974-.541l-3.974 5.1v-.007Zm-6.441-9.62c-.708-2.393-.431-3.907-.413-3.987l-4.01 5.07c-.013.08-.29 1.592.412 3.985a14.98 14.98 0 0 0 1.273 3.008l3.845-5.37a15.042 15.042 0 0 1-1.107-2.7v-.006Zm9.996.529a14.561 14.561 0 0 0-1.815-3.882l-3.568 4.546.67 3.217c.4.056.794.092 1.194.117.203.006.406.012.603.012 1.931 0 3.008-.455 3.125-.51l.277-.123c.024-.665-.019-1.84-.48-3.384l-.006.007Zm-2.24-4.208A14.43 14.43 0 0 0 92.83.834c-1.605-.08-2.756.154-3.395.338l-.056.296c-.012.061-.258 1.494.4 3.74.11.381.246.756.394 1.132l3.285-.111 3.574-4.54-.006-.006Z",
    fill: "#001E6C"
  })));
};

var STIGG_WATERMARK_CLASSNAME = 'stigg-watermark';

var PoweredByStiggThemedSvg = /*#__PURE__*/_styled(SvgPoweredByStigg, process.env.NODE_ENV === "production" ? {
  target: "ee5i8qp1"
} : {
  target: "ee5i8qp1",
  label: "PoweredByStiggThemedSvg"
})("*{fill:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.text.secondary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBvd2VyZWRCeVN0aWdnLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJMEQiLCJmaWxlIjoiUG93ZXJlZEJ5U3RpZ2cudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IFBvd2VyZWRCeVN0aWdnU3ZnIGZyb20gJy4uLy4uL2Fzc2V0cy9wb3dlcmVkLWJ5LXN0aWdnLnN2Zyc7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuZXhwb3J0IGNvbnN0IFNUSUdHX1dBVEVSTUFSS19DTEFTU05BTUUgPSAnc3RpZ2ctd2F0ZXJtYXJrJztcclxuY29uc3QgUG93ZXJlZEJ5U3RpZ2dUaGVtZWRTdmcgPSBzdHlsZWQoUG93ZXJlZEJ5U3RpZ2dTdmcpIGBcbiAgKiB7XG4gICAgZmlsbDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLnRleHQuc2Vjb25kYXJ5fTtcbiAgfVxuYDtcclxuY29uc3QgU3R5bGVkUG93ZXJlZEJ5U3RpZ2cgPSBzdHlsZWQuZGl2IGBcbiAgYWxpZ24tc2VsZjogJHsoeyAkYWxpZ25TZWxmIH0pID0+ICRhbGlnblNlbGYgfHwgJ3Vuc2V0J307XG5cbiAgQG1lZGlhIChtYXgtd2lkdGg6IDEwNDBweCkge1xuICAgIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAgfVxuYDtcclxuZXhwb3J0IGZ1bmN0aW9uIFBvd2VyZWRCeVN0aWdnKHsgc291cmNlLCBzaG93V2F0ZXJtYXJrLCBhbGlnbiwgc3R5bGUgPSB7fSB9KSB7XHJcbiAgICBpZiAoIXNob3dXYXRlcm1hcmspIHtcclxuICAgICAgICByZXR1cm4gbnVsbDtcclxuICAgIH1cclxuICAgIGNvbnN0IG9uV2F0ZXJtYXJrQ2xpY2sgPSAoKSA9PiB7XHJcbiAgICAgICAgY29uc3Qgc291cmNlRG9tYWluID0gd2luZG93LmxvY2F0aW9uLmhvc3RuYW1lLnJlcGxhY2UoJ3d3dy4nLCAnJyk7XHJcbiAgICAgICAgd2luZG93Lm9wZW4oYGh0dHBzOi8vd3d3LnN0aWdnLmlvLz91dG1fc291cmNlPSR7c291cmNlRG9tYWlufSZ1dG1fbWVkaXVtPXJlZmVycmFsJnV0bV9jYW1wYWlnbj0ke3NvdXJjZX1gLCAnX2JsYW5rJyk7XHJcbiAgICB9O1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZFBvd2VyZWRCeVN0aWdnLCB7IFwiJGFsaWduU2VsZlwiOiBhbGlnbiwgY2xhc3NOYW1lOiBTVElHR19XQVRFUk1BUktfQ0xBU1NOQU1FLCBzdHlsZTogeyBjdXJzb3I6ICdwb2ludGVyJywgLi4uc3R5bGUgfSwgb25DbGljazogb25XYXRlcm1hcmtDbGljayB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUG93ZXJlZEJ5U3RpZ2dUaGVtZWRTdmcsIG51bGwpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9UG93ZXJlZEJ5U3RpZ2cuanMubWFwIl19 */"));

var StyledPoweredByStigg = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ee5i8qp0"
} : {
  target: "ee5i8qp0",
  label: "StyledPoweredByStigg"
})("align-self:", function (_ref2) {
  var $alignSelf = _ref2.$alignSelf;
  return $alignSelf || 'unset';
}, ";@media (max-width: 1040px){align-self:center;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBvd2VyZWRCeVN0aWdnLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTd0MiLCJmaWxlIjoiUG93ZXJlZEJ5U3RpZ2cudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IFBvd2VyZWRCeVN0aWdnU3ZnIGZyb20gJy4uLy4uL2Fzc2V0cy9wb3dlcmVkLWJ5LXN0aWdnLnN2Zyc7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuZXhwb3J0IGNvbnN0IFNUSUdHX1dBVEVSTUFSS19DTEFTU05BTUUgPSAnc3RpZ2ctd2F0ZXJtYXJrJztcclxuY29uc3QgUG93ZXJlZEJ5U3RpZ2dUaGVtZWRTdmcgPSBzdHlsZWQoUG93ZXJlZEJ5U3RpZ2dTdmcpIGBcbiAgKiB7XG4gICAgZmlsbDogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLnRleHQuc2Vjb25kYXJ5fTtcbiAgfVxuYDtcclxuY29uc3QgU3R5bGVkUG93ZXJlZEJ5U3RpZ2cgPSBzdHlsZWQuZGl2IGBcbiAgYWxpZ24tc2VsZjogJHsoeyAkYWxpZ25TZWxmIH0pID0+ICRhbGlnblNlbGYgfHwgJ3Vuc2V0J307XG5cbiAgQG1lZGlhIChtYXgtd2lkdGg6IDEwNDBweCkge1xuICAgIGFsaWduLXNlbGY6IGNlbnRlcjtcbiAgfVxuYDtcclxuZXhwb3J0IGZ1bmN0aW9uIFBvd2VyZWRCeVN0aWdnKHsgc291cmNlLCBzaG93V2F0ZXJtYXJrLCBhbGlnbiwgc3R5bGUgPSB7fSB9KSB7XHJcbiAgICBpZiAoIXNob3dXYXRlcm1hcmspIHtcclxuICAgICAgICByZXR1cm4gbnVsbDtcclxuICAgIH1cclxuICAgIGNvbnN0IG9uV2F0ZXJtYXJrQ2xpY2sgPSAoKSA9PiB7XHJcbiAgICAgICAgY29uc3Qgc291cmNlRG9tYWluID0gd2luZG93LmxvY2F0aW9uLmhvc3RuYW1lLnJlcGxhY2UoJ3d3dy4nLCAnJyk7XHJcbiAgICAgICAgd2luZG93Lm9wZW4oYGh0dHBzOi8vd3d3LnN0aWdnLmlvLz91dG1fc291cmNlPSR7c291cmNlRG9tYWlufSZ1dG1fbWVkaXVtPXJlZmVycmFsJnV0bV9jYW1wYWlnbj0ke3NvdXJjZX1gLCAnX2JsYW5rJyk7XHJcbiAgICB9O1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZFBvd2VyZWRCeVN0aWdnLCB7IFwiJGFsaWduU2VsZlwiOiBhbGlnbiwgY2xhc3NOYW1lOiBTVElHR19XQVRFUk1BUktfQ0xBU1NOQU1FLCBzdHlsZTogeyBjdXJzb3I6ICdwb2ludGVyJywgLi4uc3R5bGUgfSwgb25DbGljazogb25XYXRlcm1hcmtDbGljayB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUG93ZXJlZEJ5U3RpZ2dUaGVtZWRTdmcsIG51bGwpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9UG93ZXJlZEJ5U3RpZ2cuanMubWFwIl19 */"));

function PoweredByStigg(_ref3) {
  var source = _ref3.source,
      showWatermark = _ref3.showWatermark,
      align = _ref3.align,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style;

  if (!showWatermark) {
    return null;
  }

  var onWatermarkClick = function onWatermarkClick() {
    var sourceDomain = window.location.hostname.replace('www.', '');
    window.open("https://www.stigg.io/?utm_source=" + sourceDomain + "&utm_medium=referral&utm_campaign=" + source, '_blank');
  };

  return React__default.createElement(StyledPoweredByStigg, {
    "$alignSelf": align,
    className: STIGG_WATERMARK_CLASSNAME,
    style: _extends({
      cursor: 'pointer'
    }, style),
    onClick: onWatermarkClick
  }, React__default.createElement(PoweredByStiggThemedSvg, null));
}

function hasPricePointsForPlans(plans, billingPeriod) {
  return plans.some(function (plan) {
    return hasPricePoints(plan, billingPeriod);
  });
}
function hasPricePoints(plan, billingPeriod) {
  return plan.pricePoints.some(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
}

function getPlansToDisplay(plans, selectedBillingPeriod) {
  return plans.filter(function (plan) {
    return plan.pricingType !== PricingType.Paid || hasPricePoints(plan, selectedBillingPeriod);
  });
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PaywallPlansContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e19kubi82"
} : {
  target: "e19kubi82",
  label: "PaywallPlansContainer"
})("color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.text.primary;
}, ";display:flex;align-items:stretch;justify-content:center;flex-wrap:wrap;padding:10px 0;gap:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.stigg.layout.planMargin;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var PaywallContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e19kubi81"
} : {
  target: "e19kubi81",
  label: "PaywallContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1rdsyw8",
  styles: "display:flex;flex-direction:column;align-items:center;& *{box-sizing:border-box;}"
} : {
  name: "1rdsyw8",
  styles: "display:flex;flex-direction:column;align-items:center;& *{box-sizing:border-box;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});

var PaywallLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e19kubi80"
} : {
  target: "e19kubi80",
  label: "PaywallLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "zigog8",
  styles: "display:flex;flex-direction:column;align-items:center"
} : {
  name: "zigog8",
  styles: "display:flex;flex-direction:column;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});

var Paywall = function Paywall(_ref3) {
  var plans = _ref3.plans,
      customer = _ref3.customer,
      currentSubscription = _ref3.currentSubscription,
      highlightedPlanId = _ref3.highlightedPlanId,
      selectedBillingPeriod = _ref3.selectedBillingPeriod,
      onBillingPeriodChanged = _ref3.onBillingPeriodChanged,
      availableBillingPeriods = _ref3.availableBillingPeriods,
      isCustomerOnTrial = _ref3.isCustomerOnTrial,
      onPlanSelected = _ref3.onPlanSelected,
      paywallLocale = _ref3.paywallLocale,
      locale = _ref3.locale;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg;

  var discountRate = calculatePaywallDiscountRate(plans);
  var shouldShowDescriptionSection = plans.some(function (plan) {
    return !!plan.description;
  });
  var hasMonthlyPrice = hasPricePointsForPlans(plans, BillingPeriod.Monthly);
  var hasAnnuallyPrice = hasPricePointsForPlans(plans, BillingPeriod.Annually);
  var plansToShow = getPlansToDisplay(plans, selectedBillingPeriod);
  var handleOnSubscribe = useCallback(function (plan, intentionType, billableFeatures) {
    return onPlanSelected({
      plan: plan,
      customer: customer,
      subscription: currentSubscription,
      intentionType: intentionType,
      selectedBillingPeriod: selectedBillingPeriod,
      billableFeatures: billableFeatures
    });
  }, [customer, selectedBillingPeriod]);
  var withStartingAtRow = plansToShow.some(function (plan) {
    var _plan$paywallCalculat;

    var planPrices = plan.pricePoints.filter(function (pricePoint) {
      return pricePoint.billingPeriod === selectedBillingPeriod;
    });
    var paywallCalculatedPrice = (_plan$paywallCalculat = plan.paywallCalculatedPricePoints) == null ? void 0 : _plan$paywallCalculat.find(function (pricePoint) {
      return pricePoint.billingPeriod === selectedBillingPeriod;
    });
    return planPrices.length > 1 && !!(paywallCalculatedPrice != null && paywallCalculatedPrice.additionalChargesMayApply);
  });
  var withUnitPriceRow = plansToShow.some(function (plan) {
    return !!getPlanPrice(plan, selectedBillingPeriod, paywallLocale, locale, hasMonthlyPrice).unit;
  });
  var withTiersRow = plansToShow.some(function (plan) {
    return !!getSelectedTier(plan, selectedBillingPeriod, currentSubscription, {});
  });
  var withTrialLeftRow = plansToShow.some(function (plan) {
    return plan.isCurrentCustomerPlan && plan.trialDaysLeft;
  });
  return React__default.createElement(PaywallContainer, {
    className: "stigg-paywall-container"
  }, React__default.createElement(PaywallLayout, {
    className: "stigg-paywall-layout"
  }, React__default.createElement(BillingPeriodPicker, {
    onBillingPeriodChanged: onBillingPeriodChanged,
    selectedBillingPeriod: selectedBillingPeriod,
    availableBillingPeriods: availableBillingPeriods,
    discountRate: discountRate
  }), React__default.createElement(PaywallPlansContainer, {
    className: "stigg-paywall-plans-layout"
  }, plansToShow.map(function (plan) {
    return React__default.createElement(PlanOffering, {
      withUnitPriceRow: withUnitPriceRow,
      withTiersRow: withTiersRow,
      withTrialLeftRow: withTrialLeftRow,
      key: plan.id,
      shouldShowDescriptionSection: shouldShowDescriptionSection,
      hasMonthlyPrice: hasMonthlyPrice,
      hasAnnuallyPrice: hasAnnuallyPrice,
      plan: plan,
      withStartingAtRow: withStartingAtRow,
      currentSubscription: currentSubscription,
      billingPeriod: selectedBillingPeriod,
      isHighlighted: plan.id === highlightedPlanId,
      isCustomerOnTrial: isCustomerOnTrial,
      onPlanSelected: function onPlanSelected(intentionType, billableFeatures) {
        return handleOnSubscribe(plan, intentionType, billableFeatures);
      },
      paywallLocale: paywallLocale,
      locale: locale,
      customer: customer
    });
  })), React__default.createElement(PoweredByStigg, {
    source: "paywall",
    align: "end",
    style: {
      marginTop: 16
    },
    showWatermark: stigg.isWidgetWatermarkEnabled
  })));
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

var LoggerService = /*#__PURE__*/function () {
  function LoggerService() {}

  var _proto = LoggerService.prototype;

  _proto.error = function error(message, _error) {
    for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      params[_key - 2] = arguments[_key];
    }

    console.error(message, _error || {}, params);
  };

  _proto.log = function log(message, object) {
    console.log(message, object || {});
  };

  _proto.debug = function debug(message, object) {
    console.debug(message, object || {});
  };

  return LoggerService;
}(); // Export a singleton logger service, in the future we might allow to user to configure external logger

var logger = /*#__PURE__*/new LoggerService();

var StiggContext = /*#__PURE__*/React__default.createContext(null);
StiggContext.displayName = 'StiggContext';
var DEFAULT_LOCALE = 'en-US';
var StiggProvider = function StiggProvider(_ref) {
  var apiKey = _ref.apiKey,
      baseUri = _ref.baseUri,
      baseEdgeUri = _ref.baseEdgeUri,
      enableEdge = _ref.enableEdge,
      customerId = _ref.customerId,
      customerToken = _ref.customerToken,
      resourceId = _ref.resourceId,
      theme = _ref.theme,
      locale = _ref.locale,
      useEntitlementPolling = _ref.useEntitlementPolling,
      entitlementPollingInterval = _ref.entitlementPollingInterval,
      entitlementsFallback = _ref.entitlementsFallback,
      stiggClient = _ref.stiggClient,
      children = _ref.children;
  var currentApiKey = useRef(apiKey);
  var initializeParams = {
    apiKey: apiKey,
    customerId: customerId,
    customerToken: customerToken,
    resourceId: resourceId,
    baseUri: baseUri,
    baseEdgeUri: baseEdgeUri,
    enableEdge: enableEdge,
    entitlementsFallback: entitlementsFallback,
    useEntitlementPolling: useEntitlementPolling,
    entitlementPollingInterval: entitlementPollingInterval
  };

  var _useState = useState(function () {
    return {
      stigg: stiggClient != null ? stiggClient : Stigg__default.initialize(_extends({}, initializeParams, {
        lazyLoad: true
      })),
      locale: locale || DEFAULT_LOCALE,
      isInitialized: false,
      theme: theme,
      refreshData: function () {
        var _refreshData = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
          return runtime_1.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setContext(function (ctx) {
                    return _extends({}, ctx, {
                      customerPortalUpdatedAt: new Date()
                    });
                  });
                  _context.next = 3;
                  return ctx.stigg.refresh();

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function refreshData() {
          return _refreshData.apply(this, arguments);
        }

        return refreshData;
      }()
    };
  }),
      ctx = _useState[0],
      setContext = _useState[1];

  useEffect(function () {
    var isMounted = true;

    var safeSetContext = function safeSetContext(setContextFunc) {
      if (isMounted) {
        setContext(setContextFunc);
      }
    };

    var onEntitlementsUpdated = function onEntitlementsUpdated() {
      return safeSetContext(function (ctx) {
        return _extends({}, ctx, {
          updatedAt: new Date()
        });
      });
    };

    var setStiggInstance = function setStiggInstance(stigg) {
      return safeSetContext(function (ctx) {
        if (ctx.stigg) {
          ctx.stigg.removeListener('entitlementsUpdated', onEntitlementsUpdated);
        }

        stigg.addListener('entitlementsUpdated', onEntitlementsUpdated);
        return _extends({}, ctx, {
          stigg: stigg,
          isInitialized: true,
          updatedAt: new Date()
        });
      });
    };

    var loadStiggClient = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2() {
        var stiggClient;
        return runtime_1.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                stiggClient = ctx.stigg;

                if (apiKey !== currentApiKey.current) {
                  logger.log('Updating stigg client', {
                    apiKey: apiKey
                  });
                  currentApiKey.current = apiKey;
                  stiggClient = Stigg__default.initialize(_extends({}, initializeParams));
                  safeSetContext(function (ctx) {
                    return _extends({}, ctx, {
                      isInitialized: false,
                      updatedAt: new Date()
                    });
                  });
                }

                _context2.next = 4;
                return stiggClient.waitForInitialization();

              case 4:
                setStiggInstance(stiggClient);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function loadStiggClient() {
        return _ref2.apply(this, arguments);
      };
    }();

    void loadStiggClient();
    return function () {
      isMounted = false;
      ctx.stigg.removeListener('entitlementsUpdated', onEntitlementsUpdated);
      ctx.stigg.clearCustomer();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiKey]);
  useEffect(function () {
    var stiggClient = ctx.stigg;

    if (customerId) {
      void stiggClient.setCustomerId(customerId, customerToken, resourceId);
    } else {
      stiggClient.clearCustomer();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [customerId, customerToken, resourceId]);
  useEffect(function () {
    setContext(function (ctx) {
      return _extends({}, ctx, {
        theme: theme
      });
    });
  }, [theme]);
  return React__default.createElement(StiggContext.Provider, {
    value: ctx
  }, React__default.createElement(SkeletonTheme, {
    baseColor: "#F5F6F9",
    highlightColor: "#e5e6ea"
  }, children));
};
var useStiggContext = function useStiggContext() {
  var ctx = useContext(StiggContext);

  if (!ctx) {
    throw new Error('Could not find Stigg context; You need to wrap your app in an <StiggProvider> component.');
  }

  return ctx;
};

function computeBillingPeriods(plans, activeSubscriptions, preferredBillingPeriod) {
  var billingPeriods = plans.flatMap(function (x) {
    return x.pricePoints;
  }).map(function (x) {
    return x.billingPeriod;
  });
  var counts = countBy(billingPeriods);
  var availableBillingPeriods = uniq(billingPeriods);
  var defaultBillingPeriod;

  if (preferredBillingPeriod && availableBillingPeriods.includes(preferredBillingPeriod)) {
    defaultBillingPeriod = preferredBillingPeriod;
  } else if (activeSubscriptions) {
    var activeSubscription = activeSubscriptions.find(function (x) {
      return x.status == SubscriptionStatus.Active;
    });

    if (activeSubscription && activeSubscription.prices.length > 0) {
      defaultBillingPeriod = activeSubscription == null ? void 0 : activeSubscription.prices[0].billingPeriod;
    }
  }

  if (!defaultBillingPeriod) {
    defaultBillingPeriod = (counts[BillingPeriod.Monthly] || 0) > (counts[BillingPeriod.Annually] || 0) ? BillingPeriod.Monthly : BillingPeriod.Annually;
  }

  return {
    defaultBillingPeriod: defaultBillingPeriod,
    availableBillingPeriods: availableBillingPeriods
  };
}

function calculateTrialDaysLeft(trialEndDate) {
  return moment.utc(trialEndDate).diff(moment.utc(), 'days', false) + 1;
}

var defaultCheckoutTypography = {
  h1: {
    fontSize: 24,
    fontWeight: FontWeight$1.Bold
  },
  h2: {
    fontSize: 16,
    fontWeight: FontWeight$1.Normal
  },
  h3: {
    fontSize: 16,
    fontWeight: FontWeight$1.Normal
  },
  body: {
    fontSize: 14,
    fontWeight: FontWeight$1.Normal
  }
};

function addCssUnits(value, unit) {
  if (unit === void 0) {
    unit = 'px';
  }

  if (!value) {
    return undefined;
  }

  return "" + value + unit;
}

function mapFontWeight$1(defaultValue, fontWeight) {
  if (!fontWeight) {
    return defaultValue;
  }

  switch (fontWeight) {
    case FontWeight$1.Normal:
      return 'normal';

    case FontWeight$1.Bold:
      return 'bold';

    default:
      return 'normal';
  }
}

function mapTypography(typography, defaultTypography) {
  var _typography$h, _defaultTypography$h, _typography$h2, _defaultTypography$h2, _typography$h3, _defaultTypography$h3, _defaultTypography$h4, _typography$h4, _defaultTypography$h5, _typography$h5, _defaultTypography$h6, _typography$body, _defaultTypography$bo, _typography$body2, _defaultTypography$bo2;

  return {
    fontFamilyUrl: (typography == null ? void 0 : typography.fontFamily) || undefined,
    h1: {
      fontSize: addCssUnits((typography == null ? void 0 : (_typography$h = typography.h1) == null ? void 0 : _typography$h.fontSize) || (defaultTypography == null ? void 0 : (_defaultTypography$h = defaultTypography.h1) == null ? void 0 : _defaultTypography$h.fontSize)),
      fontWeight: mapFontWeight$1('bold', (typography == null ? void 0 : (_typography$h2 = typography.h1) == null ? void 0 : _typography$h2.fontWeight) || (defaultTypography == null ? void 0 : (_defaultTypography$h2 = defaultTypography.h1) == null ? void 0 : _defaultTypography$h2.fontWeight))
    },
    h2: {
      fontSize: addCssUnits((typography == null ? void 0 : (_typography$h3 = typography.h2) == null ? void 0 : _typography$h3.fontSize) || (defaultTypography == null ? void 0 : (_defaultTypography$h3 = defaultTypography.h2) == null ? void 0 : _defaultTypography$h3.fontSize)),
      fontWeight: mapFontWeight$1('normal', defaultTypography == null ? void 0 : (_defaultTypography$h4 = defaultTypography.h2) == null ? void 0 : _defaultTypography$h4.fontWeight)
    },
    h3: {
      fontSize: addCssUnits((typography == null ? void 0 : (_typography$h4 = typography.h3) == null ? void 0 : _typography$h4.fontSize) || (defaultTypography == null ? void 0 : (_defaultTypography$h5 = defaultTypography.h3) == null ? void 0 : _defaultTypography$h5.fontSize)),
      fontWeight: mapFontWeight$1('normal', (typography == null ? void 0 : (_typography$h5 = typography.h3) == null ? void 0 : _typography$h5.fontWeight) || (defaultTypography == null ? void 0 : (_defaultTypography$h6 = defaultTypography.h3) == null ? void 0 : _defaultTypography$h6.fontWeight))
    },
    body: {
      fontSize: addCssUnits((typography == null ? void 0 : (_typography$body = typography.body) == null ? void 0 : _typography$body.fontSize) || (defaultTypography == null ? void 0 : (_defaultTypography$bo = defaultTypography.body) == null ? void 0 : _defaultTypography$bo.fontSize)),
      fontWeight: mapFontWeight$1('normal', (typography == null ? void 0 : (_typography$body2 = typography.body) == null ? void 0 : _typography$body2.fontWeight) || (defaultTypography == null ? void 0 : (_defaultTypography$bo2 = defaultTypography.body) == null ? void 0 : _defaultTypography$bo2.fontWeight))
    }
  };
}

function mapAlignment(alignment) {
  if (!alignment) {
    return undefined;
  }

  switch (alignment) {
    case Alignment.Left:
      return 'left';

    case Alignment.Center:
      return 'center';

    case Alignment.Right:
      return 'right';

    default:
      {
        return undefined;
      }
  }
}

function mapCustomerPortalConfiguration(configuration) {
  var palette = configuration.palette,
      typography = configuration.typography;
  return {
    palette: {
      primary: (palette == null ? void 0 : palette.primary) || undefined,
      backgroundPaper: (palette == null ? void 0 : palette.paywallBackgroundColor) || undefined,
      outlinedBorder: (palette == null ? void 0 : palette.borderColor) || undefined,
      backgroundHighlight: (palette == null ? void 0 : palette.currentPlanBackground) || undefined,
      text: {
        primary: (palette == null ? void 0 : palette.textColor) || undefined
      }
    },
    typography: mapTypography(typography)
  };
}
function mapPaywallConfiguration(paywallConfiguration) {
  var palette = paywallConfiguration.palette,
      layout = paywallConfiguration.layout,
      customCss = paywallConfiguration.customCss,
      typography = paywallConfiguration.typography;
  return {
    customCss: customCss || undefined,
    palette: {
      primary: (palette == null ? void 0 : palette.primary) || undefined,
      backgroundPaper: (palette == null ? void 0 : palette.backgroundColor) || undefined,
      outlinedBorder: (palette == null ? void 0 : palette.borderColor) || undefined,
      backgroundHighlight: (palette == null ? void 0 : palette.currentPlanBackground) || undefined,
      text: {
        primary: (palette == null ? void 0 : palette.textColor) || undefined
      }
    },
    typography: mapTypography(typography),
    layout: {
      ctaAlignment: mapAlignment(layout == null ? void 0 : layout.alignment),
      headerAlignment: mapAlignment(layout == null ? void 0 : layout.alignment),
      descriptionAlignment: mapAlignment(layout == null ? void 0 : layout.alignment),
      planMaxWidth: addCssUnits(layout == null ? void 0 : layout.planWidth),
      planMinWidth: addCssUnits(layout == null ? void 0 : layout.planWidth),
      planMargin: addCssUnits(layout == null ? void 0 : layout.planMargin),
      planPadding: addCssUnits(layout == null ? void 0 : layout.planPadding)
    }
  };
}
function mapCheckoutConfiguration(configuration) {
  var palette = configuration.palette,
      typography = configuration.typography;
  return {
    palette: {
      primary: (palette == null ? void 0 : palette.primary) || undefined,
      backgroundPaper: (palette == null ? void 0 : palette.backgroundColor) || undefined,
      outlinedBorder: (palette == null ? void 0 : palette.borderColor) || undefined,
      text: {
        primary: (palette == null ? void 0 : palette.textColor) || undefined
      },
      backgroundHighlight: (palette == null ? void 0 : palette.summaryBackgroundColor) || undefined
    },
    typography: mapTypography(typography, defaultCheckoutTypography)
  };
}

function getCustomerSubscriptionDetails(activeSubscriptions) {
  var _currentSubscription, _currentSubscription2;

  var isCustomerOnTrial = true;
  var currentSubscription = (activeSubscriptions == null ? void 0 : activeSubscriptions.find(function (s) {
    return s.status === SubscriptionStatus.InTrial;
  })) || null;
  var currentPlan = (_currentSubscription = currentSubscription) == null ? void 0 : _currentSubscription.plan;
  var trialDaysLeft = (_currentSubscription2 = currentSubscription) != null && _currentSubscription2.trialEndDate ? calculateTrialDaysLeft(currentSubscription.trialEndDate) : undefined;

  if (!currentPlan) {
    var _currentSubscription3;

    isCustomerOnTrial = false;
    currentSubscription = (activeSubscriptions == null ? void 0 : activeSubscriptions.find(function (s) {
      return s.status === SubscriptionStatus.Active;
    })) || null;
    currentPlan = (_currentSubscription3 = currentSubscription) == null ? void 0 : _currentSubscription3.plan;
  }

  return {
    currentSubscription: currentSubscription,
    currentPlan: currentPlan,
    isCustomerOnTrial: isCustomerOnTrial,
    trialDaysLeft: trialDaysLeft
  };
}

function mapPaywallData(paywall, showOnlyEligiblePlans) {
  var _currentSubscription$;

  var _ref = paywall || {},
      plans = _ref.plans,
      currency = _ref.currency,
      configuration = _ref.configuration,
      customer = _ref.customer,
      activeSubscriptions = _ref.activeSubscriptions,
      paywallCalculatedPricePoints = _ref.paywallCalculatedPricePoints;

  var _getCustomerSubscript = getCustomerSubscriptionDetails(activeSubscriptions),
      currentSubscription = _getCustomerSubscript.currentSubscription,
      currentPlan = _getCustomerSubscript.currentPlan,
      isCustomerOnTrial = _getCustomerSubscript.isCustomerOnTrial,
      trialDaysLeft = _getCustomerSubscript.trialDaysLeft;

  var scheduledUpdates = (currentSubscription == null ? void 0 : currentSubscription.scheduledUpdates) || [];
  var currentCustomerPlanBillingPeriod = currentSubscription == null ? void 0 : (_currentSubscription$ = currentSubscription.price) == null ? void 0 : _currentSubscription$.billingPeriod;
  var downgradeSchedule = scheduledUpdates.find(function (_ref2) {
    var subscriptionScheduleType = _ref2.subscriptionScheduleType;
    return subscriptionScheduleType === SubscriptionScheduleType.Downgrade;
  });
  var billingChangedSchedule = scheduledUpdates.find(function (_ref3) {
    var subscriptionScheduleType = _ref3.subscriptionScheduleType;
    return subscriptionScheduleType === SubscriptionScheduleType.BillingPeriod;
  });
  var paywallPlans = sortBy(plans, function (plan) {
    return plan.order;
  }).map(function (plan) {
    var _customer$eligibleFor;

    var eligibleForProductTrial = customer == null ? void 0 : (_customer$eligibleFor = customer.eligibleForTrial) == null ? void 0 : _customer$eligibleFor.find(function (productTrial) {
      return productTrial.productId === plan.product.id;
    });
    var isCurrentCustomerPlan = plan.id === (currentPlan == null ? void 0 : currentPlan.id);

    var isNextPlan = function isNextPlan(currentBillingPeriod) {
      var _downgradeSchedule$ta;

      var downgradeVariables = downgradeSchedule == null ? void 0 : downgradeSchedule.scheduleVariables;
      var billingChangedVariables = billingChangedSchedule == null ? void 0 : billingChangedSchedule.scheduleVariables;
      var isPlanHasBillingPeriodPrice = plan.pricePoints.some(function (price) {
        return price.billingPeriod === currentBillingPeriod;
      });
      return downgradeSchedule ? ((_downgradeSchedule$ta = downgradeSchedule.targetPackage) == null ? void 0 : _downgradeSchedule$ta.refId) === plan.id && (!isPlanHasBillingPeriodPrice || downgradeVariables.billingPeriod === currentBillingPeriod) : billingChangedSchedule && isCurrentCustomerPlan ? billingChangedVariables.billingPeriod === currentBillingPeriod : false;
    };

    return _extends({}, plan, {
      paywallCalculatedPricePoints: paywallCalculatedPricePoints == null ? void 0 : paywallCalculatedPricePoints.filter(function (pricePoint) {
        return pricePoint.planId === plan.id;
      }),
      isTriable: !isNil(plan.defaultTrialConfig) && (!eligibleForProductTrial || eligibleForProductTrial.eligible),
      isCurrentCustomerPlan: isCurrentCustomerPlan,
      currentCustomerPlanBillingPeriod: currentCustomerPlanBillingPeriod,
      isUpcomingPlan: false,
      trialDaysLeft: trialDaysLeft,
      isNextPlan: isNextPlan,
      paywallCurrency: currency,
      scheduledUpdate: downgradeSchedule || billingChangedSchedule
    });
  });

  if (plans && currentPlan) {
    var _plans$find;

    var currentPlanOrder = currentPlan && (plans == null ? void 0 : (_plans$find = plans.find(function (x) {
      return x.id === (currentPlan == null ? void 0 : currentPlan.id);
    })) == null ? void 0 : _plans$find.order);

    if (!isNil(currentPlanOrder)) {
      paywallPlans = paywallPlans.map(function (plan) {
        return _extends({}, plan, {
          isLowerThanCurrentPlan: currentPlanOrder > plan.order
        });
      });

      if (showOnlyEligiblePlans) {
        paywallPlans = paywallPlans.filter(function (plan) {
          return plan.order > currentPlanOrder;
        });
      }
    }
  }

  var paywallConfiguration = configuration ? mapPaywallConfiguration(configuration) : undefined;
  return {
    currentPlan: currentPlan,
    currentSubscription: currentSubscription,
    isCustomerOnTrial: isCustomerOnTrial,
    plans: paywallPlans,
    paywallConfiguration: paywallConfiguration
  };
}

function useLoadPaywallData(_ref) {
  var productId = _ref.productId,
      resourceId = _ref.resourceId,
      showOnlyEligiblePlans = _ref.showOnlyEligiblePlans,
      billingCountryCode = _ref.billingCountryCode,
      preferredBillingPeriod = _ref.preferredBillingPeriod;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg,
      locale = _useStiggContext.locale;

  var _useState = useState(BillingPeriod.Annually),
      selectedBillingPeriod = _useState[0],
      setSelectedBillingPeriod = _useState[1];

  var _useState2 = useState([]),
      availableBillingPeriods = _useState2[0],
      setAvailableBillingPeriods = _useState2[1];

  var _useState3 = useState(null),
      paywall = _useState3[0],
      setPaywall = _useState3[1];

  var _useState4 = useState(true),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  useEffect(function () {
    var loadPaywall = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
        var paywallResult, _computeBillingPeriod, _availableBillingPeriods, defaultBillingPeriod;

        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setIsLoading(true);
                _context.next = 4;
                return stigg.waitForInitialization();

              case 4:
                _context.next = 6;
                return stigg.getPaywall({
                  productId: productId,
                  resourceId: resourceId,
                  billingCountryCode: billingCountryCode
                });

              case 6:
                paywallResult = _context.sent;
                _computeBillingPeriod = computeBillingPeriods(paywallResult.plans, paywallResult.activeSubscriptions, preferredBillingPeriod), _availableBillingPeriods = _computeBillingPeriod.availableBillingPeriods, defaultBillingPeriod = _computeBillingPeriod.defaultBillingPeriod;
                setPaywall(paywallResult);
                setAvailableBillingPeriods(_availableBillingPeriods);
                setSelectedBillingPeriod(defaultBillingPeriod);
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);
                logger.error("Failed to load paywall " + (_context.t0 == null ? void 0 : _context.t0.message), _context.t0);

              case 16:
                _context.prev = 16;
                setIsLoading(false);
                return _context.finish(16);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13, 16, 19]]);
      }));

      return function loadPaywall() {
        return _ref2.apply(this, arguments);
      };
    }();

    void loadPaywall();
  }, [stigg, productId, stigg.isCustomerLoaded, billingCountryCode, resourceId]);
  var paywallData = mapPaywallData(paywall, showOnlyEligiblePlans);
  return _extends({
    customer: (paywall == null ? void 0 : paywall.customer) || null,
    isLoading: isLoading,
    selectedBillingPeriod: selectedBillingPeriod,
    setSelectedBillingPeriod: setSelectedBillingPeriod,
    availableBillingPeriods: availableBillingPeriods,
    locale: locale,
    configuration: paywallData.paywallConfiguration
  }, paywallData);
}

function getResolvedPaywallLocalize(localizeOverride) {
  var paywallDefaultLocalization = {
    highlightChip: 'Recommended',
    planCTAButton: {
      upgrade: 'Upgrade',
      downgrade: 'Downgrade',
      startTrial: function startTrial(plan) {
        var _plan$defaultTrialCon;

        return "Start " + ((_plan$defaultTrialCon = plan.defaultTrialConfig) == null ? void 0 : _plan$defaultTrialCon.duration) + " day trial";
      },
      custom: 'Contact us',
      currentPlan: 'Current plan',
      startNew: 'Get started',
      switchToBillingPeriod: function switchToBillingPeriod(billingPeriod) {
        return billingPeriod === BillingPeriod.Monthly ? 'Switch to monthly billing' : 'Switch to annual billing';
      },
      cancelScheduledUpdate: 'Cancel'
    },
    price: {
      startingAtCaption: 'Starts at',
      pricePeriod: function pricePeriod(billingPeriod) {
        return billingPeriod === BillingPeriod.Monthly ? '/ month' : '/ year';
      },
      free: function free(currency) {
        return {
          price: (currency == null ? void 0 : currency.symbol) + "0"
        };
      },
      custom: 'Custom',
      priceNotSet: 'Price not set'
    }
  };
  return merge(paywallDefaultLocalization, localizeOverride);
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var SkeletonContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f7khji6"
} : {
  target: "e1f7khji6",
  label: "SkeletonContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "zigog8",
  styles: "display:flex;flex-direction:column;align-items:center"
} : {
  name: "zigog8",
  styles: "display:flex;flex-direction:column;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});

var EntitlementCheckIcon$1 = /*#__PURE__*/_styled(SvgCheckStigg, process.env.NODE_ENV === "production" ? {
  target: "e1f7khji5"
} : {
  target: "e1f7khji5",
  label: "EntitlementCheckIcon"
})(process.env.NODE_ENV === "production" ? {
  name: "o7nnmj",
  styles: "margin-right:16px"
} : {
  name: "o7nnmj",
  styles: "margin-right:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});

var PlanOfferingSkeleton = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f7khji4"
} : {
  target: "e1f7khji4",
  label: "PlanOfferingSkeleton"
})("display:flex;flex-direction:column;align-items:flex-start;gap:20px;border-radius:10px;padding:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.layout.planPadding;
}, ";background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.stigg.palette.backgroundPaper;
}, ";min-width:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.stigg.layout.planMinWidth;
}, ";max-width:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.stigg.layout.planMaxWidth;
}, ";min-height:450px;border:", function (_ref5) {
  var theme = _ref5.theme;
  return "1px solid " + theme.stigg.palette.outlinedBorder;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var PlansContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f7khji3"
} : {
  target: "e1f7khji3",
  label: "PlansContainer"
})("display:flex;gap:", function (_ref6) {
  var theme = _ref6.theme;
  return theme.stigg.layout.planMargin;
}, ";flex-wrap:wrap;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var EntitlementContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f7khji2"
} : {
  target: "e1f7khji2",
  label: "EntitlementContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "k8xojc",
  styles: "display:flex;align-items:center;margin-bottom:12px"
} : {
  name: "k8xojc",
  styles: "display:flex;align-items:center;margin-bottom:12px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});

var FooterSkeletonLoader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f7khji1"
} : {
  target: "e1f7khji1",
  label: "FooterSkeletonLoader"
})(process.env.NODE_ENV === "production" ? {
  name: "xdvdnl",
  styles: "margin-top:auto"
} : {
  name: "xdvdnl",
  styles: "margin-top:auto",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});

var BillingPeriodLoader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1f7khji0"
} : {
  target: "e1f7khji0",
  label: "BillingPeriodLoader"
})("width:150px;margin-bottom:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.stigg.layout.switchBottomSpacing;
}, ";padding:12px 12px;border-radius:10px;background-color:white;border:", function (_ref8) {
  var theme = _ref8.theme;
  return "1px solid " + theme.stigg.palette.outlinedBorder;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function PlanOfferingLoader() {
  return React__default.createElement(PlanOfferingSkeleton, null, React__default.createElement(Skeleton$1, {
    width: 120,
    borderRadius: 4
  }), React__default.createElement(Skeleton$1, {
    circle: true,
    width: 40,
    height: 40
  }), React__default.createElement(Skeleton$1, {
    style: {
      marginBottom: 33
    },
    width: 120,
    borderRadius: 4
  }), React__default.createElement(EntitlementContainer, null, React__default.createElement(EntitlementCheckIcon$1, null), React__default.createElement(Skeleton$1, {
    width: 120,
    borderRadius: 4
  })), React__default.createElement(EntitlementContainer, null, React__default.createElement(EntitlementCheckIcon$1, null), React__default.createElement(Skeleton$1, {
    width: 120,
    borderRadius: 4
  })), React__default.createElement(EntitlementContainer, null, React__default.createElement(EntitlementCheckIcon$1, null), React__default.createElement(Skeleton$1, {
    width: 120,
    borderRadius: 4
  })), React__default.createElement(FooterSkeletonLoader, null, React__default.createElement(Skeleton$1, {
    height: 50,
    borderRadius: 4
  })));
}

function PaywallLoader() {
  return React__default.createElement(SkeletonContainer, {
    className: "stigg-skeleton-loader-container"
  }, React__default.createElement(BillingPeriodLoader, {
    className: "stigg-skeleton-loader-billing-period"
  }, React__default.createElement(Skeleton$1, {
    borderRadius: 4
  })), React__default.createElement(PlansContainer, {
    className: "stigg-skeleton-loader-plans-container"
  }, React__default.createElement(PlanOfferingLoader, null), React__default.createElement(PlanOfferingLoader, null), React__default.createElement(PlanOfferingLoader, null)));
}

var _templateObject$1;
var Fonts = function Fonts(_ref) {
  var externalFontUrl = _ref.externalFontUrl;
  return React__default.createElement(Global, {
    styles: css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n        ", "\n\n        /* latin-ext */\n        @font-face {\n          font-family: 'DM Sans';\n          font-style: normal;\n          font-weight: 400;\n          font-display: swap;\n          src: url(https://fonts.gstatic.com/s/dmsans/v11/rP2Hp2ywxg089UriCZ2IHTWEBlwu8Q.woff2) format('woff2');\n          unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,\n            U+A720-A7FF;\n        }\n        /* latin */\n        @font-face {\n          font-family: 'DM Sans';\n          font-style: normal;\n          font-weight: 400;\n          font-display: swap;\n          src: url(https://fonts.gstatic.com/s/dmsans/v11/rP2Hp2ywxg089UriCZOIHTWEBlw.woff2) format('woff2');\n          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,\n            U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n        }\n        /* latin-ext */\n        @font-face {\n          font-family: 'DM Sans';\n          font-style: normal;\n          font-weight: 500;\n          font-display: swap;\n          src: url(https://fonts.gstatic.com/s/dmsans/v11/rP2Cp2ywxg089UriAWCrCBamC3YU-CnE6Q.woff2) format('woff2');\n          unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,\n            U+A720-A7FF;\n        }\n        /* latin */\n        @font-face {\n          font-family: 'DM Sans';\n          font-style: normal;\n          font-weight: 500;\n          font-display: swap;\n          src: url(https://fonts.gstatic.com/s/dmsans/v11/rP2Cp2ywxg089UriAWCrCBimC3YU-Ck.woff2) format('woff2');\n          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,\n            U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n        }\n        /* latin-ext */\n        @font-face {\n          font-family: 'DM Sans';\n          font-style: normal;\n          font-weight: 700;\n          font-display: swap;\n          src: url(https://fonts.gstatic.com/s/dmsans/v11/rP2Cp2ywxg089UriASitCBamC3YU-CnE6Q.woff2) format('woff2');\n          unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F,\n            U+A720-A7FF;\n        }\n        /* latin */\n        @font-face {\n          font-family: 'DM Sans';\n          font-style: normal;\n          font-weight: 700;\n          font-display: swap;\n          src: url(https://fonts.gstatic.com/s/dmsans/v11/rP2Cp2ywxg089UriASitCBimC3YU-Ck.woff2) format('woff2');\n          unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074,\n            U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n        }\n      "])), externalFontUrl && "\n          @font-face {\n            font-family: 'custom-font';\n            font-style: normal;\n            font-weight: normal;\n            src: local('custom-font'), url(" + externalFontUrl + ") format('woff');\n          }\n        ")
  });
};

var _templateObject$2;

var CustomCssGlobal = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "emcdfp60"
} : {
  target: "emcdfp60",
  label: "CustomCssGlobal"
})(function (_ref) {
  var customCss = _ref.customCss;
  return customCss && css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n      ", "\n    "])), customCss);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRoZW1lLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTbUMiLCJmaWxlIjoiVGhlbWUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgbWVyZ2UgfSBmcm9tICdsb2Rhc2gnO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBUaGVtZVByb3ZpZGVyIGFzIFN0eWxlZFRoZW1lUHJvdmlkZXIgfSBmcm9tICdzdHlsZWQtY29tcG9uZW50cyc7XHJcbmltcG9ydCB7IGNzcywgVGhlbWVQcm92aWRlciB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBjcmVhdGVUaGVtZSwgVGhlbWVQcm92aWRlciBhcyBNdWlUaGVtZVByb3ZpZGVyIH0gZnJvbSAnQG11aS9tYXRlcmlhbC9zdHlsZXMnO1xyXG5pbXBvcnQgeyB1c2VTdGlnZ0NvbnRleHQgfSBmcm9tICcuLi9jb21wb25lbnRzL1N0aWdnUHJvdmlkZXInO1xyXG5pbXBvcnQgeyBGb250cyB9IGZyb20gJy4vRm9udHMnO1xyXG5pbXBvcnQgeyBnZXRSZXNvbHZlZFRoZW1lIH0gZnJvbSAnLi9nZXRSZXNvbHZlZFRoZW1lJztcclxuY29uc3QgQ3VzdG9tQ3NzR2xvYmFsID0gc3R5bGVkLmRpdiBgXG4gICR7KHsgY3VzdG9tQ3NzIH0pID0+IGN1c3RvbUNzcyAmJlxyXG4gICAgY3NzIGBcbiAgICAgICR7Y3VzdG9tQ3NzfVxuICAgIGB9XG5gO1xyXG4vKlxyXG4gIFRoaXMgbWVyZ2UgdGhlIHRoZW1lIGZyb20gMyBwbGFjZXM6XHJcbiAgMS4gRXh0ZXJuYWwgdGhlbWUgdGhhdCB3ZSBnb3QgZnJvbSB0aGUgdXNlciBpbiBTdGlnZ1Byb3ZpZGVyXHJcbiAgMi4gUmVtb3RlIHRoZW1lIGZyb20gYXBpXHJcbiAgMy4gRGVmYXVsdCB0aGVtZVxyXG4qL1xyXG5leHBvcnQgZnVuY3Rpb24gdXNlU3RpZ2dUaGVtZShyZW1vdGVUaGVtZU92ZXJyaWRlKSB7XHJcbiAgICBjb25zdCB7IHRoZW1lOiBleHRlcm5hbFRoZW1lIH0gPSB1c2VTdGlnZ0NvbnRleHQoKTtcclxuICAgIGNvbnN0IG1lcmdlZFRoZW1lID0gbWVyZ2UocmVtb3RlVGhlbWVPdmVycmlkZSwgZXh0ZXJuYWxUaGVtZSk7XHJcbiAgICBjb25zdCByZXNvbHZlZFRoZW1lID0gZ2V0UmVzb2x2ZWRUaGVtZShtZXJnZWRUaGVtZSk7XHJcbiAgICByZXR1cm4gcmVzb2x2ZWRUaGVtZTtcclxufVxyXG5mdW5jdGlvbiBjcmVhdGVUeXBvZ3JhcGh5VGhlbWUodGhlbWUpIHtcclxuICAgIGNvbnN0IHsgdHlwb2dyYXBoeSB9ID0gdGhlbWU7XHJcbiAgICBjb25zdCBodG1sRm9udFNpemUgPSAxNjtcclxuICAgIGNvbnN0IGNvZWYgPSBOdW1iZXIodHlwb2dyYXBoeS5ib2R5LmZvbnRTaXplLnJlcGxhY2UoJ3B4JywgJycpKSAvIDE0O1xyXG4gICAgcmV0dXJuIHtcclxuICAgICAgICAvLyBIYWNrIHRvIGZpeCB0aGVtaW5nIGlzc3Vlc1xyXG4gICAgICAgIC8vIEB0cy1pZ25vcmVcclxuICAgICAgICBweFRvUmVtOiAoc2l6ZSkgPT4gYCR7KHNpemUgLyBodG1sRm9udFNpemUpICogY29lZn1yZW1gLFxyXG4gICAgICAgIGJvZHlGb250RmFtaWx5OiB0eXBvZ3JhcGh5LmZvbnRGYW1pbHksXHJcbiAgICAgICAgaGVhZGluZ0ZvbnRGYW1pbHk6IHR5cG9ncmFwaHkuZm9udEZhbWlseSxcclxuICAgICAgICBmb250U2l6ZXM6IFtcclxuICAgICAgICAgICAgdHlwb2dyYXBoeS5oMS5mb250U2l6ZSxcclxuICAgICAgICAgICAgdHlwb2dyYXBoeS5oMi5mb250U2l6ZSxcclxuICAgICAgICAgICAgdHlwb2dyYXBoeS5oMy5mb250U2l6ZSxcclxuICAgICAgICAgICAgdHlwb2dyYXBoeS5ib2R5LmZvbnRTaXplLFxyXG4gICAgICAgICAgICAnMTJweCcsXHJcbiAgICAgICAgICAgICcxMHB4JyxcclxuICAgICAgICBdLFxyXG4gICAgfTtcclxufVxyXG5jb25zdCBjcmVhdGVNdWlQYWxldHRlID0gKHRoZW1lKSA9PiB7XHJcbiAgICByZXR1cm4ge1xyXG4gICAgICAgIHByaW1hcnk6IHtcclxuICAgICAgICAgICAgbWFpbjogdGhlbWUucGFsZXR0ZS5wcmltYXJ5LFxyXG4gICAgICAgIH0sXHJcbiAgICB9O1xyXG59O1xyXG5leHBvcnQgY29uc3QgU2RrVGhlbWVQcm92aWRlciA9ICh7IGNoaWxkcmVuLCBjb21wb25lbnRUaGVtZSB9KSA9PiB7XHJcbiAgICBjb25zdCB0aGVtZSA9IHVzZVN0aWdnVGhlbWUoY29tcG9uZW50VGhlbWUpO1xyXG4gICAgY29uc3QgbXVpUGFsZXR0ZSA9IGNyZWF0ZU11aVBhbGV0dGUodGhlbWUpO1xyXG4gICAgcmV0dXJuIChcclxuICAgIC8vIFdlIGFyZSB1c2luZyBzdHlsZWQtY29tcG9uZW50cyB0aGVtZSBoZXJlIG9ubHkgYmVjYXVzZSB3ZSBhcmUgdXNpbmcgc3R5bGVkLXR5cG9ncmFwaHlcclxuICAgIC8vIHdoaWNoIGRlcGVuZHMgb24gc3R5bGVkLWNvbXBvbmVudHMgZm9yIHRoZSB0eXBvZ3JhcGh5IHRoZW1pbmdcclxuICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoTXVpVGhlbWVQcm92aWRlciwgeyB0aGVtZTogY3JlYXRlVGhlbWUoeyBwYWxldHRlOiBtdWlQYWxldHRlLCBzdGlnZzogdGhlbWUgfSkgfSxcclxuICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFRoZW1lUHJvdmlkZXIsIHsgdGhlbWU6IHsgc3RpZ2c6IHRoZW1lIH0gfSxcclxuICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChDdXN0b21Dc3NHbG9iYWwsIHsgY3VzdG9tQ3NzOiB0aGVtZS5jdXN0b21Dc3MgfSxcclxuICAgICAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoRm9udHMsIHsgZXh0ZXJuYWxGb250VXJsOiB0aGVtZS50eXBvZ3JhcGh5LmZvbnRGYW1pbHlVcmwgfSksXHJcbiAgICAgICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZFRoZW1lUHJvdmlkZXIsIHsgdGhlbWU6IHsgdHlwb2dyYXBoeTogY3JlYXRlVHlwb2dyYXBoeVRoZW1lKHRoZW1lKSB9IH0sIGNoaWxkcmVuKSkpKSk7XHJcbn07XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVRoZW1lLmpzLm1hcCJdfQ== */"));
/*
  This merge the theme from 3 places:
  1. External theme that we got from the user in StiggProvider
  2. Remote theme from api
  3. Default theme
*/


function useStiggTheme(remoteThemeOverride) {
  var _useStiggContext = useStiggContext(),
      externalTheme = _useStiggContext.theme;

  var mergedTheme = merge$1(remoteThemeOverride, externalTheme);
  var resolvedTheme = getResolvedTheme(mergedTheme);
  return resolvedTheme;
}

function createTypographyTheme(theme) {
  var typography = theme.typography;
  var htmlFontSize = 16;
  var coef = Number(typography.body.fontSize.replace('px', '')) / 14;
  return {
    // Hack to fix theming issues
    // @ts-ignore
    pxToRem: function pxToRem(size) {
      return size / htmlFontSize * coef + "rem";
    },
    bodyFontFamily: typography.fontFamily,
    headingFontFamily: typography.fontFamily,
    fontSizes: [typography.h1.fontSize, typography.h2.fontSize, typography.h3.fontSize, typography.body.fontSize, '12px', '10px']
  };
}

var createMuiPalette = function createMuiPalette(theme) {
  return {
    primary: {
      main: theme.palette.primary
    }
  };
};

var SdkThemeProvider = function SdkThemeProvider(_ref2) {
  var children = _ref2.children,
      componentTheme = _ref2.componentTheme;
  var theme = useStiggTheme(componentTheme);
  var muiPalette = createMuiPalette(theme);
  return (// We are using styled-components theme here only because we are using styled-typography
    // which depends on styled-components for the typography theming
    React__default.createElement(ThemeProvider, {
      theme: createTheme({
        palette: muiPalette,
        stigg: theme
      })
    }, React__default.createElement(ThemeProvider$1, {
      theme: {
        stigg: theme
      }
    }, React__default.createElement(CustomCssGlobal, {
      customCss: theme.customCss
    }, React__default.createElement(Fonts, {
      externalFontUrl: theme.typography.fontFamilyUrl
    }), React__default.createElement(ThemeProvider$2, {
      theme: {
        typography: createTypographyTheme(theme)
      }
    }, children))))
  );
};

function useCustomerPortal(_ref) {
  var resourceId = _ref.resourceId,
      productId = _ref.productId;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg,
      customerPortalUpdatedAt = _useStiggContext.customerPortalUpdatedAt;

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(),
      customerPortal = _useState2[0],
      setCustomerPortal = _useState2[1];

  useEffect(function () {
    var loadCustomerPortal = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
        var customerPortalData;
        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!stigg.isCustomerLoaded) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 1;
                setIsLoading(true);
                _context.next = 5;
                return stigg.getCustomerPortal({
                  resourceId: resourceId,
                  productId: productId
                });

              case 5:
                customerPortalData = _context.sent;
                setCustomerPortal(customerPortalData);
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                logger.error("Failed to load customer portal " + (_context.t0 == null ? void 0 : _context.t0.message), _context.t0);

              case 12:
                _context.prev = 12;
                setIsLoading(false);
                return _context.finish(12);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 9, 12, 15]]);
      }));

      return function loadCustomerPortal() {
        return _ref2.apply(this, arguments);
      };
    }();

    void loadCustomerPortal();
  }, [stigg, stigg.isCustomerLoaded, customerPortalUpdatedAt, resourceId]);
  return {
    customerPortal: customerPortal,
    isLoading: isLoading
  };
}

function getResolvedCustomerPortalLocalize(localizeOverride) {
  var customerPortalDefaultLocalization = {
    manageSubscription: 'Manage',
    usageTabTitle: 'Usage',
    addonsTabTitle: 'Add-ons',
    promotionsTabTitle: 'Promotions',
    promotionsSubtitle: 'You were granted access to additional functionality at no additional cost.',
    contactSupportTitle: 'Have questions about your subscription?',
    contactSupportLink: 'Contact support',
    editBilling: 'Edit billing details',
    invoicesTitle: 'Invoices',
    viewInvoiceHistory: 'View invoice history',
    editPaymentDetails: 'Edit',
    paywallSectionTitle: 'Plans',
    cancelScheduledUpdatesButtonTitle: 'Cancel'
  };
  return merge(customerPortalDefaultLocalization, localizeOverride);
}

function getResolvedCustomerPortalTheme(globalTheme, themeOverride, remoteConfiguration) {
  var _remoteConfiguration$, _remoteConfiguration$2, _remoteConfiguration$3, _remoteConfiguration$4;

  var customerPortalDefaultTheme = {
    sectionTitleColor: (themeOverride == null ? void 0 : themeOverride.sectionTitleColor) || globalTheme.palette.text.secondary,
    planNameColor: (themeOverride == null ? void 0 : themeOverride.planNameColor) || globalTheme.palette.text.primary,
    backgroundColor: (themeOverride == null ? void 0 : themeOverride.backgroundColor) || (remoteConfiguration == null ? void 0 : (_remoteConfiguration$ = remoteConfiguration.palette) == null ? void 0 : _remoteConfiguration$.backgroundColor) || 'white',
    borderColor: (themeOverride == null ? void 0 : themeOverride.borderColor) || (remoteConfiguration == null ? void 0 : (_remoteConfiguration$2 = remoteConfiguration.palette) == null ? void 0 : _remoteConfiguration$2.borderColor) || 'rgba(0, 30, 108, 0.15)',
    listItemBackgroundColor: (themeOverride == null ? void 0 : themeOverride.backgroundColor) || (remoteConfiguration == null ? void 0 : (_remoteConfiguration$3 = remoteConfiguration.palette) == null ? void 0 : _remoteConfiguration$3.backgroundColor) || 'white',
    tabMaxHeight: (themeOverride == null ? void 0 : themeOverride.tabMaxHeight) || '380px',
    // add icons background color and apply to scheduled updates and customer support icons
    iconsColor: (themeOverride == null ? void 0 : themeOverride.iconsColor) || (remoteConfiguration == null ? void 0 : (_remoteConfiguration$4 = remoteConfiguration.palette) == null ? void 0 : _remoteConfiguration$4.iconsColor) || undefined,
    iconsBackgroundColor: themeOverride == null ? void 0 : themeOverride.iconsBackgroundColor
  };
  return customerPortalDefaultTheme;
}

var CustomerPortalContext = /*#__PURE__*/React__default.createContext(null);
CustomerPortalContext.displayName = 'CustomerPortalContext';
var useCustomerPortalContext = function useCustomerPortalContext() {
  var ctx = useContext(CustomerPortalContext);

  if (!ctx) {
    throw new Error('Could not find Customer portal context; You need to wrap your customer portal components in an <CustomerPortalProvider> component.');
  }

  return ctx;
};
function useCheckContextExists(contextType) {
  var ctx = useContext(contextType);
  return !!ctx;
}
function CustomerPortalProvider(_ref) {
  var children = _ref.children,
      textOverrides = _ref.textOverrides,
      theme = _ref.theme,
      resourceId = _ref.resourceId,
      productId = _ref.productId;

  var _useStiggContext = useStiggContext(),
      customerPortalUpdatedAt = _useStiggContext.customerPortalUpdatedAt;

  var _useCustomerPortal = useCustomerPortal({
    resourceId: resourceId,
    productId: productId
  }),
      customerPortal = _useCustomerPortal.customerPortal,
      isLoading = _useCustomerPortal.isLoading;

  var configuration = customerPortal != null && customerPortal.configuration ? mapCustomerPortalConfiguration(customerPortal.configuration) : undefined;
  var globalTheme = useStiggTheme(configuration);
  var customerPortalTheme = getResolvedCustomerPortalTheme(globalTheme, theme, customerPortal == null ? void 0 : customerPortal.configuration);
  var resolvedTextOverrides = getResolvedCustomerPortalLocalize(textOverrides);
  return React__default.createElement(SdkThemeProvider, {
    componentTheme: configuration
  }, React__default.createElement(CustomerPortalContext.Provider, {
    key: customerPortalUpdatedAt == null ? void 0 : customerPortalUpdatedAt.toString(),
    value: {
      customerPortal: customerPortal,
      isLoading: isLoading,
      textOverrides: resolvedTextOverrides,
      theme: customerPortalTheme,
      resourceId: resourceId
    }
  }, children));
}

var PaywallContainer$1 = function PaywallContainer(_ref) {
  var productId = _ref.productId,
      resourceId = _ref.resourceId,
      highlightedPlanId = _ref.highlightedPlanId,
      showOnlyEligiblePlans = _ref.showOnlyEligiblePlans,
      textOverrides = _ref.textOverrides,
      onPlanSelected = _ref.onPlanSelected,
      preferredBillingPeriod = _ref.preferredBillingPeriod,
      onBillingPeriodChange = _ref.onBillingPeriodChange,
      billingCountryCode = _ref.billingCountryCode;
  var hasCustomerPortalContext = useCheckContextExists(CustomerPortalContext);
  var isCustomerPortalLoading = false;

  if (hasCustomerPortalContext) {
    var _useCustomerPortalCon = useCustomerPortalContext(),
        _isLoading = _useCustomerPortalCon.isLoading,
        customerPortalResourceId = _useCustomerPortalCon.resourceId;

    isCustomerPortalLoading = _isLoading;
    resourceId = customerPortalResourceId;
  }

  var _useLoadPaywallData = useLoadPaywallData({
    productId: productId,
    resourceId: resourceId,
    showOnlyEligiblePlans: showOnlyEligiblePlans,
    billingCountryCode: billingCountryCode,
    preferredBillingPeriod: preferredBillingPeriod
  }),
      plans = _useLoadPaywallData.plans,
      customer = _useLoadPaywallData.customer,
      currentSubscription = _useLoadPaywallData.currentSubscription,
      isCustomerOnTrial = _useLoadPaywallData.isCustomerOnTrial,
      isLoading = _useLoadPaywallData.isLoading,
      selectedBillingPeriod = _useLoadPaywallData.selectedBillingPeriod,
      setSelectedBillingPeriod = _useLoadPaywallData.setSelectedBillingPeriod,
      availableBillingPeriods = _useLoadPaywallData.availableBillingPeriods,
      locale = _useLoadPaywallData.locale,
      configuration = _useLoadPaywallData.configuration;

  var paywallLocale = getResolvedPaywallLocalize(textOverrides);

  var handlePeriodChange = function handlePeriodChange(billingPeriod) {
    setSelectedBillingPeriod(billingPeriod);

    if (onBillingPeriodChange) {
      onBillingPeriodChange(billingPeriod);
    }
  };

  var component = !plans || isLoading || isCustomerPortalLoading ? React__default.createElement(PaywallLoader, null) : React__default.createElement(Paywall, {
    plans: plans,
    customer: customer,
    currentSubscription: currentSubscription,
    selectedBillingPeriod: selectedBillingPeriod,
    onBillingPeriodChanged: handlePeriodChange,
    availableBillingPeriods: availableBillingPeriods,
    highlightedPlanId: highlightedPlanId,
    isLoading: isLoading,
    isCustomerOnTrial: isCustomerOnTrial,
    onPlanSelected: onPlanSelected,
    paywallLocale: paywallLocale,
    locale: locale
  }); // When rendering the paywall in the customer portal context we don't want to apply paywall theme

  if (hasCustomerPortalContext) {
    return component;
  }

  return React__default.createElement(SdkThemeProvider, {
    componentTheme: configuration
  }, component);
};

var StyledButton = /*#__PURE__*/_styled(Button$1, process.env.NODE_ENV === "production" ? {
  target: "emvioms0"
} : {
  target: "emvioms0",
  label: "StyledButton"
})("border-radius:10px;padding:8px 16px;text-transform:none;&,&:hover{border-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.outlinedRestingBorder;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0eWxlZEJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRThDIiwiZmlsZSI6IlN0eWxlZEJ1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCBNdWlCdXR0b24gZnJvbSAnQG11aS9tYXRlcmlhbC9CdXR0b24nO1xyXG5leHBvcnQgY29uc3QgU3R5bGVkQnV0dG9uID0gc3R5bGVkKE11aUJ1dHRvbikgYFxuICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICBwYWRkaW5nOiA4cHggMTZweDtcbiAgdGV4dC10cmFuc2Zvcm06IG5vbmU7XG5cbiAgJixcbiAgJjpob3ZlciB7XG4gICAgYm9yZGVyLWNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnN0aWdnLnBhbGV0dGUub3V0bGluZWRSZXN0aW5nQm9yZGVyfTtcbiAgfVxuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9U3R5bGVkQnV0dG9uLmpzLm1hcCJdfQ== */"));

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    clipRule: "evenodd",
    d: "M13.333 2.5 17.5 6.667 6.667 17.5H2.5v-4.167L13.333 2.5v0Z",
    stroke: "#327EEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var SectionHeader = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ewz8krb0"
} : {
  target: "ewz8krb0",
  label: "SectionHeader"
})("display:flex;align-items:center;justify-content:space-between;", function (_ref) {
  var $disableMargin = _ref.$disableMargin;
  return !$disableMargin && "\n    &:not(:last-child) {\n      margin-bottom: 32px;\n    }\n  ";
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY3Rpb25IZWFkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ3dDIiwiZmlsZSI6IlNlY3Rpb25IZWFkZXIudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmV4cG9ydCBjb25zdCBTZWN0aW9uSGVhZGVyID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcblxuICAkeyh7ICRkaXNhYmxlTWFyZ2luIH0pID0+ICEkZGlzYWJsZU1hcmdpbiAmJiBgXG4gICAgJjpub3QoOmxhc3QtY2hpbGQpIHtcbiAgICAgIG1hcmdpbi1ib3R0b206IDMycHg7XG4gICAgfVxuICBgfTtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVNlY3Rpb25IZWFkZXIuanMubWFwIl19 */"));

function SectionTitle(_ref) {
  var title = _ref.title,
      className = _ref.className,
      isLoading = _ref.isLoading;

  var _useCustomerPortalCon = useCustomerPortalContext(),
      theme = _useCustomerPortalCon.theme;

  if (isLoading) {
    return React__default.createElement(Skeleton$1, {
      width: 120
    });
  }

  return React__default.createElement(Typography, {
    className: className,
    overrideColor: theme.sectionTitleColor,
    variant: "h3",
    bold: true
  }, title);
}

var StyledEditIcon = /*#__PURE__*/_styled(SvgEditIcon, process.env.NODE_ENV === "production" ? {
  target: "e1fjw26b0"
} : {
  target: "e1fjw26b0",
  label: "StyledEditIcon"
})("path{stroke:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.primary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function SubscriptionsOverviewHeader(_ref2) {
  var onManageSubscription = _ref2.onManageSubscription,
      hideManageButton = _ref2.hideManageButton,
      textOverrides = _ref2.textOverrides;
  return React__default.createElement(SectionHeader, {
    className: "stigg-customer-portal-overview-header",
    "$disableMargin": true
  }, React__default.createElement(SectionTitle, {
    title: 'Subscription',
    className: "stigg-overview-title"
  }), !hideManageButton && React__default.createElement(StyledButton, {
    className: "stigg-manage-subscription-button",
    variant: "outlined",
    onClick: onManageSubscription
  }, React__default.createElement(StyledEditIcon, {
    className: "stigg-manage-subscription-button-image"
  }), React__default.createElement(Typography, {
    className: "stigg-manage-subscription-button-text",
    color: "primary.main",
    style: {
      marginLeft: '8px'
    },
    variant: "body1"
  }, textOverrides == null ? void 0 : textOverrides.manageSubscription)));
}

function AddonsList() {
  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal;

  var addons = flatMap(customerPortal == null ? void 0 : customerPortal.subscriptions, function (subscription) {
    return subscription.addons;
  });

  if (isEmpty(addons)) {
    return null;
  }

  return React__default.createElement("div", {
    className: "stigg-addons-list-layout"
  }, addons.map(function (addon, index) {
    return React__default.createElement(Typography, {
      key: addon.addonId,
      span: true,
      className: "stigg-addon-list-item-text",
      variant: "body1"
    }, addon.quantity > 1 && addon.quantity + " X ", addon.displayName, index === addons.length - 1 ? '' : ', ');
  }));
}

var Row = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1g6q2f50"
} : {
  target: "e1g6q2f50",
  label: "Row"
})("display:flex;justify-content:space-between;align-items:center;gap:64px;border-bottom:", function (_ref) {
  var $borderColor = _ref.$borderColor;
  return "1px solid " + $borderColor;
}, ";padding:16px 0;&>*:first-child{max-width:60%;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByb21vdGlvbnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUt1QiIsImZpbGUiOiJQcm9tb3Rpb25zLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBtb21lbnQgZnJvbSAnbW9tZW50JztcclxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHsgVHlwb2dyYXBoeSB9IGZyb20gJy4uLy4uLy4uL2NvbW1vbi9UeXBvZ3JhcGh5JztcclxuaW1wb3J0IHsgdXNlQ3VzdG9tZXJQb3J0YWxDb250ZXh0IH0gZnJvbSAnLi4vLi4vQ3VzdG9tZXJQb3J0YWxQcm92aWRlcic7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuY29uc3QgUm93ID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZ2FwOiA2NHB4O1xuICBib3JkZXItYm90dG9tOiAkeyh7ICRib3JkZXJDb2xvciB9KSA9PiBgMXB4IHNvbGlkICR7JGJvcmRlckNvbG9yfWB9O1xuICBwYWRkaW5nOiAxNnB4IDA7XG5cbiAgJiA+ICo6Zmlyc3QtY2hpbGQge1xuICAgIG1heC13aWR0aDogNjAlO1xuICB9XG5gO1xyXG5mdW5jdGlvbiBnZXRQcm9tb3Rpb25UaXRsZShwcm9tb3Rpb25hbEVudGl0bGVtZW50KSB7XHJcbiAgICBjb25zdCB7IGRpc3BsYXlOYW1lLCB1c2FnZUxpbWl0LCBoYXNVbmxpbWl0ZWRVc2FnZSB9ID0gcHJvbW90aW9uYWxFbnRpdGxlbWVudDtcclxuICAgIGlmIChoYXNVbmxpbWl0ZWRVc2FnZSkge1xyXG4gICAgICAgIHJldHVybiBgVW5saW1pdGVkICR7ZGlzcGxheU5hbWV9YDtcclxuICAgIH1cclxuICAgIGlmICh1c2FnZUxpbWl0KSB7XHJcbiAgICAgICAgcmV0dXJuIGAke2Rpc3BsYXlOYW1lfSB4ICR7cHJvbW90aW9uYWxFbnRpdGxlbWVudC51c2FnZUxpbWl0Py50b0xvY2FsZVN0cmluZygpfWA7XHJcbiAgICB9XHJcbiAgICByZXR1cm4gZGlzcGxheU5hbWU7XHJcbn1cclxuZXhwb3J0IGZ1bmN0aW9uIFByb21vdGlvbnMoKSB7XHJcbiAgICBjb25zdCB7IGN1c3RvbWVyUG9ydGFsLCB0ZXh0T3ZlcnJpZGVzLCB0aGVtZSB9ID0gdXNlQ3VzdG9tZXJQb3J0YWxDb250ZXh0KCk7XHJcbiAgICBjb25zdCBwcm9tb3Rpb25hbEVudGl0bGVtZW50cyA9IGN1c3RvbWVyUG9ydGFsPy5wcm9tb3Rpb25hbEVudGl0bGVtZW50cztcclxuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChcImRpdlwiLCB7IHN0eWxlOiB7IGRpc3BsYXk6ICdmbGV4JywgZmxleERpcmVjdGlvbjogJ2NvbHVtbicgfSB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoVHlwb2dyYXBoeSwgeyBjb2xvcjogXCJzZWNvbmRhcnlcIiB9LCB0ZXh0T3ZlcnJpZGVzLnByb21vdGlvbnNTdWJ0aXRsZSksXHJcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChcImRpdlwiLCB7IHN0eWxlOiB7IGRpc3BsYXk6ICdmbGV4JywgZmxleERpcmVjdGlvbjogJ2NvbHVtbicgfSB9LFxyXG4gICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFJvdywgeyBcIiRib3JkZXJDb2xvclwiOiB0aGVtZS5ib3JkZXJDb2xvciB9LFxyXG4gICAgICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChUeXBvZ3JhcGh5LCB7IHZhcmlhbnQ6IFwiYm9keTFcIiwgYm9sZDogdHJ1ZSB9LCBcIkZlYXR1cmVcIiksXHJcbiAgICAgICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFR5cG9ncmFwaHksIHsgdmFyaWFudDogXCJib2R5MVwiLCBib2xkOiB0cnVlIH0sIFwiRXhwaXJhdGlvbiBkYXRlXCIpKSxcclxuICAgICAgICAgICAgcHJvbW90aW9uYWxFbnRpdGxlbWVudHM/Lm1hcChwcm9tb3Rpb25hbEVudGl0bGVtZW50ID0+IChSZWFjdC5jcmVhdGVFbGVtZW50KFJvdywgeyBcIiRib3JkZXJDb2xvclwiOiB0aGVtZS5ib3JkZXJDb2xvciB9LFxyXG4gICAgICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChUeXBvZ3JhcGh5LCB7IHZhcmlhbnQ6IFwiYm9keTFcIiB9LCBnZXRQcm9tb3Rpb25UaXRsZShwcm9tb3Rpb25hbEVudGl0bGVtZW50KSksXHJcbiAgICAgICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFR5cG9ncmFwaHksIHsgdmFyaWFudDogXCJib2R5MVwiLCBjb2xvcjogXCJkaXNhYmxlZFwiIH0sIHByb21vdGlvbmFsRW50aXRsZW1lbnQuZW5kRGF0ZVxyXG4gICAgICAgICAgICAgICAgICAgID8gbW9tZW50LnV0Yyhwcm9tb3Rpb25hbEVudGl0bGVtZW50LmVuZERhdGUpLmZvcm1hdCgnTU1NIERvLCBZWVlZJylcclxuICAgICAgICAgICAgICAgICAgICA6ICdOb25lJykpKSkpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9UHJvbW90aW9ucy5qcy5tYXAiXX0= */"));

function getPromotionTitle(promotionalEntitlement) {
  var displayName = promotionalEntitlement.displayName,
      usageLimit = promotionalEntitlement.usageLimit,
      hasUnlimitedUsage = promotionalEntitlement.hasUnlimitedUsage;

  if (hasUnlimitedUsage) {
    return "Unlimited " + displayName;
  }

  if (usageLimit) {
    var _promotionalEntitleme;

    return displayName + " x " + ((_promotionalEntitleme = promotionalEntitlement.usageLimit) == null ? void 0 : _promotionalEntitleme.toLocaleString());
  }

  return displayName;
}

function Promotions() {
  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal,
      textOverrides = _useCustomerPortalCon.textOverrides,
      theme = _useCustomerPortalCon.theme;

  var promotionalEntitlements = customerPortal == null ? void 0 : customerPortal.promotionalEntitlements;
  return React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement(Typography, {
    color: "secondary"
  }, textOverrides.promotionsSubtitle), React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement(Row, {
    "$borderColor": theme.borderColor
  }, React__default.createElement(Typography, {
    variant: "body1",
    bold: true
  }, "Feature"), React__default.createElement(Typography, {
    variant: "body1",
    bold: true
  }, "Expiration date")), promotionalEntitlements == null ? void 0 : promotionalEntitlements.map(function (promotionalEntitlement) {
    return React__default.createElement(Row, {
      "$borderColor": theme.borderColor
    }, React__default.createElement(Typography, {
      variant: "body1"
    }, getPromotionTitle(promotionalEntitlement)), React__default.createElement(Typography, {
      variant: "body1",
      color: "disabled"
    }, promotionalEntitlement.endDate ? moment.utc(promotionalEntitlement.endDate).format('MMM Do, YYYY') : 'None'));
  })));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledTabs = /*#__PURE__*/_styled(Tabs, process.env.NODE_ENV === "production" ? {
  target: "exlfw3j3"
} : {
  target: "exlfw3j3",
  label: "StyledTabs"
})(process.env.NODE_ENV === "production" ? {
  name: "jlwfj4",
  styles: ".MuiTabs-indicator{background-color:#001e6c;}"
} : {
  name: "jlwfj4",
  styles: ".MuiTabs-indicator{background-color:#001e6c;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YnNjcmlwdGlvblRhYnMuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd1QyIsImZpbGUiOiJTdWJzY3JpcHRpb25UYWJzLnN0eWxlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IEJveCBmcm9tICdAbXVpL21hdGVyaWFsL0JveCc7XHJcbmltcG9ydCBUYWJzIGZyb20gJ0BtdWkvbWF0ZXJpYWwvVGFicyc7XHJcbmV4cG9ydCBjb25zdCBTdHlsZWRUYWJzID0gc3R5bGVkKFRhYnMpIGBcbiAgLk11aVRhYnMtaW5kaWNhdG9yIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMDAxZTZjO1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgVGFic0xheW91dCA9IHN0eWxlZC5kaXYgYFxuICB3aWR0aDogMTAwJTtcbiAgZmxleDogMTtcbiAgbWFyZ2luLXRvcDogMTZweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUYWJDb250ZW50ID0gc3R5bGVkKEJveCkgYFxuICBtYXJnaW4tdG9wOiAxNnB4O1xuICBtYXgtaGVpZ2h0OiAkeyh7ICRtYXhIZWlnaHQgfSkgPT4gJG1heEhlaWdodH07XG4gIG92ZXJmbG93LXk6IGF1dG87XG5gO1xyXG5leHBvcnQgY29uc3QgTGlzdEJveCA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBwYWRkaW5nOiAyNHB4O1xuICBib3JkZXI6ICR7KHsgJGJvcmRlckNvbG9yIH0pID0+IGAxcHggc29saWQgJHskYm9yZGVyQ29sb3J9YH07XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDE2cHg7XG4gIHJvdy1nYXA6IDE2cHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgJGJhY2tncm91bmRDb2xvciB9KSA9PiAkYmFja2dyb3VuZENvbG9yfTtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1YnNjcmlwdGlvblRhYnMuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
var TabsLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "exlfw3j2"
} : {
  target: "exlfw3j2",
  label: "TabsLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "1dqkbz0",
  styles: "width:100%;flex:1;margin-top:16px"
} : {
  name: "1dqkbz0",
  styles: "width:100%;flex:1;margin-top:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YnNjcmlwdGlvblRhYnMuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFxQyIsImZpbGUiOiJTdWJzY3JpcHRpb25UYWJzLnN0eWxlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IEJveCBmcm9tICdAbXVpL21hdGVyaWFsL0JveCc7XHJcbmltcG9ydCBUYWJzIGZyb20gJ0BtdWkvbWF0ZXJpYWwvVGFicyc7XHJcbmV4cG9ydCBjb25zdCBTdHlsZWRUYWJzID0gc3R5bGVkKFRhYnMpIGBcbiAgLk11aVRhYnMtaW5kaWNhdG9yIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMDAxZTZjO1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgVGFic0xheW91dCA9IHN0eWxlZC5kaXYgYFxuICB3aWR0aDogMTAwJTtcbiAgZmxleDogMTtcbiAgbWFyZ2luLXRvcDogMTZweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUYWJDb250ZW50ID0gc3R5bGVkKEJveCkgYFxuICBtYXJnaW4tdG9wOiAxNnB4O1xuICBtYXgtaGVpZ2h0OiAkeyh7ICRtYXhIZWlnaHQgfSkgPT4gJG1heEhlaWdodH07XG4gIG92ZXJmbG93LXk6IGF1dG87XG5gO1xyXG5leHBvcnQgY29uc3QgTGlzdEJveCA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBwYWRkaW5nOiAyNHB4O1xuICBib3JkZXI6ICR7KHsgJGJvcmRlckNvbG9yIH0pID0+IGAxcHggc29saWQgJHskYm9yZGVyQ29sb3J9YH07XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDE2cHg7XG4gIHJvdy1nYXA6IDE2cHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgJGJhY2tncm91bmRDb2xvciB9KSA9PiAkYmFja2dyb3VuZENvbG9yfTtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1YnNjcmlwdGlvblRhYnMuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
var TabContent = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "exlfw3j1"
} : {
  target: "exlfw3j1",
  label: "TabContent"
})("margin-top:16px;max-height:", function (_ref) {
  var $maxHeight = _ref.$maxHeight;
  return $maxHeight;
}, ";overflow-y:auto;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YnNjcmlwdGlvblRhYnMuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWFzQyIsImZpbGUiOiJTdWJzY3JpcHRpb25UYWJzLnN0eWxlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IEJveCBmcm9tICdAbXVpL21hdGVyaWFsL0JveCc7XHJcbmltcG9ydCBUYWJzIGZyb20gJ0BtdWkvbWF0ZXJpYWwvVGFicyc7XHJcbmV4cG9ydCBjb25zdCBTdHlsZWRUYWJzID0gc3R5bGVkKFRhYnMpIGBcbiAgLk11aVRhYnMtaW5kaWNhdG9yIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjMDAxZTZjO1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgVGFic0xheW91dCA9IHN0eWxlZC5kaXYgYFxuICB3aWR0aDogMTAwJTtcbiAgZmxleDogMTtcbiAgbWFyZ2luLXRvcDogMTZweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBUYWJDb250ZW50ID0gc3R5bGVkKEJveCkgYFxuICBtYXJnaW4tdG9wOiAxNnB4O1xuICBtYXgtaGVpZ2h0OiAkeyh7ICRtYXhIZWlnaHQgfSkgPT4gJG1heEhlaWdodH07XG4gIG92ZXJmbG93LXk6IGF1dG87XG5gO1xyXG5leHBvcnQgY29uc3QgTGlzdEJveCA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBwYWRkaW5nOiAyNHB4O1xuICBib3JkZXI6ICR7KHsgJGJvcmRlckNvbG9yIH0pID0+IGAxcHggc29saWQgJHskYm9yZGVyQ29sb3J9YH07XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDE2cHg7XG4gIHJvdy1nYXA6IDE2cHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgJGJhY2tncm91bmRDb2xvciB9KSA9PiAkYmFja2dyb3VuZENvbG9yfTtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1YnNjcmlwdGlvblRhYnMuc3R5bGUuanMubWFwIl19 */"));
var ListBox = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "exlfw3j0"
} : {
  target: "exlfw3j0",
  label: "ListBox"
})("display:flex;flex-direction:column;padding:24px;border:", function (_ref2) {
  var $borderColor = _ref2.$borderColor;
  return "1px solid " + $borderColor;
}, ";border-radius:10px;margin-bottom:16px;row-gap:16px;background-color:", function (_ref3) {
  var $backgroundColor = _ref3.$backgroundColor;
  return $backgroundColor;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YnNjcmlwdGlvblRhYnMuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtCa0MiLCJmaWxlIjoiU3Vic2NyaXB0aW9uVGFicy5zdHlsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCBCb3ggZnJvbSAnQG11aS9tYXRlcmlhbC9Cb3gnO1xyXG5pbXBvcnQgVGFicyBmcm9tICdAbXVpL21hdGVyaWFsL1RhYnMnO1xyXG5leHBvcnQgY29uc3QgU3R5bGVkVGFicyA9IHN0eWxlZChUYWJzKSBgXG4gIC5NdWlUYWJzLWluZGljYXRvciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogIzAwMWU2YztcbiAgfVxuYDtcclxuZXhwb3J0IGNvbnN0IFRhYnNMYXlvdXQgPSBzdHlsZWQuZGl2IGBcbiAgd2lkdGg6IDEwMCU7XG4gIGZsZXg6IDE7XG4gIG1hcmdpbi10b3A6IDE2cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVGFiQ29udGVudCA9IHN0eWxlZChCb3gpIGBcbiAgbWFyZ2luLXRvcDogMTZweDtcbiAgbWF4LWhlaWdodDogJHsoeyAkbWF4SGVpZ2h0IH0pID0+ICRtYXhIZWlnaHR9O1xuICBvdmVyZmxvdy15OiBhdXRvO1xuYDtcclxuZXhwb3J0IGNvbnN0IExpc3RCb3ggPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgcGFkZGluZzogMjRweDtcbiAgYm9yZGVyOiAkeyh7ICRib3JkZXJDb2xvciB9KSA9PiBgMXB4IHNvbGlkICR7JGJvcmRlckNvbG9yfWB9O1xuICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICBtYXJnaW4tYm90dG9tOiAxNnB4O1xuICByb3ctZ2FwOiAxNnB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7ICRiYWNrZ3JvdW5kQ29sb3IgfSkgPT4gJGJhY2tncm91bmRDb2xvcn07XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1TdWJzY3JpcHRpb25UYWJzLnN0eWxlLmpzLm1hcCJdfQ== */"));

var getIconColor = function getIconColor(color, theme) {
  switch (color) {
    case 'primary':
      return theme.stigg.palette.text.primary;

    case 'secondary':
      return theme.stigg.palette.text.secondary;

    default:
      return color;
  }
};

var _g, _defs;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgAddons = function SvgAddons(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/createElement("g", {
    clipPath: "url(#addons_svg__a)",
    stroke: "#7586B0",
    strokeWidth: 1.714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M12 6.857v10.286M6.857 12h10.286M18 .857H6A5.143 5.143 0 0 0 .857 6v12A5.143 5.143 0 0 0 6 23.143h12A5.143 5.143 0 0 0 23.143 18V6A5.143 5.143 0 0 0 18 .857Z"
  }))), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "addons_svg__a"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

var _rect, _path$4, _path2;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var SvgBillingInfoCustomer = function SvgBillingInfoCustomer(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#F5F6F9"
  })), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M26 27v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2",
    stroke: "#7586B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    clipRule: "evenodd",
    d: "M18 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    stroke: "#7586B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _rect$1, _path$5, _path2$1, _path3;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var SvgContactSupport = function SvgContactSupport(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#F5F6F9"
  })), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M27 18.22C27 12.73 22.74 9 18 9c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V25h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62Z",
    fill: "#7586B0"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/createElement("path", {
    d: "M15 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM21 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: "#7586B0"
  })), _path3 || (_path3 = /*#__PURE__*/createElement("path", {
    d: "M24 17.03A6.04 6.04 0 0 0 18.05 12c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 0 0 4.86-5.89c1.31 2.63 4 4.44 7.12 4.47Z",
    fill: "#7586B0"
  })));
};

var _rect$2, _path$6;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#F5F6F9"
  })), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M26 10H10c-1.11 0-1.99.89-1.99 2L8 24c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V12c0-1.11-.89-2-2-2Zm0 14H10v-6h16v6Zm0-10H10v-2h16v2Z",
    fill: "#7586B0"
  })));
};

var _g$1, _defs$1;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var SvgDollarCoin = function SvgDollarCoin(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#dollar-coin_svg__a)",
    stroke: "#7586B0",
    strokeWidth: 1.714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M10.334 19.286A9.286 9.286 0 1 0 1.048 10a9.286 9.286 0 0 0 9.286 9.286Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.765 7.46a1.903 1.903 0 0 0-1.796-1.27H9.494a1.7 1.7 0 0 0-.363 3.362l2.245.49a1.905 1.905 0 0 1-.407 3.768h-1.27c-.83 0-1.535-.53-1.797-1.27M10.334 6.19V4.287M10.334 15.714V13.81"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "dollar-coin_svg__a"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(.333)",
    d: "M0 0h20v20H0z"
  })))));
};

var _g$2, _defs$2;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var SvgPromotions = function SvgPromotions(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#promotions_svg__a)",
    stroke: "#7586B0",
    strokeWidth: 1.714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.429 5.325H2.57c-.946 0-1.714.767-1.714 1.714v3.429c0 .947.768 1.714 1.714 1.714H21.43c.946 0 1.714-.768 1.714-1.714V7.039c0-.947-.768-1.714-1.714-1.714ZM21.429 12.182v9.429a1.714 1.714 0 0 1-1.715 1.714H4.286a1.714 1.714 0 0 1-1.714-1.714v-9.429M12 5.325v18M17.143 1.04 12 5.324 6.857 1.039"
  }))), _defs$2 || (_defs$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "promotions_svg__a"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(0 .182)",
    d: "M0 0h24v24H0z"
  })))));
};

var _path$7;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
var SvgRestore = function SvgRestore(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M10.833 2.5a7.5 7.5 0 0 0-7.5 7.5h-2.5l3.242 3.242.058.116L7.5 10H5a5.829 5.829 0 0 1 5.833-5.833A5.83 5.83 0 0 1 16.667 10a5.83 5.83 0 0 1-5.834 5.833 5.786 5.786 0 0 1-4.116-1.716L5.533 15.3a7.462 7.462 0 0 0 5.3 2.2 7.5 7.5 0 0 0 0-15ZM10 6.667v4.166l3.567 2.117.6-1.008-2.917-1.734V6.667H10Z",
    fill: "#6678A7"
  })));
};

var _rect$3, _rect2, _path$8, _defs$3;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
var SvgScheduleBox = function SvgScheduleBox(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "url(#schedule-box_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#F5F6F9"
  })), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.954 7.7a1 1 0 0 1-.654 1.254 8.998 8.998 0 0 0-1.543 16.523A9 9 0 0 0 27 17.54a1 1 0 1 1 2 0c0 .357-.017.713-.052 1.066.018.089.024.182.017.278l-.004.047a.997.997 0 0 1-.101.361A11 11 0 1 1 14.7 7.046a1 1 0 0 1 1.254.654Zm1.896.252a1 1 0 0 1 1.08-.912l.048.004a1 1 0 1 1-.178 1.992l-.038-.003a1 1 0 0 1-.912-1.081ZM22.858 9.2a1 1 0 0 1 1.391-.254l.078.054a1 1 0 1 1-1.152 1.635 8.98 8.98 0 0 0-.063-.044 1 1 0 0 1-.254-1.391Zm3.748 3.609a1 1 0 0 1 1.332.473l.04.085a1 1 0 1 1-1.813.844l-.014-.031-.019-.039a1 1 0 0 1 .474-1.332ZM19 14a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-3v-3Z",
    fill: "#7586B0"
  })), _defs$3 || (_defs$3 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
    id: "schedule-box_svg__a",
    x1: 35.02,
    y1: 1.224,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }))));
};

var _path$9;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.954 1.7A1 1 0 0 1 9.3 2.954a8.998 8.998 0 0 0-5.615 12.03A9 9 0 0 0 21 11.54a1 1 0 1 1 2 0c0 .357-.017.713-.052 1.066.018.089.024.182.017.278l-.004.047a.997.997 0 0 1-.101.361A11 11 0 1 1 8.7 1.046a1 1 0 0 1 1.254.654Zm1.896.252a1 1 0 0 1 1.08-.912l.048.004a1 1 0 1 1-.178 1.992l-.039-.003a1 1 0 0 1-.911-1.081ZM16.858 3.2a1 1 0 0 1 1.391-.254l.078.054a1 1 0 1 1-1.152 1.635 9.7 9.7 0 0 0-.063-.044 1 1 0 0 1-.254-1.391Zm3.748 3.608a1 1 0 0 1 1.332.474l.04.085a1 1 0 1 1-1.813.844l-.014-.031-.019-.039a1 1 0 0 1 .474-1.333ZM13 8a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-3V8Z",
    fill: "#7586B0"
  })));
};

var _rect$4, _path$a, _path2$2;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
var SvgSubscriptionRenewsIcon = function SvgSubscriptionRenewsIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$4 || (_rect$4 = /*#__PURE__*/createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "#F5F6F9"
  })), _path$a || (_path$a = /*#__PURE__*/createElement("path", {
    clipRule: "evenodd",
    d: "M9 12a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V12Z",
    stroke: "#7586B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/createElement("path", {
    d: "M22 8v4M14 8v4M9 16h18",
    stroke: "#7586B0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$b, _path2$3, _path3$1;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/createElement("path", {
    d: "M3 6h18",
    stroke: "#F88078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/createElement("path", {
    d: "M20 6a1 1 0 1 0-2 0h2ZM6 6a1 1 0 0 0-2 0h2Zm1 0a1 1 0 0 0 2 0H7Zm8 0a1 1 0 1 0 2 0h-2Zm3 0v14h2V6h-2Zm0 14a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3h-2Zm-1 1H7v2h10v-2ZM7 21a1 1 0 0 1-1-1H4a3 3 0 0 0 3 3v-2Zm-1-1V6H4v14h2ZM9 6V4H7v2h2Zm0-2a1 1 0 0 1 1-1V1a3 3 0 0 0-3 3h2Zm1-1h4V1h-4v2Zm4 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3v2Zm1 1v2h2V4h-2Z",
    fill: "#F88078"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/createElement("path", {
    d: "M10 11v6M14 11v6",
    stroke: "#F88078",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$c, _path2$4;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
var SvgPaymentMethod = function SvgPaymentMethod(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/createElement("path", {
    d: "M21.167 4H2.833C1.821 4 1 4.895 1 6v12c0 1.105.82 2 1.833 2h18.334C22.179 20 23 19.105 23 18V6c0-1.105-.82-2-1.833-2Z",
    fill: "#C6C6C7"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/createElement("path", {
    opacity: 0.3,
    d: "M19.75 16.429H17.5c-.488 0-.75-.229-.75-.762 0-.534.262-.762.75-.762h2.25c.488 0 .75.228.75.762 0 .533-.262.762-.75.762Zm-4.5 0H13c-.488 0-.75-.229-.75-.762 0-.534.262-.762.75-.762h2.25c.488 0 .75.228.75.762 0 .533-.262.762-.75.762Zm-4.5 0H8.5c-.488 0-.75-.229-.75-.762 0-.534.262-.762.75-.762h2.25c.488 0 .75.228.75.762 0 .533-.262.762-.75.762Zm-4.5 0H4c-.487 0-.75-.229-.75-.762 0-.534.263-.762.75-.762h2.25c.487 0 .75.228.75.762 0 .533-.263.762-.75.762Z",
    fill: "#000"
  })));
};

var _circle;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
var SvgOutlinedCircle = function SvgOutlinedCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/createElement("circle", {
    cx: 10.333,
    cy: 10,
    r: 9,
    fill: "#fff",
    stroke: "#327EEE",
    strokeWidth: 2
  })));
};

var _circle$1, _path$d;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
var SvgOutlinedCheckedCircle = function SvgOutlinedCheckedCircle(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    fill: "#327EEE",
    stroke: "#327EEE",
    strokeWidth: 1.5
  })), _path$d || (_path$d = /*#__PURE__*/createElement("path", {
    d: "M5 10.364 8.637 14l4-4 2-2",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _circle$2, _path$e;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
var SvgOutlinedCheckedCircleDisabled = function SvgOutlinedCheckedCircleDisabled(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/createElement("circle", {
    cx: 10.667,
    cy: 10,
    r: 9.25,
    fill: "#B3BCD3",
    stroke: "#B3BCD3",
    strokeWidth: 1.5
  })), _path$e || (_path$e = /*#__PURE__*/createElement("path", {
    d: "M5.667 10.364 9.304 14l4-4 2-2",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _path$f;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
var SvgArrowForward = function SvgArrowForward(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/createElement("path", {
    d: "M9 3 7.942 4.058l4.185 4.192H3v1.5h9.127l-4.185 4.193L9 15l6-6-6-6Z",
    fill: "#fff"
  })));
};

var _path$g;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/createElement("path", {
    d: "m15.834 5.342-1.175-1.175L10 8.825 5.342 4.167 4.167 5.342 8.825 10 4.167 14.66l1.175 1.175L10 11.175l4.659 4.659 1.175-1.175L11.175 10l4.659-4.658Z",
    fill: "#327EEE"
  })));
};

var _path$h;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/createElement("path", {
    d: "M20 7 9 18l-5-5",
    stroke: "#F5F6F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var _g$3, _defs$4;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
var SvgPayAsYouGoCharge = function SvgPayAsYouGoCharge(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#pay-as-you-go-charge_svg__a)",
    stroke: "#7586B0",
    strokeWidth: 1.714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M11.429 7.426 8 13.14M14.857 13.141a7.428 7.428 0 1 0-13.714 0h13.714Z"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "pay-as-you-go-charge_svg__a"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};

var _g$4;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
var SvgCoupon = function SvgCoupon(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/createElement("g", {
    stroke: "#327EEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "m1.27 11.943 4.787 4.787a.923.923 0 0 0 1.305 0l9.501-9.501A.443.443 0 0 0 17 6.872l-.727-4.714a.455.455 0 0 0-.43-.43l-4.714-.726a.443.443 0 0 0-.357.135L1.27 10.638a.923.923 0 0 0 0 1.305Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.555 6.059a.615.615 0 1 1 0-1.23.615.615 0 0 1 0 1.23Z"
  }))));
};



var customIcons = {
  __proto__: null,
  Addons: SvgAddons,
  BillingInfoCustomer: SvgBillingInfoCustomer,
  ContactSupport: SvgContactSupport,
  CreditCard: SvgCreditCard,
  DollarCoin: SvgDollarCoin,
  MiniSchedule: SvgMiniSchedule,
  Promotions: SvgPromotions,
  Restore: SvgRestore,
  ScheduleBox: SvgScheduleBox,
  ScheduleClock: SvgSchedule,
  RenewSubscription: SvgSubscriptionRenewsIcon,
  Trash: SvgTrash,
  PaymentMethod: SvgPaymentMethod,
  OutlinedCircle: SvgOutlinedCircle,
  OutlinedCheckedCircle: SvgOutlinedCheckedCircle,
  OutlinedCheckedCircleDisabled: SvgOutlinedCheckedCircleDisabled,
  ArrowForward: SvgArrowForward,
  Close: SvgClose,
  Check: SvgCheck,
  PayAsYouGoCharge: SvgPayAsYouGoCharge,
  Coupon: SvgCoupon
};

var _templateObject$3, _templateObject2, _templateObject3;

var IconWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ds7xyn0"
} : {
  target: "e1ds7xyn0",
  label: "IconWrapper"
})(function (_ref) {
  var $pathColor = _ref.$pathColor;
  return $pathColor && css(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n      path {\n        fill: ", ";\n      }\n    "])), $pathColor);
}, " ", function (_ref2) {
  var $rectColor = _ref2.$rectColor;
  return $rectColor && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      svg rect {\n        fill: ", ";\n      }\n    "])), $rectColor);
}, " ", function (_ref3) {
  var $strokeColor = _ref3.$strokeColor;
  return $strokeColor && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      g {\n        stroke: ", ";\n      }\n    "])), $strokeColor);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkljb24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUsrQiIsImZpbGUiOiJJY29uLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHsgY3NzLCB1c2VUaGVtZSB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcclxuaW1wb3J0IHsgZ2V0SWNvbkNvbG9yIH0gZnJvbSAnLi9pY29uQ29sb3InO1xyXG5pbXBvcnQgKiBhcyBjdXN0b21JY29ucyBmcm9tICcuL2N1c3RvbUljb25zJztcclxuY29uc3QgSWNvbldyYXBwZXIgPSBzdHlsZWQuZGl2IGBcbiAgJHsoeyAkcGF0aENvbG9yIH0pID0+ICRwYXRoQ29sb3IgJiZcclxuICAgIGNzcyBgXG4gICAgICBwYXRoIHtcbiAgICAgICAgZmlsbDogJHskcGF0aENvbG9yfTtcbiAgICAgIH1cbiAgICBgfVxuXG4gICR7KHsgJHJlY3RDb2xvciB9KSA9PiAkcmVjdENvbG9yICYmXHJcbiAgICBjc3MgYFxuICAgICAgc3ZnIHJlY3Qge1xuICAgICAgICBmaWxsOiAkeyRyZWN0Q29sb3J9O1xuICAgICAgfVxuICAgIGB9XG5cblxuICAkeyh7ICRzdHJva2VDb2xvciB9KSA9PiAkc3Ryb2tlQ29sb3IgJiZcclxuICAgIGNzcyBgXG4gICAgICBnIHtcbiAgICAgICAgc3Ryb2tlOiAkeyRzdHJva2VDb2xvcn07XG4gICAgICB9XG4gICAgYH1cbmA7XHJcbmV4cG9ydCBmdW5jdGlvbiBJY29uKHsgaWNvbiwgY2xhc3NOYW1lLCBzdHlsZSwgc3ZnUGF0aENvbG9yLCBzdmdSZWN0Q29sb3IsIHN2Z1N0cm9rZUNvbG9yIH0pIHtcclxuICAgIGNvbnN0IEljb25Db21wb25lbnQgPSBjdXN0b21JY29uc1tpY29uXTtcclxuICAgIGNvbnN0IHRoZW1lID0gdXNlVGhlbWUoKTtcclxuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChJY29uV3JhcHBlciwgeyBjbGFzc05hbWU6IGNsYXNzTmFtZSwgc3R5bGU6IHN0eWxlLCBcIiRwYXRoQ29sb3JcIjogZ2V0SWNvbkNvbG9yKHN2Z1BhdGhDb2xvciwgdGhlbWUpLCBcIiRyZWN0Q29sb3JcIjogZ2V0SWNvbkNvbG9yKHN2Z1JlY3RDb2xvciwgdGhlbWUpLCBcIiRzdHJva2VDb2xvclwiOiBnZXRJY29uQ29sb3Ioc3ZnU3Ryb2tlQ29sb3IsIHRoZW1lKSB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoSWNvbkNvbXBvbmVudCwgbnVsbCkpKTtcclxufVxyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1JY29uLmpzLm1hcCJdfQ== */"));

function Icon(_ref4) {
  var icon = _ref4.icon,
      className = _ref4.className,
      style = _ref4.style,
      svgPathColor = _ref4.svgPathColor,
      svgRectColor = _ref4.svgRectColor,
      svgStrokeColor = _ref4.svgStrokeColor;
  var IconComponent = customIcons[icon];
  var theme = useTheme();
  return React__default.createElement(IconWrapper, {
    className: className,
    style: style,
    "$pathColor": getIconColor(svgPathColor, theme),
    "$rectColor": getIconColor(svgRectColor, theme),
    "$strokeColor": getIconColor(svgStrokeColor, theme)
  }, React__default.createElement(IconComponent, null));
}

var _excluded$2 = ["children", "value", "index", "maxHeight"];

function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      maxHeight = props.maxHeight,
      other = _objectWithoutPropertiesLoose(props, _excluded$2);

  return React__default.createElement("div", Object.assign({
    role: "tabpanel",
    hidden: value !== index
  }, other), value === index && React__default.createElement(TabContent, {
    "$maxHeight": maxHeight
  }, children));
}

function TabTitle(_ref) {
  var isSelected = _ref.isSelected,
      label = _ref.label,
      icon = _ref.icon;
  var color = isSelected ? 'primary' : 'secondary';
  return React__default.createElement("div", {
    style: {
      display: 'flex',
      gap: 8,
      alignItems: 'center'
    }
  }, React__default.createElement(Icon, {
    icon: icon,
    svgStrokeColor: color
  }), React__default.createElement(Typography, {
    variant: "h6",
    bold: isSelected,
    fontWeight: FontWeight.Medium,
    color: color
  }, label));
}

function SubscriptionTabs(_ref2) {
  var customerPortal = _ref2.customerPortal,
      hiddenSections = _ref2.hiddenSections,
      textOverrides = _ref2.textOverrides,
      theme = _ref2.theme;
  var allAddons = flatMap(customerPortal.subscriptions, function (subscription) {
    return subscription.addons;
  });

  var isSectionHidden = function isSectionHidden(sectionName) {
    return hiddenSections == null ? void 0 : hiddenSections.some(function (section) {
      return section === sectionName;
    });
  };

  var showAddons = allAddons.length > 0 && !isSectionHidden('addons');
  var showPromotions = customerPortal.promotionalEntitlements.length > 0 && !isSectionHidden('promotionalEntitlements');

  var _useState = useState(showAddons ? 1 : 2),
      value = _useState[0],
      setValue = _useState[1];

  var handleChange = function handleChange(_, newValue) {
    setValue(newValue);
  };

  var shouldShowTabs = showAddons || showPromotions;

  if (!shouldShowTabs) {
    return null;
  }

  return React__default.createElement(TabsLayout, null, React__default.createElement(Box, {
    sx: {
      borderBottom: 1,
      borderColor: 'divider'
    }
  }, React__default.createElement(StyledTabs, {
    value: value,
    onChange: handleChange
  }, showAddons ? React__default.createElement(Tab, {
    sx: {
      textTransform: 'none'
    },
    value: 1,
    label: React__default.createElement(TabTitle, {
      isSelected: value === 1,
      label: textOverrides.addonsTabTitle,
      icon: "Addons"
    })
  }) : null, showPromotions ? React__default.createElement(Tab, {
    sx: {
      textTransform: 'none'
    },
    value: 2,
    label: React__default.createElement(TabTitle, {
      isSelected: value === 2,
      label: textOverrides.promotionsTabTitle,
      icon: "Promotions"
    })
  }) : null)), React__default.createElement(TabPanel, {
    value: value,
    index: 1,
    maxHeight: theme.tabMaxHeight
  }, React__default.createElement(AddonsList, null)), React__default.createElement(TabPanel, {
    value: value,
    index: 2,
    maxHeight: theme.tabMaxHeight
  }, React__default.createElement(Promotions, null)));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var SkeletonLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ejq3grd1"
} : {
  target: "ejq3grd1",
  label: "SkeletonLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between"
} : {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YnNjcmlwdGlvbk92ZXJ2aWV3TG9hZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHa0MiLCJmaWxlIjoiU3Vic2NyaXB0aW9uT3ZlcnZpZXdMb2FkZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XHJcbmNvbnN0IFNrZWxldG9uTGF5b3V0ID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbmA7XHJcbmNvbnN0IFNrZWxldG9uTGF5b3V0TGVmdCA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDMycHg7XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gU3Vic2NyaXB0aW9uT3ZlcnZpZXdMb2FkZXIoKSB7XHJcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b25MYXlvdXQsIHsgY2xhc3NOYW1lOiBcInN0aWdnLXN1YnNjcmlwdGlvbi1vdmVydmlldy1za2VsZXRvbi1sYXlvdXRcIiB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b25MYXlvdXRMZWZ0LCBudWxsLFxyXG4gICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFNrZWxldG9uLCB7IHdpZHRoOiAxMjAgfSksXHJcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b24sIHsgd2lkdGg6IDEyMCB9KSksXHJcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChTa2VsZXRvbiwgeyB3aWR0aDogMjk1LCBoZWlnaHQ6IDE5MyB9KSkpO1xyXG59XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1YnNjcmlwdGlvbk92ZXJ2aWV3TG9hZGVyLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});

var SkeletonLayoutLeft = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ejq3grd0"
} : {
  target: "ejq3grd0",
  label: "SkeletonLayoutLeft"
})(process.env.NODE_ENV === "production" ? {
  name: "43cxha",
  styles: "display:flex;flex-direction:column;gap:32px"
} : {
  name: "43cxha",
  styles: "display:flex;flex-direction:column;gap:32px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN1YnNjcmlwdGlvbk92ZXJ2aWV3TG9hZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPc0MiLCJmaWxlIjoiU3Vic2NyaXB0aW9uT3ZlcnZpZXdMb2FkZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgU2tlbGV0b24gZnJvbSAncmVhY3QtbG9hZGluZy1za2VsZXRvbic7XHJcbmNvbnN0IFNrZWxldG9uTGF5b3V0ID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbmA7XHJcbmNvbnN0IFNrZWxldG9uTGF5b3V0TGVmdCA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBnYXA6IDMycHg7XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gU3Vic2NyaXB0aW9uT3ZlcnZpZXdMb2FkZXIoKSB7XHJcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b25MYXlvdXQsIHsgY2xhc3NOYW1lOiBcInN0aWdnLXN1YnNjcmlwdGlvbi1vdmVydmlldy1za2VsZXRvbi1sYXlvdXRcIiB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b25MYXlvdXRMZWZ0LCBudWxsLFxyXG4gICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFNrZWxldG9uLCB7IHdpZHRoOiAxMjAgfSksXHJcbiAgICAgICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b24sIHsgd2lkdGg6IDEyMCB9KSksXHJcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChTa2VsZXRvbiwgeyB3aWR0aDogMjk1LCBoZWlnaHQ6IDE5MyB9KSkpO1xyXG59XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN1YnNjcmlwdGlvbk92ZXJ2aWV3TG9hZGVyLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});

function SubscriptionOverviewLoader() {
  return React__default.createElement(SkeletonLayout, {
    className: "stigg-subscription-overview-skeleton-layout"
  }, React__default.createElement(SkeletonLayoutLeft, null, React__default.createElement(Skeleton$1, {
    width: 120
  }), React__default.createElement(Skeleton$1, {
    width: 120
  })), React__default.createElement(Skeleton$1, {
    width: 295,
    height: 193
  }));
}

function SubscriptionScheduledUpdateDowngradeRow(_ref) {
  var scheduleUpdate = _ref.scheduleUpdate;
  var targetPackage = scheduleUpdate.targetPackage;
  return React__default.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, React__default.createElement(Grid, null, React__default.createElement(ArrowDown, {
    color: "#D94052",
    height: 20,
    className: "stigg-scheduled-updates-arrow-down"
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: "stigg-scheduled-updates-description",
    variant: "body1"
  }, "Downgrade to the ", React__default.createElement("b", null, targetPackage == null ? void 0 : targetPackage.displayName), " plan")));
}

function SubscriptionScheduledUpdateBillingPeriodChangeRow(_ref2) {
  var scheduleUpdate = _ref2.scheduleUpdate;
  var scheduleVariables = scheduleUpdate.scheduleVariables;
  var billingPeriod = scheduleVariables.billingPeriod;
  var currentBillingPeriod = billingPeriod === BillingPeriod.Monthly ? 'annually' : 'monthly';
  var nextBillingPeriod = billingPeriod === BillingPeriod.Monthly ? 'monthly' : 'annually';
  return React__default.createElement(Grid, {
    container: true,
    alignItems: "center"
  }, React__default.createElement(Grid, null, React__default.createElement(ArrowDown, {
    color: "#D94052",
    height: 20,
    className: "stigg-scheduled-updates-arrow-down"
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: "stigg-scheduled-updates-description",
    variant: "body1"
  }, "Change from an ", currentBillingPeriod, " to a ", React__default.createElement("b", null, nextBillingPeriod), " billing cycle")));
}

function SubscriptionScheduledUpdateUnitQuantityChangeRow(_ref3) {
  var subscription = _ref3.subscription,
      scheduleUpdate = _ref3.scheduleUpdate;
  var scheduleVariables = scheduleUpdate.scheduleVariables;
  var newUnitAmount = scheduleVariables.newUnitAmount,
      featureId = scheduleVariables.featureId;
  var feature = compact(map(subscription.prices, 'feature')).find(function (_ref4) {
    var id = _ref4.id;
    return id === featureId;
  });

  if (!feature) {
    return null;
  }

  var featureUnits = feature.featureUnits,
      featureUnitsPlural = feature.featureUnitsPlural;
  var newQuantityUnits = newUnitAmount === 1 ? featureUnits : featureUnitsPlural;
  return React__default.createElement(Grid, {
    container: true,
    alignItems: "flex-start",
    flexWrap: 'nowrap'
  }, React__default.createElement(Grid, null, React__default.createElement(ArrowDown, {
    color: "#D94052",
    height: 20,
    className: "stigg-scheduled-updates-arrow-down"
  })), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    className: "stigg-scheduled-updates-description",
    variant: "body1"
  }, "Reduce the ", React__default.createElement("b", null, featureUnits), " quantity to ", newUnitAmount, " ", newQuantityUnits)));
}

function SubscriptionScheduledUpdateRow(_ref5) {
  var scheduleUpdate = _ref5.scheduleUpdate,
      subscription = _ref5.subscription;

  switch (scheduleUpdate.subscriptionScheduleType) {
    case SubscriptionScheduleType.Downgrade:
      {
        return React__default.createElement(SubscriptionScheduledUpdateDowngradeRow, {
          scheduleUpdate: scheduleUpdate
        });
      }

    case SubscriptionScheduleType.BillingPeriod:
      {
        return React__default.createElement(SubscriptionScheduledUpdateBillingPeriodChangeRow, {
          scheduleUpdate: scheduleUpdate
        });
      }

    case SubscriptionScheduleType.UnitAmount:
      {
        return React__default.createElement(SubscriptionScheduledUpdateUnitQuantityChangeRow, {
          scheduleUpdate: scheduleUpdate,
          subscription: subscription
        });
      }

    default:
      {
        return null;
      }
  }
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var SubscriptionScheduleUpdateAlertContainer = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "eju957a2"
} : {
  target: "eju957a2",
  label: "SubscriptionScheduleUpdateAlertContainer"
})("border-bottom:", function (_ref) {
  var $borderColor = _ref.$borderColor;
  return "1px solid " + $borderColor;
}, ";border-top-left-radius:10px;border-top-right-radius:10px;margin:-64px -64px 64px -64px;padding:24px 32px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var LoadingIndicator$1 = /*#__PURE__*/_styled(ClipLoader, process.env.NODE_ENV === "production" ? {
  target: "eju957a1"
} : {
  target: "eju957a1",
  label: "LoadingIndicator"
})(process.env.NODE_ENV === "production" ? {
  name: "158icaa",
  styles: "margin-left:4px"
} : {
  name: "158icaa",
  styles: "margin-left:4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});

var StyledRestoreIcon = /*#__PURE__*/_styled(SvgRestore, process.env.NODE_ENV === "production" ? {
  target: "eju957a0"
} : {
  target: "eju957a0",
  label: "StyledRestoreIcon"
})("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.stigg.palette.primary;
}, ";path{fill:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.stigg.palette.primary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function MultipleScheduledUpdates(_ref4) {
  var subscription = _ref4.subscription;
  var scheduledUpdates = subscription.scheduledUpdates;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1
  }, React__default.createElement(Grid, null, React__default.createElement(Typography, {
    className: "stigg-scheduled-updates-description",
    variant: "body1"
  }, "The following updates will take effect in the next billing cycle:"))), React__default.createElement(Grid, null, (scheduledUpdates || []).map(function (scheduleUpdate) {
    return React__default.createElement(SubscriptionScheduledUpdateRow, {
      key: scheduleUpdate.subscriptionScheduleType,
      scheduleUpdate: scheduleUpdate,
      subscription: subscription
    });
  })));
}

function SingleScheduledUpdate(_ref5) {
  var subscription = _ref5.subscription;
  var scheduledUpdates = subscription.scheduledUpdates;

  var _ref6 = scheduledUpdates || [],
      scheduledUpdate = _ref6[0];

  var _getSubscriptionSched = getSubscriptionScheduleUpdateTexts({
    scheduledUpdate: scheduledUpdate,
    subscriptionPrices: subscription.prices,
    billingPeriodRange: subscription.billingPeriodRange,
    options: {
      postfix: 'at the end of the current billing period'
    }
  }),
      line1 = _getSubscriptionSched.line1,
      line2 = _getSubscriptionSched.line2;

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    container: true,
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1
  }, React__default.createElement(Grid, null, React__default.createElement(Typography, {
    className: "stigg-scheduled-updates-title",
    variant: "body1",
    color: "primary"
  }, line1))), line2 && React__default.createElement(Grid, null, React__default.createElement(Typography, {
    className: "stigg-scheduled-updates-subtitle",
    variant: "body1",
    color: "secondary"
  }, line2)));
}

function SubscriptionScheduledUpdatesAlert(_ref7) {
  var subscription = _ref7.subscription,
      onCancelScheduledUpdates = _ref7.onCancelScheduledUpdates,
      theme = _ref7.theme,
      cancelScheduledUpdatesButtonTitle = _ref7.cancelScheduledUpdatesButtonTitle;
  var stiggTheme = useTheme();

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var scheduledUpdates = subscription.scheduledUpdates;

  if (!scheduledUpdates || scheduledUpdates.length === 0) {
    return null;
  }

  var isSingleScheduledUpdate = scheduledUpdates.length === 1;
  return React__default.createElement(SubscriptionScheduleUpdateAlertContainer, {
    "$borderColor": theme.borderColor,
    className: "stigg-scheduled-updates-alert-container"
  }, React__default.createElement(Grid, {
    container: true,
    alignItems: isSingleScheduledUpdate ? 'center' : 'flex-start',
    gap: 2
  }, React__default.createElement(Grid, {
    item: true,
    display: "flex"
  }, React__default.createElement(Icon, {
    icon: 'ScheduleBox',
    svgPathColor: theme.iconsColor,
    svgRectColor: theme.iconsBackgroundColor
  })), React__default.createElement(Grid, {
    item: true,
    flex: 1
  }, isSingleScheduledUpdate ? React__default.createElement(SingleScheduledUpdate, {
    subscription: subscription
  }) : React__default.createElement(MultipleScheduledUpdates, {
    subscription: subscription
  })), !!onCancelScheduledUpdates && React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(StyledButton, {
    variant: "outlined",
    onClick: function onClick() {
      setIsLoading(true);
      Promise.resolve(onCancelScheduledUpdates(subscription))["finally"](function () {
        return setIsLoading(false);
      });
    }
  }, isLoading ? React__default.createElement(LoadingIndicator$1, {
    loading: true,
    size: 16,
    color: stiggTheme.stigg.palette.text.disabled
  }) : React__default.createElement(StyledRestoreIcon, {
    style: {
      display: 'flex',
      marginRight: 4
    },
    className: "stigg-scheduled-updates-cancel-update-button-icon"
  }), React__default.createElement(Typography, {
    variant: "body1",
    color: "primary.main",
    className: "stigg-scheduled-updates-cancel-update-button"
  }, cancelScheduledUpdatesButtonTitle)))));
}

var SectionContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1kw2z1l0"
} : {
  target: "e1kw2z1l0",
  label: "SectionContainer"
})("width:100%;display:flex;flex-direction:column;border-radius:10px;background-color:", function (_ref) {
  var $backgroundColor = _ref.$backgroundColor;
  return $backgroundColor;
}, ";border:", function (_ref2) {
  var $borderColor = _ref2.$borderColor;
  return "1px solid " + $borderColor;
}, ";padding:64px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlY3Rpb25Db250YWluZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUMyQyIsImZpbGUiOiJTZWN0aW9uQ29udGFpbmVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuZXhwb3J0IGNvbnN0IFNlY3Rpb25Db250YWluZXIgPSBzdHlsZWQuZGl2IGBcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgJGJhY2tncm91bmRDb2xvciB9KSA9PiAkYmFja2dyb3VuZENvbG9yfTtcbiAgYm9yZGVyOiAkeyh7ICRib3JkZXJDb2xvciB9KSA9PiBgMXB4IHNvbGlkICR7JGJvcmRlckNvbG9yfWB9O1xuICBwYWRkaW5nOiA2NHB4O1xuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9U2VjdGlvbkNvbnRhaW5lci5qcy5tYXAiXX0= */"));

function NextEstimatedBill(_ref) {
  var billingPeriod = _ref.billingPeriod,
      rangeEnd = _ref.rangeEnd,
      amount = _ref.amount,
      currency = _ref.currency;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Typography, {
    variant: "h6"
  }, "Next estimated bill"), React__default.createElement(Typography, {
    variant: "h1"
  }, currencyPriceFormatter({
    amount: amount,
    currency: currency,
    maximumFractionDigits: 2
  })), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, "Billed ", billingPeriod === BillingPeriod.Monthly ? 'monthly' : 'annually', " on", ' ', React__default.createElement(Typography, {
    variant: "body1",
    span: true,
    color: "primary"
  }, moment.utc(rangeEnd).format('MMM Do, YYYY'))), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, "* Additional tax rates may apply"));
}

function NoUpcomingBilling(_ref) {
  var description = _ref.description;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Typography, {
    variant: 'h6',
    color: 'secondary'
  }, "No upcoming bill"), React__default.createElement(Typography, {
    variant: 'body1',
    color: 'secondary'
  }, description));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ContactCustomerSupportLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ftdtst1"
} : {
  target: "e1ftdtst1",
  label: "ContactCustomerSupportLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "1nocm2b",
  styles: "display:flex;flex-direction:column;align-items:left;gap:8px"
} : {
  name: "1nocm2b",
  styles: "display:flex;flex-direction:column;align-items:left;gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhY3RDdXN0b21lclN1cHBvcnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlnRCIsImZpbGUiOiJDb250YWN0Q3VzdG9tZXJTdXBwb3J0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IEJ1dHRvbiBmcm9tICdAbXVpL21hdGVyaWFsL0J1dHRvbic7XHJcbmNvbnN0IENvbnRhY3RDdXN0b21lclN1cHBvcnRMYXlvdXQgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGxlZnQ7XG4gIGdhcDogOHB4O1xuYDtcclxuY29uc3QgQ29udGFjdFN1cHBvcnRCdXR0b24gPSBzdHlsZWQoQnV0dG9uKSBgXG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgJi5NdWlCdXR0b24tcm9vdCB7XG4gICAgcGFkZGluZzogMDtcbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQ6IG5vbmU7XG4gICAgfVxuICB9XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gQ29udGFjdEN1c3RvbWVyU3VwcG9ydCh7IG9uQ29udGFjdFN1cHBvcnQsIGxhYmVsLCBsaW5rTGFiZWwgfSkge1xyXG4gICAgbGV0IGNvbnRhY3RTdXBwb3J0VGV4dCA9IFJlYWN0LmNyZWF0ZUVsZW1lbnQoVHlwb2dyYXBoeSwgeyBjb2xvcjogb25Db250YWN0U3VwcG9ydCA/ICdwcmltYXJ5Lm1haW4nIDogJ3NlY29uZGFyeScgfSwgbGlua0xhYmVsKTtcclxuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChDb250YWN0Q3VzdG9tZXJTdXBwb3J0TGF5b3V0LCB7IGNsYXNzTmFtZTogXCJzdGlnZy1jb250YWN0LXN1cHBvcnQtbGF5b3V0XCIgfSxcclxuICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFR5cG9ncmFwaHksIHsgY2xhc3NOYW1lOiBcInN0aWdnLWNvbnRhY3Qtc3VwcG9ydC1sYWJlbFwiLCBjb2xvcjogXCJzZWNvbmRhcnlcIiB9LCBsYWJlbCksXHJcbiAgICAgICAgb25Db250YWN0U3VwcG9ydCA/IChSZWFjdC5jcmVhdGVFbGVtZW50KENvbnRhY3RTdXBwb3J0QnV0dG9uLCB7IGNsYXNzTmFtZTogXCJzdGlnZy1jb250YWN0LXN1cHBvcnQtYnV0dG9uXCIsIHN0eWxlOiB7IHRleHRUcmFuc2Zvcm06ICdub25lJyB9LCB2YXJpYW50OiBcInRleHRcIiwgb25DbGljazogb25Db250YWN0U3VwcG9ydCB9LCBjb250YWN0U3VwcG9ydFRleHQpKSA6IChjb250YWN0U3VwcG9ydFRleHQpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q29udGFjdEN1c3RvbWVyU3VwcG9ydC5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});

var ContactSupportButton = /*#__PURE__*/_styled(Button$1, process.env.NODE_ENV === "production" ? {
  target: "e1ftdtst0"
} : {
  target: "e1ftdtst0",
  label: "ContactSupportButton"
})(process.env.NODE_ENV === "production" ? {
  name: "1l28f5r",
  styles: "width:fit-content;&.MuiButton-root{padding:0;&:hover{background:none;}}"
} : {
  name: "1l28f5r",
  styles: "width:fit-content;&.MuiButton-root{padding:0;&:hover{background:none;}}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRhY3RDdXN0b21lclN1cHBvcnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVU0QyIsImZpbGUiOiJDb250YWN0Q3VzdG9tZXJTdXBwb3J0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IEJ1dHRvbiBmcm9tICdAbXVpL21hdGVyaWFsL0J1dHRvbic7XHJcbmNvbnN0IENvbnRhY3RDdXN0b21lclN1cHBvcnRMYXlvdXQgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGxlZnQ7XG4gIGdhcDogOHB4O1xuYDtcclxuY29uc3QgQ29udGFjdFN1cHBvcnRCdXR0b24gPSBzdHlsZWQoQnV0dG9uKSBgXG4gIHdpZHRoOiBmaXQtY29udGVudDtcbiAgJi5NdWlCdXR0b24tcm9vdCB7XG4gICAgcGFkZGluZzogMDtcbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQ6IG5vbmU7XG4gICAgfVxuICB9XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gQ29udGFjdEN1c3RvbWVyU3VwcG9ydCh7IG9uQ29udGFjdFN1cHBvcnQsIGxhYmVsLCBsaW5rTGFiZWwgfSkge1xyXG4gICAgbGV0IGNvbnRhY3RTdXBwb3J0VGV4dCA9IFJlYWN0LmNyZWF0ZUVsZW1lbnQoVHlwb2dyYXBoeSwgeyBjb2xvcjogb25Db250YWN0U3VwcG9ydCA/ICdwcmltYXJ5Lm1haW4nIDogJ3NlY29uZGFyeScgfSwgbGlua0xhYmVsKTtcclxuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChDb250YWN0Q3VzdG9tZXJTdXBwb3J0TGF5b3V0LCB7IGNsYXNzTmFtZTogXCJzdGlnZy1jb250YWN0LXN1cHBvcnQtbGF5b3V0XCIgfSxcclxuICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFR5cG9ncmFwaHksIHsgY2xhc3NOYW1lOiBcInN0aWdnLWNvbnRhY3Qtc3VwcG9ydC1sYWJlbFwiLCBjb2xvcjogXCJzZWNvbmRhcnlcIiB9LCBsYWJlbCksXHJcbiAgICAgICAgb25Db250YWN0U3VwcG9ydCA/IChSZWFjdC5jcmVhdGVFbGVtZW50KENvbnRhY3RTdXBwb3J0QnV0dG9uLCB7IGNsYXNzTmFtZTogXCJzdGlnZy1jb250YWN0LXN1cHBvcnQtYnV0dG9uXCIsIHN0eWxlOiB7IHRleHRUcmFuc2Zvcm06ICdub25lJyB9LCB2YXJpYW50OiBcInRleHRcIiwgb25DbGljazogb25Db250YWN0U3VwcG9ydCB9LCBjb250YWN0U3VwcG9ydFRleHQpKSA6IChjb250YWN0U3VwcG9ydFRleHQpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q29udGFjdEN1c3RvbWVyU3VwcG9ydC5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});

function ContactCustomerSupport(_ref) {
  var onContactSupport = _ref.onContactSupport,
      label = _ref.label,
      linkLabel = _ref.linkLabel;
  var contactSupportText = React__default.createElement(Typography, {
    color: onContactSupport ? 'primary.main' : 'secondary'
  }, linkLabel);
  return React__default.createElement(ContactCustomerSupportLayout, {
    className: "stigg-contact-support-layout"
  }, React__default.createElement(Typography, {
    className: "stigg-contact-support-label",
    color: "secondary"
  }, label), onContactSupport ? React__default.createElement(ContactSupportButton, {
    className: "stigg-contact-support-button",
    style: {
      textTransform: 'none'
    },
    variant: "text",
    onClick: onContactSupport
  }, contactSupportText) : contactSupportText);
}

var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1u4onrr0"
} : {
  target: "e1u4onrr0",
  label: "Container"
})("max-height:278px;display:flex;flex-direction:column;border-radius:10px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.backgroundSection;
}, ";border:", function (_ref2) {
  var $borderColor = _ref2.$borderColor;
  return "1px solid " + $borderColor;
}, ";padding:32px;gap:16px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

function UpcomingBilling(_ref3) {
  var _subscription$prices$, _subscription$prices, _subscription$schedul;

  var subscription = _ref3.subscription,
      theme = _ref3.theme,
      textOverrides = _ref3.textOverrides,
      onContactSupport = _ref3.onContactSupport;
  var pricingType = subscription.pricingType;
  var content;
  var noUsageBasedPrices = (_subscription$prices$ = (_subscription$prices = subscription.prices) == null ? void 0 : _subscription$prices.every(function (price) {
    return price.billingModel !== BillingModel.UsageBased;
  })) != null ? _subscription$prices$ : true;
  var scheduledDowngradeToFree = (_subscription$schedul = subscription.scheduledUpdates) == null ? void 0 : _subscription$schedul.find(function (_ref4) {
    var subscriptionScheduleType = _ref4.subscriptionScheduleType,
        targetPackage = _ref4.targetPackage;
    return subscriptionScheduleType === SubscriptionScheduleType.Downgrade && (targetPackage == null ? void 0 : targetPackage.pricingType) === PricingType.Free;
  });

  if (pricingType === PricingType.Free) {
    content = React__default.createElement(NoUpcomingBilling, {
      description: "You're on a free plan, so you don\u2019t have any upcoming charges"
    });
  } else if (pricingType === PricingType.Paid) {
    if (scheduledDowngradeToFree && noUsageBasedPrices) {
      content = React__default.createElement(NoUpcomingBilling, {
        description: "Your plan will be downgraded to a free plan, so you don\u2019t have any upcoming charges"
      });
    } else if (subscription.status === SubscriptionStatus.InTrial) {
      content = React__default.createElement(NoUpcomingBilling, {
        description: "You\u2019re on a free trial of the " + subscription.planName + " plan, so you don\u2019t have any upcoming charges"
      });
    } else {
      var _subscription$prices2, _subscription$prices3, _subscription$billing, _subscription$totalPr;

      var billingPeriod = (_subscription$prices2 = subscription.prices) == null ? void 0 : (_subscription$prices3 = _subscription$prices2[0]) == null ? void 0 : _subscription$prices3.billingPeriod;
      var rangeEnd = (_subscription$billing = subscription.billingPeriodRange) == null ? void 0 : _subscription$billing.end;
      var total = (_subscription$totalPr = subscription.totalPrice) == null ? void 0 : _subscription$totalPr.total;

      if (billingPeriod && rangeEnd && total) {
        content = React__default.createElement(NextEstimatedBill, {
          billingPeriod: billingPeriod,
          rangeEnd: rangeEnd,
          amount: total.amount,
          currency: total.currency
        });
      }
    }
  } else if (pricingType === PricingType.Custom) {
    content = React__default.createElement(ContactCustomerSupport, {
      onContactSupport: onContactSupport,
      label: textOverrides.contactSupportTitle,
      linkLabel: textOverrides.contactSupportLink
    });
  }

  return React__default.createElement(Container, {
    className: "stigg-subscription-total-price-layout",
    "$borderColor": theme.borderColor
  }, content);
}

var _path$i, _path2$5;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
var SvgSandClock = function SvgSandClock(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/createElement("path", {
    d: "M12.947 13.6h-1.013l.001-2.824a.522.522 0 0 0-.18-.392L8.622 7.918l3.134-2.465a.497.497 0 0 0 .18-.392V2.4h1.012c.278 0 .49-.212.49-.49a.481.481 0 0 0-.49-.49H3.053a.481.481 0 0 0-.49.49c0 .278.213.49.49.49h1.013l-.001 2.661c0 .147.065.294.18.392l3.117 2.465-3.117 2.466a.497.497 0 0 0-.18.392V13.6H3.054a.481.481 0 0 0-.49.49c0 .277.213.49.49.49h9.894c.277 0 .49-.213.49-.49a.481.481 0 0 0-.49-.49ZM5.045 2.4h5.91v2.416L8 7.167l-2.955-2.35V2.4Zm0 8.62L8 8.67l2.955 2.334v2.58h-5.91V11.02Z",
    fill: "#fff"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.053 1.254h9.894c.37 0 .657.287.657.656 0 .37-.287.657-.657.657h-.845L12.1 5.06c0 .214-.088.39-.238.519l-.005.004L8.89 7.918l2.974 2.34c.152.13.238.323.238.518l-.001 2.657h.846c.37 0 .657.287.657.657 0 .37-.288.657-.657.657H3.053a.648.648 0 0 1-.657-.657c0-.37.287-.657.657-.657h.846v-2.657c0-.214.087-.39.237-.519l.005-.004 2.953-2.335L4.136 5.58a.688.688 0 0 1-.238-.519V2.567h-.845a.648.648 0 0 1-.657-.656c0-.37.287-.657.657-.657Zm9.894.333H3.053a.315.315 0 0 0-.323.324c0 .185.138.323.323.323h1.18l-.001 2.827c0 .099.043.198.119.264l3.28 2.593-3.28 2.594a.33.33 0 0 0-.119.264v2.99H3.053a.315.315 0 0 0-.323.324c0 .185.138.323.323.323h9.894a.315.315 0 0 0 .323-.323.315.315 0 0 0-.323-.323h-1.18l.001-2.991a.355.355 0 0 0-.119-.264L8.351 7.918l3.298-2.593a.33.33 0 0 0 .119-.264V2.233h1.18a.315.315 0 0 0 .323-.323.315.315 0 0 0-.324-.323Zm-8.069.646h6.244v2.664L8 7.38 4.878 4.897V2.233Zm.334.334v2.169L8 6.955l2.788-2.22V2.568H5.212ZM8 8.457l3.122 2.467v2.827H4.878v-2.81L8 8.456Zm0 .425-2.788 2.219v2.316h5.576v-2.332L8 8.882Z",
    fill: "#fff"
  })));
};

var _excluded$3 = ["children", "className", "placement"];
var InformationTooltip = /*#__PURE__*/_styled(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$3);

  return React__default.createElement(Tooltip, Object.assign({
    arrow: true,
    placement: placement
  }, props, {
    classes: {
      popper: className,
      tooltip: 'stigg-tooltip',
      arrow: 'stigg-tooltip-arrow'
    }
  }), React__default.createElement("div", null, children));
}, process.env.NODE_ENV === "production" ? {
  target: "enddsuj0"
} : {
  target: "enddsuj0",
  label: "InformationTooltip"
})(function (_ref2) {
  var _ref3;

  var theme = _ref2.theme,
      _ref2$$padding = _ref2.$padding,
      $padding = _ref2$$padding === void 0 ? 8 : _ref2$$padding,
      _ref2$$maxWidth = _ref2.$maxWidth,
      $maxWidth = _ref2$$maxWidth === void 0 ? 300 : _ref2$$maxWidth;
  return _ref3 = {}, _ref3["& ." + tooltipClasses.tooltip] = {
    backgroundColor: theme.stigg.palette.white,
    maxWidth: $maxWidth,
    boxShadow: theme.stigg.shadows.popover,
    padding: $padding,
    borderRadius: theme.stigg.border.radius,
    color: theme.stigg.palette.text.primary
  }, _ref3["& ." + tooltipClasses.arrow] = {
    color: theme.stigg.palette.white
  }, _ref3;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9ybWF0aW9uVG9vbHRpcC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR2tDIiwiZmlsZSI6IkluZm9ybWF0aW9uVG9vbHRpcC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBUb29sdGlwLCB0b29sdGlwQ2xhc3NlcyB9IGZyb20gJ0BtdWkvbWF0ZXJpYWwnO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmV4cG9ydCBjb25zdCBJbmZvcm1hdGlvblRvb2x0aXAgPSBzdHlsZWQoKHsgY2hpbGRyZW4sIGNsYXNzTmFtZSwgcGxhY2VtZW50ID0gJ3RvcCcsIC4uLnByb3BzIH0pID0+IChSZWFjdC5jcmVhdGVFbGVtZW50KFRvb2x0aXAsIE9iamVjdC5hc3NpZ24oeyBhcnJvdzogdHJ1ZSwgcGxhY2VtZW50OiBwbGFjZW1lbnQgfSwgcHJvcHMsIHsgY2xhc3NlczogeyBwb3BwZXI6IGNsYXNzTmFtZSwgdG9vbHRpcDogJ3N0aWdnLXRvb2x0aXAnLCBhcnJvdzogJ3N0aWdnLXRvb2x0aXAtYXJyb3cnIH0gfSksXHJcbiAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFwiZGl2XCIsIG51bGwsIGNoaWxkcmVuKSkpKSgoeyB0aGVtZSwgJHBhZGRpbmcgPSA4LCAkbWF4V2lkdGggPSAzMDAgfSkgPT4gKHtcclxuICAgIFtgJiAuJHt0b29sdGlwQ2xhc3Nlcy50b29sdGlwfWBdOiB7XHJcbiAgICAgICAgYmFja2dyb3VuZENvbG9yOiB0aGVtZS5zdGlnZy5wYWxldHRlLndoaXRlLFxyXG4gICAgICAgIG1heFdpZHRoOiAkbWF4V2lkdGgsXHJcbiAgICAgICAgYm94U2hhZG93OiB0aGVtZS5zdGlnZy5zaGFkb3dzLnBvcG92ZXIsXHJcbiAgICAgICAgcGFkZGluZzogJHBhZGRpbmcsXHJcbiAgICAgICAgYm9yZGVyUmFkaXVzOiB0aGVtZS5zdGlnZy5ib3JkZXIucmFkaXVzLFxyXG4gICAgICAgIGNvbG9yOiB0aGVtZS5zdGlnZy5wYWxldHRlLnRleHQucHJpbWFyeSxcclxuICAgIH0sXHJcbiAgICBbYCYgLiR7dG9vbHRpcENsYXNzZXMuYXJyb3d9YF06IHtcclxuICAgICAgICBjb2xvcjogdGhlbWUuc3RpZ2cucGFsZXR0ZS53aGl0ZSxcclxuICAgIH0sXHJcbn0pKTtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW5mb3JtYXRpb25Ub29sdGlwLmpzLm1hcCJdfQ== */");

var _templateObject$4, _templateObject2$1, _templateObject3$1;
var StyledText$1 = /*#__PURE__*/styled(Typography)(_templateObject$4 || (_templateObject$4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: normal;\n  ", "\n\n  ", "\n"])), function (_ref) {
  var $display = _ref.$display;
  return $display;
}, function (_ref2) {
  var $maxLines = _ref2.$maxLines;
  return $maxLines;
}, function (_ref3) {
  var $wordBreak = _ref3.$wordBreak;
  return $wordBreak && css$1(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n      word-break: break-word;\n    "])));
}, function (_ref4) {
  var $bold = _ref4.$bold;
  return $bold && css$1(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n      font-weight: bold;\n    "])));
});

function checkTextClamped(element) {
  return element && (element.clientHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth);
}

var LongText = function LongText(_ref5) {
  var leaveDelay = _ref5.leaveDelay,
      children = _ref5.children,
      variant = _ref5.variant,
      color = _ref5.color,
      _ref5$maxLines = _ref5.maxLines,
      maxLines = _ref5$maxLines === void 0 ? 1 : _ref5$maxLines,
      wordBreak = _ref5.wordBreak,
      bold = _ref5.bold,
      _ref5$tooltipPlacemen = _ref5.tooltipPlacement,
      tooltipPlacement = _ref5$tooltipPlacemen === void 0 ? 'top' : _ref5$tooltipPlacemen,
      className = _ref5.className,
      _ref5$display = _ref5.display,
      display = _ref5$display === void 0 ? '-webkit-box' : _ref5$display,
      style = _ref5.style,
      dataTestId = _ref5['data-testid'];

  var _useState = useState(false),
      isTextClamped = _useState[0],
      setIsTextClamped = _useState[1];

  var ref = useRef(null);
  var content = React__default.createElement(StyledText$1, {
    ref: ref,
    variant: variant,
    color: color,
    "$maxLines": maxLines,
    "$wordBreak": wordBreak,
    "$bold": bold,
    className: className,
    "$display": display,
    style: style,
    "data-testid": dataTestId
  }, children); // Trigger recalculate of text clamped since ref is not always exists on first render

  useEffect(function () {
    if (ref != null && ref.current) {
      var _textClamped = checkTextClamped(ref.current);

      setIsTextClamped(_textClamped);
    }
  }, [ref]);
  var textClamped = (ref == null ? void 0 : ref.current) && checkTextClamped(ref.current);
  return React__default.createElement("span", null, isTextClamped || textClamped ? React__default.createElement(InformationTooltip, {
    placement: tooltipPlacement,
    leaveDelay: leaveDelay,
    title: React__default.createElement(Typography, {
      variant: "body1"
    }, children)
  }, content) : content);
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var OnTrialBadge = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "el5iwyw1"
} : {
  target: "el5iwyw1",
  label: "OnTrialBadge"
})("width:100%;display:flex;align-items:center;gap:4px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.warning;
}, ";border-radius:10px;padding:8px 16px;margin-top:16px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var StyledLink = /*#__PURE__*/_styled(Link, process.env.NODE_ENV === "production" ? {
  target: "el5iwyw0"
} : {
  target: "el5iwyw0",
  label: "StyledLink"
})(process.env.NODE_ENV === "production" ? {
  name: "69ka7t",
  styles: "text-decoration-color:white;color:white;cursor:pointer"
} : {
  name: "69ka7t",
  styles: "text-decoration-color:white;color:white;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});

function TrialPanel(_ref2) {
  var subscription = _ref2.subscription,
      includePlanName = _ref2.includePlanName,
      onManageSubscription = _ref2.onManageSubscription;

  if ((subscription == null ? void 0 : subscription.status) !== SubscriptionStatus.InTrial) {
    return null;
  }

  return React__default.createElement(OnTrialBadge, {
    className: "stigg-subscription-trial-badge"
  }, React__default.createElement(SvgSandClock, {
    className: "stigg-subscription-trial-badge-image"
  }), React__default.createElement("div", {
    style: {
      flex: 1,
      marginRight: 4
    }
  }, React__default.createElement(LongText, {
    variant: "body1",
    className: "stigg-subscription-trial-badge-text",
    color: "white"
  }, subscription.trialRemainingDays + " days remaining in trial", includePlanName && " of the " + subscription.planName + " plan")), React__default.createElement(StyledLink, {
    className: "stigg-subscription-trial-upgrade-button",
    onClick: onManageSubscription
  }, React__default.createElement(Typography, {
    color: "white"
  }, "Upgrade plan")));
}

function SubscriptionView(_ref) {
  var mainSubscription = _ref.mainSubscription,
      trialSubscription = _ref.trialSubscription,
      onManageSubscription = _ref.onManageSubscription,
      theme = _ref.theme;
  return React__default.createElement("div", {
    className: "stigg-subscription-view-layout"
  }, React__default.createElement(Typography, {
    className: "stigg-subscription-plan-name",
    variant: 'h1',
    overrideColor: theme.planNameColor,
    style: {
      marginTop: 8
    }
  }, mainSubscription.planName, " plan"), React__default.createElement(TrialPanel, {
    subscription: trialSubscription,
    includePlanName: (trialSubscription == null ? void 0 : trialSubscription.planName) !== mainSubscription.planName,
    onManageSubscription: onManageSubscription
  }));
}

var USAGE_PERCENTAGE_WARNING_THRESHOLD = 70;
function getUsagePercentage(currentUsage, limit) {
  return Math.min(Math.floor(currentUsage / limit * 100), 100);
}
function getUsageProgressStatus(currentUsage) {
  var status;

  if (currentUsage < USAGE_PERCENTAGE_WARNING_THRESHOLD) {
    status = 'standard';
  } else if (currentUsage < 100) {
    status = 'warning';
  } else {
    status = 'error';
  }

  return status;
}
function getResetUsageText(entitlement) {
  if (!entitlement.resetPeriod || !entitlement.nextResetDate) {
    return null;
  }

  var calculateResetDiff = function calculateResetDiff(unit) {
    return moment.utc(entitlement.nextResetDate).diff(moment.utc(), unit);
  };

  switch (entitlement.resetPeriod) {
    case 'MONTH':
      return "Resets monthly - in " + calculateResetDiff('days') + " days";

    case 'WEEK':
      return "Resets weekly - in " + calculateResetDiff('days') + " days";

    case 'DAY':
      return "Resets daily - in " + calculateResetDiff('hours') + " hours";

    case 'HOUR':
      return "Resets hourly - in " + calculateResetDiff('minutes') + " minutes";

    default:
      return null;
  }
}

var StyledLinearProgress = /*#__PURE__*/_styled(LinearProgress, process.env.NODE_ENV === "production" ? {
  target: "e1cbsoof1"
} : {
  target: "e1cbsoof1",
  label: "StyledLinearProgress"
})("height:4px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return Color(theme.stigg.palette.primary).alpha(0.4).string();
}, ";span{background-color:", function (_ref2) {
  var $progressStatus = _ref2.$progressStatus,
      theme = _ref2.theme;

  switch ($progressStatus) {
    case 'standard':
      return theme.stigg.palette.primary;

    case 'warning':
      return theme.stigg.palette.warning;

    case 'error':
      return theme.stigg.palette.error;

    default:
      return theme.stigg.palette.primary;
  }
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlYXR1cmVVc2FnZVByb2dyZXNzQmFyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNMkQiLCJmaWxlIjoiRmVhdHVyZVVzYWdlUHJvZ3Jlc3NCYXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgTGluZWFyUHJvZ3Jlc3MgZnJvbSAnQG11aS9tYXRlcmlhbC9MaW5lYXJQcm9ncmVzcyc7XHJcbmltcG9ydCB7IGdldFVzYWdlUGVyY2VudGFnZSwgZ2V0VXNhZ2VQcm9ncmVzc1N0YXR1cyB9IGZyb20gJy4vRmVhdHVyZVVzYWdlLmhlbHBlcic7XHJcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IERpdmlkZXIgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcclxuaW1wb3J0IENvbG9yIGZyb20gJ2NvbG9yJztcclxuZXhwb3J0IGNvbnN0IFN0eWxlZExpbmVhclByb2dyZXNzID0gc3R5bGVkKExpbmVhclByb2dyZXNzKSBgXG4gIGhlaWdodDogNHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IHRoZW1lIH0pID0+IENvbG9yKHRoZW1lLnN0aWdnLnBhbGV0dGUucHJpbWFyeSlcclxuICAgIC5hbHBoYSgwLjQpXHJcbiAgICAuc3RyaW5nKCl9O1xuXG4gIHNwYW4ge1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7KHsgJHByb2dyZXNzU3RhdHVzLCB0aGVtZSB9KSA9PiB7XHJcbiAgICBzd2l0Y2ggKCRwcm9ncmVzc1N0YXR1cykge1xyXG4gICAgICAgIGNhc2UgJ3N0YW5kYXJkJzpcclxuICAgICAgICAgICAgcmV0dXJuIHRoZW1lLnN0aWdnLnBhbGV0dGUucHJpbWFyeTtcclxuICAgICAgICBjYXNlICd3YXJuaW5nJzpcclxuICAgICAgICAgICAgcmV0dXJuIHRoZW1lLnN0aWdnLnBhbGV0dGUud2FybmluZztcclxuICAgICAgICBjYXNlICdlcnJvcic6XHJcbiAgICAgICAgICAgIHJldHVybiB0aGVtZS5zdGlnZy5wYWxldHRlLmVycm9yO1xyXG4gICAgICAgIGRlZmF1bHQ6XHJcbiAgICAgICAgICAgIHJldHVybiB0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnk7XHJcbiAgICB9XHJcbn19O1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgU3R5bGVkRGl2aWRlciA9IHN0eWxlZChEaXZpZGVyKSBgXG4gIGJvcmRlci1zdHlsZTogZG90dGVkO1xuICBib3JkZXItYm90dG9tLXdpZHRoOiAycHg7XG4gIGJvcmRlci1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiBDb2xvcih0aGVtZS5zdGlnZy5wYWxldHRlLm91dGxpbmVkUmVzdGluZ0JvcmRlcilcclxuICAgIC5hbHBoYSgwLjQpXHJcbiAgICAuc3RyaW5nKCl9O1xuYDtcclxuZXhwb3J0IGZ1bmN0aW9uIEZlYXR1cmVVc2FnZVByb2dyZXNzQmFyKHsgZW50aXRsZW1lbnQgfSkge1xyXG4gICAgaWYgKGVudGl0bGVtZW50Lmhhc1VubGltaXRlZFVzYWdlKSB7XHJcbiAgICAgICAgcmV0dXJuIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU3R5bGVkRGl2aWRlciwgbnVsbCk7XHJcbiAgICB9XHJcbiAgICBjb25zdCB1c2FnZVBlcmNlbnRhZ2UgPSBnZXRVc2FnZVBlcmNlbnRhZ2UoZW50aXRsZW1lbnQuY3VycmVudFVzYWdlIHx8IDAsIGVudGl0bGVtZW50LnVzYWdlTGltaXQpO1xyXG4gICAgY29uc3QgbGluZWFyUHJvZ3Jlc3NTdGF0dXMgPSBnZXRVc2FnZVByb2dyZXNzU3RhdHVzKHVzYWdlUGVyY2VudGFnZSk7XHJcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoU3R5bGVkTGluZWFyUHJvZ3Jlc3MsIHsgXCIkcHJvZ3Jlc3NTdGF0dXNcIjogbGluZWFyUHJvZ3Jlc3NTdGF0dXMsIGNsYXNzTmFtZTogYHN0aWdnLWZlYXR1cmUtdXNhZ2UtcHJvZ3Jlc3MtYmFyLSR7bGluZWFyUHJvZ3Jlc3NTdGF0dXMudG9TdHJpbmcoKX1gLCB2YXJpYW50OiBcImRldGVybWluYXRlXCIsIHZhbHVlOiB1c2FnZVBlcmNlbnRhZ2UgfSkpO1xyXG59XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUZlYXR1cmVVc2FnZVByb2dyZXNzQmFyLmpzLm1hcCJdfQ== */"));
var StyledDivider = /*#__PURE__*/_styled(Divider$1, process.env.NODE_ENV === "production" ? {
  target: "e1cbsoof0"
} : {
  target: "e1cbsoof0",
  label: "StyledDivider"
})("border-style:dotted;border-bottom-width:2px;border-color:", function (_ref3) {
  var theme = _ref3.theme;
  return Color(theme.stigg.palette.outlinedRestingBorder).alpha(0.4).string();
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlYXR1cmVVc2FnZVByb2dyZXNzQmFyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyQjZDIiwiZmlsZSI6IkZlYXR1cmVVc2FnZVByb2dyZXNzQmFyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IExpbmVhclByb2dyZXNzIGZyb20gJ0BtdWkvbWF0ZXJpYWwvTGluZWFyUHJvZ3Jlc3MnO1xyXG5pbXBvcnQgeyBnZXRVc2FnZVBlcmNlbnRhZ2UsIGdldFVzYWdlUHJvZ3Jlc3NTdGF0dXMgfSBmcm9tICcuL0ZlYXR1cmVVc2FnZS5oZWxwZXInO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgeyBEaXZpZGVyIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCBDb2xvciBmcm9tICdjb2xvcic7XHJcbmV4cG9ydCBjb25zdCBTdHlsZWRMaW5lYXJQcm9ncmVzcyA9IHN0eWxlZChMaW5lYXJQcm9ncmVzcykgYFxuICBoZWlnaHQ6IDRweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiBDb2xvcih0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnkpXHJcbiAgICAuYWxwaGEoMC40KVxyXG4gICAgLnN0cmluZygpfTtcblxuICBzcGFuIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7ICRwcm9ncmVzc1N0YXR1cywgdGhlbWUgfSkgPT4ge1xyXG4gICAgc3dpdGNoICgkcHJvZ3Jlc3NTdGF0dXMpIHtcclxuICAgICAgICBjYXNlICdzdGFuZGFyZCc6XHJcbiAgICAgICAgICAgIHJldHVybiB0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnk7XHJcbiAgICAgICAgY2FzZSAnd2FybmluZyc6XHJcbiAgICAgICAgICAgIHJldHVybiB0aGVtZS5zdGlnZy5wYWxldHRlLndhcm5pbmc7XHJcbiAgICAgICAgY2FzZSAnZXJyb3InOlxyXG4gICAgICAgICAgICByZXR1cm4gdGhlbWUuc3RpZ2cucGFsZXR0ZS5lcnJvcjtcclxuICAgICAgICBkZWZhdWx0OlxyXG4gICAgICAgICAgICByZXR1cm4gdGhlbWUuc3RpZ2cucGFsZXR0ZS5wcmltYXJ5O1xyXG4gICAgfVxyXG59fTtcbiAgfVxuYDtcclxuZXhwb3J0IGNvbnN0IFN0eWxlZERpdmlkZXIgPSBzdHlsZWQoRGl2aWRlcikgYFxuICBib3JkZXItc3R5bGU6IGRvdHRlZDtcbiAgYm9yZGVyLWJvdHRvbS13aWR0aDogMnB4O1xuICBib3JkZXItY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gQ29sb3IodGhlbWUuc3RpZ2cucGFsZXR0ZS5vdXRsaW5lZFJlc3RpbmdCb3JkZXIpXHJcbiAgICAuYWxwaGEoMC40KVxyXG4gICAgLnN0cmluZygpfTtcbmA7XHJcbmV4cG9ydCBmdW5jdGlvbiBGZWF0dXJlVXNhZ2VQcm9ncmVzc0Jhcih7IGVudGl0bGVtZW50IH0pIHtcclxuICAgIGlmIChlbnRpdGxlbWVudC5oYXNVbmxpbWl0ZWRVc2FnZSkge1xyXG4gICAgICAgIHJldHVybiBSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZERpdmlkZXIsIG51bGwpO1xyXG4gICAgfVxyXG4gICAgY29uc3QgdXNhZ2VQZXJjZW50YWdlID0gZ2V0VXNhZ2VQZXJjZW50YWdlKGVudGl0bGVtZW50LmN1cnJlbnRVc2FnZSB8fCAwLCBlbnRpdGxlbWVudC51c2FnZUxpbWl0KTtcclxuICAgIGNvbnN0IGxpbmVhclByb2dyZXNzU3RhdHVzID0gZ2V0VXNhZ2VQcm9ncmVzc1N0YXR1cyh1c2FnZVBlcmNlbnRhZ2UpO1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZExpbmVhclByb2dyZXNzLCB7IFwiJHByb2dyZXNzU3RhdHVzXCI6IGxpbmVhclByb2dyZXNzU3RhdHVzLCBjbGFzc05hbWU6IGBzdGlnZy1mZWF0dXJlLXVzYWdlLXByb2dyZXNzLWJhci0ke2xpbmVhclByb2dyZXNzU3RhdHVzLnRvU3RyaW5nKCl9YCwgdmFyaWFudDogXCJkZXRlcm1pbmF0ZVwiLCB2YWx1ZTogdXNhZ2VQZXJjZW50YWdlIH0pKTtcclxufVxyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GZWF0dXJlVXNhZ2VQcm9ncmVzc0Jhci5qcy5tYXAiXX0= */"));
function FeatureUsageProgressBar(_ref4) {
  var entitlement = _ref4.entitlement;

  if (entitlement.hasUnlimitedUsage) {
    return React__default.createElement(StyledDivider, null);
  }

  var usagePercentage = getUsagePercentage(entitlement.currentUsage || 0, entitlement.usageLimit);
  var linearProgressStatus = getUsageProgressStatus(usagePercentage);
  return React__default.createElement(StyledLinearProgress, {
    "$progressStatus": linearProgressStatus,
    className: "stigg-feature-usage-progress-bar-" + linearProgressStatus.toString(),
    variant: "determinate",
    value: usagePercentage
  });
}

var _templateObject$5;
var StyledButton$1 = /*#__PURE__*/styled(Button$1)(_templateObject$5 || (_templateObject$5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  text-transform: none;\n  padding: 0;\n  white-space: nowrap;\n"])));
function EntitlementCtaButton(_ref) {
  var entitlement = _ref.entitlement,
      feature = _ref.feature,
      onManageSubscription = _ref.onManageSubscription,
      onBuyMore = _ref.onBuyMore,
      canBuyMore = _ref.canBuyMore,
      canUpgradeSubscription = _ref.canUpgradeSubscription,
      hasCustomSubscription = _ref.hasCustomSubscription;

  if (hasCustomSubscription || entitlement.hasUnlimitedUsage) {
    return null;
  }

  if (getUsagePercentage(entitlement.currentUsage || 0, entitlement.usageLimit) < USAGE_PERCENTAGE_WARNING_THRESHOLD) {
    return null;
  }

  if (canBuyMore) {
    return onBuyMore ? React__default.createElement(StyledButton$1, {
      variant: "text",
      onClick: function onClick() {
        return onBuyMore(feature, entitlement);
      }
    }, React__default.createElement(Typography, {
      color: "primary.main"
    }, "Buy more")) : null;
  }

  if (canUpgradeSubscription) {
    return onManageSubscription ? React__default.createElement(StyledButton$1, {
      variant: "text",
      onClick: onManageSubscription
    }, React__default.createElement(Typography, {
      color: "primary.main"
    }, "Upgrade")) : null;
  }

  return null;
}

function ChargeItem(_ref) {
  var _entitlement$currentU, _entitlement$currentU2, _entitlement$usageLim;

  var amount = _ref.amount,
      currency = _ref.currency,
      entitlement = _ref.entitlement,
      feature = _ref.feature,
      hideChargePrice = _ref.hideChargePrice,
      onBuyMore = _ref.onBuyMore,
      onManageSubscription = _ref.onManageSubscription,
      canUpgradeSubscription = _ref.canUpgradeSubscription,
      hasCustomSubscription = _ref.hasCustomSubscription;
  return React__default.createElement("div", {
    className: 'stigg-charge-list-item',
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      gap: 12
    }
  }, React__default.createElement(LongText, {
    variant: "body1",
    color: "primary"
  }, feature.displayName), !hideChargePrice && React__default.createElement(LongText, {
    variant: "body1",
    color: "secondary"
  }, currencyPriceFormatter({
    amount: amount,
    currency: currency
  }), " per ", feature.featureUnits)), React__default.createElement("div", {
    style: {
      display: 'flex',
      gap: 12
    }
  }, React__default.createElement(EntitlementCtaButton, {
    entitlement: entitlement,
    feature: feature,
    canBuyMore: true,
    onBuyMore: onBuyMore,
    onManageSubscription: onManageSubscription,
    canUpgradeSubscription: canUpgradeSubscription,
    hasCustomSubscription: hasCustomSubscription
  }), React__default.createElement(Typography, {
    variant: "body1",
    color: "primary",
    style: {
      whiteSpace: 'nowrap'
    }
  }, entitlement.hasUnlimitedUsage ? (_entitlement$currentU = entitlement.currentUsage) == null ? void 0 : _entitlement$currentU.toLocaleString() : ((_entitlement$currentU2 = entitlement.currentUsage) == null ? void 0 : _entitlement$currentU2.toLocaleString()) + " of " + ((_entitlement$usageLim = entitlement.usageLimit) == null ? void 0 : _entitlement$usageLim.toLocaleString())))), React__default.createElement(FeatureUsageProgressBar, {
    entitlement: entitlement
  }));
}

function ChargeList(_ref) {
  var subscription = _ref.subscription,
      entitlements = _ref.entitlements,
      onBuyMore = _ref.onBuyMore,
      onManageSubscription = _ref.onManageSubscription,
      hasCustomSubscription = _ref.hasCustomSubscription,
      canUpgradeSubscription = _ref.canUpgradeSubscription;
  var entitlementByFeature = keyBy(entitlements, 'feature.refId');
  var filteredSubscriptionPrices = subscription.prices.filter(function (_ref2) {
    var feature = _ref2.feature,
        price = _ref2.price;
    return !!feature && entitlementByFeature[feature.refId] && !!price;
  });

  if (!filteredSubscriptionPrices.length) {
    return null;
  }

  return React__default.createElement("div", {
    className: 'stigg-charge-list',
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      marginTop: 32
    }
  }, filteredSubscriptionPrices.map(function (_ref3) {
    var feature = _ref3.feature,
        price = _ref3.price,
        billingModel = _ref3.billingModel;

    if (!feature || !price) {
      return null;
    }

    var entitlement = entitlementByFeature[feature.refId];

    if (!entitlement || !entitlement.feature) {
      return null;
    }

    return React__default.createElement(ChargeItem, {
      key: feature.refId,
      entitlement: entitlement,
      feature: entitlement.feature,
      amount: price.amount,
      currency: price.currency,
      hideChargePrice: billingModel === BillingModel.PerUnit,
      onBuyMore: onBuyMore,
      onManageSubscription: onManageSubscription,
      canUpgradeSubscription: canUpgradeSubscription,
      hasCustomSubscription: hasCustomSubscription
    });
  }));
}

function SubscriptionsOverview(_ref) {
  var onManageSubscription = _ref.onManageSubscription,
      onBuyMore = _ref.onBuyMore,
      onCancelScheduledUpdates = _ref.onCancelScheduledUpdates,
      onContactSupport = _ref.onContactSupport,
      hiddenSections = _ref.hiddenSections,
      cancelScheduledUpdatesButtonTitle = _ref.cancelScheduledUpdatesButtonTitle;

  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal,
      isLoading = _useCustomerPortalCon.isLoading,
      textOverrides = _useCustomerPortalCon.textOverrides,
      theme = _useCustomerPortalCon.theme;

  var isLoadingData = isLoading || !customerPortal;

  var _ref2 = customerPortal || {},
      subscriptions = _ref2.subscriptions,
      entitlements = _ref2.entitlements,
      canUpgradeSubscription = _ref2.canUpgradeSubscription;

  var activeSubscription = subscriptions == null ? void 0 : subscriptions.find(function (_ref3) {
    var status = _ref3.status;
    return status === SubscriptionStatus.Active;
  });
  var trialSubscription = subscriptions == null ? void 0 : subscriptions.find(function (_ref4) {
    var status = _ref4.status;
    return status === SubscriptionStatus.InTrial;
  });
  var hasCustomSubscription = (activeSubscription == null ? void 0 : activeSubscription.pricingType) === PricingType.Custom;
  var mainSubscription = activeSubscription || trialSubscription;
  return React__default.createElement(SectionContainer, {
    className: "stigg-customer-portal-subscriptions-overview",
    "$backgroundColor": theme.backgroundColor,
    "$borderColor": theme.borderColor
  }, !isLoadingData && activeSubscription && activeSubscription.scheduledUpdates && React__default.createElement(SubscriptionScheduledUpdatesAlert, {
    theme: theme,
    subscription: activeSubscription,
    onCancelScheduledUpdates: onCancelScheduledUpdates,
    cancelScheduledUpdatesButtonTitle: cancelScheduledUpdatesButtonTitle
  }), isLoadingData || !mainSubscription ? React__default.createElement(SubscriptionOverviewLoader, null) : React__default.createElement("div", {
    className: "stigg-overview-layout",
    style: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 64
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1
    }
  }, React__default.createElement(SubscriptionsOverviewHeader, {
    onManageSubscription: onManageSubscription,
    hideManageButton: hasCustomSubscription,
    textOverrides: textOverrides
  }), React__default.createElement(SubscriptionView, {
    mainSubscription: mainSubscription,
    trialSubscription: trialSubscription,
    theme: theme,
    onManageSubscription: onManageSubscription
  }), activeSubscription && entitlements && React__default.createElement(ChargeList, {
    subscription: activeSubscription,
    entitlements: entitlements,
    onBuyMore: onBuyMore,
    onManageSubscription: onManageSubscription,
    canUpgradeSubscription: !!canUpgradeSubscription,
    hasCustomSubscription: hasCustomSubscription
  }), React__default.createElement(SubscriptionTabs, {
    customerPortal: customerPortal,
    hiddenSections: hiddenSections,
    textOverrides: textOverrides,
    theme: theme
  })), React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      width: 319,
      gap: 24
    }
  }, React__default.createElement(UpcomingBilling, {
    subscription: mainSubscription,
    theme: theme,
    onContactSupport: onContactSupport,
    textOverrides: textOverrides
  }))));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$d() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var CustomerPortalHeaderLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2lw8x70"
} : {
  target: "e2lw8x70",
  label: "CustomerPortalHeaderLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "7wpci2",
  styles: "display:flex;width:100%;align-items:flex-end;justify-content:flex-end;margin-bottom:24px"
} : {
  name: "7wpci2",
  styles: "display:flex;width:100%;align-items:flex-end;justify-content:flex-end;margin-bottom:24px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkN1c3RvbWVyUG9ydGFsSGVhZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHOEMiLCJmaWxlIjoiQ3VzdG9tZXJQb3J0YWxIZWFkZXIudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBQb3dlcmVkQnlTdGlnZyB9IGZyb20gJy4uL2NvbW1vbi9Qb3dlcmVkQnlTdGlnZyc7XHJcbmNvbnN0IEN1c3RvbWVyUG9ydGFsSGVhZGVyTGF5b3V0ID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIHdpZHRoOiAxMDAlO1xuICBhbGlnbi1pdGVtczogZmxleC1lbmQ7XG4gIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gIG1hcmdpbi1ib3R0b206IDI0cHg7XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gQ3VzdG9tZXJQb3J0YWxIZWFkZXIoeyBzaG93V2F0ZXJtYXJrIH0pIHtcclxuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChDdXN0b21lclBvcnRhbEhlYWRlckxheW91dCwgeyBjbGFzc05hbWU6IFwic3RpZ2ctY3VzdG9tZXItcG9ydGFsLWhlYWRlci1sYXlvdXRcIiB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUG93ZXJlZEJ5U3RpZ2csIHsgc291cmNlOiBcImN1c3RvbWVyX3BvcnRhbFwiLCBzaG93V2F0ZXJtYXJrOiBzaG93V2F0ZXJtYXJrIH0pKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q3VzdG9tZXJQb3J0YWxIZWFkZXIuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$d
});

function CustomerPortalHeader(_ref) {
  var showWatermark = _ref.showWatermark;
  return React__default.createElement(CustomerPortalHeaderLayout, {
    className: "stigg-customer-portal-header-layout"
  }, React__default.createElement(PoweredByStigg, {
    source: "customer_portal",
    showWatermark: showWatermark
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$e() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ExternalLinkText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "eb0pe7a1"
} : {
  target: "eb0pe7a1",
  label: "ExternalLinkText"
})(process.env.NODE_ENV === "production" ? {
  name: "kxbue8",
  styles: "text-transform:none"
} : {
  name: "kxbue8",
  styles: "text-transform:none",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4dGVybmFsTGlua0J1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzRDIiwiZmlsZSI6IkV4dGVybmFsTGlua0J1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCB7IFN0eWxlZEJ1dHRvbiB9IGZyb20gJy4vU3R5bGVkQnV0dG9uJztcclxuaW1wb3J0IHsgRXh0ZXJuYWxMaW5rIGFzIEV4dGVybmFsTGlua0ljb24gfSBmcm9tICdyZWFjdC1mZWF0aGVyJztcclxuY29uc3QgRXh0ZXJuYWxMaW5rVGV4dCA9IHN0eWxlZChUeXBvZ3JhcGh5KSBgXG4gIHRleHQtdHJhbnNmb3JtOiBub25lO1xuYDtcclxuY29uc3QgTGlua0ljb24gPSBzdHlsZWQoRXh0ZXJuYWxMaW5rSWNvbikgYFxuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnl9O1xuYDtcclxuZXhwb3J0IGZ1bmN0aW9uIEV4dGVybmFsTGlua0J1dHRvbih7IHRleHQsIHVybCwgY2xhc3NOYW1lIH0pIHtcclxuICAgIGNvbnN0IG9uQ2xpY2sgPSAoKSA9PiB7XHJcbiAgICAgICAgd2luZG93Lm9wZW4odXJsLCAnX2JsYW5rJyk7XHJcbiAgICB9O1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZEJ1dHRvbiwgeyBjbGFzc05hbWU6IGNsYXNzTmFtZSwgdmFyaWFudDogXCJvdXRsaW5lZFwiLCBzdGFydEljb246IFJlYWN0LmNyZWF0ZUVsZW1lbnQoTGlua0ljb24sIHsgc2l6ZTogMjAsIHN0cm9rZVdpZHRoOiAyLjUgfSksIG9uQ2xpY2s6IG9uQ2xpY2sgfSxcclxuICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KEV4dGVybmFsTGlua1RleHQsIHsgY29sb3I6IFwicHJpbWFyeS5tYWluXCIgfSwgdGV4dCkpKTtcclxufVxyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1FeHRlcm5hbExpbmtCdXR0b24uanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$e
});

var LinkIcon = /*#__PURE__*/_styled(ExternalLink, process.env.NODE_ENV === "production" ? {
  target: "eb0pe7a0"
} : {
  target: "eb0pe7a0",
  label: "LinkIcon"
})("color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.primary;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkV4dGVybmFsTGlua0J1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUTBDIiwiZmlsZSI6IkV4dGVybmFsTGlua0J1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCB7IFN0eWxlZEJ1dHRvbiB9IGZyb20gJy4vU3R5bGVkQnV0dG9uJztcclxuaW1wb3J0IHsgRXh0ZXJuYWxMaW5rIGFzIEV4dGVybmFsTGlua0ljb24gfSBmcm9tICdyZWFjdC1mZWF0aGVyJztcclxuY29uc3QgRXh0ZXJuYWxMaW5rVGV4dCA9IHN0eWxlZChUeXBvZ3JhcGh5KSBgXG4gIHRleHQtdHJhbnNmb3JtOiBub25lO1xuYDtcclxuY29uc3QgTGlua0ljb24gPSBzdHlsZWQoRXh0ZXJuYWxMaW5rSWNvbikgYFxuICBjb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnl9O1xuYDtcclxuZXhwb3J0IGZ1bmN0aW9uIEV4dGVybmFsTGlua0J1dHRvbih7IHRleHQsIHVybCwgY2xhc3NOYW1lIH0pIHtcclxuICAgIGNvbnN0IG9uQ2xpY2sgPSAoKSA9PiB7XHJcbiAgICAgICAgd2luZG93Lm9wZW4odXJsLCAnX2JsYW5rJyk7XHJcbiAgICB9O1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZEJ1dHRvbiwgeyBjbGFzc05hbWU6IGNsYXNzTmFtZSwgdmFyaWFudDogXCJvdXRsaW5lZFwiLCBzdGFydEljb246IFJlYWN0LmNyZWF0ZUVsZW1lbnQoTGlua0ljb24sIHsgc2l6ZTogMjAsIHN0cm9rZVdpZHRoOiAyLjUgfSksIG9uQ2xpY2s6IG9uQ2xpY2sgfSxcclxuICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KEV4dGVybmFsTGlua1RleHQsIHsgY29sb3I6IFwicHJpbWFyeS5tYWluXCIgfSwgdGV4dCkpKTtcclxufVxyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1FeHRlcm5hbExpbmtCdXR0b24uanMubWFwIl19 */"));

function ExternalLinkButton(_ref2) {
  var text = _ref2.text,
      url = _ref2.url,
      className = _ref2.className;

  var onClick = function onClick() {
    window.open(url, '_blank');
  };

  return React__default.createElement(StyledButton, {
    className: className,
    variant: "outlined",
    startIcon: React__default.createElement(LinkIcon, {
      size: 20,
      strokeWidth: 2.5
    }),
    onClick: onClick
  }, React__default.createElement(ExternalLinkText, {
    color: "primary.main"
  }, text));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$f() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var InformationGridContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12mjvl51"
} : {
  target: "e12mjvl51",
  label: "InformationGridContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1hidw77",
  styles: "display:flex;flex-direction:column;align-items:flex-start;gap:16px;flex:1 0 0"
} : {
  name: "1hidw77",
  styles: "display:flex;flex-direction:column;align-items:flex-start;gap:16px;flex:1 0 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9ybWF0aW9uR3JpZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSW1EIiwiZmlsZSI6IkluZm9ybWF0aW9uR3JpZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IEZvbnRXZWlnaHQgfSBmcm9tICdzdHlsZWQtdHlwb2dyYXBoeSc7XHJcbmV4cG9ydCBjb25zdCBJbmZvcm1hdGlvbkdyaWRDb250YWluZXIgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gIGdhcDogMTZweDtcbiAgZmxleDogMSAwIDA7XG5gO1xyXG5jb25zdCBJbmZvcm1hdGlvbkdyaWRSb3cgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gIGdhcDogMTZweDtcbiAgYWxpZ24tc2VsZjogc3RyZXRjaDtcbmA7XHJcbmV4cG9ydCBmdW5jdGlvbiBJbmZvcm1hdGlvbkdyaWQoeyB0aXRsZSwgcm93cyB9KSB7XHJcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoSW5mb3JtYXRpb25HcmlkQ29udGFpbmVyLCBudWxsLFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoVHlwb2dyYXBoeSwgeyB2YXJpYW50OiBcImg2XCIsIGNvbG9yOiBcInNlY29uZGFyeVwiLCBmb250V2VpZ2h0OiBGb250V2VpZ2h0Lk1lZGl1bSB9LCB0aXRsZSksXHJcbiAgICAgICAgcm93cy5tYXAoKHsgY2xhc3NOYW1lUHJlZml4LCBsYWJlbCwgdmFsdWUsIGxhYmVsVHlwb2dyYXBoeVByb3BzLCB2YWx1ZVR5cG9ncmFwaHlQcm9wcyB9KSA9PiAoUmVhY3QuY3JlYXRlRWxlbWVudChJbmZvcm1hdGlvbkdyaWRSb3csIHsga2V5OiBsYWJlbCB9LFxyXG4gICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFR5cG9ncmFwaHksIE9iamVjdC5hc3NpZ24oeyBjbGFzc05hbWU6IGAke2NsYXNzTmFtZVByZWZpeH0tbGFiZWxgLCB2YXJpYW50OiBcImJvZHkxXCIsIGNvbG9yOiBcInNlY29uZGFyeVwiLCBzdHlsZTogeyB3aWR0aDogODAgfSB9LCBsYWJlbFR5cG9ncmFwaHlQcm9wcyksIGxhYmVsKSxcclxuICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChUeXBvZ3JhcGh5LCBPYmplY3QuYXNzaWduKHsgY2xhc3NOYW1lOiBgJHtjbGFzc05hbWVQcmVmaXh9LXRleHRgLCB2YXJpYW50OiBcImJvZHkxXCIsIGNvbG9yOiBcInNlY29uZGFyeVwiIH0sIHZhbHVlVHlwb2dyYXBoeVByb3BzKSwgdmFsdWUpKSkpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW5mb3JtYXRpb25HcmlkLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});

var InformationGridRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e12mjvl50"
} : {
  target: "e12mjvl50",
  label: "InformationGridRow"
})(process.env.NODE_ENV === "production" ? {
  name: "j9hhqa",
  styles: "display:flex;align-items:flex-start;gap:16px;align-self:stretch"
} : {
  name: "j9hhqa",
  styles: "display:flex;align-items:flex-start;gap:16px;align-self:stretch",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9ybWF0aW9uR3JpZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV3NDIiwiZmlsZSI6IkluZm9ybWF0aW9uR3JpZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCB7IEZvbnRXZWlnaHQgfSBmcm9tICdzdHlsZWQtdHlwb2dyYXBoeSc7XHJcbmV4cG9ydCBjb25zdCBJbmZvcm1hdGlvbkdyaWRDb250YWluZXIgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gIGdhcDogMTZweDtcbiAgZmxleDogMSAwIDA7XG5gO1xyXG5jb25zdCBJbmZvcm1hdGlvbkdyaWRSb3cgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gIGdhcDogMTZweDtcbiAgYWxpZ24tc2VsZjogc3RyZXRjaDtcbmA7XHJcbmV4cG9ydCBmdW5jdGlvbiBJbmZvcm1hdGlvbkdyaWQoeyB0aXRsZSwgcm93cyB9KSB7XHJcbiAgICByZXR1cm4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoSW5mb3JtYXRpb25HcmlkQ29udGFpbmVyLCBudWxsLFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoVHlwb2dyYXBoeSwgeyB2YXJpYW50OiBcImg2XCIsIGNvbG9yOiBcInNlY29uZGFyeVwiLCBmb250V2VpZ2h0OiBGb250V2VpZ2h0Lk1lZGl1bSB9LCB0aXRsZSksXHJcbiAgICAgICAgcm93cy5tYXAoKHsgY2xhc3NOYW1lUHJlZml4LCBsYWJlbCwgdmFsdWUsIGxhYmVsVHlwb2dyYXBoeVByb3BzLCB2YWx1ZVR5cG9ncmFwaHlQcm9wcyB9KSA9PiAoUmVhY3QuY3JlYXRlRWxlbWVudChJbmZvcm1hdGlvbkdyaWRSb3csIHsga2V5OiBsYWJlbCB9LFxyXG4gICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFR5cG9ncmFwaHksIE9iamVjdC5hc3NpZ24oeyBjbGFzc05hbWU6IGAke2NsYXNzTmFtZVByZWZpeH0tbGFiZWxgLCB2YXJpYW50OiBcImJvZHkxXCIsIGNvbG9yOiBcInNlY29uZGFyeVwiLCBzdHlsZTogeyB3aWR0aDogODAgfSB9LCBsYWJlbFR5cG9ncmFwaHlQcm9wcyksIGxhYmVsKSxcclxuICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChUeXBvZ3JhcGh5LCBPYmplY3QuYXNzaWduKHsgY2xhc3NOYW1lOiBgJHtjbGFzc05hbWVQcmVmaXh9LXRleHRgLCB2YXJpYW50OiBcImJvZHkxXCIsIGNvbG9yOiBcInNlY29uZGFyeVwiIH0sIHZhbHVlVHlwb2dyYXBoeVByb3BzKSwgdmFsdWUpKSkpKSk7XHJcbn1cclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW5mb3JtYXRpb25HcmlkLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$f
});

function InformationGrid(_ref) {
  var title = _ref.title,
      rows = _ref.rows;
  return React__default.createElement(InformationGridContainer, null, React__default.createElement(Typography, {
    variant: "h6",
    color: "secondary",
    fontWeight: FontWeight.Medium
  }, title), rows.map(function (_ref2) {
    var classNamePrefix = _ref2.classNamePrefix,
        label = _ref2.label,
        value = _ref2.value,
        labelTypographyProps = _ref2.labelTypographyProps,
        valueTypographyProps = _ref2.valueTypographyProps;
    return React__default.createElement(InformationGridRow, {
      key: label
    }, React__default.createElement(Typography, Object.assign({
      className: classNamePrefix + "-label",
      variant: "body1",
      color: "secondary",
      style: {
        width: 80
      }
    }, labelTypographyProps), label), React__default.createElement(Typography, Object.assign({
      className: classNamePrefix + "-text",
      variant: "body1",
      color: "secondary"
    }, valueTypographyProps), value));
  }));
}

function SkeletonButton() {
  return React__default.createElement(Skeleton$1, {
    width: 220,
    height: 42
  });
}

var EMPTY_CHAR$1 = '-';
function PaymentDetailsSection() {
  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal,
      isLoading = _useCustomerPortalCon.isLoading,
      textOverrides = _useCustomerPortalCon.textOverrides,
      theme = _useCustomerPortalCon.theme;

  var _ref = customerPortal || {},
      billingInformation = _ref.billingInformation;

  var isLoadingData = !billingInformation || isLoading;
  var items = [];

  if (isLoadingData) {
    items.push.apply(items, [React__default.createElement(InformationGridContainer, null, React__default.createElement(Skeleton$1, {
      width: 220,
      height: 12
    }), React__default.createElement(Skeleton$1, {
      width: 220,
      height: 12
    }), React__default.createElement(Skeleton$1, {
      width: 220,
      height: 12
    })), React__default.createElement(Divider$1, {
      orientation: "vertical",
      style: {
        minHeight: 93
      }
    }), React__default.createElement(InformationGridContainer, null, React__default.createElement(Skeleton$1, {
      width: 220,
      height: 12
    }), React__default.createElement(Skeleton$1, {
      width: 220,
      height: 12
    }), React__default.createElement(Skeleton$1, {
      width: 220,
      height: 12
    }))]);
  } else {
    items.push(React__default.createElement(InformationGrid, {
      title: "Billed to",
      rows: [{
        classNamePrefix: 'stigg-customer-name',
        label: 'Name',
        value: (billingInformation == null ? void 0 : billingInformation.name) || EMPTY_CHAR$1,
        valueTypographyProps: billingInformation != null && billingInformation.name ? {} : {
          color: 'disabled'
        }
      }, {
        classNamePrefix: 'stigg-customer-email',
        label: 'Email',
        value: (billingInformation == null ? void 0 : billingInformation.email) || EMPTY_CHAR$1,
        valueTypographyProps: billingInformation != null && billingInformation.email ? {} : {
          color: 'disabled'
        }
      }]
    }));

    if (billingInformation != null && billingInformation.defaultPaymentMethodId && billingInformation.defaultPaymentMethodLast4Digits && billingInformation.defaultPaymentExpirationMonth && billingInformation.defaultPaymentExpirationYear) {
      items.unshift(React__default.createElement(Divider$1, {
        orientation: "vertical",
        style: {
          minHeight: 93
        }
      }));
      items.unshift(React__default.createElement(InformationGrid, {
        title: "Payment method",
        rows: [{
          classNamePrefix: 'stigg-credit-card',
          label: 'Card',
          value: "Ending in " + billingInformation.defaultPaymentMethodLast4Digits
        }, {
          classNamePrefix: 'stigg-credit-card-expiration',
          label: 'Expires',
          value: padStart(billingInformation.defaultPaymentExpirationMonth.toString(), 2, '0') + "/" + billingInformation.defaultPaymentExpirationYear
        }]
      }));
    }
  }

  if (!isLoadingData && !(billingInformation != null && billingInformation.name) && !(billingInformation != null && billingInformation.email) && !(billingInformation != null && billingInformation.defaultPaymentMethodId)) {
    return null;
  }

  var editButton = isLoadingData ? React__default.createElement(SkeletonButton, null) : customerPortal != null && customerPortal.billingPortalUrl ? React__default.createElement(ExternalLinkButton, {
    url: customerPortal.billingPortalUrl,
    text: textOverrides.editPaymentDetails,
    className: "stigg-edit-payment-details-button"
  }) : null;
  return React__default.createElement(SectionContainer, {
    className: "stigg-payment-details-section-layout",
    "$backgroundColor": theme.backgroundColor,
    "$borderColor": theme.borderColor
  }, React__default.createElement(SectionHeader, {
    className: "stigg-payment-details-section-header"
  }, React__default.createElement(SectionTitle, {
    isLoading: isLoadingData,
    className: "stigg-payment-details-section-title",
    title: "Payment details"
  }), editButton), React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'stretch',
      gap: 64
    }
  }, items));
}

var _templateObject$6;
var CustomerPortalPaywallLayout = /*#__PURE__*/_styled(SectionContainer, process.env.NODE_ENV === "production" ? {
  target: "eqpkdww0"
} : {
  target: "eqpkdww0",
  label: "CustomerPortalPaywallLayout"
})("position:relative;.stigg-paywall-layout{width:100%;}.stigg-paywall-plans-layout{flex-wrap:nowrap;width:100%;overflow-x:auto;justify-content:unset;padding:10px 0px 0px 0px;}.stigg-paywall-plans-layout .stigg-plan-offering-container:first-of-type{margin-left:auto;}.stigg-paywall-plans-layout .stigg-plan-offering-container:last-child{margin-right:auto;}", function (_ref) {
  var $hideButtons = _ref.$hideButtons;
  return $hideButtons && css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n      .stigg-paywall-plan-button:not([disabled]) {\n        display: none;\n      }\n    "])));
}, " .", STIGG_WATERMARK_CLASSNAME, "{display:none;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkN1c3RvbWVyUG9ydGFsUGF5d2FsbC5zdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJb0UiLCJmaWxlIjoiQ3VzdG9tZXJQb3J0YWxQYXl3YWxsLnN0eWxlLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IFNUSUdHX1dBVEVSTUFSS19DTEFTU05BTUUgfSBmcm9tICcuLi8uLi9jb21tb24vUG93ZXJlZEJ5U3RpZ2cnO1xyXG5pbXBvcnQgeyBTZWN0aW9uQ29udGFpbmVyIH0gZnJvbSAnLi4vY29tbW9uL1NlY3Rpb25Db250YWluZXInO1xyXG5leHBvcnQgY29uc3QgQ3VzdG9tZXJQb3J0YWxQYXl3YWxsTGF5b3V0ID0gc3R5bGVkKFNlY3Rpb25Db250YWluZXIpIGBcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gIC5zdGlnZy1wYXl3YWxsLWxheW91dCB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cblxuICAuc3RpZ2ctcGF5d2FsbC1wbGFucy1sYXlvdXQge1xuICAgIGZsZXgtd3JhcDogbm93cmFwO1xuICAgIHdpZHRoOiAxMDAlO1xuICAgIG92ZXJmbG93LXg6IGF1dG87XG4gICAganVzdGlmeS1jb250ZW50OiB1bnNldDtcbiAgICBwYWRkaW5nOiAxMHB4IDBweCAwcHggMHB4O1xuICB9XG5cbiAgLnN0aWdnLXBheXdhbGwtcGxhbnMtbGF5b3V0IC5zdGlnZy1wbGFuLW9mZmVyaW5nLWNvbnRhaW5lcjpmaXJzdC1vZi10eXBlIHtcbiAgICBtYXJnaW4tbGVmdDogYXV0bztcbiAgfVxuICAuc3RpZ2ctcGF5d2FsbC1wbGFucy1sYXlvdXQgLnN0aWdnLXBsYW4tb2ZmZXJpbmctY29udGFpbmVyOmxhc3QtY2hpbGQge1xuICAgIG1hcmdpbi1yaWdodDogYXV0bztcbiAgfVxuXG4gICR7KHsgJGhpZGVCdXR0b25zIH0pID0+ICRoaWRlQnV0dG9ucyAmJlxyXG4gICAgY3NzIGBcbiAgICAgIC5zdGlnZy1wYXl3YWxsLXBsYW4tYnV0dG9uOm5vdChbZGlzYWJsZWRdKSB7XG4gICAgICAgIGRpc3BsYXk6IG5vbmU7XG4gICAgICB9XG4gICAgYH1cblxuICAuJHtTVElHR19XQVRFUk1BUktfQ0xBU1NOQU1FfSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q3VzdG9tZXJQb3J0YWxQYXl3YWxsLnN0eWxlLmpzLm1hcCJdfQ== */"));

var CustomerPortalPaywall = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var paywallComponent = _ref.paywallComponent,
      hidePaywallButtons = _ref.hidePaywallButtons,
      theme = _ref.theme,
      title = _ref.title,
      isLoading = _ref.isLoading;

  if (!paywallComponent) {
    return null;
  }

  return React__default.createElement(CustomerPortalPaywallLayout, {
    className: "stigg-customer-portal-paywall-section",
    ref: ref,
    "$hideButtons": hidePaywallButtons,
    "$backgroundColor": theme.backgroundColor,
    "$borderColor": theme.borderColor
  }, React__default.createElement(SectionHeader, {
    className: "stigg-customer-portal-paywall-header"
  }, React__default.createElement(SectionTitle, {
    isLoading: isLoading,
    className: "stigg-customer-portal-paywall-section-title",
    title: title
  })), paywallComponent);
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$g() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var CustomerPortalLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gjjeod1"
} : {
  target: "e1gjjeod1",
  label: "CustomerPortalLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "6xtw2",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;& *{box-sizing:border-box;}"
} : {
  name: "6xtw2",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;& *{box-sizing:border-box;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkN1c3RvbWVyUG9ydGFsLnN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUMrQyIsImZpbGUiOiJDdXN0b21lclBvcnRhbC5zdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuZXhwb3J0IGNvbnN0IEN1c3RvbWVyUG9ydGFsTGF5b3V0ID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBcbiAgJiAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgQ3VzdG9tZXJQb3J0YWxTZWN0aW9ucyA9IHN0eWxlZC5kaXYgYFxuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcm93LWdhcDogMjRweDtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUN1c3RvbWVyUG9ydGFsLnN0eWxlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});
var CustomerPortalSections = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gjjeod0"
} : {
  target: "e1gjjeod0",
  label: "CustomerPortalSections"
})(process.env.NODE_ENV === "production" ? {
  name: "1c31jfu",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;row-gap:24px"
} : {
  name: "1c31jfu",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;row-gap:24px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkN1c3RvbWVyUG9ydGFsLnN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVdpRCIsImZpbGUiOiJDdXN0b21lclBvcnRhbC5zdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuZXhwb3J0IGNvbnN0IEN1c3RvbWVyUG9ydGFsTGF5b3V0ID0gc3R5bGVkLmRpdiBgXG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBcbiAgJiAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgQ3VzdG9tZXJQb3J0YWxTZWN0aW9ucyA9IHN0eWxlZC5kaXYgYFxuICB3aWR0aDogMTAwJTtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcm93LWdhcDogMjRweDtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUN1c3RvbWVyUG9ydGFsLnN0eWxlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$g
});

function getFeatureDisplayName(feature) {
  return getFeatureDisplayNameText(feature.displayName, feature.featureUnits, feature.featureUnitsPlural);
}
function getFeatureDisplayNameText(featureDisplayName, featureUnits, featureUnitsPlural) {
  if (!featureUnits && !featureUnitsPlural) {
    return featureDisplayName;
  }

  var displayNameLowerCase = lowercase(featureDisplayName);

  if (displayNameLowerCase === lowercase(featureUnits || '') || displayNameLowerCase === lowercase(featureUnitsPlural || '')) {
    return featureDisplayName;
  }

  return featureDisplayName + " (" + featureUnitsPlural + ")";
}

var FeatureUsageContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqqveb80"
} : {
  target: "eqqveb80",
  label: "FeatureUsageContainer"
})("display:flex;flex-direction:column;padding:24px;border:", function (_ref) {
  var $borderColor = _ref.$borderColor;
  return "1px solid " + $borderColor;
}, ";border-radius:10px;row-gap:16px;height:100%;", function (_ref2) {
  var theme = _ref2.theme,
      $highlight = _ref2.$highlight;
  return $highlight && "background-color: " + theme.stigg.palette.backgroundSection;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZlYXR1cmVVc2FnZS5zdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDZ0QiLCJmaWxlIjoiRmVhdHVyZVVzYWdlLnN0eWxlLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5leHBvcnQgY29uc3QgRmVhdHVyZVVzYWdlQ29udGFpbmVyID0gc3R5bGVkLmRpdiBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIHBhZGRpbmc6IDI0cHg7XG4gIGJvcmRlcjogJHsoeyAkYm9yZGVyQ29sb3IgfSkgPT4gYDFweCBzb2xpZCAkeyRib3JkZXJDb2xvcn1gfTtcbiAgYm9yZGVyLXJhZGl1czogMTBweDtcbiAgcm93LWdhcDogMTZweDtcbiAgaGVpZ2h0OiAxMDAlO1xuXG4gICR7KHsgdGhlbWUsICRoaWdobGlnaHQgfSkgPT4gJGhpZ2hsaWdodCAmJiBgYmFja2dyb3VuZC1jb2xvcjogJHt0aGVtZS5zdGlnZy5wYWxldHRlLmJhY2tncm91bmRTZWN0aW9ufWB9O1xuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RmVhdHVyZVVzYWdlLnN0eWxlLmpzLm1hcCJdfQ== */"));

function FeatureUsage(_ref) {
  var _entitlement$feature, _entitlement$currentU, _entitlement$usageLim;

  var entitlement = _ref.entitlement,
      subscriptionPrice = _ref.subscriptionPrice,
      onManageSubscription = _ref.onManageSubscription,
      onBuyMore = _ref.onBuyMore,
      hasCustomSubscription = _ref.hasCustomSubscription,
      canUpgradeSubscription = _ref.canUpgradeSubscription;

  var _useCustomerPortalCon = useCustomerPortalContext(),
      theme = _useCustomerPortalCon.theme;

  var hasOverageUsage = !entitlement.hasUnlimitedUsage && entitlement.currentUsage > entitlement.usageLimit;

  if (!entitlement.feature) {
    return null;
  }

  return React__default.createElement(FeatureUsageContainer, {
    "$highlight": !!subscriptionPrice,
    "$borderColor": theme.borderColor
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16
    }
  }, React__default.createElement(LongText, {
    variant: "body1"
  }, entitlement.feature && getFeatureDisplayName(entitlement.feature)), subscriptionPrice && React__default.createElement(InformationTooltip, {
    title: React__default.createElement(Typography, {
      variant: "body1"
    }, subscriptionPrice.billingModel === BillingModel.PerUnit ? 'Billed for committed usage' : 'Billed for actual usage')
  }, React__default.createElement(Icon, {
    icon: "DollarCoin",
    svgStrokeColor: theme.iconsColor
  }))), React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 8
    }
  }, React__default.createElement(LongText, {
    variant: "body1",
    color: hasOverageUsage ? 'error' : 'primary',
    "data-testid": "usage-data-" + ((_entitlement$feature = entitlement.feature) == null ? void 0 : _entitlement$feature.refId)
  }, (_entitlement$currentU = entitlement.currentUsage) == null ? void 0 : _entitlement$currentU.toLocaleString(), !entitlement.hasUnlimitedUsage && " / " + ((_entitlement$usageLim = entitlement.usageLimit) == null ? void 0 : _entitlement$usageLim.toLocaleString()) + " (" + getUsagePercentage(entitlement.currentUsage || 0, entitlement.usageLimit) + "%)"), React__default.createElement(EntitlementCtaButton, {
    entitlement: entitlement,
    feature: entitlement.feature,
    onBuyMore: onBuyMore,
    canBuyMore: !!subscriptionPrice,
    onManageSubscription: onManageSubscription,
    canUpgradeSubscription: canUpgradeSubscription,
    hasCustomSubscription: hasCustomSubscription
  })), React__default.createElement(FeatureUsageProgressBar, {
    entitlement: entitlement
  }), !entitlement.hasUnlimitedUsage && !isUndefined(entitlement.usageLimit) && !isUndefined(entitlement.currentUsage) && entitlement.resetPeriod && entitlement.nextResetDate ? React__default.createElement(Typography, {
    color: "secondary"
  }, getResetUsageText(entitlement)) : null, entitlement.hasUnlimitedUsage && React__default.createElement(Typography, {
    color: "secondary"
  }, "In current billing period"));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$h() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Footer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eoaojje0"
} : {
  target: "eoaojje0",
  label: "Footer"
})(process.env.NODE_ENV === "production" ? {
  name: "3hgi0y",
  styles: "margin-top:32px"
} : {
  name: "3hgi0y",
  styles: "margin-top:32px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkN1c3RvbWVyVXNhZ2VEYXRhLnN0eWxlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLaUMiLCJmaWxlIjoiQ3VzdG9tZXJVc2FnZURhdGEuc3R5bGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBHcmlkIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCB7IHJhbmdlIH0gZnJvbSAnbG9kYXNoJztcclxuaW1wb3J0IFNrZWxldG9uIGZyb20gJ3JlYWN0LWxvYWRpbmctc2tlbGV0b24nO1xyXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5leHBvcnQgY29uc3QgRm9vdGVyID0gc3R5bGVkLmRpdiBgXG4gIG1hcmdpbi10b3A6IDMycHg7XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gQ3VzdG9tZXJVc2FnZUxvYWRlcigpIHtcclxuICAgIHJldHVybiAoUmVhY3QuY3JlYXRlRWxlbWVudChHcmlkLCB7IGNvbnRhaW5lcjogdHJ1ZSwgc3BhY2luZzogNCwgY2xhc3NOYW1lOiBcInN0aWdnLXN1YnNjcmlwdGlvbi11c2FnZS1za2VsZXRvbi1sYXlvdXRcIiB9LCByYW5nZSg2KS5tYXAoKGl0ZW0pID0+IChSZWFjdC5jcmVhdGVFbGVtZW50KEdyaWQsIHsga2V5OiBpdGVtLCBpdGVtOiB0cnVlLCB4czogNCB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU2tlbGV0b24sIHsgd2lkdGg6IDI4MCwgaGVpZ2h0OiAxMjAgfSkpKSkpKTtcclxufVxyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DdXN0b21lclVzYWdlRGF0YS5zdHlsZS5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$h
});
function CustomerUsageLoader() {
  return React__default.createElement(Grid, {
    container: true,
    spacing: 4,
    className: "stigg-subscription-usage-skeleton-layout"
  }, range(6).map(function (item) {
    return React__default.createElement(Grid, {
      key: item,
      item: true,
      xs: 4
    }, React__default.createElement(Skeleton$1, {
      width: 280,
      height: 120
    }));
  }));
}

var MAX_BOXES = 6;
function CustomerUsageData(_ref) {
  var onManageSubscription = _ref.onManageSubscription,
      onBuyMore = _ref.onBuyMore;

  var _React$useState = React__default.useState(false),
      showAll = _React$useState[0],
      setShowAll = _React$useState[1];

  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal,
      isLoading = _useCustomerPortalCon.isLoading,
      textOverrides = _useCustomerPortalCon.textOverrides,
      theme = _useCustomerPortalCon.theme;

  var isLoadingData = isLoading || !customerPortal;

  var _ref2 = customerPortal || {},
      entitlements = _ref2.entitlements,
      subscriptions = _ref2.subscriptions;

  var meteredEntitlements = entitlements == null ? void 0 : entitlements.filter(function (entitlement) {
    var _entitlement$feature, _entitlement$feature2;

    return ((_entitlement$feature = entitlement.feature) == null ? void 0 : _entitlement$feature.meterType) === MeterType.Fluctuating || ((_entitlement$feature2 = entitlement.feature) == null ? void 0 : _entitlement$feature2.meterType) === MeterType.Incremental;
  });
  var activeSubscription = subscriptions == null ? void 0 : subscriptions.find(function (_ref3) {
    var status = _ref3.status;
    return status === SubscriptionStatus.Active;
  });
  var hasCustomSubscription = (activeSubscription == null ? void 0 : activeSubscription.pricingType) === PricingType.Custom;
  var canUpgradeSubscription = !!(customerPortal != null && customerPortal.canUpgradeSubscription);
  var subscriptionPriceByFeature = keyBy(activeSubscription == null ? void 0 : activeSubscription.prices, 'feature.refId');
  var entitlementByFeature = keyBy(meteredEntitlements, 'feature.refId'); // sort features by prices first, then other entitlements

  var priceEntitlements = compact(activeSubscription == null ? void 0 : activeSubscription.prices.map(function (subscriptionPrice) {
    return subscriptionPrice.feature && entitlementByFeature[subscriptionPrice.feature.refId];
  }));
  var otherEntitlements = compact(meteredEntitlements == null ? void 0 : meteredEntitlements.filter(function (entitlement) {
    return !subscriptionPriceByFeature[entitlement.feature.refId];
  }));
  var sortedEntitlements = [].concat(priceEntitlements, otherEntitlements); // 4 -> 3 per row, 6 -> 2 per row

  var xs = sortedEntitlements.length > 2 ? 4 : 6;
  var entitlementsToShow = showAll ? sortedEntitlements : sortedEntitlements.slice(0, MAX_BOXES);

  var toggleShowAll = function toggleShowAll() {
    return setShowAll(function (prevState) {
      return !prevState;
    });
  };

  if (!isLoadingData && !(meteredEntitlements != null && meteredEntitlements.length)) {
    return null;
  }

  return React__default.createElement(SectionContainer, {
    className: "stigg-subscription-usage-layout",
    "$backgroundColor": theme.backgroundColor,
    "$borderColor": theme.borderColor
  }, React__default.createElement(SectionHeader, null, React__default.createElement(SectionTitle, {
    title: textOverrides.usageTabTitle,
    className: "stigg-customer-portal-usage-section-title",
    isLoading: isLoadingData
  })), isLoadingData ? React__default.createElement(CustomerUsageLoader, null) : React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    container: true,
    spacing: 4
  }, entitlementsToShow.map(function (entitlement) {
    return React__default.createElement(Grid, {
      item: true,
      xs: xs
    }, React__default.createElement(FeatureUsage, {
      key: entitlement.feature.refId,
      subscriptionPrice: subscriptionPriceByFeature[entitlement.feature.refId],
      entitlement: entitlement,
      onManageSubscription: onManageSubscription,
      onBuyMore: onBuyMore,
      hasCustomSubscription: hasCustomSubscription,
      canUpgradeSubscription: canUpgradeSubscription
    }));
  })), sortedEntitlements.length > MAX_BOXES && React__default.createElement(Footer, null, React__default.createElement(StyledButton, {
    className: "stigg-usage-toggle-many-button",
    variant: "text",
    startIcon: showAll ? React__default.createElement(Minus, null) : React__default.createElement(Plus, null),
    onClick: toggleShowAll
  }, showAll ? 'Show less' : 'Show more'))));
}

function CustomerPortalContainer(_ref) {
  var onManageSubscription = _ref.onManageSubscription,
      onBuyMore = _ref.onBuyMore,
      onCancelScheduledUpdates = _ref.onCancelScheduledUpdates,
      onContactSupport = _ref.onContactSupport,
      paywallComponent = _ref.paywallComponent,
      hiddenSections = _ref.hiddenSections;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg;

  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal,
      textOverrides = _useCustomerPortalCon.textOverrides,
      theme = _useCustomerPortalCon.theme,
      isLoading = _useCustomerPortalCon.isLoading;

  var customerPortalSectionRef = useRef(null);

  var onManageClick = function onManageClick() {
    if (onManageSubscription) {
      onManageSubscription();
    } else {
      var _customerPortalSectio;

      customerPortalSectionRef == null ? void 0 : (_customerPortalSectio = customerPortalSectionRef.current) == null ? void 0 : _customerPortalSectio.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  var hasCustomSubscription = customerPortal == null ? void 0 : customerPortal.subscriptions.some(function (subscription) {
    return subscription.pricingType === PricingType.Custom;
  });
  var shouldShowUsage = !(hiddenSections != null && hiddenSections.some(function (section) {
    return section === 'usage';
  }));
  var shouldShowPaymentDetails = !(hiddenSections != null && hiddenSections.some(function (section) {
    return section === 'paymentDetails' || section === 'billingInformation';
  }));
  var shouldShowInvoices = !(hiddenSections != null && hiddenSections.some(function (section) {
    return section === 'invoices' || section === 'billingInformation';
  }));
  return React__default.createElement(CustomerPortalLayout, {
    className: "stigg-customer-portal-layout"
  }, React__default.createElement(CustomerPortalHeader, {
    showWatermark: stigg.isWidgetWatermarkEnabled && !!customerPortal
  }), React__default.createElement(CustomerPortalSections, {
    className: "stigg-customer-portal-sections"
  }, React__default.createElement(SubscriptionsOverview, {
    onCancelScheduledUpdates: onCancelScheduledUpdates,
    onBuyMore: onBuyMore,
    onManageSubscription: onManageClick,
    onContactSupport: onContactSupport,
    hiddenSections: hiddenSections,
    cancelScheduledUpdatesButtonTitle: textOverrides.cancelScheduledUpdatesButtonTitle
  }), shouldShowUsage && React__default.createElement(CustomerUsageData, {
    onManageSubscription: onManageClick,
    onBuyMore: onBuyMore
  }), React__default.createElement(CustomerPortalPaywall, {
    ref: customerPortalSectionRef,
    paywallComponent: paywallComponent,
    hidePaywallButtons: !!hasCustomSubscription,
    theme: theme,
    title: textOverrides.paywallSectionTitle,
    isLoading: !customerPortal || isLoading
  }), shouldShowPaymentDetails && React__default.createElement(PaymentDetailsSection, null), shouldShowInvoices && React__default.createElement(InvoicesSection, null)));
}

var _excluded$4 = ["textOverrides", "theme", "resourceId", "productId"];
function CustomerPortal(_ref) {
  var textOverrides = _ref.textOverrides,
      theme = _ref.theme,
      resourceId = _ref.resourceId,
      productId = _ref.productId,
      restProps = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return React__default.createElement(CustomerPortalProvider, {
    textOverrides: textOverrides,
    theme: theme,
    resourceId: resourceId,
    productId: productId
  }, React__default.createElement(CustomerPortalContainer, Object.assign({}, restProps)));
}

function InvoicesSection() {
  var _useCustomerPortalCon = useCustomerPortalContext(),
      customerPortal = _useCustomerPortalCon.customerPortal,
      isLoading = _useCustomerPortalCon.isLoading,
      textOverrides = _useCustomerPortalCon.textOverrides,
      theme = _useCustomerPortalCon.theme;

  var isLoadingData = !customerPortal || isLoading;
  var viewInvoiceHistoryButton = isLoadingData ? React__default.createElement(SkeletonButton, null) : customerPortal != null && customerPortal.billingPortalUrl ? React__default.createElement(ExternalLinkButton, {
    url: customerPortal.billingPortalUrl,
    text: textOverrides.viewInvoiceHistory,
    className: "stigg-view-invoice-history-button"
  }) : null;

  if (!isLoadingData && !(customerPortal != null && customerPortal.billingPortalUrl)) {
    return null;
  }

  return React__default.createElement(SectionContainer, {
    className: "stigg-invoices-section-layout",
    "$backgroundColor": theme.backgroundColor,
    "$borderColor": theme.borderColor
  }, React__default.createElement(SectionHeader, {
    className: "stigg-invoices-section-header"
  }, React__default.createElement(SectionTitle, {
    isLoading: isLoadingData,
    className: "stigg-invoices-section-title",
    title: textOverrides.invoicesTitle
  }), viewInvoiceHistoryButton));
}

var sortAddons = function sortAddons(addons) {
  return sortBy(addons, 'displayName');
};
var sortSubscriptionAddons = function sortSubscriptionAddons(addons) {
  return sortBy(addons, 'addon.displayName');
};
function filterAddons(_ref) {
  var _addons$filter;

  var addons = _ref.addons,
      billingPeriod = _ref.billingPeriod,
      billingCountryCode = _ref.billingCountryCode,
      currency = _ref.currency;
  return (addons == null ? void 0 : (_addons$filter = addons.filter(function (addon) {
    return filterAddonPricePointsByBillingPeriod(addon, billingPeriod);
  })) == null ? void 0 : _addons$filter.map(function (addon) {
    return mapAddonPricePointsByBillingCountryCode({
      addon: addon,
      currency: currency,
      billingCountryCode: billingCountryCode
    });
  })) || [];
}
function filterSubscriptionAddons(_ref2) {
  var _addons$filter2;

  var addons = _ref2.addons,
      billingPeriod = _ref2.billingPeriod,
      billingCountryCode = _ref2.billingCountryCode,
      currency = _ref2.currency;
  return (addons == null ? void 0 : (_addons$filter2 = addons.filter(function (addon) {
    return filterAddonPricePointsByBillingPeriod(addon.addon, billingPeriod);
  })) == null ? void 0 : _addons$filter2.map(function (addon) {
    return _extends({}, addon, {
      addon: mapAddonPricePointsByBillingCountryCode({
        addon: addon.addon,
        currency: currency,
        billingCountryCode: billingCountryCode
      })
    });
  })) || [];
}

function filterAddonPricePointsByBillingPeriod(addon, billingPeriod) {
  return addon.pricePoints.some(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
}

function mapAddonPricePointsByBillingCountryCode(_ref3) {
  var addon = _ref3.addon,
      currency = _ref3.currency,
      billingCountryCode = _ref3.billingCountryCode;
  return _extends({}, addon, {
    pricePoints: addon.pricePoints.filter(function (pricePoint) {
      return pricePoint.currency === currency && (billingCountryCode ? pricePoint.billingCountryCode === billingCountryCode : true);
    })
  });
}

function getAddonsStepInitialState(_ref) {
  var _plan$pricePoints, _plan$pricePoints$;

  var activeSubscription = _ref.activeSubscription,
      plan = _ref.plan,
      billingPeriod = _ref.billingPeriod,
      billingCountryCode = _ref.billingCountryCode;
  var addons = [];
  var currency = (plan == null ? void 0 : (_plan$pricePoints = plan.pricePoints) == null ? void 0 : (_plan$pricePoints$ = _plan$pricePoints[0]) == null ? void 0 : _plan$pricePoints$.currency) || Currency.Usd;
  var availableAddons = sortAddons(filterAddons({
    addons: plan == null ? void 0 : plan.compatibleAddons,
    billingPeriod: billingPeriod,
    billingCountryCode: billingCountryCode,
    currency: currency
  }));
  var activeSubscriptionAddons = filterSubscriptionAddons({
    addons: activeSubscription == null ? void 0 : activeSubscription.addons,
    billingPeriod: billingPeriod,
    billingCountryCode: billingCountryCode,
    currency: currency
  });

  if (activeSubscriptionAddons != null && activeSubscriptionAddons.length && availableAddons != null && availableAddons.length) {
    addons = sortSubscriptionAddons(activeSubscriptionAddons.filter(function (addon) {
      return availableAddons.some(function (planAddon) {
        return planAddon.id === addon.addon.id;
      });
    }));
  }

  return {
    addons: addons,
    initialAddons: cloneDeep(addons),
    availableAddons: availableAddons
  };
}

function useSetAddon() {
  var _useCheckoutContext = useCheckoutContext(),
      setState = _useCheckoutContext[1];

  return function (addon, quantity) {
    return setState(function (draft) {
      var addonToUpdate = draft.addonsStep.addons.find(function (currentAddon) {
        return currentAddon.addon.id === addon.id;
      });

      if (addonToUpdate) {
        addonToUpdate.quantity = quantity;
      } else {
        draft.addonsStep.addons.push({
          addon: addon,
          quantity: quantity
        });
        draft.addonsStep.addons = sortSubscriptionAddons(draft.addonsStep.addons);
      }
    });
  };
}

function useRemoveAddon() {
  var _useCheckoutContext2 = useCheckoutContext(),
      setState = _useCheckoutContext2[1];

  return function (addonId) {
    return setState(function (draft) {
      remove(draft.addonsStep.addons, function (addon) {
        return addon.addon.id === addonId;
      });
    });
  };
}

function useAddonsState() {
  var _useCheckoutContext3 = useCheckoutContext(),
      addonsStep = _useCheckoutContext3[0].addonsStep;

  return addonsStep;
}

function useAddonsStepModel() {
  var state = useAddonsState();
  return _extends({}, state, {
    setAddon: useSetAddon(),
    removeAddon: useRemoveAddon()
  });
}

function useCheckoutState() {
  var _useCheckoutContext = useCheckoutContext(),
      _useCheckoutContext$ = _useCheckoutContext[0],
      checkout = _useCheckoutContext$.checkout,
      widgetState = _useCheckoutContext$.widgetState,
      checkoutLocalization = _useCheckoutContext$.checkoutLocalization;

  return {
    checkoutState: checkout,
    widgetState: widgetState,
    checkoutLocalization: checkoutLocalization
  };
}

function useSetWidgetReadonly() {
  var _useCheckoutContext2 = useCheckoutContext(),
      setState = _useCheckoutContext2[1];

  return function (readOnly) {
    return setState(function (draft) {
      draft.widgetState.readOnly = readOnly;
    });
  };
}

function useSetIsValid() {
  var _useCheckoutContext3 = useCheckoutContext(),
      setState = _useCheckoutContext3[1];

  return function (isValid) {
    return setState(function (draft) {
      draft.widgetState.isValid = isValid;
    });
  };
}

function useCheckoutModel() {
  var _useCheckoutState = useCheckoutState(),
      checkoutState = _useCheckoutState.checkoutState,
      widgetState = _useCheckoutState.widgetState,
      checkoutLocalization = _useCheckoutState.checkoutLocalization;

  return {
    checkoutState: checkoutState,
    widgetState: widgetState,
    checkoutLocalization: checkoutLocalization,
    setWidgetReadOnly: useSetWidgetReadonly(),
    setIsValid: useSetIsValid()
  };
}

function useLoadCheckout(_ref) {
  var planId = _ref.planId,
      resourceId = _ref.resourceId,
      billingCountryCode = _ref.billingCountryCode,
      onMockCheckoutState = _ref.onMockCheckoutState;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg;

  var _useState = useState(true),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useState2 = useState(),
      checkout = _useState2[0],
      setCheckout = _useState2[1];

  useEffect(function () {
    var loadCheckout = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
        var _checkout;

        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return stigg.getCheckoutState({
                  planId: planId,
                  resourceId: resourceId,
                  billingCountryCode: billingCountryCode
                });

              case 3:
                _checkout = _context.sent;
                setCheckout(_checkout);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                logger.error("Failed to load checkout " + (_context.t0 == null ? void 0 : _context.t0.message), _context.t0);

              case 10:
                _context.prev = 10;
                setIsLoading(false);
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7, 10, 13]]);
      }));

      return function loadCheckout() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (onMockCheckoutState) {
      setIsLoading(false);
      setCheckout(onMockCheckoutState({
        planId: planId,
        resourceId: resourceId,
        billingCountryCode: billingCountryCode
      }));
      return;
    }

    if (stigg.isCustomerLoaded) {
      setIsLoading(true);
      void loadCheckout();
    }
  }, [stigg, stigg.isCustomerLoaded, resourceId, planId, billingCountryCode, onMockCheckoutState]);
  return {
    checkout: checkout,
    isLoading: isLoading
  };
}

var getValidPriceQuantity = function getValidPriceQuantity(price, quantity) {
  if (price.minUnitQuantity && quantity < price.minUnitQuantity) {
    return price.minUnitQuantity;
  } else if (price.maxUnitQuantity && quantity > price.maxUnitQuantity) {
    return price.maxUnitQuantity;
  }

  return quantity;
};

var getBillingPeriod = function getBillingPeriod(billingPeriod, hasMonthlyPrices, hasAnnualPrices) {
  if (billingPeriod === BillingPeriod$1.Monthly && hasMonthlyPrices) {
    return billingPeriod;
  }

  if (billingPeriod === BillingPeriod$1.Annually && hasAnnualPrices) {
    return billingPeriod;
  }

  return null;
};

var isInAdvanceCommitmentCharge = function isInAdvanceCommitmentCharge(_ref) {
  var pricingModel = _ref.pricingModel;
  return pricingModel === BillingModel.PerUnit;
};

function getBillableFeatures(preconfiguredBillableFeatures, planPrices, activeSubscription) {
  var _activeSubscription$p;

  if (!planPrices) return [];
  var preconfBillableFeaturesByFeatureId = keyBy$1(preconfiguredBillableFeatures, 'featureId');
  var quantityByFeatureId = keyBy$1(compact$1(activeSubscription == null ? void 0 : (_activeSubscription$p = activeSubscription.prices) == null ? void 0 : _activeSubscription$p.map(function (charge) {
    var feature = charge.feature;

    if (!feature || !isInAdvanceCommitmentCharge(charge)) {
      return null;
    }

    return {
      featureId: feature.featureId,
      quantity: feature.unitQuantity || null
    };
  })), 'featureId');
  return compact$1(planPrices == null ? void 0 : planPrices.map(function (price) {
    var _price$feature, _preconfBillableFeatu, _quantityByFeatureId$;

    var featureId = (_price$feature = price.feature) == null ? void 0 : _price$feature.featureId;

    if (!featureId || !isInAdvanceCommitmentCharge(price)) {
      return null;
    }

    var quantity;
    var preconfiguredQuantity = ((_preconfBillableFeatu = preconfBillableFeaturesByFeatureId[featureId]) == null ? void 0 : _preconfBillableFeatu.quantity) || ((_quantityByFeatureId$ = quantityByFeatureId[featureId]) == null ? void 0 : _quantityByFeatureId$.quantity);
    quantity = getValidPriceQuantity(price, preconfiguredQuantity || 1);

    if (price.isTieredPrice) {
      var tier = getTierByQuantity(price.tiers, quantity);
      quantity = tier.upTo;
    }

    return {
      featureId: featureId,
      quantity: quantity
    };
  }));
}

function resolveBillingPeriod(_ref2) {
  var _activeSubscription$p2;

  var plan = _ref2.plan,
      activeSubscription = _ref2.activeSubscription,
      preferredBillingPeriod = _ref2.preferredBillingPeriod;
  var hasMonthlyPrices = plan == null ? void 0 : plan.pricePoints.some(function (pricePoint) {
    return pricePoint.billingPeriod === BillingPeriod$1.Monthly;
  });
  var hasAnnualPrices = plan == null ? void 0 : plan.pricePoints.some(function (pricePoint) {
    return pricePoint.billingPeriod === BillingPeriod$1.Annually;
  });

  if (preferredBillingPeriod) {
    var billingPeriod = getBillingPeriod(preferredBillingPeriod, hasMonthlyPrices, hasAnnualPrices);

    if (billingPeriod) {
      return billingPeriod;
    }
  }

  var isUpdate = (activeSubscription == null ? void 0 : (_activeSubscription$p2 = activeSubscription.plan) == null ? void 0 : _activeSubscription$p2.id) === (plan == null ? void 0 : plan.id);

  if (isUpdate) {
    var _activeSubscription$p3;

    return (activeSubscription == null ? void 0 : (_activeSubscription$p3 = activeSubscription.price) == null ? void 0 : _activeSubscription$p3.billingPeriod) || BillingPeriod$1.Monthly;
  }

  if (activeSubscription != null && activeSubscription.prices && (activeSubscription == null ? void 0 : activeSubscription.prices.length) > 0) {
    var _billingPeriod = getBillingPeriod(activeSubscription == null ? void 0 : activeSubscription.prices[0].billingPeriod, hasMonthlyPrices, hasAnnualPrices);

    if (_billingPeriod) {
      return _billingPeriod;
    }
  }

  return hasAnnualPrices ? BillingPeriod$1.Annually : BillingPeriod$1.Monthly;
}

function getPlanStepInitialState(_ref3) {
  var preferredBillingPeriod = _ref3.preferredBillingPeriod,
      plan = _ref3.plan,
      activeSubscription = _ref3.activeSubscription,
      billingCountryCode = _ref3.billingCountryCode,
      preconfiguredBillableFeatures = _ref3.preconfiguredBillableFeatures;
  var billingPeriod = resolveBillingPeriod({
    plan: plan,
    activeSubscription: activeSubscription,
    preferredBillingPeriod: preferredBillingPeriod
  });
  var planPrices = plan == null ? void 0 : plan.pricePoints.filter(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
  var billableFeatures = getBillableFeatures(preconfiguredBillableFeatures, planPrices, activeSubscription);
  return {
    billingPeriod: billingPeriod,
    billableFeatures: billableFeatures,
    billingCountryCode: billingCountryCode
  };
}

function usePlanState() {
  var _useCheckoutContext = useCheckoutContext(),
      planStep = _useCheckoutContext[0].planStep;

  return planStep;
}

function useSetBillableFeature() {
  var _useCheckoutContext2 = useCheckoutContext(),
      setState = _useCheckoutContext2[1];

  return function (featureId, quantity) {
    return setState(function (draft) {
      var billableFeature = draft.planStep.billableFeatures.find(function (billableFeature) {
        return billableFeature.featureId === featureId;
      });

      if (billableFeature) {
        billableFeature.quantity = quantity;
      } else {
        draft.planStep.billableFeatures.push({
          featureId: featureId,
          quantity: quantity
        });
      }
    });
  };
}

function useSetBillingPeriod() {
  var _useCheckoutContext3 = useCheckoutContext(),
      setState = _useCheckoutContext3[1];

  return function (billingPeriod) {
    return setState(function (draft) {
      draft.planStep.billingPeriod = billingPeriod;
    });
  };
}

function usePlanStepModel() {
  var state = usePlanState();
  return _extends({}, state, {
    setBillingPeriod: useSetBillingPeriod(),
    setBillableFeature: useSetBillableFeature()
  });
}

var CheckoutStepKey;

(function (CheckoutStepKey) {
  CheckoutStepKey["PLAN"] = "PLAN";
  CheckoutStepKey["ADDONS"] = "ADDONS";
  CheckoutStepKey["PAYMENT"] = "PAYMENT";
})(CheckoutStepKey || (CheckoutStepKey = {}));

var CHECKOUT_STEPS = [{
  key: CheckoutStepKey.PLAN,
  label: 'Plan'
}, {
  key: CheckoutStepKey.ADDONS,
  label: 'Add-ons'
}, {
  key: CheckoutStepKey.PAYMENT,
  label: 'Payment details'
}];
var INITIAL_STATE = {
  activeStep: 0,
  completedSteps: [],
  steps: CHECKOUT_STEPS,
  isDisabled: false
};
function getProgressBarInitialState(_ref) {
  var availableAddons = _ref.availableAddons;

  if ((availableAddons == null ? void 0 : availableAddons.length) === 0) {
    return _extends({}, INITIAL_STATE, {
      steps: CHECKOUT_STEPS.filter(function (step) {
        return step.key !== CheckoutStepKey.ADDONS;
      })
    });
  }

  return INITIAL_STATE;
}

function useProgressBarState() {
  var _useCheckoutContext = useCheckoutContext(),
      progressBar = _useCheckoutContext[0].progressBar;

  return progressBar;
}

function useSetActiveStep() {
  var _useCheckoutContext2 = useCheckoutContext(),
      setState = _useCheckoutContext2[1];

  return function (stepNumber) {
    return setState(function (_ref2) {
      var progressBar = _ref2.progressBar;
      progressBar.activeStep = stepNumber;
    });
  };
}

function useMarkStepAsCompleted() {
  var _useCheckoutContext3 = useCheckoutContext(),
      setState = _useCheckoutContext3[1];

  return function (stepNumber) {
    return setState(function (_ref3) {
      var progressBar = _ref3.progressBar;
      progressBar.completedSteps.push(stepNumber);
    });
  };
}

function isCheckoutComplete(progressBar) {
  return progressBar.completedSteps.length >= progressBar.steps.length - 1;
}

function useGoNext() {
  var _useCheckoutContext4 = useCheckoutContext(),
      setState = _useCheckoutContext4[1];

  return function () {
    return setState(function (_ref4) {
      var progressBar = _ref4.progressBar;

      if (progressBar.isDisabled) {
        return;
      }

      if (!progressBar.completedSteps.includes(progressBar.activeStep)) {
        progressBar.completedSteps.push(progressBar.activeStep);
      }

      if (progressBar.activeStep < progressBar.steps.length - 1) {
        progressBar.activeStep += 1;
      }
    });
  };
}

function useSetIsDisabled() {
  var _useCheckoutContext5 = useCheckoutContext(),
      setState = _useCheckoutContext5[1];

  return function (isDisabled) {
    return setState(function (_ref5) {
      var progressBar = _ref5.progressBar;
      progressBar.isDisabled = !!isDisabled;
    });
  };
}

function useProgressBarModel() {
  var progressBarState = useProgressBarState();
  var currentStep = progressBarState.steps[progressBarState.activeStep];
  return {
    currentStep: currentStep,
    progressBarState: progressBarState,
    isLastStep: progressBarState.activeStep === progressBarState.steps.length - 1,
    isCheckoutComplete: isCheckoutComplete(progressBarState),
    setActiveStep: useSetActiveStep(),
    markStepAsCompleted: useMarkStepAsCompleted(),
    goNext: useGoNext(),
    setIsDisabled: useSetIsDisabled()
  };
}

function useSubscriptionModel() {
  var _useCheckoutContext = useCheckoutContext(),
      _useCheckoutContext$ = _useCheckoutContext[0],
      planStep = _useCheckoutContext$.planStep,
      addonsStep = _useCheckoutContext$.addonsStep,
      promotionCode = _useCheckoutContext$.promotionCode,
      paymentStep = _useCheckoutContext$.paymentStep;

  return _extends({}, planStep, {
    addons: addonsStep.addons,
    promotionCode: promotionCode,
    billingAddress: paymentStep.billingAddress,
    taxPercentage: paymentStep.taxPercentage
  });
}

function mapBillingInformation(_ref) {
  var billingAddress = _ref.billingAddress,
      taxPercentage = _ref.taxPercentage;

  if (!billingAddress && !taxPercentage) {
    return {};
  }

  return {
    billingInformation: _extends({}, billingAddress ? {
      billingAddress: billingAddress
    } : {}, taxPercentage ? {
      taxPercentage: taxPercentage
    } : {})
  };
}

var previewSubscription = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref2) {
    var stigg, customerId, planId, resourceId, promotionCode, addons, billableFeatures, billingCountryCode, billingPeriod, billingAddress, taxPercentage, onMockCheckoutPreview, estimateAddons, subscriptionPreview, errorMessage, previewSubscriptionProps, _error$message, _ref5, errorMsg;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            stigg = _ref2.stigg, customerId = _ref2.customerId, planId = _ref2.planId, resourceId = _ref2.resourceId, promotionCode = _ref2.promotionCode, addons = _ref2.addons, billableFeatures = _ref2.billableFeatures, billingCountryCode = _ref2.billingCountryCode, billingPeriod = _ref2.billingPeriod, billingAddress = _ref2.billingAddress, taxPercentage = _ref2.taxPercentage, onMockCheckoutPreview = _ref2.onMockCheckoutPreview;
            estimateAddons = addons.map(function (_ref4) {
              var addon = _ref4.addon,
                  quantity = _ref4.quantity;
              return {
                addonId: addon.id,
                quantity: quantity
              };
            });
            subscriptionPreview = null;
            errorMessage = null;
            _context.prev = 4;

            if (!(customerId && planId)) {
              _context.next = 15;
              break;
            }

            previewSubscriptionProps = _extends({
              customerId: customerId,
              planId: planId,
              resourceId: resourceId,
              billingCountryCode: billingCountryCode,
              addons: estimateAddons,
              billingPeriod: billingPeriod,
              promotionCode: promotionCode,
              billableFeatures: isEmpty(billableFeatures) ? undefined : billableFeatures
            }, mapBillingInformation({
              billingAddress: billingAddress,
              taxPercentage: taxPercentage
            }));

            if (!onMockCheckoutPreview) {
              _context.next = 11;
              break;
            }

            _context.t0 = onMockCheckoutPreview(previewSubscriptionProps);
            _context.next = 14;
            break;

          case 11:
            _context.next = 13;
            return stigg.previewSubscription(previewSubscriptionProps);

          case 13:
            _context.t0 = _context.sent;

          case 14:
            subscriptionPreview = _context.t0;

          case 15:
            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](4);
            _ref5 = (_context.t1 == null ? void 0 : (_error$message = _context.t1.message) == null ? void 0 : _error$message.split('Error:')) || [], errorMsg = _ref5[1];
            errorMessage = errorMsg == null ? void 0 : errorMsg.trim();

          case 21:
            return _context.abrupt("return", {
              subscriptionPreview: subscriptionPreview,
              errorMessage: errorMessage
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 17]]);
  }));

  return function previewSubscription(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var usePreviewSubscriptionAction = function usePreviewSubscriptionAction(_temp) {
  var _ref6 = _temp === void 0 ? {} : _temp,
      onMockCheckoutPreview = _ref6.onMockCheckoutPreview;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg;

  var subscription = useSubscriptionModel();

  var _useCheckoutContext = useCheckoutContext(),
      resourceId = _useCheckoutContext[0].resourceId;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      widgetState = _useCheckoutModel.widgetState;

  var _ref7 = checkoutState || {},
      plan = _ref7.plan,
      customer = _ref7.customer;

  var previewSubscriptionAction = useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_temp2) {
      var _ref9, promotionCode;

      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref9 = _temp2 === void 0 ? {} : _temp2, promotionCode = _ref9.promotionCode;

              if (widgetState.isValid) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", {
                subscriptionPreview: null,
                errorMessage: null
              });

            case 3:
              return _context2.abrupt("return", previewSubscription({
                stigg: stigg,
                customerId: customer == null ? void 0 : customer.id,
                planId: plan == null ? void 0 : plan.id,
                resourceId: resourceId,
                addons: subscription.addons,
                billableFeatures: subscription.billableFeatures,
                billingCountryCode: subscription.billingCountryCode,
                billingPeriod: subscription.billingPeriod,
                billingAddress: subscription.billingAddress,
                taxPercentage: subscription.taxPercentage,
                promotionCode: promotionCode != null ? promotionCode : subscription.promotionCode,
                onMockCheckoutPreview: onMockCheckoutPreview
              }));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref8.apply(this, arguments);
    };
  }(), [stigg, customer == null ? void 0 : customer.id, plan == null ? void 0 : plan.id, resourceId, subscription.addons, subscription.billableFeatures, subscription.billingCountryCode, subscription.billingPeriod, subscription.billingAddress, subscription.taxPercentage, subscription.promotionCode, widgetState.isValid, onMockCheckoutPreview]);
  return {
    previewSubscriptionAction: previewSubscriptionAction
  };
};
var SUBSCRIPTION_PREVIEW_DEBOUNCE_TIME = 500;
var usePreviewSubscription = function usePreviewSubscription(_temp3) {
  var _ref10 = _temp3 === void 0 ? {} : _temp3,
      onMockCheckoutPreview = _ref10.onMockCheckoutPreview;

  var _useState = useState(null),
      subscriptionPreview = _useState[0],
      setSubscriptionPreview = _useState[1];

  var _useState2 = useState(false),
      isFetchingSubscriptionPreview = _useState2[0],
      setIsFetchingSubscriptionPreview = _useState2[1];

  var _usePreviewSubscripti = usePreviewSubscriptionAction({
    onMockCheckoutPreview: onMockCheckoutPreview
  }),
      previewSubscriptionAction = _usePreviewSubscripti.previewSubscriptionAction;

  useEffect(function () {
    var estimateSubscription = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3() {
        var _yield$previewSubscri, subscriptionPreview;

        return runtime_1.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return previewSubscriptionAction();

              case 2:
                _yield$previewSubscri = _context3.sent;
                subscriptionPreview = _yield$previewSubscri.subscriptionPreview;

                if (subscriptionPreview) {
                  setSubscriptionPreview(subscriptionPreview);
                }

                setIsFetchingSubscriptionPreview(false);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function estimateSubscription() {
        return _ref11.apply(this, arguments);
      };
    }();

    setIsFetchingSubscriptionPreview(true);
    var timer = setTimeout(function () {
      setIsFetchingSubscriptionPreview(true);
      void estimateSubscription();
    }, SUBSCRIPTION_PREVIEW_DEBOUNCE_TIME);
    return function () {
      clearTimeout(timer);
    };
  }, [previewSubscriptionAction]);
  return {
    subscriptionPreview: subscriptionPreview,
    isFetchingSubscriptionPreview: isFetchingSubscriptionPreview
  };
};

function getPaymentStepInitialState(_ref) {
  var customer = _ref.customer,
      taxPercentage = _ref.taxPercentage;
  return {
    useNewPaymentMethod: !(customer != null && customer.paymentMethodDetails),
    taxPercentage: taxPercentage
  };
}

function useSetUseNewPaymentMethod() {
  var _useCheckoutContext = useCheckoutContext(),
      setState = _useCheckoutContext[1];

  return function (useNewPaymentMethod) {
    return setState(function (draft) {
      draft.paymentStep.useNewPaymentMethod = useNewPaymentMethod;
    });
  };
}

function useSetErrorMessage() {
  var _useCheckoutContext2 = useCheckoutContext(),
      setState = _useCheckoutContext2[1];

  return function (errorMessage) {
    return setState(function (draft) {
      draft.paymentStep.errorMessage = errorMessage;
    });
  };
}

function useSetBillingAddress() {
  var _useCheckoutContext3 = useCheckoutContext(),
      setState = _useCheckoutContext3[1];

  return function (billingAddress) {
    return setState(function (draft) {
      draft.paymentStep.billingAddress = billingAddress;
    });
  };
}

function usePaymentState() {
  var _useCheckoutContext4 = useCheckoutContext(),
      paymentStep = _useCheckoutContext4[0].paymentStep;

  return paymentStep;
}

function usePaymentStepModel() {
  var state = usePaymentState();
  return _extends({}, state, {
    setUseNewPaymentMethod: useSetUseNewPaymentMethod(),
    setErrorMessage: useSetErrorMessage(),
    setBillingAddress: useSetBillingAddress()
  });
}

function getResolvedCheckoutLocalize(localizeOverride) {
  var checkoutDefaultLocalization = {
    changePlan: 'Change',
    billingPeriodsTitle: 'Billing cycle',
    addAddonText: 'Add',
    newPaymentMethodText: 'New payment method',
    newPaymentMethodBillingAddressTitle: 'Billing address',
    newPaymentMethodCardTitle: 'Payment method',
    summary: {
      title: 'Order summary',
      planName: function planName(_ref) {
        var plan = _ref.plan;
        return plan.displayName + " plan";
      },
      addCouponCodeText: 'Add promotion code',
      couponCodeTitle: 'Promotion code',
      addonsSectionTitle: 'Add-ons',
      discountsSectionTitle: 'Discounts',
      onlyPayAsYouGoText: 'Varies by usage',
      startsAtText: 'Starts at ',
      proratedTotalDueText: 'Prorated charge today',
      baseChargeText: function baseChargeText() {
        return 'Base charge';
      },
      totalText: 'Total',
      totalDueText: 'Total due today',
      totalBillingPeriodText: function totalBillingPeriodText(_ref2) {
        var billingPeriod = _ref2.billingPeriod;
        return "Billed " + billingPeriod.toLowerCase();
      },
      appliedCreditsTitle: 'Applied credits',
      creditsForUnusedTimeText: function creditsForUnusedTimeText(_ref3) {
        var credits = _ref3.credits;
        return "Your account will be granted credits worth " + credits + " for unused time, which will be automatically applied to future payments.";
      },
      discountText: function discountText(_ref4) {
        var discountDetails = _ref4.discountDetails,
            currency = _ref4.currency;
        var discountText = '';

        if (discountDetails.type === DiscountType.Percentage) {
          discountText = discountDetails.value + "% off";
        } else {
          discountText = "" + currencyPriceFormatter({
            amount: discountDetails.value,
            currency: currency
          });
        }

        var discountTextPostfix = '';

        switch (discountDetails.durationType) {
          case DiscountDurationType.Once:
            {
              discountTextPostfix = ' once';
              break;
            }

          case DiscountDurationType.Repeating:
            {
              var prefix = discountDetails.type === DiscountType.Fixed ? ' per month' : '';
              discountTextPostfix = prefix + " for " + discountDetails.durationInMonths + " months";
              break;
            }

          case DiscountDurationType.Forever:
          default:
            {
              discountTextPostfix = '';
            }
        }

        return "" + discountText + discountTextPostfix;
      },
      taxTitle: function taxTitle(_ref5) {
        var taxDetails = _ref5.taxDetails;
        return "Tax (" + (taxDetails == null ? void 0 : taxDetails.percentage) + "%)";
      },
      changesWillApplyAtEndOfBillingPeriod: function changesWillApplyAtEndOfBillingPeriod(_ref6) {
        var billingPeriodEnd = _ref6.billingPeriodEnd;
        return "Your changes will take effect at the end of your current billing cycle on " + moment(billingPeriodEnd).format('MMMM D, YYYY') + ".";
      },
      checkoutSuccessText: 'Changes applied',
      payAsYouGoTooltipText: 'Billed according to actual usage'
    },
    checkoutButton: {
      nextText: 'Next',
      noChangesText: 'No changes',
      updateText: 'Update subscription',
      downgradeToFreeText: 'Cancel subscription',
      upgradeText: 'Subscribe'
    },
    downgradeToFree: {
      alertText: function alertText() {
        return "We\u2019re sorry to see you cancel your paid subscription \uD83D\uDE2D";
      },
      freePlanHeader: function freePlanHeader() {
        return 'New plan';
      },
      freePlanName: function freePlanName(_ref7) {
        var plan = _ref7.plan;
        return "" + plan.displayName;
      },
      freePlanPriceText: function freePlanPriceText() {
        return 'Free';
      },
      paidPlanHeader: function paidPlanHeader() {
        return 'Current plan';
      },
      paidPlanName: function paidPlanName(_ref8) {
        var plan = _ref8.plan;
        return "" + plan.displayName;
      },
      paidPlanPriceText: function paidPlanPriceText(_ref9) {
        var billingPeriod = _ref9.billingPeriod;
        return "Paid plan" + (billingPeriod ? ", billed " + billingPeriod.toLowerCase() : '');
      }
    }
  };
  return merge(checkoutDefaultLocalization, localizeOverride);
}

var defaultCheckoutTheme = {
  primary: 'rgb(50, 126, 238)',
  textColor: 'rgb(0, 30, 108)',
  backgroundColor: 'rgb(255, 255, 255)',
  borderColor: 'rgb(235, 237, 243)',
  summaryBackgroundColor: 'rgb(109, 121, 144)'
};
function getResolvedCheckoutTheme(globalTheme, themeOverride, _remoteConfiguration) {
  var _ref = globalTheme || {},
      globalPalette = _ref.palette;

  return {
    primary: (themeOverride == null ? void 0 : themeOverride.primary) || (globalPalette == null ? void 0 : globalPalette.primary) || defaultCheckoutTheme.primary,
    textColor: (themeOverride == null ? void 0 : themeOverride.textColor) || (globalPalette == null ? void 0 : globalPalette.text.primary) || defaultCheckoutTheme.textColor,
    backgroundColor: (themeOverride == null ? void 0 : themeOverride.backgroundColor) || (globalPalette == null ? void 0 : globalPalette.backgroundPaper) || defaultCheckoutTheme.backgroundColor,
    borderColor: (themeOverride == null ? void 0 : themeOverride.borderColor) || (globalPalette == null ? void 0 : globalPalette.outlinedBorder) || defaultCheckoutTheme.borderColor,
    summaryBackgroundColor: (themeOverride == null ? void 0 : themeOverride.summaryBackgroundColor) || (globalPalette == null ? void 0 : globalPalette.backgroundHighlight) || defaultCheckoutTheme.summaryBackgroundColor
  };
}

var CheckoutContext = /*#__PURE__*/React__default.createContext(null);
CheckoutContext.displayName = 'CheckoutContext';
var useCheckoutContext = function useCheckoutContext() {
  var ctx = useContext(CheckoutContext);

  if (!ctx) {
    throw new Error('Could not find Checkout context; You need to wrap your checkout components in an <CheckoutProvider> component.');
  }

  return ctx;
};

var CheckoutContextProvider = function CheckoutContextProvider(_ref) {
  var children = _ref.children,
      initialState = _ref.initialState;

  var _useState = useState(initialState),
      state = _useState[0],
      innerSetState = _useState[1];

  useEffect(function () {
    innerSetState(initialState);
  }, [initialState]);
  var setState = useCallback(function (updater) {
    return innerSetState(function (old) {
      return produce(old, function (draft) {
        return updater(draft);
      });
    });
  }, [innerSetState]);

  var _useMemo = useMemo(function () {
    return [state, setState];
  }, [setState, state]),
      contextValue = _useMemo[0],
      setContextValue = _useMemo[1];

  return React__default.createElement(CheckoutContext.Provider, {
    value: [contextValue, setContextValue]
  }, children);
};

function CheckoutProvider(_ref2) {
  var _billingInformation$t2;

  var children = _ref2.children,
      textOverrides = _ref2.textOverrides,
      theme = _ref2.theme,
      preferredBillingPeriod = _ref2.preferredBillingPeriod,
      billableFeatures = _ref2.billableFeatures,
      resourceId = _ref2.resourceId,
      planId = _ref2.planId,
      billingCountryCode = _ref2.billingCountryCode,
      billingInformation = _ref2.billingInformation,
      onMockCheckoutState = _ref2.onMockCheckoutState;

  var _useLoadCheckout = useLoadCheckout({
    resourceId: resourceId,
    planId: planId,
    billingCountryCode: billingCountryCode,
    onMockCheckoutState: onMockCheckoutState
  }),
      checkout = _useLoadCheckout.checkout,
      isLoading = _useLoadCheckout.isLoading;

  var configuration = checkout != null && checkout.configuration ? mapCheckoutConfiguration(checkout.configuration) : {
    typography: mapTypography(defaultCheckoutTypography)
  };
  var globalTheme = useStiggTheme(configuration);
  var initialState = useMemo(function () {
    var _billingInformation$t, _checkout$resource;

    var checkoutTheme = getResolvedCheckoutTheme(globalTheme, theme);
    var checkoutLocalization = getResolvedCheckoutLocalize(textOverrides);
    var planStep = getPlanStepInitialState({
      preferredBillingPeriod: preferredBillingPeriod,
      plan: checkout == null ? void 0 : checkout.plan,
      activeSubscription: checkout == null ? void 0 : checkout.activeSubscription,
      billingCountryCode: billingCountryCode,
      preconfiguredBillableFeatures: billableFeatures != null ? billableFeatures : []
    });
    var addonsStep = getAddonsStepInitialState({
      plan: checkout == null ? void 0 : checkout.plan,
      billingPeriod: planStep.billingPeriod,
      activeSubscription: checkout == null ? void 0 : checkout.activeSubscription
    });
    var paymentStep = getPaymentStepInitialState({
      customer: checkout == null ? void 0 : checkout.customer,
      taxPercentage: billingInformation == null ? void 0 : (_billingInformation$t = billingInformation.taxDetails) == null ? void 0 : _billingInformation$t.taxPercentage
    });
    var progressBar = getProgressBarInitialState({
      availableAddons: isLoading ? undefined : addonsStep.availableAddons
    });
    var initialState = {
      checkout: checkout,
      checkoutLocalization: checkoutLocalization,
      stiggTheme: globalTheme,
      theme: checkoutTheme,
      progressBar: progressBar,
      planStep: planStep,
      addonsStep: addonsStep,
      paymentStep: paymentStep,
      resourceId: checkout == null ? void 0 : (_checkout$resource = checkout.resource) == null ? void 0 : _checkout$resource.id,
      widgetState: {
        readOnly: false,
        isValid: true,
        isLoadingCheckoutData: isLoading
      }
    };
    return initialState; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preferredBillingPeriod, billingCountryCode, checkout, isLoading, billingInformation == null ? void 0 : (_billingInformation$t2 = billingInformation.taxDetails) == null ? void 0 : _billingInformation$t2.taxPercentage]);
  return React__default.createElement(SdkThemeProvider, {
    key: checkout == null ? void 0 : checkout.plan.id,
    componentTheme: configuration
  }, React__default.createElement(CheckoutContextProvider, {
    initialState: initialState
  }, children));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$i() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CheckoutLayout = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ergo9xd2"
} : {
  target: "ergo9xd2",
  label: "CheckoutLayout"
})("margin:auto;width:100%;min-height:760px;max-width:920px;display:flex;position:relative;flex-direction:column;align-items:center;padding:16px 32px;border-radius:10px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.backgroundPaper;
}, ";border:", function (_ref2) {
  var theme = _ref2.theme;
  return "1px solid " + theme.stigg.palette.outlinedBorder;
}, ";& *{box-sizing:border-box;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0Q29udGFpbmVyLnN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV5QyIsImZpbGUiOiJDaGVja291dENvbnRhaW5lci5zdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IEJveCBmcm9tICdAbXVpL21hdGVyaWFsL0JveCc7XHJcbmV4cG9ydCBjb25zdCBDaGVja291dExheW91dCA9IHN0eWxlZC5kaXYgYFxuICBtYXJnaW46IGF1dG87XG4gIHdpZHRoOiAxMDAlO1xuICBtaW4taGVpZ2h0OiA3NjBweDtcbiAgbWF4LXdpZHRoOiA5MjBweDtcbiAgZGlzcGxheTogZmxleDtcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG4gIHBhZGRpbmc6IDE2cHggMzJweDtcbiAgYm9yZGVyLXJhZGl1czogMTBweDtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLmJhY2tncm91bmRQYXBlcn07XG4gIGJvcmRlcjogJHsoeyB0aGVtZSB9KSA9PiBgMXB4IHNvbGlkICR7dGhlbWUuc3RpZ2cucGFsZXR0ZS5vdXRsaW5lZEJvcmRlcn1gfTtcblxuICAmICoge1xuICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG4gIH1cbmA7XHJcbmV4cG9ydCBjb25zdCBDaGVja291dENvbnRlbnQgPSBzdHlsZWQoQm94KSBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBmbGV4LXN0YXJ0O1xuICBnYXA6IDMycHg7XG4gIGZsZXgtd3JhcDogd3JhcDtcbiAgd2lkdGg6IDEwMCU7XG5gO1xyXG5leHBvcnQgY29uc3QgQ2hlY2tvdXRQYW5lbCA9IHN0eWxlZChCb3gpIGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgZ2FwOiAwO1xuICBmbGV4OiAyO1xuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2hlY2tvdXRDb250YWluZXIuc3R5bGUuanMubWFwIl19 */"));
var CheckoutContent = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "ergo9xd1"
} : {
  target: "ergo9xd1",
  label: "CheckoutContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1pdbip7",
  styles: "display:flex;align-items:flex-start;gap:32px;flex-wrap:wrap;width:100%"
} : {
  name: "1pdbip7",
  styles: "display:flex;align-items:flex-start;gap:32px;flex-wrap:wrap;width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0Q29udGFpbmVyLnN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFCMkMiLCJmaWxlIjoiQ2hlY2tvdXRDb250YWluZXIuc3R5bGUudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCBCb3ggZnJvbSAnQG11aS9tYXRlcmlhbC9Cb3gnO1xyXG5leHBvcnQgY29uc3QgQ2hlY2tvdXRMYXlvdXQgPSBzdHlsZWQuZGl2IGBcbiAgbWFyZ2luOiBhdXRvO1xuICB3aWR0aDogMTAwJTtcbiAgbWluLWhlaWdodDogNzYwcHg7XG4gIG1heC13aWR0aDogOTIwcHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICBwYWRkaW5nOiAxNnB4IDMycHg7XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuc3RpZ2cucGFsZXR0ZS5iYWNrZ3JvdW5kUGFwZXJ9O1xuICBib3JkZXI6ICR7KHsgdGhlbWUgfSkgPT4gYDFweCBzb2xpZCAke3RoZW1lLnN0aWdnLnBhbGV0dGUub3V0bGluZWRCb3JkZXJ9YH07XG5cbiAgJiAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgQ2hlY2tvdXRDb250ZW50ID0gc3R5bGVkKEJveCkgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAgZ2FwOiAzMnB4O1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIHdpZHRoOiAxMDAlO1xuYDtcclxuZXhwb3J0IGNvbnN0IENoZWNrb3V0UGFuZWwgPSBzdHlsZWQoQm94KSBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogMDtcbiAgZmxleDogMjtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUNoZWNrb3V0Q29udGFpbmVyLnN0eWxlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});
var CheckoutPanel = /*#__PURE__*/_styled(Box, process.env.NODE_ENV === "production" ? {
  target: "ergo9xd0"
} : {
  target: "ergo9xd0",
  label: "CheckoutPanel"
})(process.env.NODE_ENV === "production" ? {
  name: "fszphw",
  styles: "display:flex;flex-direction:column;gap:0;flex:2"
} : {
  name: "fszphw",
  styles: "display:flex;flex-direction:column;gap:0;flex:2",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0Q29udGFpbmVyLnN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCeUMiLCJmaWxlIjoiQ2hlY2tvdXRDb250YWluZXIuc3R5bGUudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCBCb3ggZnJvbSAnQG11aS9tYXRlcmlhbC9Cb3gnO1xyXG5leHBvcnQgY29uc3QgQ2hlY2tvdXRMYXlvdXQgPSBzdHlsZWQuZGl2IGBcbiAgbWFyZ2luOiBhdXRvO1xuICB3aWR0aDogMTAwJTtcbiAgbWluLWhlaWdodDogNzYwcHg7XG4gIG1heC13aWR0aDogOTIwcHg7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICBwYWRkaW5nOiAxNnB4IDMycHg7XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuc3RpZ2cucGFsZXR0ZS5iYWNrZ3JvdW5kUGFwZXJ9O1xuICBib3JkZXI6ICR7KHsgdGhlbWUgfSkgPT4gYDFweCBzb2xpZCAke3RoZW1lLnN0aWdnLnBhbGV0dGUub3V0bGluZWRCb3JkZXJ9YH07XG5cbiAgJiAqIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgQ2hlY2tvdXRDb250ZW50ID0gc3R5bGVkKEJveCkgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogZmxleC1zdGFydDtcbiAgZ2FwOiAzMnB4O1xuICBmbGV4LXdyYXA6IHdyYXA7XG4gIHdpZHRoOiAxMDAlO1xuYDtcclxuZXhwb3J0IGNvbnN0IENoZWNrb3V0UGFuZWwgPSBzdHlsZWQoQm94KSBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGdhcDogMDtcbiAgZmxleDogMjtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUNoZWNrb3V0Q29udGFpbmVyLnN0eWxlLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$i
});

var StyledProgress = /*#__PURE__*/_styled(LinearProgress$1, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e9upyia2"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e9upyia2",
  label: "StyledProgress"
})(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      $disabled = _ref.$disabled;
  return _ref2 = {}, _ref2["&." + linearProgressClasses.root] = {
    borderRadius: theme.stigg.border.radius,
    backgroundColor: theme.stigg.palette.outlinedBorder
  }, _ref2["& ." + linearProgressClasses.bar] = {
    backgroundColor: $disabled ? theme.stigg.palette.primaryLight : theme.stigg.palette.primary
  }, _ref2;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var StyledStepButton = /*#__PURE__*/_styled(Button$2, process.env.NODE_ENV === "production" ? {
  target: "e9upyia1"
} : {
  target: "e9upyia1",
  label: "StyledStepButton"
})(function () {
  var _ref3;

  return _ref3 = {}, _ref3["&." + buttonClasses.root] = {
    textTransform: 'none',
    lineHeight: 'inherit',
    justifyContent: 'flex-start',
    padding: '8px 4px'
  }, _ref3;
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var StyledIcon = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e9upyia0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e9upyia0",
  label: "StyledIcon"
})(function (_ref4) {
  var theme = _ref4.theme,
      $disabled = _ref4.$disabled,
      $shouldFill = _ref4.$shouldFill;
  return {
    circle: {
      stroke: $disabled ? theme.stigg.palette.primaryLight : theme.stigg.palette.primary,
      fill: $shouldFill ? $disabled ? theme.stigg.palette.primaryLight : theme.stigg.palette.primary : undefined
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

function _EMOTION_STRINGIFIED_CSS_ERROR__$j() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SkeletonsContainer = /*#__PURE__*/_styled(Grid, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e1v7qkry3"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e1v7qkry3",
  label: "SkeletonsContainer"
})("display:flex;flex-direction:", function (_ref) {
  var $flexDirection = _ref.$flexDirection;
  return $flexDirection || 'row';
}, ";gap:", function (_ref2) {
  var $gap = _ref2.$gap;
  return $gap;
}, "px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9ucy5zdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHdUciLCJmaWxlIjoiU2tlbGV0b25zLnN0eWxlLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBHcmlkIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCBSZWFjdFNrZWxldG9uIGZyb20gJ3JlYWN0LWxvYWRpbmctc2tlbGV0b24nO1xyXG5leHBvcnQgY29uc3QgU2tlbGV0b25zQ29udGFpbmVyID0gc3R5bGVkKEdyaWQsIHsgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiAhcHJvcC5zdGFydHNXaXRoKCckJykgfSkgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogJHsoeyAkZmxleERpcmVjdGlvbiB9KSA9PiAkZmxleERpcmVjdGlvbiB8fCAncm93J307XG4gIGdhcDogJHsoeyAkZ2FwIH0pID0+ICRnYXB9cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgRmxleGVkU2tlbGV0b25Db250YWluZXIgPSBzdHlsZWQoU2tlbGV0b25zQ29udGFpbmVyKSBgXG4gIHNwYW4ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleDogMTtcbiAgfVxuYDtcclxuZXhwb3J0IGNvbnN0IEZsZXhlZFNrZWxldG9uID0gc3R5bGVkKEdyaWQpIGBcbiAgc3BhbiB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4OiAkeyh7IGZsZXggfSkgPT4gZmxleH07XG4gIH1cbmA7XHJcbmV4cG9ydCBjb25zdCBTa2VsZXRvbiA9IHN0eWxlZChSZWFjdFNrZWxldG9uKSBgXG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVNrZWxldG9ucy5zdHlsZS5qcy5tYXAiXX0= */"));
var FlexedSkeletonContainer = /*#__PURE__*/_styled(SkeletonsContainer, process.env.NODE_ENV === "production" ? {
  target: "e1v7qkry2"
} : {
  target: "e1v7qkry2",
  label: "FlexedSkeletonContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "o7lzx8",
  styles: "span{display:flex;flex:1;}"
} : {
  name: "o7lzx8",
  styles: "span{display:flex;flex:1;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9ucy5zdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRa0UiLCJmaWxlIjoiU2tlbGV0b25zLnN0eWxlLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBHcmlkIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCBSZWFjdFNrZWxldG9uIGZyb20gJ3JlYWN0LWxvYWRpbmctc2tlbGV0b24nO1xyXG5leHBvcnQgY29uc3QgU2tlbGV0b25zQ29udGFpbmVyID0gc3R5bGVkKEdyaWQsIHsgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiAhcHJvcC5zdGFydHNXaXRoKCckJykgfSkgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogJHsoeyAkZmxleERpcmVjdGlvbiB9KSA9PiAkZmxleERpcmVjdGlvbiB8fCAncm93J307XG4gIGdhcDogJHsoeyAkZ2FwIH0pID0+ICRnYXB9cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgRmxleGVkU2tlbGV0b25Db250YWluZXIgPSBzdHlsZWQoU2tlbGV0b25zQ29udGFpbmVyKSBgXG4gIHNwYW4ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleDogMTtcbiAgfVxuYDtcclxuZXhwb3J0IGNvbnN0IEZsZXhlZFNrZWxldG9uID0gc3R5bGVkKEdyaWQpIGBcbiAgc3BhbiB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4OiAkeyh7IGZsZXggfSkgPT4gZmxleH07XG4gIH1cbmA7XHJcbmV4cG9ydCBjb25zdCBTa2VsZXRvbiA9IHN0eWxlZChSZWFjdFNrZWxldG9uKSBgXG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVNrZWxldG9ucy5zdHlsZS5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});
var FlexedSkeleton = /*#__PURE__*/_styled(Grid, process.env.NODE_ENV === "production" ? {
  target: "e1v7qkry1"
} : {
  target: "e1v7qkry1",
  label: "FlexedSkeleton"
})("span{display:flex;flex:", function (_ref3) {
  var flex = _ref3.flex;
  return flex;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9ucy5zdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjMkMiLCJmaWxlIjoiU2tlbGV0b25zLnN0eWxlLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBHcmlkIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCBSZWFjdFNrZWxldG9uIGZyb20gJ3JlYWN0LWxvYWRpbmctc2tlbGV0b24nO1xyXG5leHBvcnQgY29uc3QgU2tlbGV0b25zQ29udGFpbmVyID0gc3R5bGVkKEdyaWQsIHsgc2hvdWxkRm9yd2FyZFByb3A6IChwcm9wKSA9PiAhcHJvcC5zdGFydHNXaXRoKCckJykgfSkgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogJHsoeyAkZmxleERpcmVjdGlvbiB9KSA9PiAkZmxleERpcmVjdGlvbiB8fCAncm93J307XG4gIGdhcDogJHsoeyAkZ2FwIH0pID0+ICRnYXB9cHg7XG5gO1xyXG5leHBvcnQgY29uc3QgRmxleGVkU2tlbGV0b25Db250YWluZXIgPSBzdHlsZWQoU2tlbGV0b25zQ29udGFpbmVyKSBgXG4gIHNwYW4ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleDogMTtcbiAgfVxuYDtcclxuZXhwb3J0IGNvbnN0IEZsZXhlZFNrZWxldG9uID0gc3R5bGVkKEdyaWQpIGBcbiAgc3BhbiB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4OiAkeyh7IGZsZXggfSkgPT4gZmxleH07XG4gIH1cbmA7XHJcbmV4cG9ydCBjb25zdCBTa2VsZXRvbiA9IHN0eWxlZChSZWFjdFNrZWxldG9uKSBgXG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVNrZWxldG9ucy5zdHlsZS5qcy5tYXAiXX0= */"));
var Skeleton = /*#__PURE__*/_styled(Skeleton$1, process.env.NODE_ENV === "production" ? {
  target: "e1v7qkry0"
} : {
  target: "e1v7qkry0",
  label: "Skeleton"
})(process.env.NODE_ENV === "production" ? {
  name: "1u8hqvf",
  styles: "border-radius:4px"
} : {
  name: "1u8hqvf",
  styles: "border-radius:4px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNrZWxldG9ucy5zdHlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFvQjhDIiwiZmlsZSI6IlNrZWxldG9ucy5zdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IHsgR3JpZCB9IGZyb20gJ0BtdWkvbWF0ZXJpYWwnO1xyXG5pbXBvcnQgUmVhY3RTa2VsZXRvbiBmcm9tICdyZWFjdC1sb2FkaW5nLXNrZWxldG9uJztcclxuZXhwb3J0IGNvbnN0IFNrZWxldG9uc0NvbnRhaW5lciA9IHN0eWxlZChHcmlkLCB7IHNob3VsZEZvcndhcmRQcm9wOiAocHJvcCkgPT4gIXByb3Auc3RhcnRzV2l0aCgnJCcpIH0pIGBcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246ICR7KHsgJGZsZXhEaXJlY3Rpb24gfSkgPT4gJGZsZXhEaXJlY3Rpb24gfHwgJ3Jvdyd9O1xuICBnYXA6ICR7KHsgJGdhcCB9KSA9PiAkZ2FwfXB4O1xuYDtcclxuZXhwb3J0IGNvbnN0IEZsZXhlZFNrZWxldG9uQ29udGFpbmVyID0gc3R5bGVkKFNrZWxldG9uc0NvbnRhaW5lcikgYFxuICBzcGFuIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXg6IDE7XG4gIH1cbmA7XHJcbmV4cG9ydCBjb25zdCBGbGV4ZWRTa2VsZXRvbiA9IHN0eWxlZChHcmlkKSBgXG4gIHNwYW4ge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleDogJHsoeyBmbGV4IH0pID0+IGZsZXh9O1xuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgU2tlbGV0b24gPSBzdHlsZWQoUmVhY3RTa2VsZXRvbikgYFxuICBib3JkZXItcmFkaXVzOiA0cHg7XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1Ta2VsZXRvbnMuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$j
});

var CheckoutProgressBar = function CheckoutProgressBar() {
  var _useProgressBarModel = useProgressBarModel(),
      progressBarState = _useProgressBarModel.progressBarState,
      setActiveStep = _useProgressBarModel.setActiveStep;

  var _useCheckoutModel = useCheckoutModel(),
      widgetState = _useCheckoutModel.widgetState;

  var readOnly = widgetState.readOnly,
      isLoadingCheckoutData = widgetState.isLoadingCheckoutData;

  var _ref = progressBarState || {},
      activeStep = _ref.activeStep,
      completedSteps = _ref.completedSteps,
      steps = _ref.steps;

  var progress = (activeStep + 1) * 100 / steps.length;
  return React__default.createElement(Box$1, {
    sx: {
      width: '100%',
      mb: 3
    }
  }, React__default.createElement(StyledProgress, {
    variant: "determinate",
    value: progress,
    "$disabled": readOnly
  }), React__default.createElement(Grid, {
    container: true,
    display: "flex"
  }, steps.map(function (_ref2, index) {
    var key = _ref2.key,
        label = _ref2.label;
    var isCompleted = completedSteps.includes(index);
    var isDisabled = readOnly || index > activeStep && !isCompleted && !completedSteps.includes(index - 1) || activeStep !== index && progressBarState.isDisabled;
    var checkedIcon = isDisabled ? 'OutlinedCheckedCircleDisabled' : 'OutlinedCheckedCircle';
    return React__default.createElement(Grid, {
      key: key,
      item: true,
      display: "flex",
      flexDirection: "row",
      flex: 1,
      justifyContent: "flex-start"
    }, isLoadingCheckoutData ? React__default.createElement(Skeleton, {
      width: 120,
      height: 20,
      style: {
        marginTop: 8
      }
    }) : React__default.createElement(StyledStepButton, {
      onClick: function onClick() {
        return setActiveStep(index);
      },
      fullWidth: true,
      disabled: isDisabled
    }, React__default.createElement(Grid, {
      item: true,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 1
    }, React__default.createElement(StepIcon, {
      icon: React__default.createElement(StyledIcon, {
        icon: isCompleted ? checkedIcon : 'OutlinedCircle',
        "$disabled": isDisabled,
        "$shouldFill": isCompleted
      })
    }), React__default.createElement(Typography, {
      variant: "h6",
      color: isDisabled ? 'primary.main.light' : 'primary.main'
    }, label))));
  })));
};

var CHARGES_BILLING_MODEL_ORDER = [BillingModel.FlatFee, BillingModel.PerUnit, BillingModel.UsageBased];
var sortCharges = function sortCharges(charges) {
  return sortBy(charges, [function (charge) {
    return CHARGES_BILLING_MODEL_ORDER.indexOf(charge.pricingModel);
  }, function (charge) {
    var _charge$feature;

    return (_charge$feature = charge.feature) == null ? void 0 : _charge$feature.displayName;
  }]);
};
var useChargesSort = function useChargesSort(charges) {
  return useMemo(function () {
    return sortCharges(charges);
  }, [charges]);
};

var _excluded$5 = ["variant"];

var StyledButton$2 = /*#__PURE__*/_styled(Button$2, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "effv4rq0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "effv4rq0",
  label: "StyledButton"
})("border-radius:10px;text-transform:none;background-color:", function (_ref) {
  var theme = _ref.theme,
      $success = _ref.$success,
      $error = _ref.$error;

  if ($success) {
    return theme.stigg.palette.success;
  } else if ($error) {
    return theme.stigg.palette.error;
  }

  return '';
}, ";&:hover{background-color:", function (_ref2) {
  var theme = _ref2.theme,
      $success = _ref2.$success,
      $error = _ref2.$error;

  if ($success) {
    return theme.stigg.palette.successDark;
  } else if ($error) {
    return theme.stigg.palette.errorDark;
  }

  return '';
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRytGIiwiZmlsZSI6IkJ1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xyXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IEJ1dHRvbiBhcyBNdWlCdXR0b24gfSBmcm9tICdAbXVpL21hdGVyaWFsJztcclxuY29uc3QgU3R5bGVkQnV0dG9uID0gc3R5bGVkKE11aUJ1dHRvbiwgeyBzaG91bGRGb3J3YXJkUHJvcDogKHByb3ApID0+ICFwcm9wLnN0YXJ0c1dpdGgoJyQnKSB9KSBgXG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIHRleHQtdHJhbnNmb3JtOiBub25lO1xuXG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUsICRzdWNjZXNzLCAkZXJyb3IgfSkgPT4ge1xyXG4gICAgaWYgKCRzdWNjZXNzKSB7XHJcbiAgICAgICAgcmV0dXJuIHRoZW1lLnN0aWdnLnBhbGV0dGUuc3VjY2VzcztcclxuICAgIH1cclxuICAgIGVsc2UgaWYgKCRlcnJvcikge1xyXG4gICAgICAgIHJldHVybiB0aGVtZS5zdGlnZy5wYWxldHRlLmVycm9yO1xyXG4gICAgfVxyXG4gICAgcmV0dXJuICcnO1xyXG59fTtcblxuICAmOmhvdmVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAkeyh7IHRoZW1lLCAkc3VjY2VzcywgJGVycm9yIH0pID0+IHtcclxuICAgIGlmICgkc3VjY2Vzcykge1xyXG4gICAgICAgIHJldHVybiB0aGVtZS5zdGlnZy5wYWxldHRlLnN1Y2Nlc3NEYXJrO1xyXG4gICAgfVxyXG4gICAgZWxzZSBpZiAoJGVycm9yKSB7XHJcbiAgICAgICAgcmV0dXJuIHRoZW1lLnN0aWdnLnBhbGV0dGUuZXJyb3JEYXJrO1xyXG4gICAgfVxyXG4gICAgcmV0dXJuICcnO1xyXG59fTtcbiAgfVxuYDtcclxuZXhwb3J0IGNvbnN0IEJ1dHRvbiA9ICh7IHZhcmlhbnQgPSAnb3V0bGluZWQnLCAuLi5wcm9wcyB9KSA9PiB7XHJcbiAgICByZXR1cm4gUmVhY3QuY3JlYXRlRWxlbWVudChTdHlsZWRCdXR0b24sIE9iamVjdC5hc3NpZ24oeyB2YXJpYW50OiB2YXJpYW50IH0sIHByb3BzKSk7XHJcbn07XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUJ1dHRvbi5qcy5tYXAiXX0= */"));

var Button = function Button(_ref3) {
  var _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'outlined' : _ref3$variant,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded$5);

  return React__default.createElement(StyledButton$2, Object.assign({
    variant: variant
  }, props));
};

var InputField = /*#__PURE__*/styled$1(TextField)(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiOutlinedInput-root': {
      height: '42px',
      borderRadius: theme.stigg.border.radius,
      fieldset: {
        borderColor: theme.stigg.palette.outlinedBorder
      },
      '&:not(.Mui-focused):hover fieldset': {
        borderColor: theme.stigg.palette.outlinedRestingBorder
      }
    },
    '& .MuiInputBase-input': _extends({
      padding: '8px 12px',
      borderRadius: theme.stigg.border.radius,
      fontFamily: theme.stigg.typography.fontFamily,
      color: theme.stigg.palette.text.primary
    }, theme.stigg.typography.body),
    '& .Mui-error': {
      fontFamily: theme.stigg.typography.fontFamily
    }
  };
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$k() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var ContentContainer = /*#__PURE__*/_styled(Grid, process.env.NODE_ENV === "production" ? {
  target: "e1q84ats0"
} : {
  target: "e1q84ats0",
  label: "ContentContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column"
} : {
  name: "1fttcpj",
  styles: "display:flex;flex-direction:column",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$k
});

function ContentLoadingSkeleton() {
  return React__default.createElement(ContentContainer, {
    container: true
  }, React__default.createElement(SkeletonsContainer, {
    item: true,
    "$gap": 48
  }, React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  }), React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  })), React__default.createElement(Divider$1, {
    className: "stigg-checkout-plan-header-divider",
    sx: {
      marginY: 2
    }
  }), React__default.createElement(ContentContainer, {
    item: true
  }, React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  }), React__default.createElement(FlexedSkeletonContainer, {
    "$gap": 16,
    marginTop: 3
  }, React__default.createElement(Skeleton, {
    height: 20
  }), React__default.createElement(Skeleton, {
    height: 20
  })), React__default.createElement(SkeletonsContainer, {
    "$gap": 130,
    marginTop: 3
  }, React__default.createElement(FlexedSkeleton, {
    flex: 1
  }, React__default.createElement(Skeleton, {
    height: 20
  })), React__default.createElement(FlexedSkeleton, {
    flex: 3
  }, React__default.createElement(Skeleton, {
    height: 20
  })))));
}

function usePromotionCodeState() {
  var _useCheckoutContext = useCheckoutContext(),
      promotionCode = _useCheckoutContext[0].promotionCode;

  return promotionCode;
}

function useSetPromotionCode() {
  var _useCheckoutContext2 = useCheckoutContext(),
      setState = _useCheckoutContext2[1];

  return function (promotionCode) {
    return setState(function (draft) {
      draft.promotionCode = promotionCode;
    });
  };
}

function usePromotionCodeModel() {
  var promotionCode = usePromotionCodeState();
  return {
    promotionCode: promotionCode,
    setPromotionCode: useSetPromotionCode()
  };
}

var _g$5;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/createElement("g", {
    stroke: "#327EEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M10 4.167v11.666M4.167 10h11.667"
  }))));
};

var StyledPlusIcon = /*#__PURE__*/_styled(SvgPlusIcon, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e3hfkj90"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  },
  target: "e3hfkj90",
  label: "StyledPlusIcon"
})("margin-right:8px;path{stroke:", function (_ref) {
  var theme = _ref.theme,
      $disabled = _ref.$disabled;
  return $disabled ? theme.stigg.palette.text.disabled : theme.stigg.palette.primary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var AddPromotionCodeButton = function AddPromotionCodeButton(_ref2) {
  var onAddClick = _ref2.onAddClick,
      checkoutLocalization = _ref2.checkoutLocalization,
      disabled = _ref2.disabled;
  return React__default.createElement(Button, {
    disabled: disabled,
    fullWidth: true,
    className: "stigg-checkout-summary-add-coupon-code-button",
    sx: {
      textTransform: 'none',
      justifyContent: 'flex-start',
      color: disabled ? 'text.disabled' : 'primary.main'
    },
    variant: "text",
    size: "medium",
    onClick: onAddClick
  }, React__default.createElement(StyledPlusIcon, {
    "$disabled": disabled,
    className: "stigg-checkout-summary-add-coupon-code-button-icon"
  }), React__default.createElement(Typography, {
    className: "stigg-checkout-change-plan-button-text",
    color: disabled ? 'disabled' : 'primary.main',
    style: {
      lineHeight: '24px'
    },
    variant: "h3"
  }, checkoutLocalization.summary.addCouponCodeText));
};

var CouponCodeAddButton = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "e8kocin0"
} : {
  target: "e8kocin0",
  label: "CouponCodeAddButton"
})("padding:4px 10px;min-width:unset;border-radius:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.border.radius;
}, ";display:flex;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var AddPromotionCode = function AddPromotionCode(_ref2) {
  var disabled = _ref2.disabled,
      checkoutLocalization = _ref2.checkoutLocalization,
      onMockCheckoutPreview = _ref2.onMockCheckoutPreview;

  var _usePromotionCodeMode = usePromotionCodeModel(),
      persistPromotionCode = _usePromotionCodeMode.setPromotionCode;

  var _useState = useState(false),
      showInput = _useState[0],
      setShowInput = _useState[1];

  var _React$useState = React__default.useState(''),
      promotionCode = _React$useState[0],
      setPromotionCode = _React$useState[1];

  var _React$useState2 = React__default.useState(false),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var _React$useState3 = React__default.useState(''),
      errorMessage = _React$useState3[0],
      setErrorMessage = _React$useState3[1];

  var _usePreviewSubscripti = usePreviewSubscriptionAction({
    onMockCheckoutPreview: onMockCheckoutPreview
  }),
      previewSubscriptionAction = _usePreviewSubscripti.previewSubscriptionAction;

  var handlePromotionCode = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var _subscriptionPreview$;

      var _yield$previewSubscri, subscriptionPreview, errorMessage;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              setErrorMessage('');
              _context.next = 4;
              return previewSubscriptionAction({
                promotionCode: promotionCode
              });

            case 4:
              _yield$previewSubscri = _context.sent;
              subscriptionPreview = _yield$previewSubscri.subscriptionPreview;
              errorMessage = _yield$previewSubscri.errorMessage;

              if (!errorMessage && subscriptionPreview != null && (_subscriptionPreview$ = subscriptionPreview.immediateInvoice) != null && _subscriptionPreview$.discountDetails) {
                persistPromotionCode(promotionCode.toUpperCase());
                setShowInput(false);
              } else if (errorMessage) {
                setErrorMessage(errorMessage);
              }

              setIsLoading(false);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handlePromotionCode() {
      return _ref3.apply(this, arguments);
    };
  }();

  if (!showInput) {
    return React__default.createElement(AddPromotionCodeButton, {
      disabled: disabled,
      onAddClick: function onAddClick() {
        return setShowInput(true);
      },
      checkoutLocalization: checkoutLocalization
    });
  }

  return React__default.createElement(Grid, null, React__default.createElement(Typography, {
    variant: "body1",
    color: errorMessage ? 'error' : disabled ? 'disabled' : 'primary.main'
  }, checkoutLocalization.summary.couponCodeTitle), React__default.createElement(InputField, {
    disabled: disabled,
    autoFocus: true,
    variant: "outlined",
    fullWidth: true,
    error: !!errorMessage,
    value: promotionCode,
    onChange: function onChange(e) {
      setPromotionCode(e.target.value);
    },
    inputProps: {
      maxLength: 20
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        void handlePromotionCode();
        e.preventDefault();
      }
    },
    // eslint-disable-next-line react/jsx-no-duplicate-props
    InputProps: {
      endAdornment: React__default.createElement(CouponCodeAddButton, {
        variant: "contained",
        disabled: disabled,
        onClick: function onClick() {
          void handlePromotionCode();
        }
      }, isLoading ? React__default.createElement(CircularProgress, {
        size: 18,
        sx: {
          color: 'white'
        }
      }) : React__default.createElement(Icon, {
        style: {
          display: 'flex'
        },
        icon: "ArrowForward"
      }))
    }
  }), !!errorMessage && React__default.createElement(Typography, {
    variant: "body1",
    color: "error"
  }, errorMessage));
};

var AppliedCouponContainer = /*#__PURE__*/_styled(Grid, process.env.NODE_ENV === "production" ? {
  target: "e1cvrfx31"
} : {
  target: "e1cvrfx31",
  label: "AppliedCouponContainer"
})("width:auto;display:inline-flex;align-items:center;flex-direction:row;gap:8px;padding:6px 8px;border-radius:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.border.radius;
}, ";border:1px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.stigg.palette.primary;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkFwcGxpZWRQcm9tb3Rpb25Db2RlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNNEMiLCJmaWxlIjoiQXBwbGllZFByb21vdGlvbkNvZGUudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBHcmlkIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCB7IEljb24gfSBmcm9tICcuLi8uLi9jb21tb24vSWNvbic7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmltcG9ydCB7IEJ1dHRvbiB9IGZyb20gJy4uL2NvbXBvbmVudHMnO1xyXG5jb25zdCBBcHBsaWVkQ291cG9uQ29udGFpbmVyID0gc3R5bGVkKEdyaWQpIGBcbiAgd2lkdGg6IGF1dG87XG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBnYXA6IDhweDtcbiAgcGFkZGluZzogNnB4IDhweDtcbiAgYm9yZGVyLXJhZGl1czogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5ib3JkZXIucmFkaXVzfTtcbiAgYm9yZGVyOiAxcHggc29saWQgJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnl9O1xuYDtcclxuZXhwb3J0IGNvbnN0IFN0eWxlZEljb24gPSBzdHlsZWQoSWNvbiwgeyBzaG91bGRGb3J3YXJkUHJvcDogKHByb3ApID0+IHByb3AgIT09ICdzdHlsZScgfSkgYFxuICBkaXNwbGF5OiBmbGV4O1xuXG4gIGcge1xuICAgIHN0cm9rZTogJHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnl9O1xuICB9XG5cbiAgcGF0aCB7XG4gICAgZmlsbDogJHsoeyB0aGVtZSwgJHNob3VsZEZpbGwgfSkgPT4gKCRzaG91bGRGaWxsID8gdGhlbWUuc3RpZ2cucGFsZXR0ZS5wcmltYXJ5IDogdW5kZWZpbmVkKX07XG4gIH1cbmA7XHJcbmV4cG9ydCBjb25zdCBBcHBsaWVkUHJvbW90aW9uQ29kZSA9ICh7IHByb21vdGlvbkNvZGUsIG9uQ2xlYXJQcm9tb3Rpb25Db2RlIH0pID0+IChSZWFjdC5jcmVhdGVFbGVtZW50KEFwcGxpZWRDb3Vwb25Db250YWluZXIsIHsgY29udGFpbmVyOiB0cnVlIH0sXHJcbiAgICBSZWFjdC5jcmVhdGVFbGVtZW50KEdyaWQsIHsgaXRlbTogdHJ1ZSwgZGlzcGxheTogXCJmbGV4XCIsIGdhcDogMSwgYWxpZ25JdGVtczogXCJjZW50ZXJcIiB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU3R5bGVkSWNvbiwgeyBpY29uOiBcIkNvdXBvblwiIH0pLFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoVHlwb2dyYXBoeSwgeyB2YXJpYW50OiBcImJvZHkxXCIsIGNvbG9yOiBcInByaW1hcnkubWFpblwiLCBsaW5lSGVpZ2h0OiBcImF1dG9cIiB9LCBwcm9tb3Rpb25Db2RlKSksXHJcbiAgICBSZWFjdC5jcmVhdGVFbGVtZW50KEdyaWQsIHsgaXRlbTogdHJ1ZSB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoQnV0dG9uLCB7IHZhcmlhbnQ6IFwidGV4dFwiLCBzeDogeyBtaW5XaWR0aDogJ3Vuc2V0JywgcGFkZGluZzogMCB9LCBvbkNsaWNrOiBvbkNsZWFyUHJvbW90aW9uQ29kZSB9LFxyXG4gICAgICAgICAgICBSZWFjdC5jcmVhdGVFbGVtZW50KFN0eWxlZEljb24sIHsgaWNvbjogXCJDbG9zZVwiLCBcIiRzaG91bGRGaWxsXCI6IHRydWUgfSkpKSkpO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1BcHBsaWVkUHJvbW90aW9uQ29kZS5qcy5tYXAiXX0= */"));

var StyledIcon$1 = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'style';
  },
  target: "e1cvrfx30"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'style';
  },
  target: "e1cvrfx30",
  label: "StyledIcon"
})("display:flex;g{stroke:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.stigg.palette.primary;
}, ";}path{fill:", function (_ref4) {
  var theme = _ref4.theme,
      $shouldFill = _ref4.$shouldFill;
  return $shouldFill ? theme.stigg.palette.primary : undefined;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var AppliedPromotionCode = function AppliedPromotionCode(_ref5) {
  var promotionCode = _ref5.promotionCode,
      onClearPromotionCode = _ref5.onClearPromotionCode;
  return React__default.createElement(AppliedCouponContainer, {
    container: true
  }, React__default.createElement(Grid, {
    item: true,
    display: "flex",
    gap: 1,
    alignItems: "center"
  }, React__default.createElement(StyledIcon$1, {
    icon: "Coupon"
  }), React__default.createElement(Typography, {
    variant: "body1",
    color: "primary.main",
    lineHeight: "auto"
  }, promotionCode)), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Button, {
    variant: "text",
    sx: {
      minWidth: 'unset',
      padding: 0
    },
    onClick: onClearPromotionCode
  }, React__default.createElement(StyledIcon$1, {
    icon: "Close",
    "$shouldFill": true
  }))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$l() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var PromotionCodeSectionContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eqejwsl0"
} : {
  target: "eqejwsl0",
  label: "PromotionCodeSectionContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1k6141t",
  styles: "margin:16px 0"
} : {
  name: "1k6141t",
  styles: "margin:16px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByb21vdGlvbkNvZGVTZWN0aW9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLaUQiLCJmaWxlIjoiUHJvbW90aW9uQ29kZVNlY3Rpb24udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyB1c2VQcm9tb3Rpb25Db2RlTW9kZWwgfSBmcm9tICcuLi9ob29rcy91c2VDb3Vwb25Nb2RlbCc7XHJcbmltcG9ydCB7IEFkZFByb21vdGlvbkNvZGUgfSBmcm9tICcuL0FkZFByb21vdGlvbkNvZGUnO1xyXG5pbXBvcnQgeyBBcHBsaWVkUHJvbW90aW9uQ29kZSB9IGZyb20gJy4vQXBwbGllZFByb21vdGlvbkNvZGUnO1xyXG5jb25zdCBQcm9tb3Rpb25Db2RlU2VjdGlvbkNvbnRhaW5lciA9IHN0eWxlZC5kaXYgYFxuICBtYXJnaW46IDE2cHggMDtcbmA7XHJcbmV4cG9ydCBjb25zdCBQcm9tb3Rpb25Db2RlU2VjdGlvbiA9ICh7IGRpc2FibGVkLCBjaGVja291dExvY2FsaXphdGlvbiwgb25Nb2NrQ2hlY2tvdXRQcmV2aWV3LCB9KSA9PiB7XHJcbiAgICBjb25zdCB7IHByb21vdGlvbkNvZGUsIHNldFByb21vdGlvbkNvZGUgfSA9IHVzZVByb21vdGlvbkNvZGVNb2RlbCgpO1xyXG4gICAgY29uc3Qgb25DbGVhclByb21vdGlvbkNvZGUgPSAoKSA9PiB7XHJcbiAgICAgICAgc2V0UHJvbW90aW9uQ29kZSgnJyk7XHJcbiAgICB9O1xyXG4gICAgY29uc3QgY29udGVudCA9IHByb21vdGlvbkNvZGUgPyAoUmVhY3QuY3JlYXRlRWxlbWVudChBcHBsaWVkUHJvbW90aW9uQ29kZSwgeyBwcm9tb3Rpb25Db2RlOiBwcm9tb3Rpb25Db2RlLCBvbkNsZWFyUHJvbW90aW9uQ29kZTogb25DbGVhclByb21vdGlvbkNvZGUgfSkpIDogKFJlYWN0LmNyZWF0ZUVsZW1lbnQoQWRkUHJvbW90aW9uQ29kZSwgeyBkaXNhYmxlZDogZGlzYWJsZWQsIGNoZWNrb3V0TG9jYWxpemF0aW9uOiBjaGVja291dExvY2FsaXphdGlvbiwgb25Nb2NrQ2hlY2tvdXRQcmV2aWV3OiBvbk1vY2tDaGVja291dFByZXZpZXcgfSkpO1xyXG4gICAgcmV0dXJuIFJlYWN0LmNyZWF0ZUVsZW1lbnQoUHJvbW90aW9uQ29kZVNlY3Rpb25Db250YWluZXIsIG51bGwsIGNvbnRlbnQpO1xyXG59O1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1Qcm9tb3Rpb25Db2RlU2VjdGlvbi5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$l
});

var PromotionCodeSection = function PromotionCodeSection(_ref) {
  var disabled = _ref.disabled,
      checkoutLocalization = _ref.checkoutLocalization,
      onMockCheckoutPreview = _ref.onMockCheckoutPreview;

  var _usePromotionCodeMode = usePromotionCodeModel(),
      promotionCode = _usePromotionCodeMode.promotionCode,
      setPromotionCode = _usePromotionCodeMode.setPromotionCode;

  var onClearPromotionCode = function onClearPromotionCode() {
    setPromotionCode('');
  };

  var content = promotionCode ? React__default.createElement(AppliedPromotionCode, {
    promotionCode: promotionCode,
    onClearPromotionCode: onClearPromotionCode
  }) : React__default.createElement(AddPromotionCode, {
    disabled: disabled,
    checkoutLocalization: checkoutLocalization,
    onMockCheckoutPreview: onMockCheckoutPreview
  });
  return React__default.createElement(PromotionCodeSectionContainer, null, content);
};

var _excluded$6 = ["postal_code"];
function StripePaymentForm(_ref) {
  var _configuration$conten;

  var onBillingAddressChange = _ref.onBillingAddressChange,
      collectPhoneNumber = _ref.collectPhoneNumber;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      checkoutLocalization = _useCheckoutModel.checkoutLocalization,
      widgetState = _useCheckoutModel.widgetState,
      setWidgetReadOnly = _useCheckoutModel.setWidgetReadOnly;

  var _usePaymentStepModel = usePaymentStepModel(),
      setBillingAddress = _usePaymentStepModel.setBillingAddress;

  var _ref2 = checkoutState || {},
      customer = _ref2.customer,
      configuration = _ref2.configuration;

  var readOnly = widgetState.readOnly;
  var shouldCollectPhoneNumber = !!(collectPhoneNumber != null ? collectPhoneNumber : configuration == null ? void 0 : (_configuration$conten = configuration.content) == null ? void 0 : _configuration$conten.collectPhoneNumber);

  var handleAddressChange = function handleAddressChange(args) {
    if (!args.complete) {
      return;
    }

    var _args$value$address = args.value.address,
        postalCode = _args$value$address.postal_code,
        addressFields = _objectWithoutPropertiesLoose(_args$value$address, _excluded$6);

    var billingAddress = _extends({
      postalCode: postalCode
    }, addressFields);

    setWidgetReadOnly(true);
    setBillingAddress(billingAddress);

    if (onBillingAddressChange) {
      var callExternalBillingAddressChanged = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
          return runtime_1.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return onBillingAddressChange({
                    billingAddress: billingAddress
                  });

                case 2:
                  setWidgetReadOnly(false);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function callExternalBillingAddressChanged() {
          return _ref3.apply(this, arguments);
        };
      }();

      void callExternalBillingAddressChanged();
    } else {
      setWidgetReadOnly(false);
    }
  };

  return React__default.createElement(Grid, {
    flexDirection: "column",
    container: true,
    gap: 3,
    padding: "16px",
    sx: {
      pointerEvents: readOnly ? 'none' : undefined
    }
  }, React__default.createElement(Grid, {
    flexDirection: "column",
    container: true,
    gap: 2
  }, React__default.createElement(Typography, {
    variant: "h6"
  }, checkoutLocalization.newPaymentMethodBillingAddressTitle), React__default.createElement(AddressElement, {
    onChange: handleAddressChange,
    options: {
      mode: 'billing',
      fields: {
        phone: shouldCollectPhoneNumber ? 'always' : 'auto'
      },
      defaultValues: _extends({}, (customer == null ? void 0 : customer.name) && {
        name: customer.name
      })
    }
  })), React__default.createElement(Grid, {
    flexDirection: "column",
    container: true,
    gap: 2
  }, React__default.createElement(Typography, {
    variant: "h6"
  }, checkoutLocalization.newPaymentMethodCardTitle), React__default.createElement(PaymentElement, {
    onChange: function onChange() {},
    onReady: function onReady() {},
    options: {
      readOnly: readOnly,
      terms: {
        card: 'never'
      },
      defaultValues: {
        billingDetails: _extends({}, (customer == null ? void 0 : customer.name) && {
          name: customer.name
        }, (customer == null ? void 0 : customer.email) && {
          email: customer.email
        })
      }
    }
  })));
}

function useStripeIntegration() {
  var _useState = useState(null),
      stripePromise = _useState[0],
      setStripePromise = _useState[1];

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState;

  var _ref = checkoutState || {},
      billingIntegration = _ref.billingIntegration,
      setupSecret = _ref.setupSecret;

  useEffect(function () {
    if (billingIntegration) {
      var billingIdentifier = billingIntegration.billingIdentifier,
          credentials = billingIntegration.credentials;

      if (billingIdentifier !== BillingVendorIdentifier.Stripe) {
        console.error('Currently only stripe integration is supported');
        return;
      }

      var accountId = credentials.accountId,
          publicKey = credentials.publicKey;
      setStripePromise(loadStripe(publicKey, {
        stripeAccount: accountId
      }));
    }
  }, [billingIntegration]);
  return {
    stripePromise: stripePromise,
    setupIntentClientSecret: setupSecret
  };
}

function useSubscriptionState() {
  var subscription = useSubscriptionModel();

  var _useCheckoutContext = useCheckoutContext(),
      resourceId = _useCheckoutContext[0].resourceId;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState;

  var _ref = checkoutState || {},
      plan = _ref.plan;

  var addons = subscription.addons.map(function (_ref2) {
    var addon = _ref2.addon,
        quantity = _ref2.quantity;
    return {
      addonId: addon.id,
      quantity: quantity
    };
  });

  if (!(plan != null && plan.id)) {
    return undefined;
  }

  return _extends({
    resourceId: resourceId,
    planId: plan.id,
    billingPeriod: subscription.billingPeriod,
    billableFeatures: subscription.billableFeatures,
    addons: addons,
    promotionCode: subscription.promotionCode,
    billingCountryCode: subscription.billingCountryCode
  }, subscription.taxPercentage ? {
    billingInformation: {
      taxPercentage: subscription.taxPercentage
    }
  } : {});
}

function handleStripeFormValidations(_x) {
  return _handleStripeFormValidations.apply(this, arguments);
}

function _handleStripeFormValidations() {
  _handleStripeFormValidations = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(_ref) {
    var elements, errorMessage, _yield$elements$submi, elementsError;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            elements = _ref.elements;

            if (elements) {
              _context.next = 5;
              break;
            }

            errorMessage = 'Stripe elements not initialized';
            console.error(errorMessage);
            return _context.abrupt("return", {
              success: false,
              errorMessage: errorMessage
            });

          case 5:
            _context.next = 7;
            return elements.submit();

          case 7:
            _yield$elements$submi = _context.sent;
            elementsError = _yield$elements$submi.error;

            if (!elementsError) {
              _context.next = 12;
              break;
            }

            console.log(elementsError.message);
            return _context.abrupt("return", {
              success: false,
              errorMessage: elementsError.message || ''
            });

          case 12:
            return _context.abrupt("return", {
              success: true
            });

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _handleStripeFormValidations.apply(this, arguments);
}

function handleNewPaymentMethod(_x2) {
  return _handleNewPaymentMethod.apply(this, arguments);
}

function _handleNewPaymentMethod() {
  _handleNewPaymentMethod = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(_ref2) {
    var stripe, elements, setupIntentClientSecret, _yield$handleStripeSe, newPaymentMethodId, setupErrorMessage;

    return runtime_1.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            stripe = _ref2.stripe, elements = _ref2.elements, setupIntentClientSecret = _ref2.setupIntentClientSecret;

            if (!(!stripe || !elements || !setupIntentClientSecret)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", {
              success: false
            });

          case 3:
            _context2.next = 5;
            return handleStripeSetup({
              stripe: stripe,
              elements: elements,
              clientSecret: setupIntentClientSecret
            });

          case 5:
            _yield$handleStripeSe = _context2.sent;
            newPaymentMethodId = _yield$handleStripeSe.newPaymentMethodId;
            setupErrorMessage = _yield$handleStripeSe.setupErrorMessage;
            return _context2.abrupt("return", {
              success: !!newPaymentMethodId,
              paymentMethodId: newPaymentMethodId,
              errorMessage: setupErrorMessage
            });

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _handleNewPaymentMethod.apply(this, arguments);
}

function handleStripeNextAction(_x3) {
  return _handleStripeNextAction.apply(this, arguments);
}

function _handleStripeNextAction() {
  _handleStripeNextAction = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee3(_ref3) {
    var _applySubscriptionRes, _applySubscriptionRes2, _applySubscriptionRes3;

    var applySubscriptionResults, stripe, paymentIntentClientSecret, _yield$stripe$handleN, NextActionError;

    return runtime_1.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            applySubscriptionResults = _ref3.applySubscriptionResults, stripe = _ref3.stripe;
            paymentIntentClientSecret = applySubscriptionResults == null ? void 0 : (_applySubscriptionRes = applySubscriptionResults.subscription) == null ? void 0 : (_applySubscriptionRes2 = _applySubscriptionRes.latestInvoice) == null ? void 0 : _applySubscriptionRes2.paymentSecret;

            if (!(stripe && paymentIntentClientSecret && (applySubscriptionResults == null ? void 0 : (_applySubscriptionRes3 = applySubscriptionResults.subscription) == null ? void 0 : _applySubscriptionRes3.paymentCollection) === PaymentCollection.ActionRequired)) {
              _context3.next = 9;
              break;
            }

            _context3.next = 5;
            return stripe.handleNextAction({
              clientSecret: paymentIntentClientSecret
            });

          case 5:
            _yield$stripe$handleN = _context3.sent;
            NextActionError = _yield$stripe$handleN.error;

            if (!NextActionError) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return", {
              errorMessage: NextActionError.message || ''
            });

          case 9:
            return _context3.abrupt("return", {
              subscription: applySubscriptionResults == null ? void 0 : applySubscriptionResults.subscription
            });

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _handleStripeNextAction.apply(this, arguments);
}

function handleStripeSetup(_x4) {
  return _handleStripeSetup.apply(this, arguments);
}

function _handleStripeSetup() {
  _handleStripeSetup = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee4(_ref4) {
    var stripe, elements, clientSecret, newPaymentMethodId, setupErrorMessage, _yield$stripe$confirm, setupError, _yield$stripe$retriev, setupIntent;

    return runtime_1.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            stripe = _ref4.stripe, elements = _ref4.elements, clientSecret = _ref4.clientSecret;
            _context4.next = 3;
            return stripe.confirmSetup({
              elements: elements,
              confirmParams: {
                return_url: window.location.href
              },
              redirect: 'if_required'
            });

          case 3:
            _yield$stripe$confirm = _context4.sent;
            setupError = _yield$stripe$confirm.error;

            if (!setupError) {
              _context4.next = 9;
              break;
            }

            if (setupError.type === 'card_error' || setupError.type === 'validation_error') {
              if (setupError.type === 'card_error') {
                // Set some error message
                setupErrorMessage = setupError.message || '';
              }
            } else {
              setupErrorMessage = 'An unexpected error occurred.';
            }

            _context4.next = 21;
            break;

          case 9:
            _context4.prev = 9;
            _context4.next = 12;
            return stripe.retrieveSetupIntent(clientSecret);

          case 12:
            _yield$stripe$retriev = _context4.sent;
            setupIntent = _yield$stripe$retriev.setupIntent;

            if (setupIntent != null && setupIntent.payment_method) {
              newPaymentMethodId = setupIntent.payment_method;
            }

            _context4.next = 21;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](9);
            setupErrorMessage = 'An unexpected error occurred.';
            console.error(_context4.t0);

          case 21:
            return _context4.abrupt("return", {
              newPaymentMethodId: newPaymentMethodId,
              setupErrorMessage: setupErrorMessage
            });

          case 22:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[9, 17]]);
  }));
  return _handleStripeSetup.apply(this, arguments);
}

var v = "5.12.1";
var fr = 30;
var ip = 0;
var op = 201;
var w = 700;
var h = 700;
var nm = "Check";
var ddd = 0;
var assets = [
];
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 4,
		nm: "Shape Layer 8",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 315,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 2,
		ty: 4,
		nm: "Shape Layer 7",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 270,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "Shape Layer 6",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 225,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "Shape Layer 5",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 180,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "Shape Layer 4",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 135,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "Shape Layer 3",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 90,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "Shape Layer 2",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 45,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "Shape Layer 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-304,
					91,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-304,
										-241
									],
									[
										-304,
										-161
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 9,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								100
							]
						},
						{
							t: 145.5,
							s: [
								0
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.667
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 130,
							s: [
								100
							]
						},
						{
							t: 139.6005859375,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 130,
		op: 204,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 9,
		ty: 4,
		nm: "Check v",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: -1.9,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					352,
					360,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-120.265,
					116.765,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					278,
					278,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-161,
										123
									],
									[
										-137,
										148
									],
									[
										-79.531,
										85.531
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								1,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 5.5,
							ix: 5
						},
						lc: 2,
						lj: 2,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 135,
							s: [
								0
							]
						},
						{
							t: 148,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 0,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 135,
		op: 201,
		st: -35,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 11,
		ty: 4,
		nm: "Circle Stroke",
		sr: 1,
		ks: {
			o: {
				a: 1,
				k: [
					{
						i: {
							x: [
								0.833
							],
							y: [
								0.833
							]
						},
						o: {
							x: [
								0.167
							],
							y: [
								0.167
							]
						},
						t: 0,
						s: [
							0
						]
					},
					{
						t: 7,
						s: [
							100
						]
					}
				],
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					4,
					-6,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					132,
					132,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						d: 1,
						ty: "el",
						s: {
							a: 0,
							k: [
								306,
								306
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						nm: "Ellipse Path 1",
						mn: "ADBE Vector Shape - Ellipse",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 1,
							k: [
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 0,
									s: [
										1,
										1,
										1,
										1
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 30,
									s: [
										1,
										1,
										1,
										1
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 61,
									s: [
										1,
										1,
										1,
										1
									]
								},
								{
									i: {
										x: [
											0.833
										],
										y: [
											0.833
										]
									},
									o: {
										x: [
											0.167
										],
										y: [
											0.167
										]
									},
									t: 87,
									s: [
										1,
										1,
										1,
										1
									]
								},
								{
									t: 136,
									s: [
										1,
										1,
										1,
										1
									]
								}
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 8,
							ix: 5
						},
						lc: 2,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								4,
								-6
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Ellipse 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.338
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 87,
							s: [
								50
							]
						},
						{
							t: 122,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.338
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.333
								],
								y: [
									0
								]
							},
							t: 87,
							s: [
								45
							]
						},
						{
							t: 122,
							s: [
								0
							]
						}
					],
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.474
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.43
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								-170.4
							]
						},
						{
							t: 111,
							s: [
								-1250.4
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 201,
		st: 0,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 13,
		ty: 1,
		nm: "Dark Gray Solid 1",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					350,
					350,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		sw: 700,
		sh: 700,
		sc: "#2d2d2d",
		ip: 0,
		op: 201,
		st: 0,
		bm: 0
	}
];
var markers = [
];
var props = {
};
var animationData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	layers: layers,
	markers: markers,
	props: props
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$m() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ANIMATION_DURATION = 5000;

var CheckoutSuccessContainer = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "eeyi5d31"
} : {
  target: "eeyi5d31",
  label: "CheckoutSuccessContainer"
})("@keyframes blurFade{0%{background-color:", function (_ref) {
  var theme = _ref.theme;
  return Color(theme.stigg.palette.backgroundPaper).alpha(0).toString();
}, ";backdrop-filter:blur(0px);}100%{background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return Color(theme.stigg.palette.backgroundPaper).alpha(0.9).toString();
}, ";backdrop-filter:blur(6.5px);}}position:absolute;top:0;left:0;bottom:0;right:0;z-index:5;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return Color(theme.stigg.palette.backgroundPaper).alpha(0.9).toString();
}, ";animation:blurFade 2s ease-in forwards;display:flex;flex-direction:column;justify-content:center;* rect{fill:transparent;}& path{stroke:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.stigg.palette.primary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var CheckoutSuccessText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "eeyi5d30"
} : {
  target: "eeyi5d30",
  label: "CheckoutSuccessText"
})(process.env.NODE_ENV === "production" ? {
  name: "1kkk1zv",
  styles: "@keyframes fadeIn{0%{opacity:0;}75%{opacity:0;}100%{opacity:1;}}align-self:center;animation:fadeIn 5s ease-in forwards"
} : {
  name: "1kkk1zv",
  styles: "@keyframes fadeIn{0%{opacity:0;}75%{opacity:0;}100%{opacity:1;}}align-self:center;animation:fadeIn 5s ease-in forwards",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0U3VjY2Vzcy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0MrQyIsImZpbGUiOiJDaGVja291dFN1Y2Nlc3MudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgeyBCb3ggfSBmcm9tICdAbXVpL21hdGVyaWFsJztcclxuaW1wb3J0IENvbG9yIGZyb20gJ2NvbG9yJztcclxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IExvdHRpZSBmcm9tICdyZWFjdC1sb3R0aWUnO1xyXG5pbXBvcnQgYW5pbWF0aW9uRGF0YSBmcm9tICcuLi8uLi8uLi9hc3NldHMvbG90dGllL2NoZWNrb3V0LXN1Y2Nlc3MuanNvbic7XHJcbmltcG9ydCB7IFR5cG9ncmFwaHkgfSBmcm9tICcuLi8uLi9jb21tb24vVHlwb2dyYXBoeSc7XHJcbmV4cG9ydCBjb25zdCBBTklNQVRJT05fRFVSQVRJT04gPSA1MDAwO1xyXG5jb25zdCBDaGVja291dFN1Y2Nlc3NDb250YWluZXIgPSBzdHlsZWQoQm94KSBgXG4gIEBrZXlmcmFtZXMgYmx1ckZhZGUge1xuICAgIDAlIHtcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gQ29sb3IodGhlbWUuc3RpZ2cucGFsZXR0ZS5iYWNrZ3JvdW5kUGFwZXIpLmFscGhhKDApLnRvU3RyaW5nKCl9O1xuICAgICAgYmFja2Ryb3AtZmlsdGVyOiBibHVyKDBweCk7XG4gICAgfVxuICAgIDEwMCUge1xuICAgICAgYmFja2dyb3VuZC1jb2xvcjogJHsoeyB0aGVtZSB9KSA9PiBDb2xvcih0aGVtZS5zdGlnZy5wYWxldHRlLmJhY2tncm91bmRQYXBlcikuYWxwaGEoMC45KS50b1N0cmluZygpfTtcbiAgICAgIGJhY2tkcm9wLWZpbHRlcjogYmx1cig2LjVweCk7XG4gICAgfVxuICB9XG5cbiAgcG9zaXRpb246IGFic29sdXRlO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIGJvdHRvbTogMDtcbiAgcmlnaHQ6IDA7XG4gIHotaW5kZXg6IDU7XG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gQ29sb3IodGhlbWUuc3RpZ2cucGFsZXR0ZS5iYWNrZ3JvdW5kUGFwZXIpLmFscGhhKDAuOSkudG9TdHJpbmcoKX07XG4gIGFuaW1hdGlvbjogYmx1ckZhZGUgMnMgZWFzZS1pbiBmb3J3YXJkcztcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgKiByZWN0IHtcbiAgICBmaWxsOiB0cmFuc3BhcmVudDtcbiAgfVxuXG4gICYgcGF0aCB7XG4gICAgc3Ryb2tlOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnN0aWdnLnBhbGV0dGUucHJpbWFyeX07XG4gIH1cbmA7XHJcbmNvbnN0IENoZWNrb3V0U3VjY2Vzc1RleHQgPSBzdHlsZWQoVHlwb2dyYXBoeSkgYFxuICBAa2V5ZnJhbWVzIGZhZGVJbiB7XG4gICAgMCUge1xuICAgICAgb3BhY2l0eTogMDtcbiAgICB9XG4gICAgNzUlIHtcbiAgICAgIG9wYWNpdHk6IDA7XG4gICAgfVxuICAgIDEwMCUge1xuICAgICAgb3BhY2l0eTogMTtcbiAgICB9XG4gIH1cblxuICBhbGlnbi1zZWxmOiBjZW50ZXI7XG4gIGFuaW1hdGlvbjogZmFkZUluIDVzIGVhc2UtaW4gZm9yd2FyZHM7XG5gO1xyXG5leHBvcnQgZnVuY3Rpb24gQ2hlY2tvdXRTdWNjZXNzKHsgY2hlY2tvdXRMb2NhbGl6YXRpb24gfSkge1xyXG4gICAgcmV0dXJuIChSZWFjdC5jcmVhdGVFbGVtZW50KENoZWNrb3V0U3VjY2Vzc0NvbnRhaW5lciwgeyBjbGFzc05hbWU6IFwic3RpZ2ctY2hlY2tvdXQtc3VjY2Vzcy1jb250YWluZXJcIiB9LFxyXG4gICAgICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoTG90dGllLCB7IHdpZHRoOiAzNTAsIGhlaWdodDogXCJhdXRvXCIsIGlzQ2xpY2tUb1BhdXNlRGlzYWJsZWQ6IHRydWUsIG9wdGlvbnM6IHsgbG9vcDogZmFsc2UsIGF1dG9wbGF5OiB0cnVlLCBhbmltYXRpb25EYXRhIH0gfSksXHJcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChDaGVja291dFN1Y2Nlc3NUZXh0LCB7IHZhcmlhbnQ6IFwiaDFcIiwgY29sb3I6IFwicHJpbWFyeS5tYWluXCIgfSwgY2hlY2tvdXRMb2NhbGl6YXRpb24uc3VtbWFyeS5jaGVja291dFN1Y2Nlc3NUZXh0KSkpO1xyXG59XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUNoZWNrb3V0U3VjY2Vzcy5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$m
});

function CheckoutSuccess(_ref5) {
  var checkoutLocalization = _ref5.checkoutLocalization;
  return React__default.createElement(CheckoutSuccessContainer, {
    className: "stigg-checkout-success-container"
  }, React__default.createElement(Lottie, {
    width: 350,
    height: "auto",
    isClickToPauseDisabled: true,
    options: {
      loop: false,
      autoplay: true,
      animationData: animationData
    }
  }), React__default.createElement(CheckoutSuccessText, {
    variant: "h1",
    color: "primary.main"
  }, checkoutLocalization.summary.checkoutSuccessText));
}

var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};

function useSubmit(_ref) {
  var onCheckout = _ref.onCheckout,
      onCheckoutCompleted = _ref.onCheckoutCompleted,
      onSuccess = _ref.onSuccess,
      disableSuccessAnimation = _ref.disableSuccessAnimation;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg;

  var _usePaymentStepModel = usePaymentStepModel(),
      useNewPaymentMethod = _usePaymentStepModel.useNewPaymentMethod;

  var subscriptionState = useSubscriptionState();

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      widgetState = _useCheckoutModel.widgetState,
      setWidgetReadOnly = _useCheckoutModel.setWidgetReadOnly;

  var _ref2 = checkoutState || {},
      setupIntentClientSecret = _ref2.setupSecret;

  var stripe = useStripe();
  var elements = useElements();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(e) {
      var checkoutParams, checkoutResults, errorMessage, paymentMethodId, checkoutAction, success, externalCheckoutResults, checkoutActionResults;
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();

              if (subscriptionState) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", {
                success: false,
                errorMessage: 'Unexpected error, please contact support.'
              });

            case 3:
              checkoutParams = _extends({}, subscriptionState);

              checkoutAction = /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
                  var _yield$handleStripeFo, _success, stripeValidationsErrorMessage, paymentMethodResults, applySubscriptionResults, nextActionResults;

                  return runtime_1.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!useNewPaymentMethod) {
                            _context.next = 13;
                            break;
                          }

                          _context.next = 3;
                          return handleStripeFormValidations({
                            elements: elements
                          });

                        case 3:
                          _yield$handleStripeFo = _context.sent;
                          _success = _yield$handleStripeFo.success;
                          stripeValidationsErrorMessage = _yield$handleStripeFo.errorMessage;

                          if (_success) {
                            _context.next = 8;
                            break;
                          }

                          return _context.abrupt("return", {
                            success: false,
                            errorMessage: stripeValidationsErrorMessage
                          });

                        case 8:
                          _context.next = 10;
                          return handleNewPaymentMethod({
                            elements: elements,
                            stripe: stripe,
                            setupIntentClientSecret: setupIntentClientSecret
                          });

                        case 10:
                          paymentMethodResults = _context.sent;

                          if (!paymentMethodResults.success) {
                            errorMessage = paymentMethodResults.errorMessage;
                          }

                          paymentMethodId = paymentMethodResults.paymentMethodId;

                        case 13:
                          if (!errorMessage) {
                            _context.next = 15;
                            break;
                          }

                          return _context.abrupt("return", {
                            success: false,
                            errorMessage: errorMessage
                          });

                        case 15:
                          checkoutParams = _extends({}, checkoutParams, {
                            paymentMethodId: paymentMethodId
                          });
                          _context.prev = 16;
                          _context.next = 19;
                          return stigg.applySubscription(checkoutParams);

                        case 19:
                          applySubscriptionResults = _context.sent;
                          _context.next = 22;
                          return handleStripeNextAction({
                            applySubscriptionResults: applySubscriptionResults,
                            stripe: stripe
                          });

                        case 22:
                          nextActionResults = _context.sent;
                          checkoutResults = nextActionResults;

                          if (nextActionResults.errorMessage) {
                            errorMessage = nextActionResults.errorMessage;
                          }

                          return _context.abrupt("return", {
                            success: !nextActionResults.errorMessage,
                            errorMessage: nextActionResults.errorMessage
                          });

                        case 28:
                          _context.prev = 28;
                          _context.t0 = _context["catch"](16);
                          console.error(_context.t0);
                          errorMessage = _context.t0 == null ? void 0 : _context.t0.message;
                          return _context.abrupt("return", {
                            success: false,
                            errorMessage: errorMessage
                          });

                        case 33:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[16, 28]]);
                }));

                return function checkoutAction() {
                  return _ref4.apply(this, arguments);
                };
              }();

              setWidgetReadOnly(true);
              success = false;

              if (!onCheckout) {
                _context2.next = 15;
                break;
              }

              _context2.next = 10;
              return onCheckout({
                checkoutParams: checkoutParams,
                checkoutAction: checkoutAction
              });

            case 10:
              externalCheckoutResults = _context2.sent;

              if (!externalCheckoutResults.success && externalCheckoutResults.errorMessage) {
                errorMessage = externalCheckoutResults.errorMessage;
              }

              success = externalCheckoutResults.success && !errorMessage;
              _context2.next = 20;
              break;

            case 15:
              _context2.next = 17;
              return checkoutAction();

            case 17:
              checkoutActionResults = _context2.sent;

              if (!checkoutActionResults.success && checkoutActionResults.errorMessage) {
                errorMessage = checkoutActionResults.errorMessage;
              }

              success = checkoutActionResults.success && !errorMessage;

            case 20:
              setWidgetReadOnly(false);

              if (!(success && onSuccess)) {
                _context2.next = 26;
                break;
              }

              onSuccess();

              if (disableSuccessAnimation) {
                _context2.next = 26;
                break;
              }

              _context2.next = 26;
              return delay(ANIMATION_DURATION);

            case 26:
              _context2.next = 28;
              return onCheckoutCompleted({
                success: success,
                error: errorMessage
              });

            case 28:
              return _context2.abrupt("return", {
                results: checkoutResults,
                success: !errorMessage,
                errorMessage: errorMessage
              });

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return {
    handleSubmit: handleSubmit,
    isLoading: !!(widgetState != null && widgetState.readOnly)
  };
}

var WithSkeleton = function WithSkeleton(_ref) {
  var isLoading = _ref.isLoading,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 50 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 16 : _ref$height,
      children = _ref.children;

  if (isLoading) {
    return React__default.createElement(Skeleton, {
      width: width,
      height: height
    });
  }

  return React__default.createElement(React__default.Fragment, null, children);
};

var RemainingCreditsCaption = function RemainingCreditsCaption(_ref) {
  var _immediateInvoice$pro, _immediateInvoice$pro2, _immediateInvoice$pro3, _immediateInvoice$pro4;

  var subscriptionPreview = _ref.subscriptionPreview,
      isFetchingSubscriptionPreview = _ref.isFetchingSubscriptionPreview,
      checkoutLocalization = _ref.checkoutLocalization;

  var _ref2 = subscriptionPreview || {},
      immediateInvoice = _ref2.immediateInvoice;

  if (!(immediateInvoice != null && (_immediateInvoice$pro = immediateInvoice.proration) != null && (_immediateInvoice$pro2 = _immediateInvoice$pro.netAmount) != null && _immediateInvoice$pro2.amount) || (immediateInvoice == null ? void 0 : (_immediateInvoice$pro3 = immediateInvoice.proration) == null ? void 0 : (_immediateInvoice$pro4 = _immediateInvoice$pro3.netAmount) == null ? void 0 : _immediateInvoice$pro4.amount) >= 0) {
    return null;
  }

  var positiveAmount = immediateInvoice.proration.netAmount.amount * -1;
  var credits = currencyPriceFormatter({
    amount: positiveAmount,
    currency: immediateInvoice.proration.netAmount.currency,
    minimumFractionDigits: 2
  });
  return React__default.createElement(Typography, {
    variant: "caption",
    style: {
      marginTop: 14
    }
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview,
    width: "100%"
  }, checkoutLocalization.summary.creditsForUnusedTimeText({
    credits: credits
  })));
};

var ScheduledUpdatesCaption = function ScheduledUpdatesCaption(_ref3) {
  var subscriptionPreview = _ref3.subscriptionPreview,
      activeSubscription = _ref3.activeSubscription,
      isFetchingSubscriptionPreview = _ref3.isFetchingSubscriptionPreview,
      checkoutLocalization = _ref3.checkoutLocalization;

  if (!(subscriptionPreview != null && subscriptionPreview.hasScheduledUpdates) || !(activeSubscription != null && activeSubscription.currentBillingPeriodEnd)) {
    return null;
  }

  var currentBillingPeriodEnd = activeSubscription.currentBillingPeriodEnd;
  var changesWillApplyText = typeof checkoutLocalization.summary.changesWillApplyAtEndOfBillingPeriod === 'function' ? checkoutLocalization.summary.changesWillApplyAtEndOfBillingPeriod({
    billingPeriodEnd: currentBillingPeriodEnd
  }) : checkoutLocalization.summary.changesWillApplyAtEndOfBillingPeriod;
  return React__default.createElement(Typography, {
    variant: "caption",
    style: {
      marginTop: 14
    }
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview,
    width: "100%"
  }, changesWillApplyText));
};

var NextBillingCaption = function NextBillingCaption(_ref4) {
  var subscriptionPreview = _ref4.subscriptionPreview,
      activeSubscription = _ref4.activeSubscription,
      plan = _ref4.plan,
      isFetchingSubscriptionPreview = _ref4.isFetchingSubscriptionPreview,
      billingPeriod = _ref4.billingPeriod;

  var _ref5 = subscriptionPreview || {},
      recurringInvoice = _ref5.recurringInvoice;

  if (!subscriptionPreview || !(recurringInvoice != null && recurringInvoice.total.amount)) {
    return null;
  }

  var currentBillingPeriodEnd = subscriptionPreview.hasScheduledUpdates ? activeSubscription == null ? void 0 : activeSubscription.currentBillingPeriodEnd : subscriptionPreview == null ? void 0 : subscriptionPreview.billingPeriodRange.end;
  var total = currencyPriceFormatter(_extends({}, recurringInvoice.total, {
    minimumFractionDigits: 2
  }));
  var hasUnitBasedPricing = plan == null ? void 0 : plan.pricePoints.some(function (price) {
    return price.pricingModel === BillingModel.UsageBased;
  });
  var hasNonUnitBasedPricing = plan == null ? void 0 : plan.pricePoints.some(function (price) {
    return price.pricingModel !== BillingModel.UsageBased;
  });
  var text = 'We will bill you ';
  var totalAmountText = total + " ";

  if (hasUnitBasedPricing) {
    if (!hasNonUnitBasedPricing) {
      totalAmountText = 'for';
    } else {
      totalAmountText += '+';
    }

    totalAmountText += ' applicable usage-based charges for this subscription ';
  }

  var nextBillingDate;
  var billingPeriodText;

  switch (billingPeriod) {
    case BillingPeriod.Monthly:
      billingPeriodText = 'month';
      nextBillingDate = "the " + moment(currentBillingPeriodEnd).format('Do');
      break;

    case BillingPeriod.Annually:
      billingPeriodText = 'year';
      nextBillingDate = moment(currentBillingPeriodEnd).format('MMMM Do');
      break;
  }

  text += totalAmountText + "for this subscription every " + billingPeriodText + " on " + nextBillingDate + ", unless you cancel.";
  return React__default.createElement(Typography, {
    variant: "body1",
    style: {
      marginTop: 14
    }
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview,
    width: "100%"
  }, text));
};

function CheckoutCaptions(props) {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(RemainingCreditsCaption, Object.assign({}, props)), React__default.createElement(ScheduledUpdatesCaption, Object.assign({}, props)), React__default.createElement(NextBillingCaption, Object.assign({}, props)));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$n() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var LineItemContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ultpe61"
} : {
  target: "e1ultpe61",
  label: "LineItemContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "rdmn2i",
  styles: "&+&{margin-top:8px;}"
} : {
  name: "rdmn2i",
  styles: "&+&{margin-top:8px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});
var LineItemRow = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ultpe60"
} : {
  target: "e1ultpe60",
  label: "LineItemRow"
})(process.env.NODE_ENV === "production" ? {
  name: "bcffy2",
  styles: "display:flex;align-items:center;justify-content:space-between"
} : {
  name: "bcffy2",
  styles: "display:flex;align-items:center;justify-content:space-between",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$n
});
var getPriceString = function getPriceString(_ref) {
  var amount = _ref.amount,
      price = _ref.price,
      quantity = _ref.quantity;
  var billingPeriod = price.billingPeriod;
  var billingPeriodString = null;

  if (billingPeriod === BillingPeriod.Annually) {
    amount /= 12;
    billingPeriodString = '12 months';
  }

  var addonPriceFormat = currencyPriceFormatter({
    amount: amount,
    currency: price.currency,
    minimumFractionDigits: 2
  });
  return "" + (quantity > 1 ? quantity + " x " + addonPriceFormat + " each" : addonPriceFormat) + (billingPeriodString ? " x " + billingPeriodString : '');
};

var PayAsYouGoPriceTooltip = function PayAsYouGoPriceTooltip(_ref2) {
  var checkoutLocalization = _ref2.checkoutLocalization;
  var title = React__default.createElement(Typography, {
    variant: "body1"
  }, checkoutLocalization.summary.payAsYouGoTooltipText);
  return React__default.createElement(InformationTooltip, {
    placement: "left",
    title: title
  }, React__default.createElement(Icon, {
    icon: "PayAsYouGoCharge",
    style: {
      display: 'flex'
    }
  }));
};

var BilledPriceLineItem = function BilledPriceLineItem(_ref3) {
  var checkoutLocalization = _ref3.checkoutLocalization,
      label = _ref3.label,
      quantity = _ref3.quantity,
      price = _ref3.price;
  var billingPeriod = price.billingPeriod;
  var isPayAsYouGo = price.pricingModel === BillingModel.UsageBased;
  var amount;

  if (price.isTieredPrice) {
    var tier = getTierByQuantity(price.tiers, quantity);
    amount = tier.unitPrice.amount;
  } else {
    amount = price.amount;
  }

  return React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, {
    style: {
      alignItems: 'flex-start'
    }
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, label), (quantity > 1 || billingPeriod === BillingPeriod.Annually) && React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, getPriceString({
    amount: amount,
    price: price,
    quantity: quantity
  }))), React__default.createElement(Grid, {
    item: true,
    display: "flex",
    gap: 1,
    alignItems: "center"
  }, isPayAsYouGo && React__default.createElement(PayAsYouGoPriceTooltip, {
    checkoutLocalization: checkoutLocalization
  }), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary",
    style: {
      wordBreak: 'break-word'
    }
  }, currencyPriceFormatter({
    amount: quantity * amount,
    currency: price.currency,
    minimumFractionDigits: 2
  }), isPayAsYouGo && ' / unit'))));
};
var FreeChargeLineItem = function FreeChargeLineItem(_ref4) {
  var label = _ref4.label;
  return React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, {
    style: {
      alignItems: 'flex-end'
    }
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, label)), React__default.createElement(Grid, {
    item: true,
    display: "flex",
    gap: 1,
    alignItems: "center"
  }, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary",
    style: {
      wordBreak: 'break-word'
    }
  }, "Free"))));
};
var DiscountLineItem = function DiscountLineItem(_ref5) {
  var subscriptionPreview = _ref5.subscriptionPreview,
      isFetchingSubscriptionPreview = _ref5.isFetchingSubscriptionPreview,
      checkoutLocalization = _ref5.checkoutLocalization;
  var immediateInvoice = subscriptionPreview.immediateInvoice,
      recurringInvoice = subscriptionPreview.recurringInvoice;

  var _ref6 = recurringInvoice || {},
      discount = _ref6.discount,
      discountDetails = _ref6.discountDetails;

  if (!discount || !discountDetails) {
    return null;
  }

  return React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, null, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, checkoutLocalization.summary.discountText({
    discountDetails: discountDetails,
    currency: immediateInvoice.total.currency
  })), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, isFetchingSubscriptionPreview ? React__default.createElement(Skeleton, {
    width: 50,
    height: 16
  }) : currencyPriceFormatter({
    amount: discount.amount,
    currency: discount.currency,
    minimumFractionDigits: 2
  }))));
};
var AppliedCreditsLineItem = function AppliedCreditsLineItem(_ref7) {
  var subscriptionPreview = _ref7.subscriptionPreview,
      isFetchingSubscriptionPreview = _ref7.isFetchingSubscriptionPreview,
      checkoutLocalization = _ref7.checkoutLocalization;

  var _ref8 = subscriptionPreview || {},
      immediateInvoice = _ref8.immediateInvoice;

  var _ref9 = immediateInvoice || {},
      credits = _ref9.credits;

  if (!credits || !credits.used || credits.used.amount <= 0) {
    return null;
  }

  return React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, null, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, checkoutLocalization.summary.appliedCreditsTitle), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview
  }, currencyPriceFormatter({
    amount: -1 * credits.used.amount,
    currency: credits.used.currency,
    minimumFractionDigits: 2
  })))));
};
var TaxLineItem = function TaxLineItem(_ref10) {
  var tax = _ref10.tax,
      taxDetails = _ref10.taxDetails,
      isFetchingSubscriptionPreview = _ref10.isFetchingSubscriptionPreview,
      checkoutLocalization = _ref10.checkoutLocalization;

  if (!taxDetails || !tax || (tax == null ? void 0 : tax.amount) <= 0) {
    return null;
  }

  return React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, null, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, checkoutLocalization.summary.taxTitle({
    taxDetails: taxDetails
  })), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview
  }, currencyPriceFormatter({
    amount: tax == null ? void 0 : tax.amount,
    currency: tax == null ? void 0 : tax.currency,
    minimumFractionDigits: 2
  })))));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$o() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SummaryContainer = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "e9ji7bp4"
} : {
  target: "e9ji7bp4",
  label: "SummaryContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "kj9yp4",
  styles: "max-width:470px;flex:1.5"
} : {
  name: "kj9yp4",
  styles: "max-width:470px;flex:1.5",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});
var SummaryCard = /*#__PURE__*/_styled(Paper, process.env.NODE_ENV === "production" ? {
  target: "e9ji7bp3"
} : {
  target: "e9ji7bp3",
  label: "SummaryCard"
})("border-radius:10px;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.backgroundHighlight;
}, ";padding:16px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
SummaryCard.defaultProps = {
  elevation: 0
};

var SummaryTitle = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e9ji7bp2"
} : {
  target: "e9ji7bp2",
  label: "SummaryTitle"
})(process.env.NODE_ENV === "production" ? {
  name: "1jcocwa",
  styles: "margin-bottom:16px;font-weight:500"
} : {
  name: "1jcocwa",
  styles: "margin-bottom:16px;font-weight:500",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

var StyledDivider$1 = /*#__PURE__*/_styled(Divider$1, process.env.NODE_ENV === "production" ? {
  target: "e9ji7bp1"
} : {
  target: "e9ji7bp1",
  label: "StyledDivider"
})(process.env.NODE_ENV === "production" ? {
  name: "1k6141t",
  styles: "margin:16px 0"
} : {
  name: "1k6141t",
  styles: "margin:16px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

var TotalDueText = /*#__PURE__*/_styled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e9ji7bp0"
} : {
  target: "e9ji7bp0",
  label: "TotalDueText"
})(process.env.NODE_ENV === "production" ? {
  name: "5bhc30",
  styles: "margin-bottom:8px"
} : {
  name: "5bhc30",
  styles: "margin-bottom:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$o
});

function resolveCheckoutButtonText(_ref2) {
  var isLastStep = _ref2.isLastStep,
      checkoutHasChanges = _ref2.checkoutHasChanges,
      isFreeDowngrade = _ref2.isFreeDowngrade,
      checkoutLocalization = _ref2.checkoutLocalization,
      isPlanUpdate = _ref2.isPlanUpdate;

  if (!isLastStep) {
    return checkoutLocalization.checkoutButton.nextText;
  }

  if (!checkoutHasChanges) {
    return checkoutLocalization.checkoutButton.noChangesText;
  }

  if (isPlanUpdate) {
    return checkoutLocalization.checkoutButton.updateText;
  }

  if (isFreeDowngrade) {
    return checkoutLocalization.checkoutButton.downgradeToFreeText;
  }

  return checkoutLocalization.checkoutButton.upgradeText;
}

var CheckoutSummary = function CheckoutSummary(_ref3) {
  var _plan$pricePoints, _subscription$addons, _immediateInvoice$pro, _immediateInvoice$sub, _immediateInvoice$tax;

  var onCheckout = _ref3.onCheckout,
      onCheckoutCompleted = _ref3.onCheckoutCompleted,
      disablePromotionCode = _ref3.disablePromotionCode,
      disableSuccessAnimation = _ref3.disableSuccessAnimation,
      isFreeDowngrade = _ref3.isFreeDowngrade,
      onMockCheckoutPreview = _ref3.onMockCheckoutPreview;

  var _useState = useState(false),
      isCheckoutCompletedSuccessfully = _useState[0],
      setIsCheckoutCompletedSuccessfully = _useState[1];

  var _usePaymentStepModel = usePaymentStepModel(),
      setErrorMessage = _usePaymentStepModel.setErrorMessage;

  var progressBar = useProgressBarModel();
  var subscription = useSubscriptionModel();

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      checkoutLocalization = _useCheckoutModel.checkoutLocalization;

  var _ref4 = checkoutState || {},
      plan = _ref4.plan,
      activeSubscription = _ref4.activeSubscription;

  var planPrices = useChargesSort((plan == null ? void 0 : (_plan$pricePoints = plan.pricePoints) == null ? void 0 : _plan$pricePoints.filter(function (price) {
    return price.billingPeriod === subscription.billingPeriod;
  })) || []);

  var _partition = partition(planPrices, function (price) {
    return price.pricingModel === BillingModel.FlatFee;
  }),
      baseCharges = _partition[0],
      usageCharges = _partition[1];

  var _ref5 = baseCharges || [],
      baseCharge = _ref5[0];

  var isLastStep = isFreeDowngrade || progressBar.isCheckoutComplete && progressBar.isLastStep;

  var _usePreviewSubscripti = usePreviewSubscription({
    onMockCheckoutPreview: onMockCheckoutPreview
  }),
      subscriptionPreview = _usePreviewSubscripti.subscriptionPreview,
      isFetchingSubscriptionPreview = _usePreviewSubscripti.isFetchingSubscriptionPreview;

  var _useSubmit = useSubmit({
    disableSuccessAnimation: disableSuccessAnimation,
    onCheckout: onCheckout,
    onCheckoutCompleted: onCheckoutCompleted,
    onSuccess: function onSuccess() {
      setIsCheckoutCompletedSuccessfully(true);
      progressBar.markStepAsCompleted(progressBar.progressBarState.activeStep);
    }
  }),
      handleSubmit = _useSubmit.handleSubmit,
      isLoading = _useSubmit.isLoading;

  var handleCheckout = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(e) {
      var _ref7, errorMessage;

      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isCheckoutCompletedSuccessfully) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return handleSubmit(e);

            case 4:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 7;
                break;
              }

              _context.t0 = {};

            case 7:
              _ref7 = _context.t0;
              errorMessage = _ref7.errorMessage;

              if (errorMessage) {
                setErrorMessage(errorMessage);
                setIsCheckoutCompletedSuccessfully(false);
              } else {
                setErrorMessage(undefined);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleCheckout(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var onCheckoutClick = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee2(e) {
      return runtime_1.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!isLoading) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (!isLastStep) {
                _context2.next = 7;
                break;
              }

              _context2.next = 5;
              return handleCheckout(e);

            case 5:
              _context2.next = 8;
              break;

            case 7:
              progressBar.goNext();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onCheckoutClick(_x2) {
      return _ref8.apply(this, arguments);
    };
  }();

  var _ref9 = subscriptionPreview || {},
      immediateInvoice = _ref9.immediateInvoice,
      recurringInvoice = _ref9.recurringInvoice;

  var checkoutHasChanges = !!subscriptionPreview && (!!(immediateInvoice != null && immediateInvoice.proration) || !!subscriptionPreview.hasScheduledUpdates);
  var showPromotionCodeLine = !disablePromotionCode && !isFreeDowngrade;
  var showDiscountLine = !!(recurringInvoice != null && recurringInvoice.discountDetails) && !isFreeDowngrade;
  var hasDiscounts = showPromotionCodeLine || showDiscountLine;
  var hasPayAsYouGoCharges = usageCharges.some(function (price) {
    return price.pricingModel === BillingModel.UsageBased;
  });
  var onlyPayAsYouGoCharges = hasPayAsYouGoCharges && !baseCharge && usageCharges.every(function (price) {
    return price.pricingModel === BillingModel.UsageBased;
  });
  var baseChargeLabel = typeof checkoutLocalization.summary.baseChargeText === 'function' ? checkoutLocalization.summary.baseChargeText({
    billingPeriod: subscription.billingPeriod
  }) : checkoutLocalization.summary.baseChargeText;
  return React__default.createElement(SummaryContainer, null, React__default.createElement(SummaryCard, null, React__default.createElement(SummaryTitle, {
    variant: "h3"
  }, checkoutLocalization.summary.title), React__default.createElement(Grid, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginY: 2
  }, React__default.createElement(Typography, {
    variant: "h6",
    color: "primary",
    style: {
      paddingRight: '8px'
    }
  }, checkoutLocalization.summary.planName({
    plan: plan
  })), React__default.createElement(StyledDivider$1, {
    className: "stigg-checkout-summary-divider",
    sx: {
      flex: 1,
      margin: '0 !important'
    }
  })), baseCharge && React__default.createElement(BilledPriceLineItem, {
    checkoutLocalization: checkoutLocalization,
    label: baseChargeLabel,
    quantity: 1,
    price: baseCharge
  }), !baseCharge && isFreeDowngrade ? React__default.createElement(FreeChargeLineItem, {
    label: baseChargeLabel
  }) : null, usageCharges.map(function (price) {
    var _subscription$billabl, _price$feature2, _price$feature3, _price$feature4, _price$feature5;

    var priceBillableFeature = (_subscription$billabl = subscription.billableFeatures) == null ? void 0 : _subscription$billabl.find(function (billableFeature) {
      var _price$feature;

      return billableFeature.featureId === ((_price$feature = price.feature) == null ? void 0 : _price$feature.featureId);
    });
    return React__default.createElement(BilledPriceLineItem, {
      checkoutLocalization: checkoutLocalization,
      key: (_price$feature2 = price.feature) == null ? void 0 : _price$feature2.featureId,
      label: getFeatureDisplayNameText(((_price$feature3 = price.feature) == null ? void 0 : _price$feature3.displayName) || '', (_price$feature4 = price.feature) == null ? void 0 : _price$feature4.units, (_price$feature5 = price.feature) == null ? void 0 : _price$feature5.unitsPlural),
      quantity: (priceBillableFeature == null ? void 0 : priceBillableFeature.quantity) || 1,
      price: price
    });
  }), !!((_subscription$addons = subscription.addons) != null && _subscription$addons.length) && React__default.createElement(React__default.Fragment, null, React__default.createElement(Grid, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginY: 2
  }, React__default.createElement(Typography, {
    variant: "h6",
    color: "primary",
    style: {
      paddingRight: '8px'
    }
  }, checkoutLocalization.summary.addonsSectionTitle), React__default.createElement(StyledDivider$1, {
    className: "stigg-checkout-summary-divider",
    sx: {
      flex: 1,
      margin: '0 !important'
    }
  })), subscription.addons.map(function (addon) {
    var _addon$addon$pricePoi, _addon$addon;

    var addonPrice = (_addon$addon$pricePoi = addon.addon.pricePoints) == null ? void 0 : _addon$addon$pricePoi.find(function (price) {
      return price.billingPeriod === subscription.billingPeriod;
    });
    if (!addonPrice) return null;
    var addonQuantity = addon.quantity && addon.quantity > 0 ? addon.quantity : 1;
    return React__default.createElement(BilledPriceLineItem, {
      checkoutLocalization: checkoutLocalization,
      key: addon == null ? void 0 : (_addon$addon = addon.addon) == null ? void 0 : _addon$addon.id,
      label: addon.addon.displayName,
      quantity: addonQuantity,
      price: addonPrice
    });
  })), !hasDiscounts && React__default.createElement(StyledDivider$1, {
    className: "stigg-checkout-summary-divider"
  }), hasDiscounts && React__default.createElement(Grid, {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginY: 2
  }, React__default.createElement(Typography, {
    variant: "h6",
    color: "primary",
    style: {
      paddingRight: '8px'
    }
  }, checkoutLocalization.summary.discountsSectionTitle), React__default.createElement(StyledDivider$1, {
    className: "stigg-checkout-summary-divider",
    sx: {
      flex: 1,
      margin: '0 !important'
    }
  })), showPromotionCodeLine && React__default.createElement(PromotionCodeSection, {
    disabled: isLoading || isFetchingSubscriptionPreview,
    checkoutLocalization: checkoutLocalization,
    onMockCheckoutPreview: onMockCheckoutPreview
  }), showDiscountLine && React__default.createElement(DiscountLineItem, {
    subscriptionPreview: subscriptionPreview,
    isFetchingSubscriptionPreview: isFetchingSubscriptionPreview,
    checkoutLocalization: checkoutLocalization
  }), hasDiscounts && React__default.createElement(StyledDivider$1, {
    className: "stigg-checkout-summary-divider"
  }), React__default.createElement(TaxLineItem, {
    tax: recurringInvoice == null ? void 0 : recurringInvoice.tax,
    taxDetails: recurringInvoice == null ? void 0 : recurringInvoice.taxDetails,
    isFetchingSubscriptionPreview: isFetchingSubscriptionPreview,
    checkoutLocalization: checkoutLocalization
  }), !isFreeDowngrade ? React__default.createElement(React__default.Fragment, null, React__default.createElement(LineItemRow, {
    style: {
      marginTop: 16
    }
  }, React__default.createElement(Grid, {
    display: "flex",
    flexDirection: "column",
    container: true
  }, React__default.createElement(Grid, {
    item: true,
    display: "flex",
    justifyContent: "space-between"
  }, React__default.createElement(Typography, {
    variant: "h6"
  }, checkoutLocalization.summary.totalText), React__default.createElement(Typography, {
    variant: "h6"
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview
  }, onlyPayAsYouGoCharges ? checkoutLocalization.summary.onlyPayAsYouGoText : null, !onlyPayAsYouGoCharges && hasPayAsYouGoCharges ? checkoutLocalization.summary.startsAtText : null, !onlyPayAsYouGoCharges ? currencyPriceFormatter(_extends({
    amount: 0
  }, recurringInvoice == null ? void 0 : recurringInvoice.total, {
    minimumFractionDigits: 2
  })) : null))), React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, checkoutLocalization.summary.totalBillingPeriodText({
    billingPeriod: subscription.billingPeriod
  }))))), React__default.createElement(StyledDivider$1, {
    className: "stigg-checkout-summary-divider"
  })) : null, immediateInvoice != null && (_immediateInvoice$pro = immediateInvoice.proration) != null && _immediateInvoice$pro.hasProrations && immediateInvoice != null && immediateInvoice.subTotal && (immediateInvoice == null ? void 0 : immediateInvoice.subTotal.amount) > 0 ? React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, null, React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, checkoutLocalization.summary.proratedTotalDueText), React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary"
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview
  }, currencyPriceFormatter({
    amount: (immediateInvoice == null ? void 0 : (_immediateInvoice$sub = immediateInvoice.subTotal) == null ? void 0 : _immediateInvoice$sub.amount) + ((immediateInvoice == null ? void 0 : (_immediateInvoice$tax = immediateInvoice.tax) == null ? void 0 : _immediateInvoice$tax.amount) || 0),
    currency: immediateInvoice == null ? void 0 : immediateInvoice.subTotal.currency,
    minimumFractionDigits: 2
  }))))) : null, React__default.createElement(AppliedCreditsLineItem, {
    subscriptionPreview: subscriptionPreview,
    isFetchingSubscriptionPreview: isFetchingSubscriptionPreview,
    checkoutLocalization: checkoutLocalization
  }), React__default.createElement(LineItemContainer, null, React__default.createElement(LineItemRow, null, React__default.createElement(TotalDueText, {
    variant: "h6"
  }, checkoutLocalization.summary.totalDueText), React__default.createElement(TotalDueText, {
    variant: "h6"
  }, React__default.createElement(WithSkeleton, {
    isLoading: isFetchingSubscriptionPreview
  }, currencyPriceFormatter(_extends({
    amount: 0
  }, immediateInvoice == null ? void 0 : immediateInvoice.total, {
    minimumFractionDigits: 2
  })))))), React__default.createElement(CheckoutCaptions, {
    plan: plan,
    activeSubscription: activeSubscription,
    subscriptionPreview: subscriptionPreview,
    isFetchingSubscriptionPreview: isFetchingSubscriptionPreview,
    checkoutLocalization: checkoutLocalization,
    billingPeriod: subscription.billingPeriod
  }), React__default.createElement(Button, {
    "$success": isCheckoutCompletedSuccessfully,
    "$error": isLastStep && isFreeDowngrade,
    disabled: isLoading || isFetchingSubscriptionPreview || progressBar.progressBarState.isDisabled || isLastStep && !checkoutHasChanges,
    className: "stigg-checkout-summary-cta-button",
    sx: {
      textTransform: 'none',
      borderRadius: '10px',
      marginTop: '24px',
      height: '36px'
    },
    variant: "contained",
    size: "medium",
    onClick: function onClick(e) {
      void onCheckoutClick(e);
    },
    fullWidth: true
  }, React__default.createElement(Typography, {
    className: "stigg-checkout-summary-cta-button-text",
    variant: "h3",
    color: "white",
    style: {
      display: 'flex'
    }
  }, isCheckoutCompletedSuccessfully ? React__default.createElement(Icon, {
    icon: "Check",
    style: {
      display: 'contents'
    }
  }) : isLoading || isFetchingSubscriptionPreview ? React__default.createElement(CircularProgress, {
    size: 20,
    sx: {
      color: 'white'
    }
  }) : resolveCheckoutButtonText({
    isLastStep: isLastStep,
    checkoutHasChanges: checkoutHasChanges,
    isFreeDowngrade: isFreeDowngrade,
    checkoutLocalization: checkoutLocalization,
    isPlanUpdate: !!activeSubscription && (activeSubscription == null ? void 0 : activeSubscription.plan.id) === (plan == null ? void 0 : plan.id)
  })))), React__default.createElement(PoweredByStigg, {
    source: "checkout",
    showWatermark: true,
    style: {
      marginTop: 8,
      display: 'flex',
      justifyContent: 'center'
    }
  }), !disableSuccessAnimation && isCheckoutCompletedSuccessfully && React__default.createElement(CheckoutSuccess, {
    checkoutLocalization: checkoutLocalization
  }));
};

var CheckoutSummarySkeleton = function CheckoutSummarySkeleton() {
  return React__default.createElement(SummaryContainer, null, React__default.createElement(SummaryCard, null, React__default.createElement(SkeletonsContainer, {
    "$flexDirection": "column",
    "$gap": 24
  }, React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  }), React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  }), React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  }), React__default.createElement(Skeleton, {
    width: 120,
    height: 20
  })), React__default.createElement(SkeletonsContainer, {
    "$flexDirection": "column",
    "$gap": 24,
    marginTop: 5
  }, React__default.createElement(Skeleton, {
    height: 20
  }), React__default.createElement(Skeleton, {
    height: 20
  }), React__default.createElement(Skeleton, {
    height: 20
  })), React__default.createElement(FlexedSkeleton, {
    flex: 1,
    marginTop: 5
  }, React__default.createElement(Skeleton, {
    height: 34
  }))), React__default.createElement(PoweredByStigg, {
    source: "checkout",
    showWatermark: true,
    style: {
      marginTop: 8,
      display: 'flex',
      justifyContent: 'center'
    }
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$p() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CheckoutAddonsContainer = /*#__PURE__*/_styled(Grid, process.env.NODE_ENV === "production" ? {
  target: "e1o28dc92"
} : {
  target: "e1o28dc92",
  label: "CheckoutAddonsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1wte80x",
  styles: "width:100%;gap:8px"
} : {
  name: "1wte80x",
  styles: "width:100%;gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0QWRkb25zU3RlcC5zdHlsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR29EIiwiZmlsZSI6IkNoZWNrb3V0QWRkb25zU3RlcC5zdHlsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IEdyaWQgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcclxuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cyc7XHJcbmV4cG9ydCBjb25zdCBDaGVja291dEFkZG9uc0NvbnRhaW5lciA9IHN0eWxlZChHcmlkKSBgXG4gIHdpZHRoOiAxMDAlO1xuICBnYXA6IDhweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBBZGRvbkxpc3RJdGVtQ29udGFpbmVyID0gc3R5bGVkKEdyaWQpIGBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6IDgwcHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVHJhc2hCdXR0b24gPSBzdHlsZWQoQnV0dG9uKSBgXG4gIG1pbi13aWR0aDogdW5zZXQ7XG4gIHdpZHRoOiA0MXB4O1xuICBoZWlnaHQ6IDQxcHg7XG4gIHBhZGRpbmc6IDA7XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGVja291dEFkZG9uc1N0ZXAuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});
var AddonListItemContainer = /*#__PURE__*/_styled(Grid, process.env.NODE_ENV === "production" ? {
  target: "e1o28dc91"
} : {
  target: "e1o28dc91",
  label: "AddonListItemContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "a3p0fn",
  styles: "display:flex;justify-content:space-between;align-items:center;height:80px"
} : {
  name: "a3p0fn",
  styles: "display:flex;justify-content:space-between;align-items:center;height:80px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0QWRkb25zU3RlcC5zdHlsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT21EIiwiZmlsZSI6IkNoZWNrb3V0QWRkb25zU3RlcC5zdHlsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IEdyaWQgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcclxuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cyc7XHJcbmV4cG9ydCBjb25zdCBDaGVja291dEFkZG9uc0NvbnRhaW5lciA9IHN0eWxlZChHcmlkKSBgXG4gIHdpZHRoOiAxMDAlO1xuICBnYXA6IDhweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBBZGRvbkxpc3RJdGVtQ29udGFpbmVyID0gc3R5bGVkKEdyaWQpIGBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6IDgwcHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVHJhc2hCdXR0b24gPSBzdHlsZWQoQnV0dG9uKSBgXG4gIG1pbi13aWR0aDogdW5zZXQ7XG4gIHdpZHRoOiA0MXB4O1xuICBoZWlnaHQ6IDQxcHg7XG4gIHBhZGRpbmc6IDA7XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGVja291dEFkZG9uc1N0ZXAuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});
var TrashButton = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "e1o28dc90"
} : {
  target: "e1o28dc90",
  label: "TrashButton"
})(process.env.NODE_ENV === "production" ? {
  name: "156064h",
  styles: "min-width:unset;width:41px;height:41px;padding:0"
} : {
  name: "156064h",
  styles: "min-width:unset;width:41px;height:41px;padding:0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0QWRkb25zU3RlcC5zdHlsZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBYTBDIiwiZmlsZSI6IkNoZWNrb3V0QWRkb25zU3RlcC5zdHlsZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZC9tYWNybyc7XHJcbmltcG9ydCB7IEdyaWQgfSBmcm9tICdAbXVpL21hdGVyaWFsJztcclxuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cyc7XHJcbmV4cG9ydCBjb25zdCBDaGVja291dEFkZG9uc0NvbnRhaW5lciA9IHN0eWxlZChHcmlkKSBgXG4gIHdpZHRoOiAxMDAlO1xuICBnYXA6IDhweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBBZGRvbkxpc3RJdGVtQ29udGFpbmVyID0gc3R5bGVkKEdyaWQpIGBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBoZWlnaHQ6IDgwcHg7XG5gO1xyXG5leHBvcnQgY29uc3QgVHJhc2hCdXR0b24gPSBzdHlsZWQoQnV0dG9uKSBgXG4gIG1pbi13aWR0aDogdW5zZXQ7XG4gIHdpZHRoOiA0MXB4O1xuICBoZWlnaHQ6IDQxcHg7XG4gIHBhZGRpbmc6IDA7XG5gO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1DaGVja291dEFkZG9uc1N0ZXAuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$p
});

function AddonListItem(_ref) {
  var _addonState$quantity;

  var addon = _ref.addon,
      billingPeriod = _ref.billingPeriod,
      addonState = _ref.addonState,
      initialAddonState = _ref.initialAddonState,
      setAddon = _ref.setAddon,
      removeAddon = _ref.removeAddon,
      checkoutLocalization = _ref.checkoutLocalization,
      onAddonsValidationChange = _ref.onAddonsValidationChange,
      isValid = _ref.isValid;
  var addonPrice = addon.pricePoints.find(function (pricePoint) {
    return pricePoint.billingPeriod === billingPeriod;
  });
  var isAdded = !!addonState;
  var hasChanges = !!addonState && !!initialAddonState && addonState.quantity !== initialAddonState.quantity || !!initialAddonState && !addonState;

  var handleQuantityChange = function handleQuantityChange(quantity) {
    if (!quantity || quantity <= 0) {
      onAddonsValidationChange({
        addonId: addon.id,
        isValid: false
      }); // Reset the input value to null
      // @ts-ignore

      setAddon(addon, quantity != null ? quantity : null);
      return;
    }

    onAddonsValidationChange({
      addonId: addon.id,
      isValid: true
    });
    setAddon(addon, quantity);
  };

  var handleUndo = function handleUndo() {
    if (initialAddonState) {
      setAddon(addon, initialAddonState.quantity);
    } else {
      removeAddon(addon.id);
    }

    onAddonsValidationChange({
      addonId: addon.id,
      isValid: true
    });
  };

  return React__default.createElement(AddonListItemContainer, {
    container: true
  }, React__default.createElement(Grid, {
    item: true
  }, React__default.createElement(Typography, {
    variant: "h6",
    lineHeight: "24px"
  }, addon.displayName), !!addonPrice && React__default.createElement(Typography, {
    variant: "body1",
    lineHeight: "20px",
    color: "secondary"
  }, currencyPriceFormatter({
    amount: addonPrice.amount,
    currency: addonPrice.currency,
    minimumFractionDigits: 2
  }) + "/" + (billingPeriod === BillingPeriod.Annually ? 'year' : 'month'))), React__default.createElement(Grid, {
    item: true
  }, hasChanges && React__default.createElement(Button, {
    variant: "text",
    size: "small",
    sx: {
      padding: '8px',
      minWidth: 'unset'
    },
    onClick: handleUndo
  }, React__default.createElement(Typography, {
    color: "primary.main",
    variant: "body1"
  }, "Undo")), isAdded && React__default.createElement(React__default.Fragment, null, React__default.createElement(InputField, {
    id: addon.id + "-input",
    type: "number",
    sx: {
      width: 120,
      marginX: 2
    },
    value: (_addonState$quantity = addonState == null ? void 0 : addonState.quantity) != null ? _addonState$quantity : '',
    error: !isValid,
    helperText: !isValid ? 'Minimum 1' : undefined,
    FormHelperTextProps: {
      sx: {
        margin: '4px'
      }
    },
    onChange: function onChange(event) {
      var _event$target, _event$target2;

      return handleQuantityChange(event != null && (_event$target = event.target) != null && _event$target.value ? Number(event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.value) : null);
    }
  }), React__default.createElement(TrashButton, {
    color: "error",
    onClick: function onClick() {
      removeAddon(addon.id);
      onAddonsValidationChange({
        addonId: addon.id,
        isValid: true
      });
    }
  }, React__default.createElement(Icon, {
    icon: "Trash",
    style: {
      display: 'flex'
    }
  }))), !isAdded && React__default.createElement(Button, {
    sx: {
      paddingX: '22px',
      paddingY: '8px'
    },
    onClick: function onClick() {
      return handleQuantityChange(1);
    }
  }, React__default.createElement(Typography, {
    color: "primary.main",
    variant: "body1"
  }, checkoutLocalization.addAddonText))));
}

function CheckoutAddonsStep() {
  var _useCheckoutModel = useCheckoutModel(),
      checkoutLocalization = _useCheckoutModel.checkoutLocalization,
      setIsValid = _useCheckoutModel.setIsValid;

  var _usePlanStepModel = usePlanStepModel(),
      billingPeriod = _usePlanStepModel.billingPeriod;

  var _useProgressBarModel = useProgressBarModel(),
      setIsDisabled = _useProgressBarModel.setIsDisabled;

  var _useAddonsStepModel = useAddonsStepModel(),
      initialAddons = _useAddonsStepModel.initialAddons,
      addons = _useAddonsStepModel.addons,
      availableAddons = _useAddonsStepModel.availableAddons,
      setAddon = _useAddonsStepModel.setAddon,
      removeAddon = _useAddonsStepModel.removeAddon;

  var _useState = useState((availableAddons == null ? void 0 : availableAddons.reduce(function (acc, curr) {
    acc[curr.id] = true;
    return acc;
  }, {})) || {}),
      addonsValidation = _useState[0],
      setAddonsValidation = _useState[1];

  useEffect(function () {
    var isDisabled = Object.values(addonsValidation).some(function (x) {
      return !x;
    });
    setIsDisabled(isDisabled);
    setIsValid(!isDisabled);
  }, [addonsValidation, setIsDisabled, setIsValid]);
  return React__default.createElement(CheckoutAddonsContainer, {
    container: true
  }, availableAddons == null ? void 0 : availableAddons.map(function (addon) {
    var addonState = addons.find(function (x) {
      return x.addon.id === addon.id;
    });
    var initialAddonState = initialAddons == null ? void 0 : initialAddons.find(function (x) {
      return x.addon.id === addon.id;
    });
    var isValid = addonsValidation[addon.id];
    return React__default.createElement(AddonListItem, {
      key: addon.id,
      addon: addon,
      billingPeriod: billingPeriod,
      addonState: addonState,
      initialAddonState: initialAddonState,
      setAddon: setAddon,
      removeAddon: removeAddon,
      checkoutLocalization: checkoutLocalization,
      onAddonsValidationChange: function onAddonsValidationChange(_ref2) {
        var _extends2;

        var addonId = _ref2.addonId,
            isValid = _ref2.isValid;
        return setAddonsValidation(_extends({}, addonsValidation, (_extends2 = {}, _extends2[addonId] = isValid, _extends2)));
      },
      isValid: isValid
    });
  }));
}

var _templateObject$7, _templateObject2$2, _templateObject3$2, _templateObject4;
var PaymentMethodContainer = /*#__PURE__*/styled$1(Grid, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !prop.startsWith('$');
  }
})(_templateObject$7 || (_templateObject$7 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  padding: 8px;\n  border-radius: 10px;\n  border: 1px solid ", ";\n  cursor: ", ";\n  opacity: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.outlinedBorder;
}, function (_ref2) {
  var $disabled = _ref2.$disabled;
  return $disabled ? 'not-allowed' : 'pointer';
}, function (_ref3) {
  var $disabled = _ref3.$disabled;
  return $disabled ? 0.6 : 1;
});
var NewPaymentMethodContainer = /*#__PURE__*/styled$1(PaymentMethodContainer)(_templateObject2$2 || (_templateObject2$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  flex-direction: column;\n  align-items: unset;\n"])));
var PaymentMethodLayoutContainer = /*#__PURE__*/styled$1(Grid)(_templateObject3$2 || (_templateObject3$2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 12px;\n"])));
var PaymentMethodTextContainer = /*#__PURE__*/styled$1(Grid)(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));

function PaymentMethodLayout(_ref) {
  var checked = _ref.checked,
      icon = _ref.icon,
      text = _ref.text,
      subtitle = _ref.subtitle,
      readOnly = _ref.readOnly;
  return React__default.createElement(PaymentMethodLayoutContainer, null, React__default.createElement(Radio, {
    checked: checked,
    disabled: readOnly
  }), React__default.createElement(Icon, {
    icon: icon,
    style: {
      display: 'flex'
    }
  }), React__default.createElement(PaymentMethodTextContainer, {
    container: true
  }, React__default.createElement(Grid, {
    item: true
  }, text), subtitle && React__default.createElement(Grid, {
    item: true
  }, subtitle)));
}

function ExistingPaymentMethod(_ref2) {
  var checked = _ref2.checked,
      paymentMethodDetails = _ref2.paymentMethodDetails,
      readOnly = _ref2.readOnly,
      onSelect = _ref2.onSelect;

  if (!paymentMethodDetails) {
    return null;
  }

  var last4Digits = paymentMethodDetails.last4Digits,
      expirationMonth = paymentMethodDetails.expirationMonth,
      expirationYear = paymentMethodDetails.expirationYear;
  return React__default.createElement(PaymentMethodContainer, {
    item: true,
    onClick: onSelect,
    "$disabled": readOnly
  }, React__default.createElement(PaymentMethodLayout, {
    checked: checked,
    readOnly: readOnly,
    icon: "PaymentMethod",
    text: React__default.createElement(Typography, {
      variant: "h6"
    }, "Card ending in " + last4Digits),
    subtitle: !!expirationMonth && !!expirationYear && React__default.createElement(Typography, {
      variant: "body1"
    }, "Expires " + expirationMonth.toString().padStart(2, '0') + "/" + expirationYear)
  }));
}
function NewPaymentMethod(_ref3) {
  var checked = _ref3.checked,
      onSelect = _ref3.onSelect,
      readOnly = _ref3.readOnly,
      checkoutLocalization = _ref3.checkoutLocalization,
      onBillingAddressChange = _ref3.onBillingAddressChange,
      collectPhoneNumber = _ref3.collectPhoneNumber;
  return React__default.createElement(NewPaymentMethodContainer, {
    item: true,
    onClick: onSelect,
    "$disabled": readOnly
  }, React__default.createElement(PaymentMethodLayout, {
    checked: checked,
    readOnly: readOnly,
    icon: "PaymentMethod",
    text: React__default.createElement(Typography, {
      variant: "h6"
    }, checkoutLocalization.newPaymentMethodText)
  }), React__default.createElement(Collapse, {
    "in": checked
  }, React__default.createElement(StripePaymentForm, {
    onBillingAddressChange: onBillingAddressChange,
    collectPhoneNumber: collectPhoneNumber
  })));
}

var _templateObject$8;
var PaymentContainer = /*#__PURE__*/styled$1(Grid)(_templateObject$8 || (_templateObject$8 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"])));
function PaymentStep(_ref) {
  var onBillingAddressChange = _ref.onBillingAddressChange,
      collectPhoneNumber = _ref.collectPhoneNumber;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      checkoutLocalization = _useCheckoutModel.checkoutLocalization,
      widgetState = _useCheckoutModel.widgetState;

  var _ref2 = checkoutState || {},
      customer = _ref2.customer;

  var _usePaymentStepModel = usePaymentStepModel(),
      errorMessage = _usePaymentStepModel.errorMessage,
      useNewPaymentMethod = _usePaymentStepModel.useNewPaymentMethod,
      setUseNewPaymentMethod = _usePaymentStepModel.setUseNewPaymentMethod;

  var readOnly = widgetState.readOnly;

  var handleOnSelect = function handleOnSelect(openNewPaymentMethod) {
    if (readOnly) {
      return;
    }

    setUseNewPaymentMethod(openNewPaymentMethod);
  };

  return React__default.createElement(PaymentContainer, {
    container: true
  }, !!errorMessage && React__default.createElement(Alert, {
    severity: "error",
    sx: {
      alignItems: 'center'
    }
  }, React__default.createElement(Typography, {
    overrideColor: "inherit"
  }, errorMessage)), React__default.createElement(ExistingPaymentMethod, {
    readOnly: readOnly,
    checked: !useNewPaymentMethod,
    paymentMethodDetails: customer == null ? void 0 : customer.paymentMethodDetails,
    onSelect: function onSelect() {
      return handleOnSelect(false);
    }
  }), React__default.createElement(NewPaymentMethod, {
    readOnly: readOnly,
    checked: useNewPaymentMethod,
    checkoutLocalization: checkoutLocalization,
    onSelect: function onSelect() {
      return handleOnSelect(true);
    },
    onBillingAddressChange: onBillingAddressChange,
    collectPhoneNumber: collectPhoneNumber
  }));
}

var ChangePlanButton = function ChangePlanButton(_ref) {
  var onClick = _ref.onClick,
      checkoutLocalization = _ref.checkoutLocalization,
      size = _ref.size;
  return React__default.createElement(Button$2, {
    className: "stigg-checkout-change-plan-button",
    sx: {
      textTransform: 'none'
    },
    variant: "text",
    size: size,
    onClick: onClick
  }, React__default.createElement(Typography, {
    className: "stigg-checkout-change-plan-button-text",
    color: "primary.main",
    variant: "h3",
    style: {
      lineHeight: '24px'
    }
  }, checkoutLocalization.changePlan));
};

function PlanHeader$1(_ref) {
  var _ref$allowChangePlan = _ref.allowChangePlan,
      allowChangePlan = _ref$allowChangePlan === void 0 ? false : _ref$allowChangePlan,
      onChangePlan = _ref.onChangePlan;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      checkoutLocalization = _useCheckoutModel.checkoutLocalization;

  var _ref2 = checkoutState || {},
      plan = _ref2.plan;

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(Box$1, {
    sx: {
      marginBottom: '16px'
    }
  }, React__default.createElement(Typography, {
    variant: "body1",
    color: "disabled",
    style: {
      opacity: 0.6,
      marginBottom: '8px'
    }
  }, "Selected plan"), React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, React__default.createElement(Typography, {
    variant: "h1"
  }, plan == null ? void 0 : plan.displayName), allowChangePlan && onChangePlan && React__default.createElement(ChangePlanButton, {
    onClick: function onClick() {
      onChangePlan({
        currentPlan: plan
      });
    },
    checkoutLocalization: checkoutLocalization,
    size: "medium"
  }))), React__default.createElement(Divider$1, {
    className: "stigg-checkout-plan-header-divider"
  }));
}

function formatBillingPeriod(billingPeriod) {
  switch (billingPeriod) {
    case BillingPeriod.Annually:
      return 'Annual';

    case BillingPeriod.Monthly:
      return 'Monthly';

    default:
      return '';
  }
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$q() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BillingPeriodPickerContainer = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "ekae5v44"
} : {
  target: "ekae5v44",
  label: "BillingPeriodPickerContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1k6141t",
  styles: "margin:16px 0"
} : {
  name: "1k6141t",
  styles: "margin:16px 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJpbGxpbmdQZXJpb2RQaWNrZXIuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUd3RCIsImZpbGUiOiJCaWxsaW5nUGVyaW9kUGlja2VyLnN0eWxlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IHsgQm94LCBDaGlwIH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmltcG9ydCBDb2xvciBmcm9tICdjb2xvcic7XHJcbmV4cG9ydCBjb25zdCBCaWxsaW5nUGVyaW9kUGlja2VyQ29udGFpbmVyID0gc3R5bGVkKEJveCkgYFxuICBtYXJnaW46IDE2cHggMDtcbmA7XHJcbmV4cG9ydCBjb25zdCBCaWxsaW5nUGVyaW9kQnV0dG9uID0gc3R5bGVkLmJ1dHRvbiBgXG4gIGN1cnNvcjogJHsoeyAkZGlzYWJsZWQsICRpc09ubHlCaWxsaW5nUGVyaW9kIH0pID0+ICRkaXNhYmxlZCA/ICdkZWZhdWx0JyA6ICRpc09ubHlCaWxsaW5nUGVyaW9kID8gJ2RlZmF1bHQnIDogJ3BvaW50ZXInfTtcbiAgZmxleDogMTtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAganVzdGlmeS1jb250ZW50OiBmbGV4LXN0YXJ0O1xuICBwYWRkaW5nOiAycHggOHB4O1xuICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICBib3JkZXI6ICR7KHsgdGhlbWUsICRpc0FjdGl2ZSwgJGlzT25seUJpbGxpbmdQZXJpb2QgfSkgPT4ge1xyXG4gICAgbGV0IGJvcmRlckNvbG9yID0gdGhlbWUuc3RpZ2cucGFsZXR0ZS5vdXRsaW5lZEJvcmRlcjtcclxuICAgIGlmICgkaXNPbmx5QmlsbGluZ1BlcmlvZCkge1xyXG4gICAgICAgIGJvcmRlckNvbG9yID0gJ3RyYW5zcGFyZW50JztcclxuICAgIH1cclxuICAgIGVsc2UgaWYgKCRpc0FjdGl2ZSkge1xyXG4gICAgICAgIGJvcmRlckNvbG9yID0gdGhlbWUuc3RpZ2cucGFsZXR0ZS5vdXRsaW5lZFJlc3RpbmdCb3JkZXI7XHJcbiAgICB9XHJcbiAgICByZXR1cm4gYDFweCBzb2xpZCAke2JvcmRlckNvbG9yfWA7XHJcbn19O1xuICBiYWNrZ3JvdW5kOiAkeyh7IHRoZW1lLCAkaXNBY3RpdmUsICRpc09ubHlCaWxsaW5nUGVyaW9kIH0pID0+IHtcclxuICAgIGlmICgkaXNPbmx5QmlsbGluZ1BlcmlvZCkge1xyXG4gICAgICAgIHJldHVybiAndHJhbnNwYXJlbnQnO1xyXG4gICAgfVxyXG4gICAgaWYgKCRpc0FjdGl2ZSkge1xyXG4gICAgICAgIHJldHVybiBDb2xvcih0aGVtZS5zdGlnZy5wYWxldHRlLnByaW1hcnkpLmFscGhhKDAuMTUpLnRvU3RyaW5nKCk7XHJcbiAgICB9XHJcbiAgICByZXR1cm4gJ3RyYW5zcGFyZW50JztcclxufX07XG4gIHRleHQtdHJhbnNmb3JtOiBub25lO1xuICB0ZXh0LWFsaWduOiBzdGFydDtcbiAgaGVpZ2h0OiAzNnB4O1xuXG4gICYuTXVpQnV0dG9uLXJvb3Qge1xuICAgIHBhZGRpbmc6IDAgMTZweCAwIDhweDtcbiAgICAmOmhvdmVyIHtcbiAgICAgIGJhY2tncm91bmQ6IG5vbmU7XG4gICAgfVxuICB9XG5gO1xyXG5leHBvcnQgY29uc3QgQmlsbGluZ1BlcmlvZE9wdGlvbnMgPSBzdHlsZWQoQm94KSBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGdhcDogMTZweDtcbiAgbWFyZ2luLXRvcDogMTZweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBCaWxsaW5nUGVyaW9kUHJpY2UgPSBzdHlsZWQuZGl2IGBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGJhc2VsaW5lO1xuICBnYXA6IDhweDtcbmA7XHJcbmV4cG9ydCBjb25zdCBEaXNjb3VudENoaXAgPSBzdHlsZWQoQ2hpcCkgYFxuICAmIC5NdWlDaGlwLWxhYmVsIHtcbiAgICBmb250LXNpemU6IDEycHg7XG4gIH1cbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUJpbGxpbmdQZXJpb2RQaWNrZXIuc3R5bGUuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
var BillingPeriodButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "ekae5v43"
} : {
  target: "ekae5v43",
  label: "BillingPeriodButton"
})("cursor:", function (_ref) {
  var $disabled = _ref.$disabled,
      $isOnlyBillingPeriod = _ref.$isOnlyBillingPeriod;
  return $disabled ? 'default' : $isOnlyBillingPeriod ? 'default' : 'pointer';
}, ";flex:1;display:flex;align-items:center;justify-content:flex-start;padding:2px 8px;border-radius:10px;border:", function (_ref2) {
  var theme = _ref2.theme,
      $isActive = _ref2.$isActive,
      $isOnlyBillingPeriod = _ref2.$isOnlyBillingPeriod;
  var borderColor = theme.stigg.palette.outlinedBorder;

  if ($isOnlyBillingPeriod) {
    borderColor = 'transparent';
  } else if ($isActive) {
    borderColor = theme.stigg.palette.outlinedRestingBorder;
  }

  return "1px solid " + borderColor;
}, ";background:", function (_ref3) {
  var theme = _ref3.theme,
      $isActive = _ref3.$isActive,
      $isOnlyBillingPeriod = _ref3.$isOnlyBillingPeriod;

  if ($isOnlyBillingPeriod) {
    return 'transparent';
  }

  if ($isActive) {
    return Color(theme.stigg.palette.primary).alpha(0.15).toString();
  }

  return 'transparent';
}, ";text-transform:none;text-align:start;height:36px;&.MuiButton-root{padding:0 16px 0 8px;&:hover{background:none;}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var BillingPeriodOptions = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "ekae5v42"
} : {
  target: "ekae5v42",
  label: "BillingPeriodOptions"
})(process.env.NODE_ENV === "production" ? {
  name: "1neb8ay",
  styles: "display:flex;gap:16px;margin-top:16px"
} : {
  name: "1neb8ay",
  styles: "display:flex;gap:16px;margin-top:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
var BillingPeriodPrice = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ekae5v41"
} : {
  target: "ekae5v41",
  label: "BillingPeriodPrice"
})(process.env.NODE_ENV === "production" ? {
  name: "1dz2cns",
  styles: "display:flex;align-items:baseline;gap:8px"
} : {
  name: "1dz2cns",
  styles: "display:flex;align-items:baseline;gap:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});
var DiscountChip = /*#__PURE__*/_styled(Chip, process.env.NODE_ENV === "production" ? {
  target: "ekae5v40"
} : {
  target: "ekae5v40",
  label: "DiscountChip"
})(process.env.NODE_ENV === "production" ? {
  name: "dcu1sk",
  styles: "& .MuiChip-label{font-size:12px;}"
} : {
  name: "dcu1sk",
  styles: "& .MuiChip-label{font-size:12px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$q
});

var BillingPeriodOption = function BillingPeriodOption(_ref) {
  var billingPeriod = _ref.billingPeriod,
      isOnlyBillingPeriod = _ref.isOnlyBillingPeriod;

  var _usePlanStepModel = usePlanStepModel(),
      selectedBillingPeriod = _usePlanStepModel.billingPeriod,
      setBillingPeriod = _usePlanStepModel.setBillingPeriod;

  var isActive = selectedBillingPeriod === billingPeriod;
  return React__default.createElement(BillingPeriodButton, {
    onClick: function onClick() {
      return setBillingPeriod(billingPeriod);
    },
    "$isActive": isActive,
    "$isOnlyBillingPeriod": isOnlyBillingPeriod
  }, React__default.createElement(Radio, {
    checked: isActive,
    onChange: function onChange() {
      return setBillingPeriod(billingPeriod);
    },
    value: billingPeriod,
    disabled: isOnlyBillingPeriod,
    inputProps: {
      'aria-label': formatBillingPeriod(billingPeriod)
    },
    sx: {
      padding: 0,
      marginRight: '8px'
    }
  }), React__default.createElement(Box$1, null, React__default.createElement(Typography, {
    variant: "h3",
    color: "primary"
  }, formatBillingPeriod(billingPeriod))));
};

function BillingPeriodPicker$1(_ref2) {
  var plan = _ref2.plan,
      checkoutLocalization = _ref2.checkoutLocalization;

  var _partition = partition$1(plan == null ? void 0 : plan.pricePoints, function (price) {
    return price.billingPeriod === BillingPeriod.Monthly;
  }),
      monthlyPrices = _partition[0],
      annualPrices = _partition[1];

  var hasBothBillingPeriods = !!(monthlyPrices != null && monthlyPrices.length) && !!(annualPrices != null && annualPrices.length);

  if (!hasBothBillingPeriods) {
    return null;
  }

  return React__default.createElement(BillingPeriodPickerContainer, null, React__default.createElement(Typography, {
    variant: "h6",
    color: "primary",
    fontWeight: FontWeight.Medium
  }, checkoutLocalization.billingPeriodsTitle), React__default.createElement(BillingPeriodOptions, null, !!(monthlyPrices != null && monthlyPrices.length) && React__default.createElement(BillingPeriodOption, {
    key: BillingPeriod.Monthly,
    billingPeriod: BillingPeriod.Monthly,
    isOnlyBillingPeriod: !hasBothBillingPeriods
  }), !!(annualPrices != null && annualPrices.length) && React__default.createElement(BillingPeriodOption, {
    key: BillingPeriod.Annually,
    billingPeriod: BillingPeriod.Annually,
    isOnlyBillingPeriod: !hasBothBillingPeriods
  })));
}

var _templateObject$9;
var StyledPlanCharge = /*#__PURE__*/styled$1.div(_templateObject$9 || (_templateObject$9 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 60px;\n  margin-top: 16px;\n"])));

var getValidationText = function getValidationText(charge, quantity) {
  var minUnitQuantity = charge.minUnitQuantity,
      maxUnitQuantity = charge.maxUnitQuantity;

  if (!quantity || quantity < (minUnitQuantity || 1)) {
    return "Minimum " + (minUnitQuantity || 1);
  }

  if (maxUnitQuantity && quantity > maxUnitQuantity) {
    return "Maximum " + maxUnitQuantity;
  }

  return '';
};

function PlanCharge(_ref) {
  var _charge$feature, _charge$feature2, _charge$feature3, _charge$feature4, _charge$feature5;

  var charge = _ref.charge,
      isValid = _ref.isValid,
      setBillableFeature = _ref.setBillableFeature,
      billableFeature = _ref.billableFeature,
      onValidationChange = _ref.onValidationChange;
  var featureId = (_charge$feature = charge.feature) == null ? void 0 : _charge$feature.featureId;
  var isBaseCharge = !featureId;
  var isPayAsYouGo = charge.pricingModel === BillingModel.UsageBased;
  var displayName = isBaseCharge ? 'Base charge' : getFeatureDisplayNameText(((_charge$feature2 = charge.feature) == null ? void 0 : _charge$feature2.displayName) || '', (_charge$feature3 = charge.feature) == null ? void 0 : _charge$feature3.units, (_charge$feature4 = charge.feature) == null ? void 0 : _charge$feature4.unitsPlural);
  var hasQuantityRestrictions = !!(charge != null && charge.minUnitQuantity || charge != null && charge.maxUnitQuantity);

  var handleQuantityChange = function handleQuantityChange(event) {
    var _event$target, _event$target2;

    if (isBaseCharge || !featureId) return;
    var minUnitQuantity = charge.minUnitQuantity,
        maxUnitQuantity = charge.maxUnitQuantity;
    var value = event != null && (_event$target = event.target) != null && _event$target.value ? Number(event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.value) : null;

    if (!value || value <= 0 || minUnitQuantity && value < minUnitQuantity || maxUnitQuantity && value > maxUnitQuantity) {
      onValidationChange({
        featureId: featureId,
        isValid: false
      }); // Reset the input value to null
      // @ts-ignore

      setBillableFeature(featureId, value != null ? value : null);
      return;
    }

    onValidationChange({
      featureId: featureId,
      isValid: true
    });
    var quantity = getValidPriceQuantity(charge, value);
    setBillableFeature(featureId, quantity);
  };

  var chargeRow;

  if (isBaseCharge || isPayAsYouGo) {
    var formattedAmount = currencyPriceFormatter({
      amount: charge.amount,
      currency: charge.currency,
      locale: 'en-us',
      minimumFractionDigits: 2
    });
    chargeRow = "" + formattedAmount;

    if (isPayAsYouGo) {
      chargeRow += ' / unit';
    }
  } else if (charge.isTieredPrice && featureId) {
    var tier = getTierByQuantity(charge.tiers, billableFeature.quantity || 1);
    chargeRow = React__default.createElement(TiersSelectContainer, {
      componentId: featureId + "-tiers",
      tiers: charge.tiers,
      selectedTier: tier,
      handleTierChange: function handleTierChange(tier) {
        setBillableFeature(featureId, tier.upTo);
      }
    });
  } else {
    var _billableFeature$quan;

    chargeRow = React__default.createElement(InputField, {
      sx: {
        width: 120
      },
      id: featureId + "-input",
      type: "number",
      error: !isValid,
      helperText: !isValid ? getValidationText(charge, billableFeature == null ? void 0 : billableFeature.quantity) : undefined,
      FormHelperTextProps: {
        sx: {
          margin: '4px'
        }
      },
      value: (_billableFeature$quan = billableFeature == null ? void 0 : billableFeature.quantity) != null ? _billableFeature$quan : '',
      onChange: handleQuantityChange,
      onWheel: function onWheel(e) {
        return e.target.blur();
      }
    });
  }

  return React__default.createElement(StyledPlanCharge, null, React__default.createElement(Box$1, {
    display: "flex",
    flexDirection: "column"
  }, React__default.createElement(Typography, {
    variant: "h6",
    color: "primary",
    lineHeight: "24px"
  }, displayName), hasQuantityRestrictions && React__default.createElement(Typography, {
    variant: "body1",
    color: "secondary",
    lineHeight: "20px"
  }, calculateUnitQuantityText(charge.minUnitQuantity, charge.maxUnitQuantity, (_charge$feature5 = charge.feature) == null ? void 0 : _charge$feature5.unitsPlural))), React__default.createElement(Typography, {
    variant: "h6",
    color: "primary"
  }, chargeRow));
}
function CheckoutChargeList(_ref2) {
  var _plan$pricePoints;

  var plan = _ref2.plan,
      billingPeriod = _ref2.billingPeriod;

  var _usePlanStepModel = usePlanStepModel(),
      billableFeatures = _usePlanStepModel.billableFeatures,
      setBillableFeature = _usePlanStepModel.setBillableFeature;

  var _useProgressBarModel = useProgressBarModel(),
      setIsDisabled = _useProgressBarModel.setIsDisabled;

  var _useCheckoutModel = useCheckoutModel(),
      setIsValid = _useCheckoutModel.setIsValid;

  var planCharges = useChargesSort((plan == null ? void 0 : (_plan$pricePoints = plan.pricePoints) == null ? void 0 : _plan$pricePoints.filter(function (p) {
    return p.billingPeriod === billingPeriod;
  })) || []);

  var _useState = useState(planCharges == null ? void 0 : planCharges.reduce(function (acc, curr) {
    var _curr$feature;

    acc[((_curr$feature = curr.feature) == null ? void 0 : _curr$feature.featureId) || 'base-charge'] = true;
    return acc;
  }, {})),
      chargesValidation = _useState[0],
      setChargesValidation = _useState[1];

  useEffect(function () {
    var isDisabled = Object.values(chargesValidation).some(function (x) {
      return !x;
    });
    setIsDisabled(isDisabled);
    setIsValid(!isDisabled);
  }, [chargesValidation, setIsDisabled, setIsValid]);
  return React__default.createElement("div", null, planCharges == null ? void 0 : planCharges.map(function (charge) {
    var _charge$feature7, _charge$feature8;

    var billableFeature = billableFeatures.find(function (x) {
      var _charge$feature6;

      return x.featureId === ((_charge$feature6 = charge.feature) == null ? void 0 : _charge$feature6.featureId);
    });
    return React__default.createElement(PlanCharge, {
      key: ((_charge$feature7 = charge.feature) == null ? void 0 : _charge$feature7.featureId) || 'base-charge',
      charge: charge,
      setBillableFeature: setBillableFeature,
      billableFeature: billableFeature,
      isValid: chargesValidation[((_charge$feature8 = charge.feature) == null ? void 0 : _charge$feature8.featureId) || 'base-charge'],
      onValidationChange: function onValidationChange(_ref3) {
        var featureId = _ref3.featureId,
            isValid = _ref3.isValid;
        return setChargesValidation(function (prev) {
          var _extends2;

          return _extends({}, prev, (_extends2 = {}, _extends2[featureId] = isValid, _extends2));
        });
      }
    });
  }));
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$r() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var CheckoutPlanContainer = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "emtnukp0"
} : {
  target: "emtnukp0",
  label: "CheckoutPlanContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrb3V0UGxhblN0ZXAuc3R5bGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpRCIsImZpbGUiOiJDaGVja291dFBsYW5TdGVwLnN0eWxlLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkL21hY3JvJztcclxuaW1wb3J0IHsgQm94IH0gZnJvbSAnQG11aS9tYXRlcmlhbCc7XHJcbmV4cG9ydCBjb25zdCBDaGVja291dFBsYW5Db250YWluZXIgPSBzdHlsZWQoQm94KSBgXG4gIHdpZHRoOiAxMDAlO1xuYDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2hlY2tvdXRQbGFuU3RlcC5zdHlsZS5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$r
});

var CheckoutPlanStep = function CheckoutPlanStep(_ref) {
  var onChangePlan = _ref.onChangePlan;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      checkoutLocalization = _useCheckoutModel.checkoutLocalization;

  var _ref2 = checkoutState || {},
      plan = _ref2.plan;

  var _usePlanStepModel = usePlanStepModel(),
      billingPeriod = _usePlanStepModel.billingPeriod;

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(PlanHeader$1, {
    allowChangePlan: true,
    onChangePlan: onChangePlan
  }), React__default.createElement(CheckoutPlanContainer, null, React__default.createElement(BillingPeriodPicker$1, {
    plan: plan,
    checkoutLocalization: checkoutLocalization
  }), React__default.createElement(CheckoutChargeList, {
    plan: plan,
    billingPeriod: billingPeriod
  })));
};

var _g$6;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/createElement("g", {
    stroke: "#7586B0",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M2.667 8h10.667M9.333 4l4 4-4 4"
  }))));
};

var StyledArrowRightIcon = /*#__PURE__*/_styled(SvgArrowRight, process.env.NODE_ENV === "production" ? {
  target: "e8986nu0"
} : {
  target: "e8986nu0",
  label: "StyledArrowRightIcon"
})("path{stroke:", function (_ref) {
  var theme = _ref.theme;
  return theme.stigg.palette.text.secondary;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlN0eWxlZEFycm93LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMkQiLCJmaWxlIjoiU3R5bGVkQXJyb3cudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQvbWFjcm8nO1xyXG5pbXBvcnQgQXJyb3dSaWdodEljb24gZnJvbSAnLi4vLi4vLi4vYXNzZXRzL2Fycm93LXJpZ2h0LnN2Zyc7XHJcbmV4cG9ydCBjb25zdCBTdHlsZWRBcnJvd1JpZ2h0SWNvbiA9IHN0eWxlZChBcnJvd1JpZ2h0SWNvbikgYFxuICBwYXRoIHtcbiAgICBzdHJva2U6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuc3RpZ2cucGFsZXR0ZS50ZXh0LnNlY29uZGFyeX07XG4gIH1cbmA7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVN0eWxlZEFycm93LmpzLm1hcCJdfQ== */"));

function _EMOTION_STRINGIFIED_CSS_ERROR__$s() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var DowngradeToFreePlansContainer = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "eaawmuo2"
} : {
  target: "eaawmuo2",
  label: "DowngradeToFreePlansContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "zjik7",
  styles: "display:flex",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
});

var DowngradeToFreeAlert = /*#__PURE__*/_styled(Alert, process.env.NODE_ENV === "production" ? {
  target: "eaawmuo1"
} : {
  target: "eaawmuo1",
  label: "DowngradeToFreeAlert"
})(process.env.NODE_ENV === "production" ? {
  name: "18uqayh",
  styles: "margin-bottom:16px"
} : {
  name: "18uqayh",
  styles: "margin-bottom:16px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$s
});

var DowngradeToFreePlanBox = /*#__PURE__*/_styled(Box$1, process.env.NODE_ENV === "production" ? {
  target: "eaawmuo0"
} : {
  target: "eaawmuo0",
  label: "DowngradeToFreePlanBox"
})("padding:16px;border-radius:10px;width:100%;border:", function (_ref) {
  var theme = _ref.theme;
  return "1px solid " + theme.stigg.palette.outlinedBorder;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var DowngradeToFreeContent = function DowngradeToFreeContent(_ref2) {
  var headerText = _ref2.headerText,
      planName = _ref2.planName,
      priceText = _ref2.priceText;
  return React__default.createElement(DowngradeToFreePlanBox, {
    className: "stigg-checkout-downgrade-to-free-container"
  }, React__default.createElement(Typography, {
    className: "stigg-checkout-downgrade-to-free-text-header",
    style: {
      opacity: 0.8
    },
    variant: "caption",
    color: "disabled"
  }, headerText), React__default.createElement(Typography, {
    className: "stigg-checkout-downgrade-to-free-plan-name",
    bold: true,
    variant: "h3",
    color: "primary"
  }, planName), React__default.createElement(Typography, {
    className: "stigg-checkout-downgrade-to-free-price-text",
    color: "secondary"
  }, priceText));
};
var DowngradeToFreePlan = function DowngradeToFreePlan(_ref3) {
  var checkoutLocalization = _ref3.checkoutLocalization,
      activeSubscription = _ref3.activeSubscription,
      freePlan = _ref3.freePlan,
      _ref3$allowChangePlan = _ref3.allowChangePlan,
      allowChangePlan = _ref3$allowChangePlan === void 0 ? false : _ref3$allowChangePlan,
      onChangePlan = _ref3.onChangePlan;
  var alertAction;

  if (allowChangePlan && onChangePlan) {
    alertAction = React__default.createElement(ChangePlanButton, {
      onClick: function onClick() {
        onChangePlan({
          currentPlan: freePlan
        });
      },
      checkoutLocalization: checkoutLocalization,
      size: "small"
    });
  }

  var paidBillingPeriod = activeSubscription.prices.length > 0 ? activeSubscription.prices[0].billingPeriod : undefined;
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(DowngradeToFreeAlert, {
    action: alertAction,
    className: "stigg-checkout-downgrade-to-free-alert",
    severity: "info"
  }, React__default.createElement(Typography, {
    span: true,
    color: "secondary"
  }, checkoutLocalization.downgradeToFree.alertText({
    plan: activeSubscription.plan
  }))), React__default.createElement(DowngradeToFreePlansContainer, {
    className: "stigg-checkout-downgrade-to-free-plans-container"
  }, React__default.createElement(DowngradeToFreeContent, {
    headerText: checkoutLocalization.downgradeToFree.paidPlanHeader({
      plan: activeSubscription.plan
    }),
    planName: checkoutLocalization.downgradeToFree.paidPlanName({
      plan: activeSubscription.plan
    }),
    priceText: checkoutLocalization.downgradeToFree.paidPlanPriceText({
      plan: activeSubscription.plan,
      billingPeriod: paidBillingPeriod
    })
  }), React__default.createElement(StyledArrowRightIcon, {
    className: "stigg-checkout-downgrade-to-free-arrow",
    style: {
      margin: 'auto 16px',
      minWidth: '16px'
    }
  }), React__default.createElement(DowngradeToFreeContent, {
    headerText: checkoutLocalization.downgradeToFree.freePlanHeader({
      plan: freePlan
    }),
    planName: checkoutLocalization.downgradeToFree.freePlanName({
      plan: freePlan
    }),
    priceText: checkoutLocalization.downgradeToFree.freePlanPriceText({
      plan: freePlan
    })
  })));
};

var getStepProps = function getStepProps(currentStep, _ref) {
  var onBillingAddressChange = _ref.onBillingAddressChange,
      onChangePlan = _ref.onChangePlan,
      collectPhoneNumber = _ref.collectPhoneNumber;

  switch (currentStep.key) {
    case CheckoutStepKey.PLAN:
      return {
        content: React__default.createElement(CheckoutPlanStep, {
          onChangePlan: onChangePlan
        })
      };

    case CheckoutStepKey.ADDONS:
      return {
        content: React__default.createElement(CheckoutAddonsStep, null)
      };

    case CheckoutStepKey.PAYMENT:
      return {
        content: React__default.createElement(PaymentStep, {
          onBillingAddressChange: onBillingAddressChange,
          collectPhoneNumber: collectPhoneNumber
        })
      };

    default:
      return {
        content: null
      };
  }
};

function CheckoutContainer(_ref2) {
  var onCheckout = _ref2.onCheckout,
      onCheckoutCompleted = _ref2.onCheckoutCompleted,
      onChangePlan = _ref2.onChangePlan,
      onBillingAddressChange = _ref2.onBillingAddressChange,
      collectPhoneNumber = _ref2.collectPhoneNumber,
      disablePromotionCode = _ref2.disablePromotionCode,
      disableSuccessAnimation = _ref2.disableSuccessAnimation,
      onMockCheckoutPreview = _ref2.onMockCheckoutPreview;

  var _useStripeIntegration = useStripeIntegration(),
      stripePromise = _useStripeIntegration.stripePromise,
      setupIntentClientSecret = _useStripeIntegration.setupIntentClientSecret;

  var _useCheckoutContext = useCheckoutContext(),
      _useCheckoutContext$ = _useCheckoutContext[0],
      stiggTheme = _useCheckoutContext$.stiggTheme,
      widgetState = _useCheckoutContext$.widgetState;

  var _useProgressBarModel = useProgressBarModel(),
      currentStep = _useProgressBarModel.currentStep;

  var isLoadingCheckoutData = widgetState.isLoadingCheckoutData;

  var _useCheckoutModel = useCheckoutModel(),
      checkoutState = _useCheckoutModel.checkoutState,
      checkoutLocalization = _useCheckoutModel.checkoutLocalization;

  var _ref3 = checkoutState || {},
      plan = _ref3.plan,
      activeSubscription = _ref3.activeSubscription;

  var isFreeDowngrade = !!plan && plan.pricingType === PricingType.Free && !!activeSubscription && activeSubscription.pricingType !== PricingType.Free;

  var _getStepProps = getStepProps(currentStep, {
    onBillingAddressChange: onBillingAddressChange,
    onChangePlan: onChangePlan,
    collectPhoneNumber: collectPhoneNumber
  }),
      content = _getStepProps.content;

  var checkoutContent = React__default.createElement(React__default.Fragment, null, isFreeDowngrade ? React__default.createElement(DowngradeToFreePlan, {
    freePlan: plan,
    activeSubscription: activeSubscription,
    allowChangePlan: true,
    checkoutLocalization: checkoutLocalization,
    onChangePlan: onChangePlan
  }) : React__default.createElement(React__default.Fragment, null, content));
  var stripeElementsMode = useMemo(function () {
    return setupIntentClientSecret ? {
      clientSecret: setupIntentClientSecret
    } : {
      mode: 'setup',
      currency: 'usd'
    };
  }, [setupIntentClientSecret]);
  return React__default.createElement(Elements, {
    key: setupIntentClientSecret,
    stripe: stripePromise,
    options: _extends({}, stripeElementsMode, {
      appearance: {
        theme: 'stripe',
        variables: {
          colorText: stiggTheme.palette.text.primary,
          colorPrimaryText: stiggTheme.palette.text.primary,
          colorTextPlaceholder: stiggTheme.palette.text.disabled,
          fontFamily: stiggTheme.typography.fontFamily
        }
      }
    })
  }, React__default.createElement(CheckoutLayout, {
    className: "stigg-checkout-layout"
  }, !isFreeDowngrade && React__default.createElement(CheckoutProgressBar, null), React__default.createElement(CheckoutContent, null, React__default.createElement(CheckoutPanel, null, isLoadingCheckoutData ? React__default.createElement(ContentLoadingSkeleton, null) : checkoutContent), isLoadingCheckoutData ? React__default.createElement(CheckoutSummarySkeleton, null) : React__default.createElement(CheckoutSummary, {
    disablePromotionCode: disablePromotionCode,
    disableSuccessAnimation: disableSuccessAnimation,
    onCheckout: onCheckout,
    onCheckoutCompleted: onCheckoutCompleted,
    isFreeDowngrade: isFreeDowngrade,
    onMockCheckoutPreview: onMockCheckoutPreview
  }))));
}

var _excluded$7 = ["textOverrides", "theme", "resourceId", "planId", "preferredBillingPeriod", "billingCountryCode", "billableFeatures", "billingInformation", "onMockCheckoutState"];
var Checkout = function Checkout(_ref) {
  var textOverrides = _ref.textOverrides,
      theme = _ref.theme,
      resourceId = _ref.resourceId,
      planId = _ref.planId,
      preferredBillingPeriod = _ref.preferredBillingPeriod,
      billingCountryCode = _ref.billingCountryCode,
      billableFeatures = _ref.billableFeatures,
      billingInformation = _ref.billingInformation,
      onMockCheckoutState = _ref.onMockCheckoutState,
      containerProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);

  return React__default.createElement(CheckoutProvider, {
    textOverrides: textOverrides,
    theme: theme,
    resourceId: resourceId,
    planId: planId,
    preferredBillingPeriod: preferredBillingPeriod,
    billingCountryCode: billingCountryCode,
    billableFeatures: billableFeatures,
    billingInformation: billingInformation,
    onMockCheckoutState: onMockCheckoutState
  }, React__default.createElement(CheckoutContainer, Object.assign({}, containerProps)));
};

function useQueryParams(paramName) {
  return useMemo(function () {
    var urlSearchParams = new URLSearchParams(window.location.search);
    return paramName ? urlSearchParams.get(paramName) : urlSearchParams;
  }, [paramName, window.location.search]);
}

var ProvisionStatus;

(function (ProvisionStatus) {
  ProvisionStatus["IN_PROGRESS"] = "IN_PROGRESS";
  ProvisionStatus["SUCCEEDED"] = "SUCCEEDED";
  ProvisionStatus["FAILED"] = "FAILED";
})(ProvisionStatus || (ProvisionStatus = {}));

var useWaitForCheckoutCompleted = function useWaitForCheckoutCompleted(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      onProvisionStart = _ref.onProvisionStart,
      onProvisionSucceeded = _ref.onProvisionSucceeded,
      onProvisionFailed = _ref.onProvisionFailed;

  var _useStiggContext = useStiggContext(),
      stigg = _useStiggContext.stigg;

  var _useState = useState(ProvisionStatus.IN_PROGRESS),
      provisionStatus = _useState[0],
      setProvisionStatus = _useState[1];

  var _useState2 = useState(false),
      isAwaitingCheckout = _useState2[0],
      setIsAwaitingCheckout = _useState2[1];

  var checkoutCompleted = useQueryParams('checkoutCompleted');
  useEffect(function () {
    var waitForCheckoutToComplete = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
        var subscription;
        return runtime_1.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!checkoutCompleted || checkoutCompleted.toLowerCase() === 'false' || isAwaitingCheckout)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                setIsAwaitingCheckout(true);
                onProvisionStart && onProvisionStart();
                _context.prev = 4;
                _context.next = 7;
                return stigg.waitForCheckoutCompleted();

              case 7:
                subscription = _context.sent;
                setProvisionStatus(ProvisionStatus.SUCCEEDED);
                onProvisionSucceeded && onProvisionSucceeded(subscription);
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](4);
                console.error('Failed to wait for checkout to complete', _context.t0);
                setProvisionStatus(ProvisionStatus.FAILED);
                onProvisionFailed && onProvisionFailed(_context.t0);

              case 17:
                _context.prev = 17;
                setIsAwaitingCheckout(false);
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 12, 17, 20]]);
      }));

      return function waitForCheckoutToComplete() {
        return _ref2.apply(this, arguments);
      };
    }();

    waitForCheckoutToComplete();
  }, [stigg, checkoutCompleted]);
  return {
    isAwaitingCheckout: isAwaitingCheckout,
    provisionStatus: provisionStatus
  };
};

export { AddonsList, Checkout, CustomerPortal, CustomerPortalProvider, CustomerUsageData, InvoicesSection, PaymentDetailsSection, PaywallContainer$1 as Paywall, Promotions, ProvisionStatus, StiggContext, StiggProvider, SubscribeIntentionType, SubscriptionsOverview, useStiggContext, useWaitForCheckoutCompleted };
//# sourceMappingURL=react-sdk.esm.js.map
